import { campaignSocialImportPt } from './campaignSocialImport';
import { rankingPt } from './ranking';

export const pt = {

  translation: {
    ranking: rankingPt,
    soundEffectsPicker: {
      "title": "Adicionar áudio",
      "description": "Escolha um efeito sonoro ou envie seu próprio áudio.",
      "search": "Buscar efeitos sonoros…",
      "category": "Categoria do som",
      "allCategories": "Todas as categorias",
      "region": "Região do som",
      "regions": {
            "all": "Todos os sons",
            "br": "Brasil",
            "us": "Estados Unidos"
      },
      "preview": "Ouvir {{name}}",
      "stop": "Parar {{name}}",
      "add": "Adicionar {{name}}",
      "addButton": "Adicionar",
      "loading": "Carregando sons…",
      "loadError": "Não foi possível carregar os efeitos sonoros. Tente novamente.",
      "retry": "Tentar novamente",
      "empty": "Nenhum som encontrado. Tente outra busca ou filtro.",
      "loadMore": "Carregar mais",
      "upload": "Enviar áudio",
      "count": "{{shown}} de {{total}} sons",
      "previewError": "Não foi possível ouvir este som. Tente novamente.",
      "errors": {
            "outside_clip": "Mova o cursor para dentro do clipe para adicionar este som.",
            "invalid_time": "Mova o cursor para dentro do clipe para adicionar este som.",
            "too_many_sfx": "Este clipe já tem 30 efeitos sonoros. Remova um antes de adicionar outro.",
            "too_many_overlapping_sfx": "Só dois efeitos sonoros podem tocar ao mesmo tempo. Mova o cursor ou ajuste os sons existentes.",
            "generic": "Não foi possível adicionar este som. Tente novamente."
      },
      "categories": {
            "whoosh": "Transição",
            "impact": "Impacto",
            "riser": "Crescendo",
            "pop": "Pop",
            "click": "Clique",
            "ding": "Sino",
            "fail": "Erro",
            "glitch": "Falha digital",
            "cash": "Dinheiro",
            "reaction": "Reação",
            "cartoon": "Desenho animado",
            "typing": "Digitação",
            "drama": "Drama"
      }
},
    motionGallery: {
      "title": "Animações",
      "examples": "Exemplos",
      "scene": "Cena salva",
      "names": {
            "lower-third": "Tarja de nome",
            "title-card": "Cartão de título",
            "subscribe": "Inscreva-se",
            "counter": "Contador",
            "kinetic-captions": "Legendas animadas",
            "emoji-burst": "Chuva de emojis",
            "bar-chart": "Gráfico de barras",
            "route": "Trajeto animado",
            "repeated-stars": "Estrelas repetidas",
            "group-3d": "Grupo 3D",
            "kosky1": "Kosky 1",
            "kosky2": "Kosky 2",
            "kosky3": "Kosky 3"
      }
},
    videoEffects: {
      "title": "Efeitos",
      "enabled": "Ativar efeitos",
      "description": "Cor e efeitos visuais no vídeo deste corte.",
      "looks": "Filtros",
      "adjust": "Ajustes",
      "visual": "Visual",
      "original": "Original",
      "customLut": "LUT personalizada",
      "strength": "Intensidade do LUT",
      "importing": "Importando…",
      "importHint": ".cube 3D, até 12 MB. Otimizado para uma tabela SDR de 17³ no editor.",
      "importError": "Escolha um LUT .cube 3D válido (2–65 pontos por eixo, até 12 MB). LUTs 1D e combinados não são compatíveis.",
      "importErrorTitle": "Não foi possível importar o LUT",
      "saveError": "Não foi possível salvar os efeitos.",
      "retry": "Tentar novamente",
      "showOriginal": "Antes",
      "showEdited": "Depois",
      "comparing": "Exibindo o vídeo original. Seus efeitos serão mantidos na exportação.",
      "reset": "Restaurar efeitos do clipe inteiro",
      "resetControl": "Restaurar",
      "previewUnavailable": "Prévia dos efeitos indisponível. Recarregue ou use um navegador com WebGL2.",
      "presets": {
        "warm": "Quente",
        "cool": "Frio",
        "cinema": "Cinema",
        "vintage": "Retrô",
        "vivid": "Vívido",
        "mono": "Monocromático"
      },
      "controls": {
        "exposure": "Exposição",
        "contrast": "Contraste",
        "saturation": "Saturação",
        "temperature": "Temperatura",
        "tint": "Matiz",
        "shadows": "Sombras",
        "highlights": "Realces",
        "vibrance": "Vivacidade",
        "blur": "Desfoque",
        "vignette": "Vinheta",
        "grain": "Grão de filme",
        "grayscale": "Preto e branco"
      },
      "import": "Importar LUT .cube",
      "sections": {
        "add": "Efeitos",
        "tabDynamic": "Dinâmicos",
        "tabLook": "Visual",
        "intensity": "Intensidade",
        "ease": "Entrada/saída suave",
        "speed": "Velocidade",
        "frequency": "Frequência",
        "delete": "Excluir efeito",
        "proTitle": "Efeitos na linha do tempo são PRO",
        "proBody": "Você pode adicionar e pré-visualizar efeitos de graça. Para exportar um corte com efeitos na linha do tempo é preciso o plano PRO — faça o upgrade ou remova os efeitos para exportar grátis.",
        "library": {
          "shake": "Tremor", "zoom-punch": "Zoom punch", "flash": "Flash", "glitch": "Glitch", "rgb-split": "RGB split",
          "focus-pull": "Foco", "strobe": "Estroboscópio", "vhs": "VHS",
          "look-warm": "Quente", "look-cool": "Frio", "look-cinema": "Cinema", "look-vintage": "Vintage",
          "look-vivid": "Vívido", "look-mono": "Mono", "bw": "P&B", "grain": "Granulado", "vignette": "Vinheta", "blur": "Desfoque"
        }
      }
    },

    // Job titles (shared across signup, login/register modal, account settings)
    jobTitles: {
      contentCreator: "Criador de Conteúdo",
      clippingChannel: "Canal de Cortes",
      serviceProvider: "Prestador de Serviço",
      brand: "Marca / contratante",
    },

    // Shared color input (swatch + picker popover)
    colorInput: {
      openPicker: "Escolher cor",
      hexValue: "Valor hexadecimal da cor",
      other: "Outra",
      palette: "Paleta",
    },

    paletteEditor: {
      addColor: "Adicionar cor",
      removeColor: "Remover cor",
      randomize: "Randomizar",
      highlightRole: "Cor de destaque",
      fontColorRole: "Cor de fundo",
      accentColors: "Cores de acento",
    },

    billing: {
      storeManagedCheckout: "Sua assinatura é gerenciada pela {{store}}. Para mudar de plano, use a loja.",
      embeddedCourseCheckout: "Cursos não podem ser comprados no app.",
      pastDueBanner: "Pagamento da assinatura pendente. Regularize para continuar criando e exportando.",
      payNow: "Pagar agora",
      paying: "Abrindo pagamento...",
      pastDuePortalError: "Não foi possível abrir o portal de pagamento. Tente novamente em instantes.",
      planRenewsOn: "Plano renova em {{date}}",
      planExpiresOn: "Plano expira em {{date}}",
      partnerUntil: "Parceria até {{date}}",
      usageResetsOn: "Clipes e tempo renovam em {{date}}",
      usageResetsOnPayment: "Clipes e tempo renovam quando o pagamento for confirmado",
      planAndUsageRenewOn: "Plano, clipes e tempo renovam em {{date}}",
      renewedCycle: {
        notice: "Renovação paga. Seus limites atuais continuam até {{date}}; o novo ciclo começa nessa data.",
        startNow: "Começar novo ciclo agora",
        confirmTitle: "Começar o novo ciclo agora?",
        confirmDescription: "Os limites que sobraram do ciclo atual serão descartados.",
        confirm: "Começar agora",
        started: "Novo ciclo iniciado. Seus limites foram renovados.",
        error: "Não foi possível começar o novo ciclo. Tente novamente em instantes.",
      },
    },

    // Common
    common: {
      email: "Email",
      password: "Senha",
      loading: "Carregando...",
      error: "Erro",
      success: "Sucesso",
      cancel: "Cancelar",
      save: "Salvar",
      confirm: "Confirmar",
      delete: "Excluir",
      create: "Criar",
      edit: "Editar",
      close: "Fechar",
      back: "Voltar",
      next: "Próximo",
      submit: "Enviar",
      search: "Pesquisar",
      filter: "Filtrar",
      clear: "Limpar",
      yes: "Sim",
      no: "Não",
      or: "ou",
      and: "e",
      user: "Usuário",
      name: "Nome",
      phone: "Telefone",
      saveChanges: "Salvar Alterações",
      saving: "Salvando...",
      loadingData: "Carregando dados...",
      pro: "PRO",
      free: "Grátis",
      comingSoon: "Em Breve",
      unlimited: "Ilimitado",
      perMonth: "por mês",
      billedAnnually: "cobrado anualmente",
      learnMore: "Saiba mais",
      viewAll: "Ver todos",
      download: "Baixar",
      downloading: "Baixando...",
      upload: "Upload",
      uploading: "Enviando...",
      processing: "Processando...",
      retry: "Tentar novamente",
      apply: "Aplicar",
      remove: "Remover",
      fileTooLarge: "O arquivo deve ter no máximo {{size}}",
      invalidFileType: "Por favor, selecione um arquivo {{types}}",
      checkingAuth: "Verificando autenticação...",
      checkingPermissions: "Verificando permissões...",
      verifying: "Verificando...",
      enterprise: "Enterprise",
      talkToSpecialist: "Falar com Especialista",
      responseIn24h: "Resposta em até 24 horas",
    },

    viralizeQualification: {
      title: "Antes de começar o Viralize",
      description: "Responda estas perguntas rápidas para personalizar sua jornada.",
      progress: "Etapa {{current}} de {{total}}",
      contact: {
        title: "Como podemos falar com você?",
        name: "Nome",
        whatsapp: "WhatsApp",
        country: "País",
        search: "Buscar país...",
        notFound: "Nenhum país encontrado.",
        placeholder: "(11) 99999-9999",
      },
      back: "Voltar",
      exit: "Sair",
      continue: "Continuar",
      saving: "Salvando...",
      loading: "Carregando suas respostas...",
      loadingDescription: "Aguarde um instante.",
      retry: "Tentar novamente",
      close: "Fechar",
      loadError: "Não foi possível carregar suas respostas. Tente novamente.",
      saveError: "Não foi possível salvar sua resposta. Tente novamente.",
      equipmentOptionalHint: "Opcional — você pode continuar sem selecionar nenhum.",
      introVideo: {
        title: "Assista a esta introdução",
        iframeTitle: "Vídeo de introdução do Viralize",
        countdown: "Continuar em {{seconds}}s",
      },
      questions: {
        motivation: {
          question: "O que mais te motiva no digital?",
          options: {
            make_money: "Ganhar dinheiro",
            recognition: "Reconhecimento",
            entertain_friends: "Divertir amigos",
            professional_growth: "Crescer profissionalmente",
          },
        },
        starting_difficulty: {
          question: "Hoje qual a sua maior dificuldade para começar a fazer cortes?",
          options: {
            lack_of_time: "Falta de tempo",
            technical_difficulty: "Dificuldade técnica",
            creativity: "Criatividade",
            insecurity: "Insegurança",
          },
        },
        equipment: {
          question: "Qual desses equipamentos você tem?",
          options: {
            phone_only: "Apenas meu celular",
            notebook: "Notebook",
            tablet: "iPad ou Tablet",
            desktop: "Computador",
          },
        },
        monthly_income: {
          question: "Você ganha quanto por mês?",
          options: {
            under_1000: "menos de R$ 1.000,00",
            up_to_2500: "Até R$ 2.500,00",
            "2500_to_5000": "R$ 2500 - R$ 5.000,00",
            "5000_to_7000": "R$ 5000 - R$ 7.000,00",
            over_10000: "mais de R$ 10.000,00",
          },
        },
        clipper_experience: {
          question: "Você já é clipador (a)?",
          options: {
            not_clipper: "Não sou clipador",
            one_campaign: "Só participei de uma campanha/competição!",
            some_campaigns: "Participei de algumas campanhas!",
            lives_from_clips: "Eu vivo de fazer cortes!",
          },
        },
        could_earn_more: {
          question: "Você já sentiu que poderia ganhar muito mais do que ganha hoje??",
          options: {
            false: "Não",
            true: "Claro, com toda certeza",
          },
        },
        financially_stuck: {
          question: "E mesmo tentando, você continua no mesmo lugar, ganhando pouco dinheiro e sem muitas perspectivas financeiras?",
          options: {
            false: "Não",
            true: "Sim",
          },
        },
        likes_current_job: {
          question: "Você gosta do seu trabalho atual?",
          options: {
            false: "Não",
            true: "Sim",
          },
        },
        wants_remote_mobile_work: {
          question: "Trabalhar de casa, com o celular e ganhando dinheiro muito bem, seria um bom cenário para você?",
          options: {
            true: "Seria sim, com certeza!",
            false: "Não, prefiro continuar no mesmo lugar!",
          },
        },
        self_employment_outlook: {
          question: "Já pensou em trabalhar sendo você o/a próprio/a chefe e trabalhando para si mesmo?",
          options: {
            dream: "Sim, esse seria o meu sonho",
            not_possible: "Não acho que seja possível para mim",
            already_self_employed_more_income: "Eu já trabalho para mim e quero mais dinheiro!",
          },
        },
        first_30_day_revenue_outlook: {
          question: "Quer ter seu primeiro faturamento nos primeiros 30 dias?",
          options: {
            yes: "Sim, com certeza!",
            afraid: "Não sei, eu sou muito medroso (a)!",
            no: "Não mesmo, quero continuar no mesmo lugar!",
          },
        },
      },
    },

    // Login page
    login: {
      title: "Entrar",
      subtitle: "Entre com suas credenciais",
      emailPlaceholder: "Digite o seu email",
      passwordPlaceholder: "Digite a sua senha",
      forgotPassword: "Esqueceu a senha?",
      submitButton: "Entrar",
      submitting: "Entrando...",
      lastUsed: "Usado pela última vez",
      noAccount: "Não possui conta?",
      createAccount: "Criar conta",
      errors: {
        invalidCredentials: "Email ou senha inválidos",
      },
    },

    // Register page
    register: {
      title: "Criar Conta",
      name: "Nome",
      namePlaceholder: "Digite o seu nome",
      emailPlaceholder: "Digite o seu email",
      function: "Função",
      functionPlaceholder: "Escolha sua função",
      objectivesLabel: "Qual é o seu principal objetivo ao usar o Autoclipper?",
      objectivesPlaceholder: "Descreva o seu principal objetivo...",
      workflowLabel: "Como você pretende usar o Autoclipper no seu dia a dia?",
      workflowPlaceholder: "Descreva como pretende usar no seu dia a dia...",
      phone: "Telefone",
      passwordPlaceholder: "Digite a sua senha",
      confirmPassword: "Confirmar Senha",
      confirmPasswordPlaceholder: "Digite a sua senha",
      submitButton: "Criar Conta",
      submitting: "Criando conta...",
      marketingOptIn: "Quero receber novidades, dicas e ofertas por email. Você pode cancelar quando quiser.",
      tosNotice: "Ao criar uma conta, você concorda com os nossos <tos>Termos de Uso</tos> e com a nossa <privacy>Política de Privacidade</privacy>.",
      signUpWithGoogle: "Cadastrar com Google",
      hasAccount: "Já possui conta?",
      loginHere: "Entre aqui",
      errors: {
        passwordMismatch: "As senhas não coincidem.",
        selectFunction: "Por favor, selecione sua função.",
        minWords: "Por favor, escreva pelo menos 4 palavras.",
        emailTaken: "Email já cadastrado.",
        invalidEmail: "Email inválido.",
        registrationError: "Erro no registro. Tente novamente.",
      },
    },

    // Forgot Password page
    forgotPassword: {
      title: "Esqueceu a Senha",
      subtitle: "Digite seu email para receber um link de redefinição",
      emailPlaceholder: "Digite o seu email",
      submitButton: "Enviar Email",
      submitting: "Enviando...",
      rememberedPassword: "Lembrou sua senha?",
      loginLink: "Fazer login",
      emailSent: {
        title: "Email Enviado",
        subtitle: "Verifique sua caixa de entrada para redefinir sua senha",
        message: "Enviamos um link de redefinição de senha para o email fornecido.",
        sendAgain: "Enviar novamente",
        backToLogin: "Voltar para o login",
      },
      toast: {
        successTitle: "Email enviado",
        successDescription: "Verifique sua caixa de entrada para redefinir sua senha",
        errorTitle: "Erro",
        errorDescription: "Erro ao enviar email de redefinição",
      },
    },

    // Reset Password page
    resetPassword: {
      title: "Redefinir Senha",
      subtitle: "Digite sua nova senha",
      newPassword: "Nova Senha",
      newPasswordPlaceholder: "Digite a nova senha",
      confirmNewPassword: "Confirmar Nova Senha",
      confirmNewPasswordPlaceholder: "Confirme a nova senha",
      submitButton: "Redefinir Senha",
      submitting: "Redefinindo...",
      backToLogin: "Voltar para o login",
      success: {
        title: "Senha Redefinida",
        subtitle: "Sua senha foi redefinida com sucesso",
        message: "Agora você pode fazer login com sua nova senha.",
        goToLogin: "Ir para o Login",
      },
      toast: {
        invalidToken: "Token inválido",
        invalidLink: "Link de redefinição inválido",
        successTitle: "Senha redefinida",
        successDescription: "Sua senha foi redefinida com sucesso",
        errorTitle: "Erro",
        errorDescription: "Erro ao redefinir senha",
        passwordMismatch: "As senhas não coincidem",
        passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
      },
    },

    // Header
    header: {
      joinCommunity: "Acesse a nossa comunidade no WhatsApp",
      logout: "Sair",
      objective: {
        ownBrand: "Minha marca",
        otherChannels: "Outros canais",
        tooltip: "A interface ser\u00e1 otimizada para o objetivo selecionado",
      },
      viralizeCourseCta: "Viralize em 4 Semanas",
      viralizeCourseCtaShort: "Viralize",
    },

    // Sidebar
    sidebar: {
      challenge: "Campeonato AutoClipper",
      challengeLabel: "Competição",
      createNewProject: "Criar novo projeto",
      projectsList: "Lista de Projetos",
      exportedClips: "Clipes Exportados",
      calendar: "Calendário",
      queues: "Filas de Publicação",
      viralizeCourse: "Viralize em 4 Semanas",
      analytics: "Analytics",
      earn: "Ganhe com Cortes",
      ranks: "Rankings",
      earnWallet: "Minha carteira - Clip&Pix",
      affiliates: 'Indique e Ganhe',
      newBadge: "NOVO",
      brandKit: "Templates",
      myMedia: "Minha Mídia",
      tutorials: "Tutoriais",
      api: "API",
      apiKeys: "Chaves de API",
      apiRequests: "Requisições de API",
      apiReference: "Referência da API",
      myPlan: "Meu Plano",
      time: "Tempo",
      clips: "Clipes",
      curations: "Curadorias",
      exports: "Exportações",
      videoTime: "Tempo de Vídeo",
      upgradeToPro: "Atualizar para PRO",
      accessPreviousVersion: "Acessar Versão Anterior",
      library: "Acervo",
      myLibrary: "Meu Acervo",
      communityLibrary: "Acervo da Comunidade",
      myProjects: "Meus Projetos",
      exploreLibrary: "Ver acervo",
      hireClippers: "Contratar clipadores",
      templateIdeas: "Ideias de template",
      buyMoreMinutes: "Comprar mais minutos",
      renewPix: "Renovar via PIX",
      pastDue: "Pagamento pendente",
      payNow: "Pagar agora",
      logout: "Sair",
      admin: {
        title: "Admin",
        users: "Usuários",
        projects: "Projetos",
        clips: "Clipes",
        downloads: "Downloads",
        coupons: "Cupons",
        liveWatches: "Lives monitoradas",
        emailFlows: 'Fluxos de Email',
        payouts: "Pagamentos",
        pixVerifications: "Verificação de PIX",
        contatos: "Contatos",
        challenges: "Desafios",
        campaigns: "Campanhas CPM",
        clipperSeasons: "Temporadas dos clipadores",
        channels: "Canais",
        library: "Acervo",
        brandKits: "Templates",
        resultados: "Resultados & Métricas",
        botConversations: "Conversas do Bot",
        cpmLeads: "Leads CPM",
        courseRevenueShares: "Coprodutores de intensivos",
        affiliateEarnings: 'Afiliados',
        commissionsAndRoyalties: 'Comissões e royalties',
        templateSuggestions: 'Sugestões de template',
        communityCuration: 'Curadoria da comunidade',
        aiUsage: 'Uso da IA',
      },
      campaignAudit: "Auditoria",
      campaignAuditBadge: "CPM",
    },

    analytics: {
      title: "Analytics",
      subtitle: "Uma visão clara do desempenho público das suas contas sociais conectadas.",
      platforms: {
        instagram: "Instagram",
        tiktok: "TikTok",
        youtube: "YouTube",
        linkedin: "LinkedIn",
        facebook: "Facebook",
      },
      mediaTypes: { video: "Vídeo", reel: "Reel", short: "Short", image: "Imagem", carousel: "Carrossel", unknown: "Outro" },
      filters: {
        accounts: "Contas",
        allAccounts: "Todas as contas",
        multiSelectHint: "Selecione uma ou mais contas",
        platforms: "Plataformas",
        allPlatforms: "Todas as plataformas",
        dateRange: "Período",
        search: "Buscar conteúdo",
        clear: "Limpar filtros",
        label: "Filtros",
        platformsCount: "Plataformas ({{count}})",
        mediaTypes: "Tipos de conteúdo",
        allMediaTypes: "Todos os tipos",
        mediaTypesCount: "Tipos ({{count}})",
        period: "Posts exibidos",
        periodActive: "Ativos no período",
        periodPublished: "Publicados no período",
        availability: "Disponibilidade",
        availabilityValues: { all: "Todos os status", available: "Disponível", unavailable: "Indisponível", deleted: "Excluído" },
      },
      importing: {
        title: "Importando analytics da conta",
        description: "Os dados oficiais da sua conta estão sendo preparados. Os resultados existentes continuam disponíveis durante a importação.",
        accountProgress: "Importando @{{account}}",
      },
      empty: {
        title: "Conecte uma conta para começar a acompanhar o desempenho",
        description: "O Analytics usa a mídia pública disponibilizada por cada conexão oficial. Conecte uma conta para importar o conteúdo disponível e as métricas de vida útil.",
        connectInstagram: "Conectar Instagram",
        connectTiktok: "Conectar TikTok",
        connectYoutube: "Conectar YouTube",
        connectLinkedin: "Conectar LinkedIn",
        connectFacebook: "Conectar Facebook",
        officialDataNote: "Conteúdo privado, excluído ou não disponibilizado pela plataforma pode não estar disponível.",
      },
      error: {
        title: "O Analytics está temporariamente indisponível",
        description: "Tente novamente em alguns instantes. Os dados das suas contas conectadas não foram alterados.",
        retry: "Tentar novamente",
      },
      reconnect: {
        beforeImport: "Reconecte esta conta para começar a importar os analytics disponíveis.",
      },
      status: {
        stale: {
          title: "Mostrando seus analytics salvos mais recentes",
          description: "A atualização de uma ou mais contas não foi concluída. Seus resultados salvos continuam disponíveis.",
        },
        reconnectRequired: {
          title: "Reconecte uma conta para retomar as atualizações",
          description: "A conta afetada precisa ser reconectada antes que os analytics possam ser atualizados novamente.",
        },
        reconnectRequiredShort: "Reconectar",
        nonActiveShort: "Inativa",
        nonActive: "Conta inativa — reconecte para retomar as atualizações.",
        reconnect: "Gerenciar conexão",
        lastSuccess: "Última sincronização bem-sucedida: {{date}}",
        lastCompleteSync: "Última sincronização completa: {{date}}",
        noSuccessfulSync: "Ainda não houve sincronização concluída",
        cachedDataHint: "As métricas salvas continuam visíveis até a próxima atualização bem-sucedida.",
        automaticRetry: "Vamos tentar novamente automaticamente",
        queued: "Atualização na fila",
        running: "Atualizando analytics da conta",
        cooldown: "Atualização disponível novamente em {{date}}",
      },
      refresh: {
        label: "Atualizar",
        comingSoon: "A atualização manual estará disponível quando o workspace de Analytics estiver completo.",
        unavailable: "Nenhuma conta selecionada pode ser atualizada ainda",
        account: "Conta",
        results: { queued: "Atualização na fila", already_running: "Atualização já em andamento", cooldown: "Esta conta está no período de espera", cooldownUntil: "Atualização disponível novamente em {{date}}", reconnect_required: "Reconexão necessária", unsupported: "A atualização não está disponível para esta conta", featureDisabled: "A atualização do Analytics está temporariamente indisponível.", queueFailed: "Não foi possível iniciar esta atualização. Tente novamente em instantes.", unavailable: "Não foi possível colocar a atualização na fila. Tente novamente em instantes." },
      },
      metrics: {
        lifetimeViews: "Visualizações totais",
        viewsGained: "Visualizações obtidas",
        engagementRate: "Taxa de engajamento",
        trackedContent: "Conteúdo acompanhado",
        likes: "Curtidas",
        comments: "Comentários",
        shares: "Compartilhamentos",
        selectedAccounts: "Contas selecionadas",
        unavailable: "Não disponível",
        previousPeriod: "Período anterior",
        interactionsDetail: "{{likes}} curtidas · {{comments}} comentários · {{shares}} compartilhamentos",
        label: "Métricas de desempenho",
      },
      tooltips: {
        engagementRate: "A disponibilidade de curtidas, comentários e compartilhamentos varia por plataforma e tipo de conteúdo.",
        unavailableMetric: "Esta métrica não é fornecida para este conteúdo pela plataforma conectada.",
        measuredGrowth: "O crescimento é medido apenas a partir de observações armazenadas desde o início do acompanhamento.",
        trackedContent: "Inclui todos os itens de mídia importados, mesmo quando a plataforma não fornece visualizações.",
      },
      tabs: {
        label: "Visualizações de conteúdo do Analytics",
        allContent: "Todo o conteúdo",
        cpmCampaigns: "Campanhas CPM",
      },
      cpm: {
        title: "Campanhas CPM",
        payoutQualifiedDescription: "Aqui são mostradas apenas visualizações qualificadas para pagamento e valor acumulado do CPM. Elas não são métricas gerais de conteúdo.",
        payoutQualifiedViews: "Visualizações qualificadas para pagamento",
        loading: "Carregando registros de campanhas CPM…",
        error: "Os registros de campanhas CPM estão temporariamente indisponíveis. Os registros salvos continuam visíveis quando disponíveis.",
        empty: "Ainda não há envios de campanhas CPM para estes filtros de plataforma.",
        unnamedCampaign: "Campanha sem nome",
        openPost: "Abrir publicação canônica",
        columns: {
          campaign: "Campanha",
          account: "Conta",
          status: "Status",
          accumulatedPayout: "Pagamento acumulado",
          lastSync: "Última sincronização do CPM",
        },
        status: {
          approved: "Aprovado",
          pending: "Aguardando análise",
          disapproved: "Não aprovado",
          disqualified: "Desqualificado",
          unknown: "Status indisponível",
        },
      },
      drawer: {
        openOn: "Abrir no {{platform}}",
        chartTitle: "Visualizações ao longo do tempo",
        trackingSince: "Acompanhado desde {{date}} (importado)",
        singlePoint: "O crescimento aparece após a próxima sincronização diária.",
        error: "Não foi possível carregar o histórico deste post.",
        thatDay: "no dia",
      },
      content: {
        details: "Detalhes",
        detailsFor: "Detalhes de {{title}}",
        title: "Todo o conteúdo",
        filtersLabel: "Filtros do conteúdo",
        searchPlaceholder: "Buscar conteúdo",
        content: "Conteúdo",
        account: "Conta",
        published: "Publicado em",
        lastSync: "Última sincronização",
        availability: "Disponibilidade",
        noContent: "Ainda não há conteúdo acompanhado para esta seleção.",
        noActiveContent: "Nenhum post ganhou visualizações neste período ainda.",
        showPublished: "Mostrar posts publicados no período",
        untitled: "Conteúdo sem título",
        openProvider: "Abrir na plataforma",
        resultCount: "{{count}} itens",
        mobileEquivalent: "Os cartões móveis abaixo contêm os mesmos campos de conteúdo da tabela.",
        loading: "Carregando conteúdo salvo…",
        error: "Não foi possível carregar o conteúdo salvo. Os dados da sua conta não foram alterados.",
        columns: { content: "Conteúdo", account: "Conta", views: "Visualizações", published: "Publicado em", viewsInPeriod: "Visualizações no período", lastSync: "Última sincronização" },
      },
      ranges: { D7: "Últimos 7 dias", D30: "Últimos 30 dias", D90: "Últimos 90 dias", ALL: "Todo o período" },
      chart: { title: "Visualizações obtidas por dia", subtitle: "Alterações medidas a partir de observações oficiais armazenadas", summary: "Visualizações obtidas por dia em {{range}}. Crescimento total medido: {{value}}.", trackingSince: "Dados de acompanhamento disponíveis a partir de {{date}}" },
      platformBreakdown: { empty: "Não há métricas de plataforma disponíveis para esta seleção." },
      breakdown: {
        title: "Distribuição",
        label: "Visualização da distribuição",
        platform: "Plataforma",
        account: "Conta",
        posts_one: "{{count}} post",
        posts_other: "{{count}} posts",
        shareOfViews: "{{value}} das visualizações",
        lastSync: "Última sincronização: {{date}}",
        emptyAccounts: "Não há métricas de conta disponíveis para esta seleção.",
      },
      pagination: { previous: "Anterior", next: "Próxima", page: "Página {{page}} de {{count}}" },
      workspace: {
        label: "Workspace de Analytics",
        overviewTitle: "Visão geral de desempenho",
        contentTitle: "Workspace de conteúdo",
        placeholder: "Sua visão geral salva aparecerá aqui à medida que o workspace de Analytics for disponibilizado.",
        contentPlaceholder: "As visualizações de conteúdo e campanhas CPM estarão disponíveis aqui.",
      },
      insights: {
        label: "O que está funcionando",
        subtitle_one: "Mediana de visualizações por post · {{count}} post",
        subtitle_other: "Mediana de visualizações por post · {{count}} posts",
        posts_one: "{{count}} post",
        posts_other: "{{count}} posts",
        insufficient: "Esmaecidos: menos de {{count}} posts, fora do ranking.",
        insufficientShort: "Posts insuficientes para ranquear",
        error: "Os insights estão temporariamente indisponíveis.",
        shortRange: { title: "Escolha 30 dias ou mais", description: "Estes insights só consideram posts com pelo menos {{days}} dias, então este período não tem nenhum." },
        notEnough: { title: "Ainda não há posts suficientes", description: "Os insights aparecem quando pelo menos {{count}} posts deste período tiverem {{days}} dias ou mais." },
        formats: { title: "Qual formato funciona" },
        times: {
          title: "Quando postar",
          weekdays: { 0: "Dom", 1: "Seg", 2: "Ter", 3: "Qua", 4: "Qui", 5: "Sex", 6: "Sáb" },
          weekdaysLong: { 0: "Domingo", 1: "Segunda", 2: "Terça", 3: "Quarta", 4: "Quinta", 5: "Sexta", 6: "Sábado" },
          cell: "{{slot}} · mediana de {{median}} visualizações · posts: {{count}}",
          cellEmpty: "{{slot}} · sem posts",
          best: "Melhor: {{slot}}",
          bestDetail: "(mediana de {{median}} · posts: {{count}})",
          timezone: "Horários em {{timezone}}",
        },
      },
      errors: {
        mediaNotFound: "Este post não está mais disponível.",
        invalidTimezone: "O fuso horário do seu navegador não é suportado nestes insights.",
        invalidMediaType: "Este filtro de tipo de conteúdo não é suportado.",
        invalidPeriod: "Este filtro de período não é suportado.",
      },
    },

    // Projects page
    projects: {
      title: "Transforme seus vídeos longos em cortes virais!",
      titleViewOnly: "Visualize projetos e clipes",
      subtitle: "Clipe e crie com IA e gere os melhores cortes para bombar no TikTok, Reels ou Shorts!",
      subtitleViewOnly: "Explore os projetos disponíveis e veja os clipes gerados pela equipe.",
      pasteVideoUrl: "Cole o link do seu vídeo aqui",
      acceptedLinks: "Aceitamos links do YouTube, Twitch (pro), Instagram (pro), Google Drive (pro) e Dropbox (pro)",
      urlPlaceholder: "https://youtube.com/watch?v=...",
      createClips: "Criar cortes",
      analyzingVideo: "Analisando vídeo...",
      orUploadVideo: "Ou faça upload do seu vídeo",
      uploadProOnly: "Recurso disponível apenas para usuários PRO",
      acceptedFiles: "Aceitamos arquivos MP4 de até 50 GB",
      selectFile: "Selecionar Arquivo",
      uploadingFile: "Enviando...",
      processingFile: "Processando...",
      upgradeToPro: "Upgrade para PRO",
      newsMode: "Modo News",
      newsModeDescription: "Envie um vídeo e o espelho da cabeça de matéria para criar clipes",
      selectFiles: "Selecionar Arquivos",
      heroTitle: "Transforme seus vídeos longos",
      heroTitleAccent: "em cortes virais",
      heroSubtitle: "Clipe e crie com IA e gere os melhores cortes para bombar no TikTok, Reels ou Shorts!",
      exploreCommunity: "Ou explore o Acervo da Comunidade",
      projectHistory: "Histórico de projetos",
      expiredGroup_one: "{{count}} projeto expirado",
      expiredGroup_other: "{{count}} projetos expirados",
      searchPlaceholder: "Buscar por nome…",
      noProjectsFound: "Nenhum projeto encontrado.",
      failedToLoadProjects: "Falha ao carregar projetos.",
      loadingMore: "Carregando mais...",
      tour: {
        welcome: "Bem vindo ao Autoclipper! Aqui você pode criar cortes de vídeo de forma automática.",
        urlInput: "Comece criando seu primeiro projeto. Cole o link do seu vídeo aqui. Aceitamos links do YouTube, Twitch (pro), Instagram (pro), Google Drive (pro) e Dropbox (pro)",
        fileInput: "Ou você pode fazer upload do seu vídeo aqui (apenas usuários PRO). Aceitamos arquivos MP4 de até 50 GB",
        projectHistory: "Aqui você pode visualizar todos os seus projetos criados. Clique em um projeto para gerar clipes dele de forma automática.",
        helpButton: "Clique aqui para ver novamente o tour de como usar o Autoclipper.",
      },
    },

    dropbox: {
      linkHelp: "Dropbox PRO: use um link público de arquivo de vídeo. Até 50 GiB, sujeito aos limites do plano e do vídeo.",
      previewAfterImport: "A prévia do vídeo ficará disponível após a importação. Você pode informar o intervalo de tempo manualmente.",
      errors: {
        proRequired: "A importação do Dropbox requer PRO. Faça o upgrade do plano para continuar.",
        invalidLink: "Cole o link público completo de um arquivo de vídeo do Dropbox, incluindo a chave de acesso quando houver.",
        folderUnsupported: "Este é um link de pasta. Abra o vídeo individual no Dropbox e copie o link de compartilhamento dele.",
        unavailable: "Não foi possível acessar este vídeo do Dropbox. Verifique se o link é público e tente novamente.",
        unsupportedMedia: "Este arquivo não é um vídeo compatível. Escolha outro arquivo de vídeo.",
        fileTooLarge: "Este vídeo excede o tamanho aceito no Dropbox. Use um arquivo de até 50 GiB, sujeito aos limites atuais.",
        sourceChanged: "O arquivo do Dropbox foi alterado. Cole o link novamente para atualizar as informações.",
        metadataTimeout: "A análise do vídeo demorou demais. Tente novamente em instantes.",
        storageUnavailable: "A importação de vídeo está temporariamente indisponível. Tente novamente em instantes.",
        downloadFailed: "Não foi possível importar o vídeo do Dropbox. Verifique o link compartilhado e tente novamente.",
        processingFailed: "Não foi possível processar o vídeo importado. Tente outro arquivo de vídeo.",
      },
    },

    frameio: {
      linkHelp: "Frame.io PRO: cole o link público de uma pasta ou de um vídeo compartilhado.",
      shareTitle: "Vídeos do Frame.io",
      selectAll: "Selecionar todos",
      clearSelection: "Limpar seleção",
      selectedCount: "{{selected}} de {{total}} selecionados",
      truncated: "Mostrando apenas os primeiros 200 vídeos desta pasta.",
      tooLong: "Mais longo que o limite do seu plano",
      portrait: "Vertical",
      landscape: "Horizontal",
      noSelection: "Selecione pelo menos um vídeo do Frame.io.",
      creatingProgress: "Criando {{current}} de {{total}}…",
      summaryAllCreated_one: "{{count}} vídeo importado do Frame.io",
      summaryAllCreated_other: "{{count}} vídeos importados do Frame.io",
      summaryPartial: "{{created}} importados, {{failed}} com erro",
      summaryStopped: "Importação interrompida: limite do plano atingido.",
      summaryStoppedPro: "Importação interrompida: a importação do Frame.io requer PRO.",
      failedListTitle: "Não foi possível importar:",
      errors: {
        proRequired: "A importação do Frame.io requer PRO. Faça o upgrade do plano para continuar.",
        unsupportedLink: "Cole um link público de compartilhamento do Frame.io (next.frame.io/share/…).",
        privateOrExpired: "Este compartilhamento do Frame.io é privado, protegido por senha ou expirou.",
        notFound: "Não encontramos este compartilhamento do Frame.io. Verifique o link.",
        noVideos: "Não há vídeos neste link do Frame.io.",
        notReady: "Este vídeo ainda está sendo processado pelo Frame.io. Tente novamente em instantes.",
        unavailable: "Não foi possível acessar o Frame.io agora. Tente novamente em instantes.",
        downloadFailed: "Não foi possível importar o vídeo do Frame.io. Tente novamente.",
      },
    },

    mediasilo: {
      linkHelp: "MediaSilo PRO: cole o link público de revisão (app.mediasilo.com/review/…).",
      shareTitle: "Vídeos do MediaSilo",
      selectAll: "Selecionar todos",
      clearSelection: "Limpar seleção",
      selectedCount: "{{selected}} de {{total}} selecionados",
      truncated: "Mostrando apenas os primeiros 200 vídeos desta revisão.",
      tooLong: "Mais longo que o limite do seu plano",
      portrait: "Vertical",
      landscape: "Horizontal",
      noSelection: "Selecione pelo menos um vídeo do MediaSilo.",
      creatingProgress: "Criando {{current}} de {{total}}…",
      summaryAllCreated_one: "{{count}} vídeo importado do MediaSilo",
      summaryAllCreated_other: "{{count}} vídeos importados do MediaSilo",
      summaryPartial: "{{created}} importados, {{failed}} com erro",
      summaryStopped: "Importação interrompida: limite do plano atingido.",
      summaryStoppedPro: "Importação interrompida: a importação do MediaSilo requer PRO.",
      failedListTitle: "Não foi possível importar:",
      errors: {
        proRequired: "A importação do MediaSilo requer PRO. Faça o upgrade do plano para continuar.",
        unsupportedLink: "Cole um link público de revisão do MediaSilo (app.mediasilo.com/review/…).",
        privateOrExpired: "Esta revisão do MediaSilo é privada, protegida por senha ou expirou.",
        notFound: "Não encontramos esta revisão do MediaSilo. Verifique o link.",
        noVideos: "Não há vídeos neste link do MediaSilo.",
        notReady: "Este vídeo ainda está sendo processado pelo MediaSilo. Tente novamente em instantes.",
        unavailable: "Não foi possível acessar o MediaSilo agora. Tente novamente em instantes.",
        downloadFailed: "Não foi possível importar o vídeo do MediaSilo. Tente novamente.",
      },
    },

    // Library page
    library: {
      title: "Acervo de Conteúdo",
      titleViewOnly: "Acervo de Conteúdo",
      subtitle: "Adicione vídeos ao acervo e navegue por conteúdo curado de todos os usuários.",
      subtitleViewOnly: "Navegue por vídeos curados do acervo.",
      pasteVideoUrl: "Cole o link do seu vídeo aqui",
      addToLibrary: "Adicionar ao acervo",
      heroTitle: "Transforme um vídeo seu",
      heroTitleAccent: "em cortes prontos para publicar",
      heroSubtitle: "Cole o link de um vídeo, podcast, aula ou live e deixe a IA fazer o seu trabalho por você",
      urlPlaceholder: "Cole o link do vídeo aqui",
      generateFirstClip: "Gerar meu primeiro corte",
      generateClips: "Gerar cortes",
      uploadFile: "Enviar um arquivo",
      uploadFileShort: "Arquivo",
      sources: {
        youtube: "YouTube",
        instagram: "Instagram",
        twitch: "Twitch",
        googleDrive: "Google Drive",
        dropbox: "Dropbox",
        frameio: "Frame.io",
        mediasilo: "MediaSilo",
      },
      unsupportedSource: "Link não suportado",
      unsupportedSourceDescription: "Use YouTube, Instagram, Twitch, Google Drive, um link público de vídeo do Dropbox, do Frame.io ou do MediaSilo, ou envie um arquivo.",
      urlRequired: "Cole o link do vídeo",
      urlRequiredDescription: "Adicione o link do vídeo para gerar cortes.",
      steps: {
        addVideo: {
          title: "Adicione seu vídeo",
          description: "cole o link ou envie o arquivo",
        },
        aiSelects: {
          title: "A IA seleciona os melhores momentos",
          description: "Os trechos com mais potencial viram cortes",
        },
        export: {
          title: "Exporte e publique",
          description: "Revise, edite se quiser e publique",
        },
      },
      libraryItems: "Acervo",
      noItemsFound: "Nenhum item encontrado no acervo.",
      failedToLoad: "Falha ao carregar acervo.",
      loadingMore: "Carregando mais...",
      exploreCommunity: "Explorar Acervo da Comunidade",
      exploreCommunityDescription: "Podcasts e vídeos compartilhados pela comunidade The Clippers",
      exploreCommunityChannels: "{{count}} canais para remixar",
      openCollection: "Abrir acervo",
      emptyCommunityTab: "Você ainda não adicionou nenhum projeto da comunidade.",
      exploreCommunityButton: "Explorar Acervo da Comunidade",
      addYourVideo: "Adicionar seu vídeo",
      addYourVideoDescription: "Cole um link do YouTube do seu vídeo",
      videoLink: "Link do vídeo",
      or: "ou",
      selectFile: "Selecionar arquivo",
      fileFormats: "Formatos: MKV, AVI ou MP4 • Até 3GB",
      createClips: "Criar cortes",
      projectHistory: "Histórico de projetos",
      expiredGroup_one: "{{count}} vídeo expirado",
      expiredGroup_other: "{{count}} vídeos expirados",
      createdByMe: "Criados por mim",
      community: "Comunidade (colab)",
      originUploaded: "Enviado",
      originCommunity: "Comunidade",
      copyToMyAccount: "Copiar para minha conta",
      generateAIClips: "Gerar cortes com IA",
      copyDialogTitle: "Copiar para minha conta",
      copyDialogDescription: "Escolha um prompt e um template para criar um novo item no acervo na sua conta a partir deste vídeo da comunidade.",
      copyConfirm: "Gerar Cortes",
      videoUnavailableForClips: "Este vídeo ainda não está disponível para gerar cortes. Tente novamente em instantes.",
      copying: "Criando...",
      copySuccess: "Item criado no acervo",
      copySuccessDescription: "O item foi adicionado ao seu acervo e será processado em breve.",
      copyError: "Falha ao criar item no acervo",
      copyErrorDescription: "Não foi possível criar este item no acervo agora. Tente novamente em instantes.",
      pastDueErrorTitle: "Pagamento da assinatura pendente",
      pastDueErrorDescription: "Regularize o pagamento da sua assinatura para criar itens no acervo.",
      pastDuePortalError: "Não foi possível abrir o portal de pagamento. Tente novamente em instantes.",
      payNow: "Pagar agora",
      curationLimitErrorTitle: "Limite mensal de curadorias atingido",
      curationLimitErrorDescription: "Você usou todas as curadorias com IA incluídas no seu plano este mês. Faça upgrade para continuar gerando cortes a partir do acervo da comunidade.",
      proOnlyFeature: "Apenas no plano Pro",
      upgradeToPro: "Fazer upgrade",
      searchPlaceholder: "Buscar por nome ou canal…",
      allTags: "Todos",
      communityAvailableTitle: "Vídeo já está no Acervo da Comunidade",
      communityAvailableDescription: "Este vídeo já está disponível no acervo da comunidade. Vá até lá para remixá-lo e gerar seus cortes com IA diretamente — sem precisar enviar novamente.",
      goToCommunityLibrary: "Remixar no Acervo da Comunidade",
      paidPlanRequired: "Faça upgrade para adicionar novos vídeos",
      paidPlanRequiredDescription: "Faça upgrade para um plano pago para enviar novos vídeos ao acervo. Você ainda pode gerar cortes a partir dos vídeos existentes na comunidade.",
      upgradePlan: "Atualizar Plano",
      tour: {
        welcome: "Bem-vindo ao seu Acervo! Aqui você pode gerenciar sua coleção pessoal de vídeos e explorar conteúdo da comunidade.",
        exploreCommunity: "Navegue por vídeos compartilhados pela comunidade The Clippers. Encontre podcasts e vídeos em alta para remixar com cortes de IA.",
        addVideo: "Cole um link do YouTube para adicionar seu próprio vídeo ao acervo e gerar cortes de IA a partir dele.",
        steps: "Cole o link, deixe a IA escolher os momentos e depois exporte e publique.",
        projectHistory: "Veja todos os seus projetos do acervo aqui. Alterne entre vídeos que você criou e os que copiou da comunidade.",
        tabs: "Use estas abas para filtrar entre suas próprias criações e remixes da comunidade.",
        helpButton: "Clique aqui para ver novamente o tour do acervo.",
      },
    },

    proDialog: {
      priceAnchor: 'PRO a partir de {{price}}/mês',
    },

    downloadUpsell: {
      title: 'Seu corte está pronto 🎉',
      body: 'Boa! Em um plano pago você continua sem os limites mensais — mais tempo de processamento, mais cortes e exportação em lote de uma vez só.',
      dismiss: 'Continuar cortando',
      upgrade: 'Ver planos',
    },

    quotaUpsell: {
      dismiss: 'Agora não',
      upgrade: 'Fazer upgrade',
      clip_exports: {
        title: 'Você atingiu o limite de clipes do mês',
        body: 'O plano gratuito inclui 5 clipes por mês. No plano pago você exporta sem esse teto e continua editando.',
      },
      processing_time: {
        title: 'Sem tempo de processamento suficiente',
        body: 'Este vídeo é maior do que o tempo que resta no seu plano. Um plano pago libera mais horas por mês.',
      },
      library_curation: {
        title: 'Limite mensal de curadorias',
        body: 'Você já usou as curadorias de IA incluídas neste mês. Faça upgrade para continuar gerando cortes do acervo.',
      },
      library_video_time: {
        title: 'Limite de tempo de vídeo do acervo',
        body: 'Este vídeo passa do tempo de acervo que resta no seu plano. Faça upgrade para enviar vídeos mais longos.',
      },
      library_exports: {
        title: 'Limite de exportações do acervo',
        body: 'Você já usou as exportações de clipes do acervo deste mês. Faça upgrade para continuar exportando.',
      },
      brand_kits: {
        title: 'Limite de Templates',
        body: 'Seu plano não permite mais Templates. Faça upgrade para salvar mais identidades visuais.',
      },
      paid_feature: {
        title: 'Recurso de plano pago',
        body: 'Upload de arquivo, Google Drive, Dropbox e envio de novos vídeos ao acervo fazem parte dos planos pagos. No gratuito você ainda usa links do YouTube.',
      },
    },

    copyLibrary: {
      processingMode: "Modo de processamento",
      copilot: "Copiloto",
      copilotDescription: "Mais controle sobre os clipes que você quer exportar.",
      automatic: "Automático",
      automaticDescription: "Mais fácil de gerar e exportar todos os clipes de uma vez.",
      unlockedForCampaign: "Desbloqueado para esta campanha",
    },

    // Community Library page
    communityLibrary: {
      receiveToClip: "Clip & Pix",
      ratePerThousand: "{{amount}} / 1.000 views",
      minViewsShort: "Mín. {{views}} views",
      noMinViews: "Sem mín. de views",
      prizePool: "Premiação: {{amount}}",
      seeCampaign: "Ver Campanha",
      viewCampaignShort: "Ver",
      subscribeProCta: "Assinar plano",
      // Short on purpose: the Acervo chip button is ~90px wide.
      selectedOnlyCta: "Só convidados",
      activeCampaignsSectionTitle: "Campanhas ativas",
      title: "Acervo da Comunidade",
      subtitle: "Podcasts e vídeos compartilhados pela comunidade The Clippers",
      liveWatch: {
        title: "Live sendo clipada",
        subtitle: "O Autoclipper está clipando esta live agora.",
        openLive: "Abrir live",
        badge: "Ao vivo",
        curate: "Curar",
        waitingForClips: "Os cortes aparecem após a primeira janela.",
      },
      freeAnalysis: "Escolha qualquer vídeo. A análise é gratuita.",
      joinWhatsAppCommunity: "Entrar na Comunidade no WhatsApp",
      joinTheClippers: "Entrar",
      theClippersCommunityLabel: "Comunidade oficial no WhatsApp",
      back: "Voltar",
      banner: "Conteúdos compartilhados pela comunidade para você gerar cortes com IA",
      trending: "Em alta",
      searchPlaceholder: "Buscar por podcast, criador ou tema...",
      pageTitle: "Acervo da Comunidade",
      smartSearchPlaceholder: "Buscar vídeos ou colar link do YouTube...",
      searchSubtitle: "Para criar um novo projeto, busque um vídeo do acervo ou adicione um novo colando um link do YouTube",
      teaserTitle: "Este acervo é para o modo clipador",
      teaserBody: "Estes vídeos existem para clipadores gerarem cortes de outros criadores. Troque para o modo clipador para usar esta página — você pode voltar quando quiser.",
      searchExample: "Ex de busca: Renato Cariani",
      urlExample: "Ex de link: youtube.com/watch?v=...",
      filterByChannel: "Filtrar por canal",
      searchChannels: "Buscar canais...",
      channelSortName: "Nome",
      channelSortRemixes: "Mais remixes",
      channelSortSubscribers: "Mais inscritos",
      seeMoreVideos: "Ver mais vídeos",
      clearFilters: "Limpar filtros",
      allChannels: "Todos",
      allTypes: "Todos os tipos",
      subscribers: "inscritos",
      viewChannel: "Ver canal",
      partnerBadge: "Parceiro",
      partnerChannelsTitle: "Canais Parceiros",
      watchOnYouTube: "Ver no YouTube",
      originalVideoDownload: {
        triggerLabel: "Baixar vídeo original",
        title: "Baixar vídeo original?",
        description: "Este arquivo é o vídeo original completo ({{sourceDuration}}).",
        descriptionWithoutDurations: "Este arquivo é o vídeo original completo.",
        cancel: "Cancelar",
        confirm: "Baixar vídeo original",
        proTitle: "Baixar o vídeo original é PRO",
        proBody: "No plano gratuito você pode gerar cortes a partir dos vídeos da comunidade. Faça upgrade para baixar o arquivo original.",
        proDismiss: "Agora não",
        proUpgrade: "Fazer upgrade",
      },
      uploadedBy: "Enviado por {{name}}",
      views: "visualizações",
      remixes_one: "remix",
      remixes_other: "remixes",
      remixes: "remixes",
      sortBy: "Ordenar por",
      languageFilter: "Idioma do vídeo",
      languageFilterShort: "Idioma",
      languageAll: "Todos os idiomas",
      languagePtBr: "Português",
      languageEnUs: "English",
      sortNewest: "Mais recentes",
      sortOldest: "Mais antigos",
      sortViews: "Mais visualizações",
      sortSubscribers: "Mais inscritos",
      sortRemixes: "Mais remixes",
      sortRemixesLabel: "Mais remixes — {{window}}",
      sortRemixesWindow24h: "Últimas 24 horas",
      sortRemixesWindow7d: "Últimos 7 dias",
      sortRemixesWindow30d: "Últimos 30 dias",
      sortRemixesWindow90d: "Últimos 90 dias",
      sortRemixesWindowAll: "Desde sempre",
      remixesInWindow24h: "({{count}} hoje)",
      remixesInWindow7d: "({{count}} esta semana)",
      remixesInWindow30d: "({{count}} este mês)",
      remixesInWindow90d: "({{count}} este trimestre)",
      campaignRow: {
        title: "Campanhas pagando agora",
        subtitle: "Toque numa campanha para ver os vídeos dela.",
        seeAll: "Ver todas",
        filterBy: "Filtrar vídeos pela campanha {{name}}",
        scrollLeft: "Campanhas anteriores",
        scrollRight: "Próximas campanhas",
        used: "Consumido",
      },
      categories: {
        "Film & Animation": "Filmes e Animação",
        "Autos & Vehicles": "Automóveis e Veículos",
        "Music": "Música",
        "Pets & Animals": "Animais de Estimação",
        "Sports": "Esportes",
        "Short Movies": "Curta-metragens",
        "Travel & Events": "Viagens e Eventos",
        "Gaming": "Jogos",
        "Videoblogging": "Videoblog",
        "People & Blogs": "Pessoas e Blogs",
        "Comedy": "Comédia",
        "Entertainment": "Entretenimento",
        "News & Politics": "Notícias e Política",
        "Howto & Style": "Instrução e Estilo",
        "Education": "Educação",
        "Science & Technology": "Ciência e Tecnologia",
        "Nonprofits & Activism": "Sem Fins Lucrativos e Ativismo",
      },
      tour: {
        welcome: "Bem-vindo ao Acervo da Comunidade! Descubra vídeos compartilhados pela comunidade The Clippers e gere cortes de IA a partir deles.",
        uploadCard: "Busque um vídeo já existente no acervo pelo tema, criador ou podcast, ou cole um link do YouTube para adicionar seu próprio vídeo diretamente ao acervo.",
        searchSort: "Busque por podcasts, criadores ou temas específicos, e ordene os resultados por mais recentes, visualizações, inscritos ou remixes.",
        channels: "Filtre vídeos por canal. Navegue pelos canais por categoria, busque canais específicos ou ordene por nome, remixes ou inscritos.",
        videoGrid: "Navegue pela coleção de vídeos aqui. Clique em qualquer vídeo para gerar cortes de IA a partir dele.",
        helpButton: "Clique aqui para ver novamente o tour do acervo da comunidade.",
      },
      metrics: {
        title: "Métricas de Engajamento da Comunidade",
        subtitle: "Os criadores, vídeos e templates que mais geram valor na comunidade",
        week: "Semana",
        month: "Mês",
        topCreator: "Top Creator da Semana",
        topVideos: "Top 3 vídeos mais utilizados da comunidade",
        topBrandKits: "Top 3 Templates mais aplicados da comunidade",
        disclaimer: "* Os valores exibidos são simulações para fins de gamificação e não representam valores reais.",
      },
    },

    // CPM Campaigns
    campaign: {
      socialImport: campaignSocialImportPt,
      cpmBadge: "Campanha CPM",
      aiGuidelines: {
        eyebrow: "DIRETRIZES DA CAMPANHA",
        title: "Uso de IA liberado nesta campanha",
        accessTitle: "Disponível para todos os planos",
        accessBadge: "ACESSO TOTAL",
        accessDescription: "Free, Starter, Plus e Pro+ podem utilizar a IA nesta campanha.",
        allPlans: "IA liberada para todos os planos",
        openCampaigns: "Somente em campanhas abertas",
        eligibleVideos: "Somente com vídeos elegíveis",
        explanation: "Nesta campanha, você pode usar a IA para gerar cortes automaticamente, sem custo adicional e independente do seu plano. O uso da IA é permitido apenas em campanhas abertas e exclusivamente com os vídeos elegíveis disponibilizados nesta página.",
        permittedTitle: "PERMITIDO:",
        permittedItem1: "Usar a IA para gerar cortes dos vídeos elegíveis da campanha",
        permittedItem2: "Utilizar a IA independentemente do plano (Free, Starter, Plus ou Pro+)",
        permittedItem3: "Criar conteúdos exclusivamente a partir dos vídeos elegíveis da campanha",
        forbiddenTitle: "NÃO PERMITIDO:",
        forbiddenItem1: "Usar a IA com vídeos de fora da campanha",
        forbiddenItem2: "Criar cortes com conteúdos não relacionados à campanha",
        forbiddenItem3: "Reaproveitar vídeos antigos que não estejam entre os vídeos elegíveis",
        importantPrefix: "Importante:",
        importantMessage: "somente os vídeos da seção “Vídeos Elegíveis” podem ser utilizados para gerar cortes com IA e são válidos para monetização.",
        dismissAll: "Não mostrar este aviso novamente",
        joinCta: "Entendi, participar da campanha",
        acknowledgeCta: "Entendi",
      },
      wallet: {
        title: "Saldo disponível para saque",
        statusPill: "Disponível para saque",
        requestButton: "Solicitar saque",
        minimumNotMet: "Saque mínimo: {{min}}",
      },
      multipleBadge: "{{count}} campanhas",
      earnPerThousand: "Ganhe {{amount}} por 1.000 visualizações",
      remainingBudget: "Orçamento restante: {{amount}}",
      statusAvailable: "Campanha disponível",
      ended: {
        title: "Campanha encerrada",
        deadline: "Encerrada em {{date}} (horário de Brasília).",
        submissionsClosed: "Esta campanha não aceita mais envios de clipes.",
        quotaNote: "A gratuidade desta campanha terminou. Para continuar sem descontar do seu plano, escolha vídeos das campanhas ativas.",
      },
      budgetConsumingFast: "Orçamento consumindo rápido",
      maxEarningsLabel: "Valor Total da Campanha",
      editingAssets: {
        title: "Arquivos para edição",
        hint: "Baixe estes arquivos para editar os vídeos da campanha fora da plataforma (logos, fontes, overlays, etc.).",
      },
      budgetRemainingLabel: "Orçamento Restante",
      unlimited: "Ilimitado",
      participateCta: "Participar da campanha",
      participateSubtext: "Ganhe por cada 1.000 visualizações",
      createViralClips: "Criar clipes virais",
      sendMyClips: "Enviar meus clipes",
      participateTagsReminder: "Lembre-se de incluir as marcações obrigatórias na legenda dos seus vídeos para que sejam contabilizados.",
      howItWorks: {
        title: "Como Funciona",
        subtitle: "Em 5 passos simples você já está ganhando",
        steps: {
          chooseVideo:  { title: "Escolha um vídeo",  description: "Navegue pelos vídeos elegíveis da campanha" },
          createClip:   { title: "Crie um corte",     description: "Gere um clipe viral com a IA da AutoClipper" },
          postOnSocial: { title: "Poste nas redes",   description: "Publique no TikTok, Instagram ou YouTube" },
          sendLink:     { title: "Envie o link",      description: "Cole aqui o link do seu vídeo publicado" },
          earnByViews:  { title: "Ganhe por views",   description: "Receba por cada 1.000 visualizações verificadas" },
        },
      },
      rateLabel: "Taxa CPM",
      per1kViews: "1k views",
      rateLabelHint: "Ganhe {{rate}} a cada 1.000 views no seu clipe",
      rateLabelHintPerPlatform: "Valor a cada 1.000 views. Cada rede paga o seu CPM, e o clipe ganha pela taxa da rede onde foi postado.",
      minViewsLabel: "Views mínimas para ganhar",
      minViewsHint: "Cada clipe precisa de pelo menos {{views}} visualizações para começar a ganhar. Depois disso, todas as views contam.",
      minViewsShort: "mín. {{count}}",
      minViewsPerClipSuffix: "views / clipe",
      noMinViews: "Sem mínimo",
      noMinViewsHint: "Não há mínimo de views: seu clipe ganha desde a primeira visualização.",
      accrualWindowNote: "As views contam para pagamento nas primeiras {{hours}} horas após o envio do seu clipe. As views continuam sendo contadas depois, mas não geram mais ganhos.",
      clipLimitLabel: "Ganho máximo por clipe",
      allowedNetworks: "Redes permitidas",
      budgetSectionTitle: "Orçamento da Campanha",
      budgetLow: "Orçamento acabando",
      budgetExhausted: "Orçamento esgotado",
      budgetExhaustedBanner: "O orçamento desta campanha acabou. Clipes aprovados não vão render até que mais verba seja adicionada.",
      budgetSpendDrift: "Contador de pagamento {{stored}} vs ganhos aprovados {{approved}}. {{amount}} está reservado e não pode ser pago até isso ser corrigido.",
      budgetSpendDriftBehind: "O contador de pagamento {{stored}} está atrás dos ganhos aprovados {{approved}}.",
      totalSpent: "Gasto total",
      remaining: "restantes",
      budget: {
        spent: "Pago",
        pending: "Em análise",
        remaining: "Disponível",
        pendingTooltip: "Em análise — pode descontar do orçamento se aprovado",
      },
      budgetGoal: "Meta de {{amount}}",
      loading: "Carregando…",
      notFound: "Campanha não encontrada",
      error: "Erro",
      requiredHashtags: "Hashtags obrigatórias",
      hashtagsCardTitle: "Marcações obrigatórias",
      hashtagsCardDescription: "Copie e utilize essas marcações na legenda dos seus vídeos",
      requiredMentionLabel: "Menção obrigatória: {{mention}}",
      minClipDurationLabel: "Duração mínima do clipe: {{duration}}. Clipes mais curtos são recusados no envio.",
      clipDuration: {
        value: "Duração: {{duration}}",
        unmeasured: "Duração não verificada",
        belowMinimum: "{{duration}}, abaixo do mínimo de {{min}}",
      },
      copyHashtags: "Copiar marcações",
      hashtagsCopied: "Marcações copiadas!",
      copyHashtagsTiktok: "Copiar marcações para TikTok",
      copyHashtagsInstagram: "Copiar marcações para Instagram",
      copyHashtagsYoutube: "Copiar marcações para YouTube",
      hashtagsCopiedTiktok: "Marcações do TikTok copiadas!",
      hashtagsCopiedInstagram: "Marcações do Instagram copiadas!",
      hashtagsCopiedYoutube: "Marcações do YouTube copiadas!",
      hashtagsAuditWarning: "Nossas ferramentas verificam automaticamente as marcações nos vídeos enviados. A ausência delas pode resultar em desclassificação.",
      followRequiredWarning: "É obrigatório seguir o perfil marcado para participar desta campanha.",
      captionExamplesTitle: "Exemplos de legenda",
      eligibleContent: "Conteúdo elegível",
      generateAiClips: "Gerar cortes com IA",
      clipQuotaExemption: "Os cortes deste vídeo não descontam do limite do seu plano",
      clipQuotaStandardUsage: "Novas curadorias e exportações usam os limites do seu plano",
      curatedRecommendation: "Aprovado para esta campanha",
      removeVideo: {
        trigger: "Remover da campanha",
        title: "Remover este vídeo da campanha?",
        description: "Ele deixa de aparecer nos vídeos elegíveis e de contar para a campanha. Dá para restaurar depois na edição da campanha.",
        confirm: "Remover",
        cancel: "Cancelar",
        errorTitle: "Não foi possível remover",
        error: "Não conseguimos remover o vídeo da campanha. Tente novamente.",
      },
      participatingVideos: {
        title: "Vídeos Elegíveis",
        available_one: "{{count}} Disponível",
        available_other: "{{count}} Disponíveis",
        showAll: "Ver todos os {{count}} vídeos da campanha",
        showLess: "Mostrar menos",
        empty: "Nenhum vídeo participante ainda.",
      },
      warningBanner: "Ei clipador, leia as regras atentamente antes de enviar seus vídeos. O não cumprimento pode resultar em desclassificação ou banimento.",
      warningPrefix: "Atenção:",
      titleBrand: "Campanha",
      titleHighlight: "CPM",
      subtitle: "Monetize seus clipes por visualizações",
      rules: {
        title: "Regulamento",
        readCarefully: "leia as regras atentamente antes de enviar seus clipes",
        allowed: "PODE",
        forbidden: "NÃO PODE",
        attention: "ATENÇÃO",
        warning: "AVISO",
        authorizedBadge: "AUTORIZADO",
        authorizedTitle: "O que você pode fazer nesta campanha",
        forbiddenBadge: "PROIBIDO",
        forbiddenTitle: "O que não é permitido",
        punishmentsBadge: "PUNIÇÕES",
        punishmentsTitle: "Consequências por descumprimento",
        layoutModelsBadge: "MODELOS",
        layoutModelsTitle: "Sugestão de layout para clipes manuais",
        layoutModels: {
          intro: "O vídeo obrigatório da campanha deve estar visível e legível no seu clipe. Se precisar de uma referência, confira os modelos abaixo — eles seguem as boas práticas de safe zone para redes sociais. Adapte ao seu estilo à vontade, desde que o vídeo da campanha apareça claramente.",
          safeZoneLabel: "ÁREA SEGURA",
          safeZoneCaption: "Área segura 9:16 — evite elementos fora da borda verde",
          model1Caption: "Modelo A — Split Lateral",
          model2Caption: "Modelo B — Split Vertical",
          model3Caption: "Modelo C — Split 50/50",
          hint: "Estes são apenas modelos de referência. Qualquer formato que mantenha o vídeo obrigatório visível e legível está dentro das regras.",
        },
      },
      status: {
        draft: "Rascunho",
        active: "Ativa",
        paused: "Pausada",
        ended: "Encerrada",
      },
      channels: {
        title: "Meus canais nesta campanha",
        empty: "Adicione os canais que você vai usar para publicar. Um admin vai revisar antes de você poder enviar vídeos.",
        add: "Solicitar aprovação do canal",
        cancel: "Cancelar solicitação",
        statusPending: "Aguardando revisão",
        statusApproved: "Aprovado",
        statusRejected: "Rejeitado",
        platformLabel: { youtube: "YouTube", instagram: "Instagram", tiktok: "TikTok", facebook: "Facebook" },
        invalidUrl: "Não conseguimos identificar essa URL de canal.",
        duplicate: "Você já tem uma solicitação para esse canal.",
        cannotDelete: "Você só pode cancelar uma solicitação enquanto ela está aguardando revisão.",
      },
      accountDisqualification: {
        title: "Contas desclassificadas nesta campanha",
        description: "Os clipes dessas contas não contam nesta campanha. Seus outros clipes e contas continuam valendo.",
        item: "{{account}} ({{platform}})",
        reason: "Motivo: {{reason}}",
      },
      submit: {
        title: "Enviar clipe",
        instruction: "Cole o link do post já publicado nas redes sociais com as marcações obrigatórias.",
        platform: "Plataforma",
        url: "URL do clipe",
        submit: "Enviar",
        success: "Clipe enviado! Aguarde aprovação.",
        successTitle: "Clipe enviado!",
        successDescription: "Recebemos seu clipe e ele está aguardando aprovação.",
        submitTooltip: "Aprovação em até 72h após o envio. Views contabilizadas por 72h após o envio do link para a campanha.",
        afterSubmitMessage: "Clipe recebido! A aprovação leva até 72h. As views elegíveis são contabilizadas durante as primeiras 72h após o envio do link para a campanha.",
        paymentFaqLink: "Dúvidas sobre pagamento?",
        duplicateError: "Esta URL já foi enviada para esta campanha.",
        viewSubmission: "Ver envio",
        unsupportedUrl: "URL não reconhecida. Use links do YouTube, Instagram ou TikTok.",
        channelRequired: "Você precisa de um canal aprovado no {{platform}} para esta campanha.",
        channelMismatch: "Esse vídeo é de um canal que ainda não foi aprovado para você.",
        connectionRequired: "Conecte a conta do {{platform}} proprietária desta publicação antes de enviá-la.",
        missingHashtags: "Hashtags ausentes: {{tokens}}.",
        missingMentions: "Menções ausentes: {{tokens}}.",
        clipTooShort: "Este clipe tem {{duration}} e a campanha exige no mínimo {{min}}. A duração não pode ser editada depois de publicada: publique um clipe mais longo e envie o novo link.",
        selectConnection: "Conta que publicou",
        errors: {
          cpm_required_caption_tokens_missing: "A legenda da publicação está sem marcações obrigatórias da campanha. Atualize a legenda e envie este link novamente.",
          cpm_clip_too_short: "Este clipe é mais curto que a duração mínima da campanha.",
          social_connection_required: "Conecte a conta social proprietária desta publicação.",
          social_media_not_owned: "Este vídeo não é de nenhuma conta que você vinculou. Vincule a conta do {{platform}} que publicou o vídeo e tente de novo.",
          social_connection_reconnect_required: "Reconecte esta conta social e tente novamente.",
          invalid_tiktok_video_url: "Use a URL completa do TikTok no formato tiktok.com/@usuario/video/id.",
          provider_unavailable: "Não foi possível verificar esta publicação agora. Tente novamente em instantes.",
          invalid_youtube_video_url: "Use uma URL completa do YouTube (watch, Shorts ou youtu.be).",
          invalid_instagram_media_url: "Use a URL completa da publicação ou Reel do Instagram.",
          channel_not_approved: "Esse vídeo é de um canal que ainda não foi aprovado para você.",
          platform_not_approved: "Você precisa de um canal aprovado nessa plataforma.",
          duplicate_submission: "Este vídeo já foi enviado para esta campanha.",
          cpm_account_disqualified: "A conta {{account}} foi desclassificada nesta campanha e não pode enviar clipes.",
          generic: "Falha ao enviar.",
          not_joined: "Entre na campanha antes de enviar clipes.",
        },
      },
      join: {
        title: "Participe desta campanha",
        description: "Entre na campanha para enviar seus clipes e começar a ganhar.",
        cta: "Entrar na campanha",
        joining: "Entrando...",
        successTitle: "Você entrou na campanha!",
        upgradeCta: "Faça upgrade para entrar em mais campanhas",
        freeLimitNote: "Plano gratuito: você pode participar de 1 campanha por vez. Faça upgrade para PRO para campanhas ilimitadas.",
        errors: {
          free_campaign_limit: "Você já está participando de uma campanha. Faça upgrade para PRO para participar de mais de uma campanha ao mesmo tempo.",
          invite_required: "Esta campanha é apenas por convite. Você precisa de um convite para entrar.",
        },
      },
      leave: {
        cta: "Sair da campanha",
        successTitle: "Você saiu da campanha.",
        successDescription: "Seus clipes aprovados continuam rendendo.",
        confirmTitle: "Sair desta campanha?",
        confirmDescription: "Você não poderá enviar novos clipes nem receberá avisos de novos vídeos desta campanha. Dá para entrar de novo enquanto ela estiver ativa.",
        pendingRejected_one: "Seu clipe em análise será reprovado.",
        pendingRejected_other: "Seus {{count}} clipes em análise serão reprovados.",
        approvedKept_one: "Seu clipe aprovado mantém o que já ganhou e continua rendendo com novas visualizações.",
        approvedKept_other: "Seus {{count}} clipes aprovados mantêm o que já ganharam e continuam rendendo com novas visualizações.",
        confirm: "Sair da campanha",
        cancel: "Continuar participando",
        errors: {
          generic: "Não foi possível tirar você da campanha. Tente de novo.",
        },
      },
      submission: {
        checkingDuplicate: "Verificando link",
      },
      terms: {
        title: "Termo de Adesão — Campanhas Remuneradas",
        versionLabel: "Versão {{version}}",
        download: "Baixar PDF",
        cancel: "Cancelar",
        accept: "Aceitar",
        accepting: "Salvando…",
        accepted: "Termo aceito",
        acceptCheckbox: "Li e concordo com o Termo de Adesão às Campanhas Remuneradas da AutoClipper",
        overlayTitle: "Aceite o Termo de Adesão",
        overlayBody: "Para enviar clipes nesta campanha, leia e aceite o Termo de Adesão das Campanhas Remuneradas da AutoClipper.",
        overlayCta: "Ler e Aceitar Termos",
        errorGeneric: "Falha ao registrar aceite. Tente novamente.",
      },
      submissions: {
        title: "Seus envios",
        empty: "Você ainda não enviou clipes para esta campanha.",
        url: "URL",
        platform: "Plataforma",
        views: "Visualizações",
        viewsCount: "{{count}} visualizações",
        earnings: "Ganhos",
        approval: "Aprovação",
        approvalStates: {
          pending: "Pendente",
          pendingTooltip: "Aguardando auditoria — aprovação em até 72h após a submissão",
          approved: "Aprovado",
          disapproved: "Reprovado",
          disqualified: "Desclassificado",
          pre_approved: "Pré-Aprovado",
          preApprovedTooltip: "Aprovação automática preliminar — a auditoria ainda vai revisar este clipe. Não é uma aprovação final.",
        },
        preApproval: {
          pendingAuditNote: "Pré-aprovação automática. A auditoria ainda vai revisar este clipe.",
          estimatedPayout: "Estimativa (sujeita a auditoria): {{amount}}",
        },
        synced: "Sincronizado",
        disqualified: "desclassificado",
        provisionalEarnings: "Meus ganhos provisórios",
        summary: {
          confirmed: "Ganhos confirmados",
          potential: "Ganhos potenciais",
          views: "Views contabilizadas",
          clips: "Clipes contabilizados",
        },
        calculatedAt: "Calculado com base na taxa de {{rate}} a cada 1.000 visualizações",
        calculatedAtPerPlatform: "Calculado com o CPM de cada rede, a cada 1.000 visualizações",
        customRate: "CPM personalizado: {{rate}}",
        clipLink: "Link do clipe",
        duplicateLinkTag: "Link duplicado",
        verdict: "Veredito",
        feedback: "Feedback",
        adminObservationLabel: "Observação do admin",
        feedbackCodes: {
          video_from_unapproved_channel: "Vídeo postado em um canal que não foi aprovado para esta campanha.",
          left_campaign: "Reprovado automaticamente porque você saiu da campanha.",
          missing_hashtag: "O clipe não inclui as hashtags obrigatórias da campanha.",
          off_brief: "O conteúdo do clipe está fora do briefing da campanha.",
          missing_watermark: "O clipe não inclui a marca d'água exigida pela campanha.",
          suspected_duplicate_resolved: "Esse clipe foi desclassificado desta campanha porque o mesmo link foi enviado duas vezes para a campanha. Se achar que foi engano, fale com a equipe Autoclipper.",
          missing_mention: "O clipe não inclui a menção obrigatória da campanha.",
          platform_not_allowed: "Essa plataforma não está entre as permitidas para esta campanha.",
        },
        captionTokens: {
          missing: "Faltou na legenda: {{tokens}}.",
          required: "A campanha exige nesta plataforma: {{tokens}}.",
          hint: "Maiúsculas e minúsculas não importam, mas cada marcação precisa estar completa, sem letras ou números colados logo depois dela.",
        },
        appeal: {
          contest: "Contestar",
          dialogTitle: "Contestar reprovação",
          dialogHint: "Explique por que este clipe deveria ser aprovado. A auditoria vai revisar seu argumento.",
          argumentLabel: "Seu argumento",
          extraUrlLabel: "Link extra (opcional)",
          photosLabel: "Fotos (opcional)",
          photosHint: "Adicione até {{max}} capturas ou fotos como evidência.",
          photosRemove: "Remover foto",
          photosInvalidType: "Use imagens JPEG, PNG ou WebP.",
          photosUploadFailed: "Não foi possível enviar uma das fotos. Tente de novo.",
          submit: "Enviar contestação",
          pendingBadge: "Em contestação",
          pendingCopy: "Sua contestação está em análise pela auditoria.",
          keptReplyLabel: "Resposta da auditoria",
          needsMoreCopy: "A auditoria manteve a reprovação e pediu informações adicionais.",
          sendMoreData: "Enviar dados adicionais",
          followUpTitle: "Enviar dados adicionais",
          followUpHint: "Envie um novo argumento e qualquer evidência extra pedida pela auditoria. Isso substitui o pacote anterior da contestação.",
          followUpSubmit: "Enviar dados adicionais",
          acceptedReplyLabel: "Observação da auditoria",
          errors: {
            campaign_not_active: "Esta campanha não está mais ativa para contestações.",
            not_disapproved: "Só é possível contestar clipes reprovados.",
            appeal_window_closed: "O prazo para contestar esta reprovação já encerrou.",
            appeal_already_exists: "Você já contestou esta reprovação.",
            left_campaign: "Clipes reprovados porque você saiu da campanha não podem ser contestados.",
            grouped_submission: "Este clipe faz parte de um grupo e não pode ser contestado individualmente.",
            disqualified_submission: "Clipes desclassificados não podem ser contestados.",
            not_owner: "Você só pode contestar os seus próprios envios.",
            argument_required: "Escreva um argumento para enviar a contestação.",
            invalid_extra_url: "Informe um link válido ou deixe o campo em branco.",
            invalid_evidence_image_urls: "Um ou mais links de foto são inválidos. Envie de novo e tente outra vez.",
            too_many_evidence_images: "Você pode anexar no máximo 5 fotos.",
            appeal_not_awaiting_response: "Esta contestação não está aguardando dados adicionais.",
            generic: "Não foi possível enviar a contestação. Tente novamente.",
          },
        },
        disqualifiedGenericReason: "Esse clipe foi desclassificado desta campanha. Isso costuma acontecer quando o mesmo clipe já foi enviado antes. Se achar que foi engano, fale com a equipe Autoclipper.",
        underReviewReason: "Estamos confirmando se esse link já foi enviado antes para esta campanha. Isso não afeta a aprovação do seu clipe — só pode levar um pouco mais de tempo.",
        metricsErrors: {
          instagram_insights_permission_denied: "O Instagram não compartilhou as visualizações oficiais deste reel. Reconecte a conta em Configurações e confirme se o Insights está disponível para este post.",
          instagram_media_unavailable: "O Instagram não reconhece mais este post na conta conectada. Reconecte a conta que publicou este reel, ou envie um novo link.",
          facebook_insights_permission_denied: "O Facebook não permitiu ler as métricas deste reel. Reconecte a Página e conceda todas as permissões.",
          facebook_media_unavailable: "Este reel não está mais disponível no Facebook.",
          social_connection_reconnect_required: "Reconecte esta conta do Instagram em Configurações para lermos as visualizações oficiais.",
          unofficial_metrics_source: "Este clipe precisa de visualizações oficiais do Instagram. Reconecte a conta e envie de novo se precisar.",
          official_media_identity_mismatch: "Este clipe não corresponde mais à conta do Instagram conectada. Reconecte a conta que publicou o reel, ou envie um novo link.",
          official_metrics_failed: "Ainda não conseguimos ler as visualizações oficiais deste clipe. Se continuar, reconecte a conta.",
        },
        earningsProgress: "Ganhos / Progresso até teto",
        potentialLabel: "Estimado",
        potentialTooltip: "Estimativa com base nas visualizações atuais. O valor só entra na carteira depois da aprovação.",
        viewsRemainingToEarn: "Faltam {{count}} visualizações para começar a ganhar (mín. {{threshold}})",
        missedThresholdInWindow: "Não atingiu {{threshold}} views nas primeiras {{hours}}h, então este clipe não rendeu.",
        budgetExhaustedApprovedWarning: "Orçamento esgotado. Este clipe já tem views suficientes, mas não há verba restante para pagá-lo.",
        viewsUntilMin: "Faltam {{count}} views (mín. {{threshold}})",
        meetsMinViews: "Mín. {{threshold}} views para ganhar",
        clipsCount_one: "{{count}} clipe",
        clipsCount_other: "{{count}} clipes",
        progress: "Progresso",
        status: "Status",
        submittedAt: "Enviado em",
        limitReached: "Limite atingido",
        remainingToLimit: "Faltam {{amount}} para o limite",
        accrualWindowClosed: "Views após {{hours}}h não pagam",
        budgetExhaustedPendingWarning: "Orçamento esgotado. Este clipe está em análise, mas não há verba reservada para ele.",
        maxEarnReached: "Ganho máximo de {{amount}} atingido",
        disclaimer: "Os valores acima são estimativas baseadas nos dados coletados. O pagamento será realizado ao final da campanha, sujeito à verificação de autenticidade das visualizações.",
        hideDisapproved_one: "Ocultar reprovado ({{count}})",
        hideDisapproved_other: "Ocultar reprovados ({{count}})",
        showDisapproved_one: "Mostrar reprovado ({{count}})",
        showDisapproved_other: "Mostrar reprovados ({{count}})",
        allDisapprovedHidden: "Todos os seus clipes enviados foram reprovados nesta campanha.",
      },
      calculator: {
        title: "Calculadora de ganhos",
        numberOfClips: "Número de clipes",
        viewsPerClip: "Visualizações por clipe",
        perClip: "Por clipe",
        totalViews: "Total de visualizações",
        estimatedEarnings: "Ganhos estimados",
        belowMinimumPayout: "Abaixo do pagamento mínimo por clipador ({{amount}}).",
        belowMinimumViews: "Cada clipe precisa de pelo menos {{count}} visualizações para contar.",
      },
    },

    campaignAudit: {
      report: {
        download: "Baixar relatório PDF",
        analyzing: "Analisando resultados com IA…",
        collecting: "Buscando dados…",
        progress: "Carregando {{loaded}}/{{total}} envios…",
        rendering: "Gerando PDF…",
        scope: "Relatório completo da campanha em português, com os dados mais recentes disponíveis.",
        errorTitle: "Não foi possível gerar o relatório",
        retry: "Tentar novamente",
        errors: {
          ai_unavailable: "A análise por IA está temporariamente indisponível. Tente novamente mais tarde.",
          ai_busy: "A análise por IA está ocupada. Aguarde um momento e tente novamente.",
          ai_failed: "Não foi possível analisar os resultados com IA. Tente gerar o relatório novamente.",
          load: "Não foi possível consultar todos os dados da campanha. Verifique sua conexão e seu acesso e tente novamente.",
          invalid: "Alguns dados da campanha precisam ser verificados antes de gerar o relatório. Tente novamente ou entre em contato com o suporte.",
          inconsistent: "Os registros da campanha mudaram durante a consulta ou os totais ainda não conferem. Aguarde um momento e tente novamente.",
          pdf: "Não foi possível gerar o arquivo PDF. Tente novamente.",
        },
      },

      title: "Auditoria de Campanhas",
      subtitle: "Gerencie e audite os clipes enviados nas suas campanhas.",
      empty: "Você ainda não é auditor em nenhuma campanha.",
      loading: "Carregando…",
      pendingAppeals: "{{value}} contestando",
      reviewAction: "Revisar envios",
      startsAt: "Começa em {{date}}",
      pendingClips_one: "{{value}} clipe pendente",
      pendingClips_other: "{{value}} clipes pendentes",
      allReviewed: "Tudo auditado",
      noSubmissions: "Nenhum clipe enviado",
      approvedClips_one: "{{value}} aprovado",
      approvedClips_other: "{{value}} aprovados",
      disapprovedClips_one: "{{value}} reprovado",
      disapprovedClips_other: "{{value}} reprovados",
      pendingChannelRequests_one: "{{value}} pedido de canal",
      pendingChannelRequests_other: "{{value}} pedidos de canal",
      searchPlaceholder: "Buscar campanha ou canal…",
      clearSearch: "Limpar busca",
      found_one: "{{count}} campanha encontrada",
      found_other: "{{count}} campanhas encontradas",
      noMatchTitle: "Nenhuma campanha encontrada",
      noMatchBody: "Tente outro status ou outro termo de busca.",
      tabs: {
        all: "Todas",
        active: "Ativas",
        paused: "Pausadas",
        scheduled: "Agendadas",
        draft: "Rascunhos",
        ended: "Finalizadas",
      },
      kpis: {
        pendingClips: "Clipes pendentes",
        pendingClipsHint: "aguardando revisão",
        pendingAppeals: "Contestações",
        pendingAppealsHint: "aguardando resposta",
        pendingChannelRequests: "Pedidos de canal",
        pendingChannelRequestsHint: "aguardando aprovação",
        activeCampaigns: "Campanhas ativas",
        activeCampaignsHint: "de {{total}} · {{scheduled}} agendadas · {{draft}} rascunhos",
      },
      viewsChart: {
        title: "Views dos envios ao longo do tempo",
        empty: "Ainda não há dados de views para esta campanha.",
        yLabel: "Views",
      },
      status: {
        draft: "Rascunho",
        scheduled: "Agendada",
        active: "Em andamento",
        paused: "Pausada",
        ended: "Finalizada",
      },
    },

    // Delete Library
    deleteLibrary: {
      success: "Item do acervo removido",
      successDescription: "O item do acervo foi removido com sucesso.",
      error: "Erro",
      errorDescription: "Falha ao remover item do acervo. Tente novamente.",
    },

    // Upload Modal
    uploadModal: {
      chooseAudioTrack: "Escolha uma faixa de áudio",
      audioTrack: "Faixa de áudio",
      audioLanguage: "Idioma do áudio",
      subtitleLanguage: "Idioma das legendas",
      trackOriginalSuffix: "original",
      trackAutoDubSuffix: "dublagem automática",
      trackUnsupported: "não suportado",
      subtitleProHint: "Legendas em outro idioma são um recurso PRO.",
      audioLookupPending: "Verificando as faixas de áudio do vídeo...",
      title: "Criar Novo Projeto",
      projectName: "Nome do Projeto",
      projectNamePlaceholder: "Digite o nome do projeto...",
      videoFormat: "Duração dos vídeos",
      selectFormat: "Selecione o formato",
      shortMax30Sec: "Short Max. 30s.",
      shortMax1Min: "Short Max. 1min.",
      automatic: "Automático",
      videoLanguage: "Idioma do vídeo",
      selectLanguage: "Selecione o idioma",
      portuguese: "Português",
      english: "Inglês",
      spanish: "Espanhol",
      removeSilence: "Retirar silêncio",
      removeSilenceDescription: "Remove automaticamente pausas e trechos sem áudio dos clipes gerados, deixando o resultado mais dinâmico.",
      brandKit: "Template (Opcional)",
      loadingBrandKits: "Carregando templates...",
      selectBrandKit: "Selecione um template (opcional)",
      noBrandKit: "Nenhum template",
      myBrandKits: "Meus Templates",
      publicBrandKits: "Templates Públicos",
      default: "Padrão",
      brandKitProTip: "💡 Aplicar automaticamente o estilo visual do template selecionado aos clipes gerados.",
      brandKitProOnly: "🔒 Atualize para o plano PRO para usar templates personalizados.",
      createFirstBrandKit: "Crie seu primeiro Template",
      brandKitDescription: "Personalize seus vídeos com cores, logos e fontes da sua marca. Templates garantem consistência visual em todos os seus clipes.",
      createBrandKit: "Criar Template",
      whatYouLookingFor: "O que você procura no vídeo",
      viralClips: "Clipes virais",
      viralClipsDesc: "Faça clipes com as partes mais envolventes e de alto impacto do vídeo.",
      memorableQuotes: "Frases memoráveis",
      memorableQuotesDesc: "Gere um clipe com as citações mais memoráveis.",
      topicClips: "Clipes de tópicos",
      topicClipsDesc: "Gere vários clipes com base nos principais tópicos abordados.",
      productAds: "Anúncios de produtos",
      productAdsDesc: "Crie anúncios em vídeo para meu produto ou serviço.",
      testimonials: "Depoimentos",
      testimonialsDesc: "Extraia depoimentos e casos de sucesso do vídeo.",
      other: "Outro",
      otherDesc: "Especifique a tarefa que deseja executar com o vídeo.",
      describeWhatYouLookFor: "Descreva o que você procura no vídeo",
      customPromptPlaceholder: "Por exemplo: 'Extraia momentos engraçados', 'Encontre partes sobre marketing digital', 'Crie clipes com dicas práticas'...",
      customPromptTip: "💡 Seja específico sobre o que você quer extrair do vídeo para obter melhores resultados.",
      videoExtension: "Extensão do vídeo para processamento",
      selectExtension: "Selecione a extensão",
      fullVideo: "Vídeo inteiro",
      videoSegment: "Trecho do Vídeo",
      selectVideoSegment: "Selecionar Trecho do Vídeo",
      startTime: "Tempo de Início (HH:mm:ss)",
      endTime: "Tempo de Fim (HH:mm:ss)",
      typeOnlyNumbers: "Digite apenas números (ex: 123456 = 12:34:56)",
      useCaptureButtons: "💡 Use os botões para capturar o tempo atual do vídeo, ou digite apenas números no formato HH:mm:ss",
      processingTime: "Tempo de Processamento",
      clipsCreated: "Clipes Criados",
      videoWillConsume: "Este vídeo irá consumir:",
      processingOnlySegment: "(Processando apenas o trecho selecionado:",
      insufficientTime: "Tempo insuficiente: este projeto requer {{required}} e você tem {{available}} disponíveis neste mês.",
      considerUpgrading: "Considere atualizar seu plano para ter mais tempo de processamento.",
      upgradePlan: "Atualizar Plano",
      errorCreatingProject: "⚠️ Erro ao criar projeto:",
      cancelButton: "Cancelar",
      waitingUpload: "Aguardando upload...",
      creating: "Criando...",
      createProject: "Criar Projeto",
      uploadInProgress: "Upload em progresso",
      waitForUpload: "Aguarde o upload terminar antes de criar o projeto.",
      cannotCreateYet: "Complete os dados antes de criar",
      projectNameRequired: "Informe um nome para o projeto.",
      customPromptRequired: "Descreva o que você quer extrair do vídeo.",
      internalError: "Erro interno",
      videoUrlNotProcessed: "URL do vídeo ainda não foi processada. Aguarde um momento.",
      projectCreatedSuccess: "Projeto criado com sucesso! 🎉",
      projectAddedToList: "\"{{name}}\" foi adicionado à sua lista de projetos.",
      browserNotSupportVideo: "Seu navegador não suporta o elemento de vídeo.",
      browserNotSupportAudio: "Seu navegador não suporta o elemento de áudio.",
      videoAudio: "Áudio do Vídeo",
      previewLowRes: "Preview exibido em baixa resolução para maior agilidade no carregamento. O processamento será feito na qualidade original do vídeo.",
      uploadingFile: "Enviando arquivo...",
      progress: "Progresso:",
      transferred: "Transferido:",
      speed: "Velocidade:",
      remainingTime: "Tempo restante:",
      uploadComplete: "Upload concluído com sucesso!",
      sectionVideo: "O vídeo",
      sectionHowToCut: "Como cortar",
      sectionBranding: "Identidade visual",
      invalidTimeFormat: "Formato de tempo inválido. Use HH:mm:ss",
      startMustBeLessThanEnd: "O tempo de início deve ser menor que o tempo de fim",
      segmentMustBeOver10Min: "O trecho selecionado deve ter mais de 10 minutos",
      endTimeExceedsDuration: "O tempo de fim não pode ser maior que a duração do vídeo",
      videoPreview: "Preview do Vídeo",
      video: "Vídeo",
      platform: "Plataforma",
      yourVideoWillAppearHere: "Seu vídeo aparecerá aqui",
      insufficientProcessingTime: "Tempo de processamento insuficiente",
      projectRequiresTime: "Este projeto requer {{required}} e você tem {{available}} disponíveis no mês.",
      videoTags: "Tags do Vídeo",
      videoTagsDescription: "Essas tags serão aplicadas automaticamente ao seu acervo.",
      channel: "Canal",
    },

    // Clips page
    clips: {
      title: "Clipes Exportados",
      noClipsFound: "Nenhum clipe encontrado.",
      failedToLoadClips: "Falha ao carregar clipes.",
      loadingMore: "Carregando mais...",
      tour: {
        welcome: "Bem-vindo à página de Clipes Exportados! Aqui você encontra todos os vídeos que foram exportados e estão prontos para uso.",
        clipsGrid: "Seus clipes exportados aparecem aqui. Clique em um clipe para fazer download, editar ou gerenciar o vídeo.",
        helpButton: "Clique aqui para ver novamente o tour da página de clipes.",
      },
    },

    // Clip Card
    clipCard: {
      noName: "Sem nome",
      estimate: "Estimativa:",
      clipThumbnail: "Thumbnail do clipe",
      downloading: "Baixando...",
      titleGenerator: "Gerador de Títulos",
      editVideo: "Editar vídeo",
      downloadVideo: "Baixar vídeo",
      videoPreview: "Pré-visualização do vídeo",
      browserNotSupportVideo: "Seu navegador não suporta a reprodução de vídeos.",
      videoNotEdited: "Vídeo Não Editado",
      videoNotEditedDesc: "Este clipe ainda não foi editado. O vídeo baixado será apenas o corte bruto do projeto original.",
      addSubtitlesDesc: "Se você deseja adicionar legendas e outras modificações, edite o vídeo antes de fazer o download.",
      editVideoButton: "Editar Vídeo",
      downloadAnyway: "Baixar Mesmo Assim",
      downloadFailedTitle: "Falha no Download",
      downloadFailedDesc: "Não conseguimos baixar o vídeo automaticamente. Tente novamente.",
      openInNewTab: "Abrir em Nova Aba",
      download: "Baixar",
      downloadingProgress: "Baixando, {{progress}}%",
      edit: "Editar",
      moreActions: "Mais ações",
      play: "Assistir: {{name}}",
      generateTitles: "Gerar títulos",
      like: "Gostei",
      dislike: "Não gostei",
    },
    clipCover: {
      action: 'Thumbnail',
      title: 'Thumbnail do corte',
      description: 'Crie uma imagem de capa e baixe para enviar ao YouTube.',
      empty: 'Este corte ainda não tem thumbnail.',
      frameSource: 'Frame do vídeo',
      frame: {
        title: 'Escolha o frame',
        use: 'Usar este frame',
        back: 'Voltar',
        scrubber: 'Posição no vídeo',
        prev: 'Frame anterior',
        next: 'Próximo frame',
        previewAlt: 'Frame do vídeo',
        unavailable: 'Não foi possível abrir o vídeo. Use uma imagem ou gere com IA.',
      },
      download: 'Baixar',
      downloading: 'Baixando...',
      downloadError: 'Não foi possível baixar a thumbnail. Tente novamente.',
      saving: 'Salvando...',
      saveError: 'Não foi possível salvar a thumbnail. Tente novamente.',
      fileSuffix: 'capa',
      reExportHint: 'O vídeo já renderizado não muda. Se exportar de novo, a thumbnail vira o primeiro frame.',
      ai: {
        useReference: 'Usar um frame do corte como referência',
        renderedReference: 'Arraste para escolher o momento do corte usado como referência.',
      },
    },

    projectPreview: {
      playbackErrorTitle: "Não foi possível reproduzir este preview",
      playbackErrorDescription: "O navegador teve um problema com o áudio do vídeo. Tente novamente sem som para continuar editando.",
      retryMuted: "Tentar novamente sem som",
      loading: "Carregando preview",
    },

    // Pricing Plans
    pricing: {
      title: "Escolha seu Plano",
      subtitle: "Desbloqueie todo o potencial do AutoClipper com nossos planos profissionais",
      failedToLoadPlans: "Falha ao carregar planos.",
      monthly: "Mensal",
      yearly: "Anual",
      saveUpTo: "Economize até {{percent}}%",
      loadingPlans: "Carregando planos...",
      currentPlan: "Plano Atual",
      mostPopular: "Mais Popular",
      walletDiscount: "{{percent}}% OFF com saldo da carteira · {{price}}",
      selectPlan: "Selecionar Plano",
      selectYearlyPlan: "Selecionar Plano Anual",
      processingMinutes: "{{minutes}} minutos de processamento",
      processingHours: "{{hours}} horas de processamento",
      processingHoursMinutes: "{{hours}}h {{minutes}}m de processamento",
      processingTime: "{{time}} de processamento",
      clipsPerMonth: "{{clips}} cortes exportados por mês",
      unlimitedClips: "Cortes ilimitados por mês",
      projectsKeptDays: "Projetos e Clipes mantidos por {{days}} dias",
      projectsKeptDaysTooltip: "Precisa manter seus projetos por mais tempo? Entre em contato e podemos estender o período de retenção.",
      withWatermark: "Com marca d'água",
      lowerPriorityRendering: "Renderização e curadoria com menor prioridade",
      lowerPriorityRenderingTooltip: "Vídeos do plano gratuito são processados após os vídeos de planos pagos, podendo demorar mais para ficarem prontos.",
      priorityRendering: "Renderização e curadoria prioritária",
      priorityRenderingTooltip: "Vídeos de planos pagos são processados primeiro, então seus clipes ficam prontos mais rápido.",
      free: "Grátis",
      comingSoon: "Em breve",
      haveQuestions: "Tem dúvidas?",
      contactSupport: "Entre em contato",
      customPlanMessage: "com nosso suporte para um plano personalizado.",
      clippers: {
        title: "Planos Exclusivos para Clipadores",
        subtitle1: "Desbloqueie todo o seu potencial com o Acervo Compartilhado da comunidade",
        subtitle2: "The Clippers",
        cutsPerMonth: "cortes/mês",
        perCut: "por corte",
        perMonthShort: "mês",
        hoursForNewVideos: "{{hours}} horas para vídeos novos",
        hoursMinutesForNewVideos: "{{hours}}h {{minutes}}m para vídeos novos",
        timeForNewVideos: "{{time}} para vídeos novos",
        exclusive: "EXCLUSIVO",
        subscribeNow: "Assinar agora",
        mostPopular: "MAIS POPULAR",
        explorePlans: "Explorar planos",
        close: "Fechar",
      },
      plans: {
        enterprise: {
          description: "Soluções personalizadas para grandes equipes e agências com necessidades específicas",
          price: "Sob Consulta",
          priceSubtitle: "Plano personalizado para sua empresa",
          features: [
            "Processamento ilimitado",
            "Usuários e projetos ilimitados",
            "API dedicada e integrações personalizadas",
            "SLA garantido e suporte prioritário 24/7",
            "Gerente de conta dedicado",
            "Onboarding e treinamento personalizado",
          ],
        },
      },
    },

    // Plan Checkout
    checkout: {
      backToPlans: "Voltar aos planos",
      planSummary: "Resumo do Plano",
      total: "Total",
      annualTotal: "Total anual:",
      save: "Economize {{percent}}%",
      discountCode: "Código de Desconto",
      enterCouponCode: "Digite o código do cupom",
      validating: "Validando...",
      couponApplied: "Cupom {{code}} aplicado",
      discount: "{{percent}}% de desconto",
      discountForever: "para sempre",
      discountForMonths: "por {{cycles}} mês",
      discountForMonths_plural: "por {{cycles}} meses",
      discountForYears: "por {{cycles}} ano",
      discountForYears_plural: "por {{cycles}} anos",
      subtotal: "Subtotal:",
      discountAmount: "Desconto:",
      featuresIncluded: "Recursos incluídos:",
      paymentMethod: "Método de Pagamento",
      creditCard: "Cartão de Crédito",
      bankSlip: "Boleto Bancário",
      pix: "PIX",
      whatsapp: "WhatsApp",
      phoneCountry: "Código de chamada do país",
      searchCountry: "Buscar país...",
      noCountryFound: "Nenhum país encontrado.",
      whatsappPlaceholder: "Digite seu número de WhatsApp",
      documentType: "Tipo de Documento",
      cpf: "CPF",
      cnpj: "CNPJ",
      awaitingPayment: "Aguardando pagamento",
      scanQrCode: "Escaneie o QR Code abaixo para realizar o pagamento via PIX",
      expiresIn: "Expira em {{time}}",
      expired: "Expirado",
      orCopyPixCode: "Ou copie o código PIX:",
      paymentAutoConfirm: "O pagamento será confirmado automaticamente após a transação ser processada.",
      generateNewQrCode: "Gerar novo QR Code",
      finalizePayment: "Finalizar Pagamento",
      processing: "Processando...",
      simulatePurchase: "Simular Compra",
      loadingPlan: "Carregando plano...",
      planNotFound: "Plano não encontrado",
      couponRequired: "Cupom obrigatório",
      enterCouponCodeRequired: "Por favor, insira um código de cupom.",
      couponInvalid: "Cupom inválido",
      couponNotValidForPlan: "O cupom não é válido para este plano.",
      couponValidationError: "Erro ao validar cupom",
      couponValidationErrorDesc: "Ocorreu um erro ao validar o cupom. Tente novamente.",
      pixCodeCopied: "Código PIX copiado!",
      pixCodeCopiedDesc: "O código foi copiado para sua área de transferência.",
      pixCopyError: "Erro ao copiar",
      pixCopyErrorDesc: "Não foi possível copiar o código. Tente novamente.",
      qrCodeGenerated: "QR Code gerado",
      qrCodeGeneratedDesc: "Escaneie o QR Code para realizar o pagamento.",
      qrCodeExpired: "QR Code expirado",
      qrCodeExpiredDesc: "O código PIX expirou. Gere um novo para continuar.",
      paymentConfirmed: "Pagamento confirmado!",
      paymentConfirmedDesc: "Seu pagamento foi processado com sucesso.",
      paymentNotProcessed: "Pagamento não processado",
      paymentNotProcessedDesc: "O pagamento não foi concluído. Tente novamente.",
      requiredField: "Campo obrigatório",
      fillDocumentField: "Por favor, preencha o campo de documento.",
      invalidDocument: "Documento inválido",
      invalidDocumentDesc: "Por favor, insira um {{type}} válido.",
      invalidPhoneDesc: "Por favor, insira um celular válido para o país selecionado.",
      pixError: "Erro ao gerar PIX",
      pixErrorDesc: "Ocorreu um erro ao gerar o código PIX. Tente novamente.",
      checkoutError: "Erro ao processar pagamento",
      checkoutErrorDesc: "Ocorreu um erro ao iniciar o checkout. Tente novamente.",
      apply: "Aplicar",
      remove: "Remover",
      walletPayButton: "Assinar com saldo",
      walletCouponNote: "Cupons reduzem o valor cobrado do saldo. Se o saldo cobrir 100%, não é preciso informar pagamento.",
      walletDiscountNote: "O desconto de {{percent}}% vale só sobre a parte paga com saldo.",
      walletDiscountAmount: "Desconto com saldo ({{percent}}%)",
      walletConfirmTitle: "Confirmar assinatura com saldo",
      walletPlanLabel: "Plano",
      walletBalanceApplied: "Saldo aplicado",
      walletFullCoverage: "Seu saldo cobre 100% do valor — nada mais a pagar.",
      walletRemainderVia: "Restante via {{method}}",
      walletHoldNote: "O saldo fica reservado e só é debitado quando o pagamento do restante for confirmado.",
      walletConfirmButton: "Confirmar",
      walletRedeemSuccess: "Assinatura ativada!",
      walletRedeemSuccessDesc: "Seu saldo foi usado para ativar o plano.",
      walletErrorBalanceTooLow: "Seu saldo disponível é insuficiente para iniciar o resgate.",
      walletErrorPayoutPending: "Você já tem um saque ou resgate em andamento. Aguarde ele concluir antes de iniciar outro.",
      walletErrorRemainderRequired: "Escolha como pagar o restante (cartão ou PIX).",
      walletErrorRenewalNotDue: "A renovação ainda não está disponível.",
      walletErrorNotEligible: "Este plano não pode ser renovado com saldo.",
    },

    // Wallet (CPM balance holds)
    wallet: {
      totalEarnedDescription: "Campanhas, afiliados e royalties de intensivos",
      producerBreakdown: "Royalties de intensivos: {{amount}}",
      viewCourseRoyalties: "Ver royalties de intensivos",
      viewCampaign: "Ver campanha",
      viewCampaignAria: "Ver campanha {{name}}",
      pendingHoldNotice: "Você tem um resgate com saldo aguardando o pagamento do restante — ele reserva seu saldo até concluir.",
      affiliateHoldBadge: "Em espera",
      affiliateHoldTitle: "Em espera (30 dias)",
      affiliateHoldProtection: "Proteção contra estornos",
      affiliateHoldDescription: "Este valor fica disponível automaticamente após o período de segurança.",
      cancelHoldButton: "Cancelar resgate pendente",
      cancelHoldConfirmTitle: "Cancelar resgate pendente?",
      cancelHoldConfirmDesc: "O pagamento do restante será invalidado (o QR/checkout deixa de funcionar) e o saldo reservado volta a ficar disponível. Nada será debitado.",
      cancelHoldConfirmButton: "Cancelar resgate",
      holdCancelledTitle: "Resgate cancelado",
      holdCancelledDesc: "Seu saldo foi liberado.",
      holdCancelErrorTitle: "Não foi possível cancelar",
      holdErrorAlreadyPaid: "O pagamento do restante já foi confirmado — o resgate será concluído em instantes.",
      holdErrorCancelFailed: "Não conseguimos invalidar a cobrança do restante agora. Tente novamente em alguns minutos.",
      holdErrorNothingPending: "Nenhum resgate pendente encontrado.",
      holdErrorWithdrawal: "Saques PIX pendentes são processados pela equipe e não podem ser cancelados por aqui.",
    },

    courseRoyalties: {
      title: "Royalties de intensivos",
      subtitle: "Seu extrato como coprodutor",
      loading: "Carregando royalties",
      dateUnavailable: "—",
      totals: {
        title: "Resumo dos royalties",
        accrued: "Total acumulado",
        pending: "Em espera",
        available: "Liberado (total)",
        reversed: "Revertido",
      },
      configurations: {
        title: "Seus acordos",
        rate: "{{rate}}% sobre cada venda paga",
        active: "Ativo",
        inactive: "Inativo",
      },
      earnings: {
        title: "Extrato de vendas",
        empty: "Nenhuma venda com royalty registrada ainda.",
        loadMore: "Carregar mais",
        loadingMore: "Carregando mais",
        loadMoreError: "Não foi possível carregar mais vendas. Tente novamente.",
      },
      columns: {
        course: "Intensivo",
        date: "Data da venda",
        releasesAt: "Liberação",
        gross: "Valor da venda",
        rate: "Sua participação",
        royalty: "Seu royalty",
        status: "Status",
      },
      status: {
        pending: "Em espera",
        available: "Liberado",
        reversed: "Revertido",
      },
      empty: {
        title: "Nenhum acordo de coprodução",
        description: "Seus acordos ativos aparecerão aqui.",
      },
      error: {
        title: "Não foi possível carregar seus royalties",
        description: "Tente novamente para atualizar o extrato.",
        retry: "Tentar novamente",
      },
    },

    // Purchase Complete
    purchaseComplete: {
      thankYou: "Obrigado pela sua compra!",
      paymentProcessed: "Seu pagamento foi processado com sucesso!",
      nowHaveAccess: "Você agora tem acesso a todos os recursos do seu plano. Comece a criar conteúdo incrível agora mesmo!",
      startCreating: "Começar a Criar",
      joinCommunity: "Entrar na Comunidade",
      readyToCreate: "🚀 Pronto para criar seus primeiros projetos?",
    },

    // Not Found
    notFound: {
      title: "Ops! Página não encontrada",
      description: "A página que você está procurando não existe ou foi movida. Que tal voltar ao início e explorar nossos recursos?",
      backToHome: "Voltar ao Início",
      previousPage: "Página Anterior",
      needHelp: "Precisa de ajuda? Entre em contato com nossa",
      whatsAppCommunity: "comunidade no WhatsApp",
    },

    facebookDataDeletion: {
      neutralTitle: "Exclusão de dados do Facebook",
      title: "Seu pedido de exclusão de dados do Facebook foi processado",
      body: "Desconectamos suas Páginas do Facebook do Autoclipper, descartamos os tokens de acesso delas e excluímos as análises e as descrições de reels que recebemos da Meta. Guarde este código de confirmação para seus registros:",
      missingCode: "Esta página confirma pedidos de exclusão de dados do Facebook. Abra o link que o Facebook te deu para ver o seu código de confirmação.",
    },

    legalPage: {
      toc: "Índice",
      updatedAt: "Atualizado em {{date}}",
      questionsTitle: "Dúvidas sobre este documento?",
      questionsBody: "Entre em contato conosco através do e-mail: <email>contato@autoclipper.live</email>.",
      seeAlso: "Veja também",
      logoAlt: "Autoclipper",
      skipToContent: "Pular para o conteúdo",
      terms: {
        title: "Termos de Uso",
        subtitle: "Autoclipper — plataforma de edição automática de vídeos",
      },
      privacy: {
        title: "Política de Privacidade",
        subtitle: "Autoclipper — plataforma de edição automática de vídeos",
      },
    },

    // Account Settings
    account: {
      title: "Minha Conta",
      editPhoto: "Editar Foto",
      fullName: "Nome Completo",
      jobTitle: "Cargo",
      changePassword: "Alterar Senha",
      setPassword: "Criar senha",
      setPasswordDescription: "Crie uma senha para entrar com e-mail além do Google.",
      currentPassword: "Senha Atual",
      newPassword: "Nova Senha",
      confirmNewPassword: "Confirmar Nova Senha",
      passwordMismatch: "As senhas não coincidem.",
      changing: "Alterando...",
      changePasswordButton: "Alterar Senha",
      setPasswordButton: "Criar senha",
      connectSocialMedia: "Conectar Redes Sociais",
      instagram: "Instagram",
      tiktok: "TikTok",
      youtube: "YouTube",
      linkedin: "LinkedIn",
      socialConnectionsDescription: "Conecte a conta proprietária das suas publicações de CPM. Os tokens ficam no servidor e são usados apenas para métricas oficiais.",
      connectInstagram: "Conectar Instagram",
      connectTikTok: "Conectar TikTok",
      connectYouTube: "Conectar YouTube",
      connectLinkedIn: "Conectar LinkedIn",
      facebook: "Página do Facebook",
      connectFacebook: "Conectar Página do Facebook",
      facebookConnectionNote: "Somente Páginas do Facebook podem ser conectadas, não perfis pessoais.",
      addAnotherSocialAccount: "Adicionar outra conta",
      instagramProfessionalRequired: "Requer uma conta Profissional ou de Criador no Instagram.",
      tiktokConnectionNote: "Conecte a conta TikTok que publica os vídeos das campanhas.",
      youtubeConnectionNote: "Conecte um canal do YouTube para comprovar a propriedade; as visualizações públicas continuam usando a API oficial.",
      linkedinConnectionNote: "Conecte uma Página de Empresa do LinkedIn da qual você é administrador. Perfis pessoais não importam analytics.",
      youtubeOfficialNoConnection: "As visualizações públicas do YouTube já usam a API oficial; nenhuma conexão é necessária.",
      socialConnectedBadge: "Conectada",
      facebookReconnectTitle: "Reconecte sua Página do Facebook para publicar",
      facebookReconnectRequired: "Se você administra esta Página e quer publicar nela, reconecte e permita publicações para o Autoclipper postar.",
      youtubeReconnectRequired: "Reconecte esta conta do YouTube para liberar o envio de vídeos.",
      reconnectSocial: "Reconectar",
      disconnectSocial: "Desconectar",
      disconnectSocialTitle: "Desconectar a conta social?",
      disconnectSocialDescription: "As futuras atualizações de visualizações de CPM de {{account}} serão interrompidas até a reconexão.",
      socialConnected: "Conta social conectada",
      socialConnectedDescription: "Agora você pode enviar para campanhas de CPM publicações pertencentes a esta conta.",
      socialConnectionFailed: "Não foi possível conectar a conta",
      socialConnectionFailedDescription: "Tente novamente.",
      socialOauthErrors: {
        accessDenied: "A autorização foi cancelada ou negada. Conecte a conta novamente.",
        alreadyConnected: "Esta conta já está conectada a outra conta do Autoclipper. Desconecte-a por lá ou entre nessa conta e tente novamente.",
        sessionExpired: "A sessão de conexão expirou. Inicie a conexão novamente.",
        linkedinOrganizationRequired: "Conecte uma Página de Empresa do LinkedIn da qual você é administrador. Perfis pessoais não importam analytics.",
        facebook_page_required: "Não conseguimos conectar uma Página do Facebook. Escolha uma Página que você administra; perfis pessoais não podem ser conectados.",
        facebook_connections_unavailable: "A conexão de Páginas do Facebook ainda não está disponível para a sua conta.",
      },
      socialPopupBlocked: "Permita pop-ups para conectar sua conta social.",
      socialOauthRelay: {
        title: "Conectando sua conta",
        body: "Continue nesta janela para autorizar o Autoclipper.",
        invalidPlatform: "Este link de conexão é inválido. Feche esta janela e tente de novo em Minha Conta.",
        startFailed: "Não foi possível iniciar a conexão. Feche esta janela e tente de novo.",
      },
      socialDisconnected: "Conta social desconectada",
      socialDisconnectFailed: "Não foi possível desconectar a conta",
      myPlan: "Meu Plano",
      plan: "Plano:",
      subscriptionCanceled: "Assinatura cancelada",
      pastDue: "Pagamento da assinatura pendente",
      pastDuePay: "Pagar agora",
      storeManaged: {
        app_store: "Gerenciado pela App Store",
        google_play: "Gerenciado pelo Google Play",
        manage: "Gerenciar na loja",
      },
      pastDueGrace: "Regularize até {{date}} para não perder o plano",
      renewPixSubscription: "Renovar Assinatura PIX",
      renewPixTitle: "Renovar Assinatura via PIX",
      renewPixDescription: "Escaneie o QR Code ou copie o código PIX para renovar sua assinatura.",
      renewPixGenerating: "Gerando QR Code...",
      renewPixError: "Erro ao gerar QR Code de renovação. Tente novamente.",
      renewPixExpires: "Expira em",
      renewPixAmount: "Valor",
      renewPixCopyCode: "Copiar Código PIX",
      renewPixCodeCopied: "Código PIX copiado!",
      renewPixSuccess: "Pagamento confirmado! Sua assinatura foi renovada.",
      renewPixWaiting: "Aguardando pagamento...",
      renewPixCheckingStatus: "Verificando status do pagamento...",
      renewWithWallet: "Renovar com saldo",
      renewPlanNow: "Renovar plano agora",
      renewPayCard: "Pagar com cartão",
      renewWalletTitle: "Renovar seu plano",
      renewWalletInsufficient: "Saldo insuficiente. Renove em Planos.",
      renewWalletPriceUnavailable: "O valor da renovação está temporariamente indisponível. Você ainda pode renovar via PIX.",
      renewWalletGoPlans: "Ir para planos",
      renewWalletSuccess: "Pagamento confirmado! Seu plano foi renovado.",
      buyExtraMinutesTitle: "Comprar Minutos Extras",
      buyExtraMinutesDescription: "Minutos extras não expiram e são consumidos apenas quando ultrapassam o limite do plano.",
      buyExtraMinutesLabel: "Quantidade de minutos",
      buyExtraMinutesHours: "{{hours}}h {{minutes}}min",
      buyExtraMinutesHoursOnly: "{{hours}}h",
      buyExtraMinutesMinutesOnly: "{{minutes}}min",
      buyExtraMinutesTotal: "Total",
      buyExtraMinutesPayCard: "Pagar com Cartão",
      buyExtraMinutesPayPix: "Pagar com PIX",
      buyExtraMinutesCpfCnpj: "CPF ou CNPJ",
      buyExtraMinutesGeneratePix: "Gerar PIX",
      buyExtraMinutesBack: "Voltar",
      buyExtraMinutesPixDescription: "Escaneie o QR Code ou copie o código PIX para pagar.",
      buyExtraMinutesCopyCode: "Copiar Código PIX",
      buyExtraMinutesCodeCopied: "Código PIX copiado!",
      buyExtraMinutesPixExpires: "Expira em",
      buyExtraMinutesPixWaiting: "Aguardando pagamento...",
      buyExtraMinutesSuccess: "Pagamento confirmado! Seus minutos extras foram adicionados.",
      buyExtraMinutesError: "Erro ao processar pagamento. Tente novamente.",
      buyExtraMinutesPastDue: "Pague a assinatura antes de comprar minutos extras.",
      buyExtraMinutesWalletTitle: "Saldo da carteira",
      buyExtraMinutesWalletAvailable: "Disponível",
      buyExtraMinutesWalletRemainder: "Restante a pagar",
      buyExtraMinutesWalletApplied: "Saldo aplicado",
      buyExtraMinutesWalletPayFull: "Pagar com saldo",
      buyExtraMinutesWalletPlusCard: "Saldo + Cartão",
      buyExtraMinutesWalletPlusPix: "Saldo + PIX",
      buyExtraMinutesMinimum: "Mínimo de 60 minutos",
      buyExtraMinutesPricePerMinute: "R$ 0,27 / minuto",
      processingTime: "Tempo de Processamento",
      clipsUsed: "Clipes Utilizados",
      curationsUsed: "Curadorias Utilizadas",
      exportsUsed: "Exportações Utilizadas",
      videoTime: "Tempo de Vídeo",
      upgradeToPro: "Atualizar para PRO",
      changePlan: "Mudar de Plano",
      cancelSubscription: "Cancelar Assinatura",
      reactivateSubscription: "Reativar Assinatura",
      manageSubscription: "Gerenciar Assinatura",
      loading: "Carregando...",
      usersOnPlan: "Usuários no Plano",
      invite: "Convidar",
      master: "Master",
      leaveTeam: "Sair da Equipe",
      userManagement: "Gerenciamento de Usuários",
      availableOnGoldPlan: "Está disponível apenas no Plano Ouro.",
      inviteUser: "Convidar Usuário",
      invitationLink: "Link de Convite",
      shareLink: "Compartilhe este link com a pessoa que você deseja convidar para o plano.",
      regenerateLink: "Re-gerar Link de Convite",
      regenerateLinkTitle: "Re-gerar Link de Convite",
      regenerateLinkWarning: "Atenção:",
      regenerateLinkDesc: "Ao re-gerar o link de convite, todos os links anteriores deixarão de funcionar. Usuários que ainda não aceitaram o convite precisarão receber o novo link.",
      regenerating: "Regenerando...",
      changeProfilePicture: "Alterar Foto de Perfil",
      file: "Arquivo:",
      cancel: "Cancelar",
      confirm: "Confirmar",
      uploading: "Enviando...",
      cancelSubscriptionTitle: "Cancelar Assinatura",
      whyCanceling: "Por que você está cancelando a assinatura?",
      selectReason: "Selecione um motivo",
      cancellationReasons: {
        notExpected: "Não era o que eu esperava",
        tooExpensive: "Achei caro para o que oferece",
        noTime: "Não tive tempo para usar",
        technicalProblems: "Tive problemas técnicos",
        foundBetterTool: "Encontrei outra ferramenta melhor",
        other: "Outro",
      },
      whatReason: "Qual o motivo?",
      describeReason: "Descreva o motivo específico...",
      couldWeHaveDoneSomething: "Existe algo que poderíamos ter feito para evitar o cancelamento?",
      shareFeedback: "Nos ajude a melhorar compartilhando seu feedback...",
      sendAndContinue: "Enviar e Continuar",
      sending: "Enviando...",
      leaveTeamTitle: "Sair da Equipe",
      leaveTeamConfirm: "Tem certeza que deseja sair da equipe? Você perderá o acesso ao plano compartilhado e precisará ser convidado novamente para retornar.",
      leaving: "Saindo...",
      confirmLeave: "Confirmar Saída",
      removeUser: "Remover Usuário",
      removeUserConfirm: "Tem certeza que deseja remover <strong>{{name}}</strong> da equipe? O usuário perderá o acesso ao plano compartilhado imediatamente.",
      removing: "Removendo...",
      confirmRemoval: "Confirmar Remoção",
      notifications: "Notificações",
      profileUpdated: "Perfil atualizado",
      profileUpdatedDesc: "Seu perfil foi atualizado com sucesso.",
      profileUpdateError: "Erro ao atualizar perfil",
      profileUpdateErrorDesc: "Por favor, tente novamente.",
      profilePictureUpdated: "Foto de perfil atualizada",
      profilePictureUpdatedDesc: "Sua foto de perfil foi atualizada com sucesso.",
      uploadError: "Erro no upload",
      formatNotSupported: "Formato não suportado",
      onlyJpgPng: "Apenas arquivos JPG e PNG são aceitos.",
      fileTooLarge: "Arquivo muito grande",
      maxSize: "O tamanho máximo permitido é 5MB.",
      feedbackSent: "Feedback enviado",
      feedbackSentDesc: "Obrigado pelo seu feedback. Você será redirecionado para o WhatsApp.",
      feedbackError: "Erro ao enviar feedback",
      leftTeam: "Saiu da equipe com sucesso",
      leftTeamDesc: "Você não faz mais parte da equipe.",
      leaveTeamError: "Erro ao sair da equipe",
      userRemoved: "Usuário removido com sucesso",
      userRemovedDesc: "O usuário foi removido da equipe.",
      removeUserError: "Erro ao remover usuário",
      roleChanged: "Cargo alterado com sucesso",
      roleChangedDesc: "O cargo do usuário foi alterado para {{role}}.",
      roleChangeError: "Erro ao alterar cargo",
      invitationRegenerated: "Link de convite regenerado",
      invitationRegeneratedDesc: "O novo link de convite foi gerado com sucesso. Links anteriores não funcionarão mais.",
      invitationRegenerateError: "Erro ao re-gerar link",
      featureUnavailable: "Recurso Indisponível",
      featureOnGoldPlan: "Esta funcionalidade está disponível apenas no Plano Ouro.",
      microsoftAccess: "Acesso via Microsoft",
      switchToOwnContent: {
        cta: "Usar o modo criador de conteúdo",
        hint: "Sua página inicial e a forma como os minutos contam vão mudar.",
        title: "Mudar para o modo criador de conteúdo?",
        getHeading: "Você passa a ter",
        getHome: "Projetos como página inicial",
        getWorkflow: "Um espaço feito para criadores de conteúdo",
        getUnlimitedClips: "Clipes ilimitados",
        loseHeading: "Você deixa de ter",
        loseHome: "Ver acervo como página inicial",
        loseMinutes: "Contar os minutos usados no acervo — eles passam a contar nos seus próprios vídeos",
        loseNoMigrate: "Projetos e cortes do modo clipador — eles ficam lá e não vêm para cá",
        loseAcervo: "Usar os vídeos do acervo para gerar cortes",
        keep: "Você pode voltar quando quiser. Clip & Pix e o resto do que você usou no mês continuam iguais.",
        confirm: "Mudar",
        cancel: "Cancelar",
        error: "Não foi possível mudar agora. Tente novamente.",
      },
      switchToClippingChannels: {
        cta: "Usar o modo clipador",
        hint: "Sua página inicial e a forma como os minutos contam vão mudar.",
        title: "Mudar para o modo clipador?",
        getHeading: "Você passa a ter",
        getHome: "Ver acervo como página inicial",
        getWorkflow: "Um espaço feito para o modo clipador",
        getAcervo: "Acesso ao acervo",
        getUnlimitedCurations: "Curadorias ilimitadas",
        getClips: "{{count}} clipes por mês",
        getUnlimitedClips: "Clipes ilimitados",
        loseHeading: "Você deixa de ter",
        loseHome: "Projetos como página inicial",
        loseMinutes: "Contar os minutos usados nos seus vídeos — eles passam a contar no acervo",
        loseNoMigrate: "Projetos do modo criador de conteúdo — eles ficam lá e não vêm para cá",
        keep: "Você pode voltar quando quiser. Clip & Pix e o resto do que você usou no mês continuam iguais.",
        confirm: "Mudar",
        cancel: "Cancelar",
        error: "Não foi possível mudar agora. Tente novamente.",
      },
      onboarding: {
        title: "Preferências de Uso",
        objective: "Qual seu objetivo principal?",
        selectObjective: "Selecione seu objetivo",
        dailyVolume: "Qual volume diário você espera?",
        selectDailyVolume: "Selecione o volume diário",
        savePreferences: "Salvar Preferências",
      },
    },

    clipperFeatureNag: {
      title: "Este é um recurso de clipadores",
      communityLibraryBody: "Ver acervo é feito para o modo clipador. Você pode continuar usando — o que você gerar aqui vira um projeto seu.",
      earnBody: "Clip & Pix é feito para clipadores. Você pode continuar usando — seu espaço continua configurado para o modo criador de conteúdo.",
      continue: "Continuar",
      dontShowAgain: "Não mostrar de novo",
    },

    // Tutorials
    tutorials: {
      title: "Tutoriais Autoclipper",
      subtitle: "Aprenda a usar todas as funcionalidades da Autoclipper com nossos tutoriais em vídeo",
      beginner: "Iniciante",
      intermediate: "Intermediário",
      advanced: "Avançado",
    },

    // Project Card
    // Filters and expired videos on /projects and /library
    lists: {
      filtersLabel: "Filtrar vídeos",
      filters: {
        all: "Todos",
        uploaded: "Enviados",
        community: "Comunidade",
        expired: "Expirados",
      },
      expired: "Expirado",
      show: "Mostrar",
      hide: "Ocultar",
      showMore: "Mostrar mais",
      loadFailedRetry: "Não foi possível carregar. Tentar de novo",
      noExpired: "Nenhum vídeo expirado.",
      expiredMatches: "Procurar também nos expirados",
      clearSearch: "Limpar busca",
    },

    projectCard: {
      readyToProcess: "Pronto para processar",
      processing: "Processando",
      completed: "Concluído",
      failed: "Falhou",
      clips: "clipes",
      viewProject: "Ver projeto",
      estimate: "Estimativa: {{time}}",
      noPreview: "Sem preview",
      removeProject: "Remover projeto",
      removeProjectConfirm: "Tem certeza que deseja remover este projeto?",
      removeProjectWarning: "Os minutos deste projeto não serão devolvidos.",
      removing: "Removendo...",
      remove: "Remover",
      duplicateProject: "Reprocessar",
      openClips: "Ver cortes",
      openEditor: "Abrir no editor",
      seeFailure: "Ver o que houve",
      statusProcessing: "Processando",
      statusFailed: "Falhou",
      failedTitle: "Não deu certo",
      failedDescription: "Não conseguimos processar este vídeo",
      clipsCount_zero: "{{count}} cortes",
      clipsCount_one: "{{count}} corte",
      clipsCount_other: "{{count}} cortes",
      exportedCount_zero: "{{count}} exportados",
      exportedCount_one: "{{count}} exportado",
      exportedCount_other: "{{count}} exportados",
      versions_one: "{{count}} versão",
      versions_other: "{{count}} versões",
      versionsTitle_one: "Você tem {{count}} cópia deste vídeo",
      versionsTitle_other: "Você tem {{count}} cópias deste vídeo",
      moreActions: "Mais ações",
      uploadedFile: "Arquivo enviado",
      menu: {
        clips: "Ver cortes",
        editor: "Abrir no editor",
        duplicate: "Reprocessar",
        downloadOriginal: "Baixar vídeo original",
        delete: "Remover projeto",
      },
      originalVideoDownload: {
        triggerLabel: "Baixar vídeo original",
        title: "Baixar vídeo original?",
        description: "Este arquivo é o vídeo original completo ({{sourceDuration}}).",
        descriptionWithoutDurations: "Este arquivo é o vídeo original completo.",
        cancel: "Cancelar",
        confirm: "Baixar vídeo original",
        proTitle: "Baixar o vídeo original é PRO",
        proBody: "No plano gratuito você pode gerar cortes. Faça upgrade para baixar o arquivo original.",
        proDismiss: "Agora não",
        proUpgrade: "Fazer upgrade",
      },
    },

    // Duplicate Project Dialog
    duplicateProject: {
      title: "Reprocessar Projeto",
      description: "Reprocesse este vídeo com configurações diferentes. Escolha um novo formato, prompt e template.",
      confirm: "Reprocessar",
      creating: "Criando...",
      success: "Projeto criado",
      successDescription: "O projeto foi criado e será processado em breve.",
      error: "Falha ao criar projeto",
      replacePdf: "Substituir PDF (opcional)",
      replacePdfHint: "Deixe vazio para manter o PDF original.",
      selectPdf: "Clique para selecionar um PDF",
      uploadingPdf: "Enviando PDF...",
      invalidPdf: "Apenas arquivos .pdf são aceitos",
      pdfUploadError: "Falha ao enviar o PDF. Tente novamente.",
    },

    // Export Modal
    exportModal: {
      title: "Exportar Clipe",
      exporting: "Exportando...",
      export: "Exportar",
      chooseFormat: "Escolha o formato de exportação",
      horizontal: "Horizontal",
      horizontalDescription: "Formato 16:9 ideal para YouTube, sites e outras plataformas de vídeo horizontal.",
      exportHorizontal: "Exportar Horizontal",
      vertical: "Vertical",
      verticalDescription: "Formato 9:16 ideal para TikTok, Instagram Reels, YouTube Shorts e redes sociais.",
      exportVertical: "Exportar Vertical",
    },

    // Error Messages
    errors: {
      invalidFileType: "Tipo de arquivo inválido",
      onlyMp4Accepted: "Apenas arquivos .mp4 são aceitos",
      failedToReadVideo: "Falha ao ler vídeo",
      couldNotDetermineDuration: "Não foi possível determinar a duração do vídeo.",
      videoHasNoAudio: "Vídeo sem áudio",
      videoHasNoAudioDescription: "Este vídeo não tem faixa de áudio, então não dá para transcrevê-lo. Exporte o vídeo de novo com o áudio ativado e envie outra vez.",
      liveVideo: "Vídeo ao vivo",
      insertNonLiveVideo: "Insira um link de vídeo que não está ao vivo.",
      videoProcessing: "Vídeo em processamento",
      videoStillProcessing: "Este vídeo ainda está sendo processado pelo YouTube, aguarde o fim do processamento",
      scheduledVideo: "Vídeo agendado",
      insertAvailableVideo: "Insira um link de vídeo que já esteja disponível.",
      youtubeOnly: "Apenas links do YouTube são aceitos",
      youtubeOnlyDescription: "O acervo aceita apenas links de vídeos do YouTube.",
      videoTooLong: "Vídeo muito longo",
      videoTooLongDescription: "Apenas vídeos com até {{hours}}h de duração são aceitos para o seu plano.",
      videoAnalysisError: "Erro ao analisar vídeo",
      checkVideoLink: "Não foi possível analisar o vídeo. Verifique se o link está correto.",
      uploadError: "Erro no upload",
      uploadErrorOccurred: "Ocorreu um erro durante o upload do arquivo.",
      proFeatureRequired: "Recurso PRO Necessário",
      fileUploadProOnly: "O upload de arquivos está disponível apenas para usuários PRO. Faça o upgrade para acessar este recurso.",
      googleDriveProOnly: "O Google Drive está disponível apenas para usuários PRO. Faça o upgrade para acessar este recurso.",
    },

    // Validation
    validation: {
      required: "Este campo é obrigatório",
      invalidEmail: "Endereço de email inválido",
      minLength: "Deve ter pelo menos {{min}} caracteres",
      maxLength: "Deve ter no máximo {{max}} caracteres",
      passwordsDoNotMatch: "As senhas não coincidem",
    },

    // Time and Duration
    time: {
      seconds: "{{count}}s",
      minutes: "{{count}}m",
      hours: "{{count}}h",
      days: "{{count}}d",
      ago: "atrás",
      remaining: "restante",
    },

    // File Size
    fileSize: {
      bytes: "B",
      kilobytes: "KB",
      megabytes: "MB",
      gigabytes: "GB",
    },

    // Brand Kits page
    brandKits: {
      title: "Templates",
      subtitle: "Gerencie todos os seus templates personalizados",
      brandKitsCount: "{{count}} de {{max}} templates criados",
      createNewBrandKit: "Criar Novo Template",
      createFirstBrandKit: "Criar Primeiro Template",
      noBrandKitFound: "Nenhum template encontrado",
      noBrandKitCreated: "Nenhum template criado",
      adjustSearch: "Tente ajustar sua busca ou criar um novo template.",
      startCreatingBrandKit: "Comece criando seu primeiro template para personalizar seus vídeos.",
      loadingBrandKits: "Carregando templates...",
      errorLoadingBrandKits: "Erro ao carregar templates",
      errorLoadingBrandKitsDesc: "Não foi possível carregar seus templates. Tente novamente.",
      tryAgain: "Tentar novamente",
      deletedSuccess: "Template excluído com sucesso!",
      errorDeleting: "Erro ao excluir template. Tente novamente.",
      setAsDefaultSuccess: "Template definido como padrão com sucesso!",
      errorSettingDefault: "Erro ao definir template como padrão. Tente novamente.",
      default: "Padrão",
      edit: "Editar",
      setAsDefault: "Definir como Padrão",
      setting: "Definindo...",
      delete: "Excluir",
      deleting: "Excluindo...",
      confirmDelete: "Confirmar Exclusão",
      confirmDeleteDefault: "Tem certeza que deseja excluir o template padrão \"{{name}}\"? Esta ação não pode ser desfeita e você precisará definir outro template como padrão.",
      confirmDeleteNormal: "Tem certeza que deseja excluir o template \"{{name}}\"? Esta ação não pode ser desfeita.",
      cancel: "Cancelar",
      logoNotDefined: "Logo: Não definido",
      logo: "Logo",
      logoCouldNotLoad: "Logo não pôde ser carregado",
      colorPalette: "Paleta de Cores",
      titleFont: "Fonte do Título",
      bodyFont: "Fonte do Corpo",
      subtitleFont: "Fonte da Legenda",
      notDefined: "Não definida",
      unnamed: "Template sem nome",
      sampleText: "Exemplo de Texto",
      created: "Criado:",
      updated: "Atualizado:",
      reachedLimit: "Você atingiu o limite de {{max}} templates do seu plano",
      tour: {
        welcome: "Bem-vindo aos Templates! Aqui você pode criar e gerenciar templates personalizados com fontes, cores, logos e estilos de legenda.",
        createButton: "Clique aqui para criar um novo template. Você pode personalizar fontes, cores, logos e legendas para seus vídeos.",
        grid: "Aqui aparecem todos os seus templates criados. Clique em um card para editar ou gerenciar um template existente.",
        helpButton: "Clique aqui para ver novamente o tour de como usar os templates.",
      },
    },

    // My Media page
    myMedia: {
      title: "Minha Mídia",
      subtitle: "Seu acervo pessoal de imagens, vídeos e áudios enviados — reutilize em qualquer projeto.",
      upload: "Enviar arquivo",
      uploading: "Enviando…",
      searchPlaceholder: "Buscar por nome…",
      picker: {
        title: "Escolher da Minha Mídia",
        description: "Reutilize uma imagem que você já enviou. Busque pelo nome ou filtre por pasta.",
        open: "Minha Mídia",
        images: "Minhas imagens",
        searchPlaceholder: "Buscar nas suas imagens…",
        folderFilter: "Filtrar imagens por pasta",
        browseStock: "Ver banco de imagens",
        uploadInstead: "Enviar nova",
        loading: "Carregando suas imagens…",
        emptyTitle: "Nenhuma imagem encontrada",
        emptyDescription: "Tente outra busca ou pasta, ou envie uma nova imagem do seu computador.",
      },
      kind: {
        all: "Todos",
        image: "Imagens",
        video: "Vídeos",
        audio: "Áudios",
      },
      folders: {
        all: "Todos",
        root: "Sem pasta",
        options: "Opções da pasta",
        new: "Nova pasta",
        newTitle: "Nova pasta",
        nameLabel: "Nome",
        namePlaceholder: "Ex: B-roll, Logos, Músicas…",
        create: "Criar",
        creating: "Criando…",
        rename: "Renomear",
        renameTitle: "Renomear pasta",
        delete: "Excluir",
        confirmDeleteTitle: "Excluir esta pasta?",
        confirmDeleteBody: "A pasta \"{{name}}\" será removida. A mídia dentro dela não será excluída — ela volta para \"Sem pasta\".",
      },
      item: {
        rename: "Renomear",
        renameTitle: "Renomear item",
        moveTo: "Mover para pasta",
        delete: "Excluir",
        confirmDeleteTitle: "Excluir este item?",
        confirmDeleteBody: "\"{{name}}\" será excluído permanentemente do seu acervo de mídia. Isso não pode ser desfeito. Projetos que usam este arquivo podem perder o acesso a ele.",
        untitled: "Sem título",
      },
      empty: "Você ainda não enviou nenhuma mídia. Clique em Enviar arquivo para adicionar imagens, vídeos ou áudios.",
      noResults: "Nenhuma mídia encontrada com os filtros atuais.",
      errorLoading: "Não foi possível carregar sua mídia. Tente novamente.",
      retry: "Tentar novamente",
      loadMore: "Carregar mais",
      cancel: "Cancelar",
      save: "Salvar",
      saving: "Salvando…",
      deleting: "Excluindo…",
      toast: {
        unsupportedType: "Tipo de arquivo não suportado.",
        uploadError: "Falha no envio. Tente novamente.",
        folderError: "Algo deu errado com a pasta. Tente novamente.",
        itemError: "Algo deu errado. Tente novamente.",
      },
    },

    // API Keys page
    apiKeys: {
      title: "Chaves de API",
      subtitle: "Gerencie suas chaves de API para integração.",
      newKey: "Nova Chave",
      createNewApiKey: "Criar Nova Chave de API",
      createNewApiKeyDesc: "Crie uma nova chave de API para integração.",
      keyName: "Nome da Chave",
      keyNamePlaceholder: "Ex: Chave de Produção, Chave de Teste, etc.",
      cancel: "Cancelar",
      creating: "Criando...",
      createKey: "Criar Chave",
      failedToLoad: "Falha ao carregar chaves de API",
      noApiKeys: "Nenhuma chave de API",
      noApiKeysDesc: "Você ainda não criou nenhuma chave de API. Crie sua primeira chave para começar a integrar.",
      createFirstKey: "Criar Primeira Chave",
      createdAt: "Criada em",
      edit: "Editar",
      delete: "Excluir",
      apiKey: "Chave de API",
      copy: "Copiar",
      editApiKey: "Editar Chave de API",
      editApiKeyDesc: "Altere o nome da sua chave de API.",
      saving: "Salvando...",
      saveChanges: "Salvar Alterações",
      deleteApiKey: "Excluir Chave de API",
      deleteApiKeyDesc: "Tem certeza que deseja excluir esta chave de API? Esta ação não pode ser desfeita e todas as integrações que utilizam esta chave irão parar de funcionar.",
      deleting: "Excluindo...",
      toast: {
        error: "Erro",
        keyNameRequired: "Nome da chave é obrigatório",
        success: "Sucesso",
        keyCreated: "Chave de API criada com sucesso",
        keyCreateError: "Falha ao criar chave de API",
        keyUpdated: "Chave de API atualizada com sucesso",
        keyUpdateError: "Falha ao atualizar chave de API",
        keyDeleted: "Chave de API excluída com sucesso",
        keyDeleteError: "Falha ao excluir chave de API",
        copied: "Copiado",
        keyCopied: "Chave de API copiada para a área de transferência",
        copyError: "Falha ao copiar chave de API",
      },
    },

    // API Requests page
    apiRequests: {
      title: "Requisições de API",
      noName: "Sem nome",
      failedToLoad: "Falha ao carregar requisições de API.",
      noRequests: "Nenhuma requisição de API encontrada.",
      loadingMore: "Carregando mais...",
      webhookRetriggered: "Notificação webhook enviada com sucesso",
      webhookRetriggerFailed: "Falha ao reenviar webhook",
      stats: {
        total: "Total",
      },
      card: {
        source: "Fonte",
        copyWebhookUrl: "Copiar URL do webhook",
        retriggerWebhook: "Reenviar webhook",
      },
      status: {
        processing: "Processando",
        completed: "Concluído",
        failed: "Falhou",
        pending: "Pendente",
        expired: "Expirado",
      },
    },

    // API Documentation page
    apiDocumentation: {
      title: "Documentação da API do Autoclipper",
      subtitle: "Integre a poderosa edição de vídeo com IA em seus aplicativos. Transforme vídeos longos em clipes envolventes com apenas algumas chamadas de API.",
      getStarted: "Começar",
      tryPlayground: "Testar Playground",
      apiReference: "Referência da API",
      apiEndpoints: "Endpoints de API",
      apiArchitecture: "Arquitetura da API",
      responseFormat: "Formato de Resposta",
      quickStart: "Início Rápido",
      quickStartDescription: "Comece a usar a API do Autoclipper em três passos simples",
      step1Title: "Obtenha sua Chave de API",
      step1Description: "Gere uma chave de API no seu painel para autenticar requisições",
      getApiKey: "Obter Chave de API",
      step2Title: "Crie um Projeto",
      step2Description: "Envie uma URL de vídeo para iniciar o processo automatizado de corte",
      tryExample: "Testar Exemplo",
      step3Title: "Monitore o Progresso",
      step3Description: "Verifique o status do projeto e recupere os clipes gerados quando prontos",
      viewDocs: "Ver Documentação",
      keyFeatures: "Recursos Principais",
      keyFeaturesDescription: "Capacidades poderosas de processamento de vídeo ao seu alcance",
      features: {
        autoClipGeneration: "Geração Automática de Clipes",
        autoClipGenerationDescription: "Análise de vídeo com IA para criar clipes envolventes de conteúdo longo",
        multiLanguageSupport: "Suporte Multi-idioma",
        multiLanguageSupportDescription: "Processe vídeos em múltiplos idiomas com geração precisa de legendas",
        realtimeUpdates: "Atualizações em Tempo Real",
        realtimeUpdatesDescription: "Acompanhe o status do processamento e receba notificações webhook quando os clipes estiverem prontos",
        webhookNotifications: "Notificações Webhook",
        webhookNotificationsDescription: "Notificações POST automáticas para seu endpoint quando o processamento é concluído",
        multipleFormats: "Múltiplos Formatos de Saída",
        multipleFormatsDescription: "Escolha entre vários formatos de duração de clipe para adequar à sua estratégia de conteúdo",
      },
      codeExamples: "Exemplos de Código",
      codeExamplesDescription: "Exemplos de requisição para ajudá-lo a começar rapidamente",
      createProject: "Criar Projeto",
      listProjects: "Listar Projetos",
      getProject: "Obter Projeto",
      additionalResources: "Recursos Adicionais",
      additionalResourcesDescription: "Explore mais documentação e ferramentas para melhorar sua integração",
      gettingStartedGuide: "Guia de Início",
      gettingStartedGuideDescription: "Tutorial passo a passo para iniciantes",
      interactivePlayground: "Playground Interativo",
      interactivePlaygroundDescription: "Teste endpoints de API diretamente do navegador",
      apiReferenceTitle: "Referência da API",
      apiReferenceDescription: "Documentação detalhada de todos os endpoints",
      openApiSpec: "Especificação OpenAPI",
      openApiSpecDescription: "Especificação de API legível por máquina",
      manageApiKeys: "Gerenciar Chaves de API",
      manageApiKeysDescription: "Gere e gerencie suas chaves de API",
    },

    // API Playground
    apiPlayground: {
      copiedToClipboard: "Copiado para a área de transferência",
      copiedDescription: "O conteúdo foi copiado para sua área de transferência.",
      selectApiKeyFirst: "Selecione uma chave de API primeiro",
      enterProjectId: "Insira um ID de projeto",
      title: "API Playground",
      subtitle: "Teste os endpoints da API do Autoclipper diretamente do seu navegador",
      authentication: "Autenticação",
      selectApiKeyDescription: "Selecione uma chave de API para autenticar suas requisições",
      loadingApiKeys: "Carregando chaves de API...",
      chooseApiKey: "Escolher Chave de API",
      selectApiKey: "Selecione uma chave de API",
      noApiKeys: "Nenhuma chave de API encontrada.",
      createOneHere: "Crie uma aqui",
      makeRequest: "Fazer Requisição",
      configureAndSend: "Configure e envie requisições de API",
      videoUrl: "URL do Vídeo *",
      projectName: "Nome do Projeto *",
      format: "Formato *",
      language: "Idioma *",
      webhookUrl: "URL do Webhook",
      prompt: "Prompt",
      brandKitId: "Template",
      brandKitDefault: "Padrão (template da conta ou Basic)",
      brandKitOverridePlaceholder: "Override opcional de template",
      myBrandKits: "Meus Templates",
      publicBrandKits: "Templates Públicos",
      promptPlaceholder: "Instruções adicionais para geração de clipes...",
      createProject: "Criar Projeto",
      listProjects: "Listar Projetos",
      getProject: "Obter Projeto",
      createProjectDescription: "Crie um novo projeto de vídeo para processamento",
      listProjectsDescription: "Obtenha a lista dos seus projetos",
      getProjectDescription: "Obtenha detalhes de um projeto específico",
      formatAuto: "Auto - IA determina duração ideal",
      formatMax1Min: "Máximo 1 Minuto",
      formatMax30Sec: "Máximo 30 Segundos",
      langPtBr: "Português (Brasil)",
      langEnUs: "Inglês (EUA)",
      langEsEs: "Espanhol (Espanha)",
      limit: "Limite",
      offset: "Deslocamento",
      projectId: "ID do Projeto *",
      projectIdPlaceholder: "Insira o ID do projeto da lista ou resposta de criação",
      response: "Resposta",
      responseDescription: "Veja respostas e informações de depuração da API",
      requestUrl: "URL da Requisição",
      requestBody: "Corpo da Requisição",
      makingRequest: "Fazendo requisição...",
      error: "Erro:",
      emptyResponse: "Selecione uma chave de API e faça uma requisição para ver a resposta aqui",
      codePreview: "Pré-visualização de Código",
      codePreviewDescription: "Exemplos para copiar e colar na sua linguagem preferida",
      copy: "Copiar",
      needHelp: "Precisa de Ajuda?",
      gettingStarted: "Primeiros Passos",
      learnBasics: "Aprenda o básico",
      apiReference: "Referência da API",
      completeDocumentation: "Documentação completa",
      manageApiKeys: "Gerenciar Chaves de API",
      createAndManageKeys: "Crie e gerencie chaves",
    },

    // Invitation Accept page
    invitation: {
      invalidToken: "Token de convite inválido",
      teamInvitation: "Convite para Equipe",
      invitedToTeam: "Você foi convidado para participar de uma equipe no Autoclipper",
      acceptingInvitation: "Ao aceitar este convite, você passará a fazer parte de uma equipe e poderá:",
      accessTeamProjects: "Acessar projetos da equipe",
      ownerPermissions: "O dono da equipe poderá determinar se você terá permissão para enviar projetos ou criar clipes.",
      accepting: "Aceitando...",
      acceptInvitation: "Aceitar Convite",
      cancel: "Cancelar",
      processingInvitation: "Processando Convite",
      acceptingTeamInvitation: "Aceitando convite para a equipe...",
      invitationAccepted: "Convite Aceito!",
      welcomeToTeam: "Bem-vindo à equipe!",
      redirectingToProjects: "Você será redirecionado para seus projetos em instantes...",
      invitationError: "Erro no Convite",
      couldNotAccept: "Não foi possível aceitar o convite",
      backToProjects: "Voltar aos Projetos",
      toast: {
        acceptedSuccess: "Convite aceito com sucesso!",
        acceptedDesc: "Você agora faz parte da equipe. Será redirecionado em instantes.",
        errorAccepting: "Erro ao aceitar convite",
      },
    },

    linkAccount: {
      connectingAs: "Conectando a conta:",
      title: "Conecte sua conta",
      description: "Conecte sua conta Autoclipper pra o bot poder criar cortes pra você.",
      confirmButton: "Conectar conta",
      connecting: "Conectando...",
      successTitle: "Conta conectada!",
      successDescription: "Pode voltar pro chat do bot agora.",
      errorTitle: "Não foi possível conectar",
      tryAgain: "Tentar de novo",
      error: {
        invalidCode: "Este link é inválido, expirou ou já foi usado. Peça um novo no bot.",
        missingCode: "Este link está sem o código. Peça um novo no bot.",
        generic: "Algo deu errado. Tenta de novo daqui a pouco.",
      },
    },
    botConnection: {
      title: "Conexões do bot",
      channelName: { telegram: "Telegram", whatsapp: "WhatsApp" },
      connectedSince: "Conectado desde {{date}}",
      description: "Sua conta Autoclipper está conectada ao bot.",
      disconnectButton: "Desconectar bot do {{channel}}",
      confirmTitle: "Desconectar o bot do {{channel}}?",
      confirmBody: "Você vai precisar conectar de novo pelo chat do bot pra usá-lo.",
      cancel: "Cancelar",
      confirmDisconnect: "Desconectar",
      disconnectedTitle: "Bot desconectado",
      disconnectedDesc: "Sua conexão com o bot do {{channel}} foi removida.",
      errorTitle: "Não foi possível desconectar",
      errorDesc: "Algo deu errado. Tente de novo em instantes.",
    },

    // Clip Titles Dialog
    clipTitles: {
      title: "Copy",
      generate: "Gerar Copy",
      titlesAndSuggestions: "Títulos e Sugestões",
      titlesGeneratedBy: "Títulos e descrições gerados por IA para:",
      mainTitles: "Títulos Principais",
      description: "Descrição",
      copyDescription: "Copiar descrição",
      tags: "Tags",
      copyAllTags: "Copiar todas as tags",
      noTitlesGenerated: "Nenhum título foi gerado ainda para este clipe.",
      clickToGenerate: "Clique no botão abaixo para gerar títulos, descrições e tags usando IA.",
      copyAll: "Copiar Tudo",
      downloadTxt: "Baixar TXT",
      close: "Fechar",
      regenerate: "Regerar",
      generateTitles: "Gerar Títulos",
      startingGeneration: "Iniciando geração...",
      generatingTitles: "Gerando títulos e descrições...",
      toast: {
        copied: "Copiado!",
        copiedToClipboard: "Texto copiado para a área de transferência",
      },
    },

    // Quota Warning
    quotaWarning: {
      limitReached: "Limite mensal de clipes atingido. Atualize seu plano para continuar.",
      viewPlans: "Ver planos",
      approaching: {
        clips: "Resta {{remaining}} corte no seu plano este mês.",
        processing_time: "Você já usou {{percentage}}% do seu tempo de processamento deste mês.",
        library_curations: "Resta {{remaining}} curadoria no seu plano este mês.",
        library_exports: "Resta {{remaining}} exportação no seu plano este mês.",
        library_video_time: "Você já usou {{percentage}}% do seu tempo de vídeo do acervo deste mês.",
      },
    },

    // Profile Completion Modal
    profileCompletion: {
      title: "Complete seu perfil",
      subtitle: "Precisamos de algumas informações para personalizar sua experiência.",
      name: "Nome completo",
      namePlaceholder: "Digite seu nome completo",
      phoneNumber: "Número de telefone",
      jobTitle: "Qual é a sua função?",
      jobTitlePlaceholder: "Selecione sua função",
      objective: "Qual seu objetivo principal?",
      dailyVolume: "Qual volume diário você espera?",
      saving: "Salvando...",
      continue: "Continuar",
      toast: {
        success: "Perfil atualizado",
        profileUpdated: "Seu perfil foi atualizado com sucesso.",
        error: "Erro ao atualizar",
        couldNotUpdate: "Não foi possível atualizar seu perfil. Tente novamente.",
      },
    },

    // Onboarding Modal
    hireClippers: {
      title: "Contratar clipadores",
      subtitle: "Conte sobre sua marca e nosso time monta uma campanha com clipadores publicando cortes do seu conteúdo. Você paga pelas views entregues.",
      stepCounter: "Etapa {{current}} de {{total}}",
      steps: {
        demandType: { title: "Quem é você?" },
        objective: { title: "Qual seu principal objetivo?" },
        contentType: { title: "O que você já possui?", hint: "Escolha uma ou mais opções." },
        platforms: { title: "Em quais plataformas quer distribuir?" },
        budget: { title: "Qual faixa de investimento pretende utilizar?" },
        contact: { title: "Como falamos com você?" },
      },
      options: {
        demandType: {
          brand: "Marca",
          creator: "Creator",
          agency: "Agência",
          infoproducer: "Infoprodutor",
          podcast: "Podcast",
          mediaGroup: "Grupo de comunicação",
          seller: "Seller / e-commerce",
          other: "Outro",
        },
        objective: {
          awareness: "Awareness",
          distributeContent: "Distribuir conteúdo",
          launch: "Lançamento",
          growAudience: "Crescer audiência",
          sales: "Gerar vendas",
          distributePodcast: "Distribuir podcast",
          other: "Outro",
        },
        contentType: {
          readyContent: "Conteúdo pronto",
          podcast: "Podcast",
          longVideos: "Vídeos longos",
          creators: "Creators",
          ugc: "UGC",
          archive: "Acervo",
          product: "Produto",
          needToProduce: "Ainda preciso produzir",
        },
        platforms: {
          tiktok: "TikTok",
          instagram: "Instagram",
          youtube: "YouTube",
          multiple: "Múltiplas",
        },
        budget: {
          undecided: "Ainda definindo",
          range_5k_10k: "R$ 5 mil a R$ 10 mil",
          range_10k_20k: "R$ 10 mil a R$ 20 mil",
          range_20k_50k: "R$ 20 mil a R$ 50 mil",
          range_50k_150k: "R$ 50 mil a R$ 150 mil",
          range_150k_plus: "Acima de R$ 150 mil",
        },
      },
      fields: {
        name: "Seu nome",
        company: "Empresa / projeto",
        email: "E-mail",
        whatsapp: "WhatsApp",
        country: "País",
        search: "Buscar país",
        notFound: "Nenhum país encontrado.",
        placeholder: "(11) 99999-9999",
      },
      actions: {
        back: "Voltar",
        next: "Continuar",
        submit: "Enviar",
        submitting: "Enviando…",
      },
      errors: {
        required: "Escolha pelo menos uma opção para continuar.",
        invalidName: "Informe seu nome.",
        invalidEmail: "Confira o e-mail.",
        invalidPhone: "Confira o WhatsApp: use um número de celular válido, com DDD.",
        submit: "Não conseguimos enviar agora. Confira seus dados e tente de novo.",
      },
      success: {
        title: "Recebemos seu pedido",
        description: "Nosso time vai te chamar no WhatsApp em breve para montar sua campanha.",
        cta: "Enquanto isso, teste a IA de cortes",
      },
    },
    onboarding: {
      saving: "Salvando...",
      objective: {
        question: "Qual o seu objetivo com a AutoClipper?",
        subtitle: "Escolha a opção que melhor descreve o que você quer fazer agora.",
        hireClippers: {
          heading: "Quero contratar clipadores",
          title: "Você não edita nada",
          description: "Nosso time monta a campanha com clipadores e você paga pelas views.",
        },
        clippingChannels: {
          heading: "Sou Clipador",
          title: "Quero ganhar dinheiro com cortes",
          description: "Encontre conteúdos, acelere sua rotina e construa canais que monetizam.",
        },
        aiClipping: {
          heading: "Sou criador, marca ou agência",
          title: "Quero usar a IA de cortes",
          description: "Transforme vídeos, podcasts e lives em cortes prontos para publicar.",
        },
      },
      experience: {
        question: "Como você define sua experiência com canais de corte?",
        subtitle: "Sua resposta nos ajuda a indicar o próximo passo mais útil.",
        options: {
          starting_from_zero: "Estou começando do zero",
          started_not_monetizing: "Já comecei, mas ainda não monetizo",
          experienced_with_clips: "Já tenho experiência com cortes",
          monetizing_clipping_channel: "Já monetizo o meu canal de cortes",
        },
      },
      courseOffer: {
        eyebrow: "Seu próximo passo",
        title: "Viralize em 4 Semanas",
        description: "Um caminho prático para tirar seu canal do planejamento e chegar a uma rotina consistente de publicação.",
        detail: "Aprenda a escolher nichos, criar cortes com potencial e construir uma estratégia de monetização.",
        visualLabel: "04 semanas / plano prático",
        player: {
          play: "Reproduzir vídeo",
          pause: "Pausar vídeo",
          seek: "Posição do vídeo",
          mute: "Silenciar",
          unmute: "Ativar som",
          volume: "Volume",
          fullscreen: "Tela cheia",
          enableAudio: "Toque para ativar o áudio",
          errorTitle: "Não foi possível carregar o vídeo",
          retry: "Tentar novamente",
        },
        primary: "Conhecer o Viralize",
        secondary: "Agora não",
      },
      communityOffer: {
        title: "Faça parte da maior comunidade de clipadores do Brasil!",
        description: "Entre para a comunidade The Clippers no WhatsApp e conecte-se com outros clipadores.",
        primary: "Quero fazer parte!",
        secondary: "Agora não.",
      },
      toast: {
        error: "Erro ao atualizar",
        couldNotUpdate: "Não foi possível atualizar seu perfil. Tente novamente.",
      },
    },

    // Clip Edit page
    clipEdit: {
      loadingClip: "Carregando clipe…",
      errorLoading: "Erro ao carregar o clipe.",
      clipNotFound: "Clipe não encontrado.",
      clipExpired: "Este clipe expirou e não pode ser editado.",
      preparingClip: "Preparando clipe…",
      waitForGeneration: "Aguarde a geração atual deste clipe...",
      estimate: "Estimativa:",
    },
    clipStudio: {
      title: "AutoCut Studio",
      beta: "Beta",
      open: "AutoCut Studio",
      back: "Voltar",
      loading: "Abrindo o AutoCut Studio…",
      unavailable: "Não foi possível encontrar este corte.",
      sourcePreparing: "O vídeo deste corte ainda está sendo preparado. Tente de novo em alguns minutos.",
      sourceUnavailable: "O vídeo deste corte não está mais disponível.",
      goToClips: "Voltar aos cortes",
      unsupported: "O AutoCut Studio ainda não abre cortes {{composition}}.",
      loadFailed: "Não foi possível abrir o AutoCut Studio.",
      saving: "Salvando…",
      saved: "Salvo",
      saveFailed: "Não foi possível salvar o projeto do estúdio.",
      restart: "Recomeçar do corte",
      restartTitle: "Recomeçar do corte atual?",
      restartDescription: "O projeto do estúdio deste corte será substituído pelo corte como ele está agora no editor.",
      cancel: "Cancelar",
      confirmRestart: "Recomeçar",
      warnings: "Ainda não aparece no estúdio: {{list}}",
    },

    // Community Modal
    community: {
      title: "Comunidade The Clippers",
      joinNow: "Quero participar",
      close: "Fechar",
    },

    // WhatsApp Community Gate (hard block)
    communityGate: {
      title: "Entre na comunidade The Clippers",
      description: "Entre na nossa comunidade oficial no WhatsApp — é onde compartilhamos novidades, dicas e tiramos dúvidas em tempo real.",
      bullet1: "Receba avisos sobre novos recursos e atualizações em primeira mão",
      bullet2: "Tire dúvidas direto com o time e outros criadores",
      bullet3: "Aprenda estratégias de conteúdo viral com a galera",
      cta: "Entrar na comunidade no WhatsApp",
      dismiss: "Agora não",
      footer: "Você será redirecionado para o WhatsApp em uma nova aba.",
    },

    // News PDF Upload Modal
    newsPdf: {
      title: "Modo News",
      projectName: "Nome do Projeto",
      projectNamePlaceholder: "Digite o nome do projeto...",
      pdfFile: "Arquivo PDF",
      clickToSelectPdf: "Clique para selecionar o PDF",
      mp4Video: "Vídeo MP4",
      clickToSelectMp4: "Clique para selecionar o vídeo MP4",
      brandKitOptional: "Template (Opcional)",
      loadingBrandKits: "Carregando templates...",
      selectBrandKit: "Selecione um template (opcional)",
      proOnlyFeature: "Recurso disponível apenas no plano PRO",
      noBrandKit: "Nenhum template",
      myBrandKits: "Meus Templates",
      default: "Padrão",
      publicBrandKits: "Templates Públicos",
      brandKitTip: "💡 O template selecionado será aplicado automaticamente aos clipes gerados.",
      brandKitProOnly: "🔒 Atualize para o plano PRO para usar templates personalizados.",
      createFirstBrandKit: "Crie seu primeiro Template",
      brandKitDescription: "Personalize seus vídeos com cores, logos e fontes da sua marca. Templates garantem consistência visual em todos os seus clipes.",
      createBrandKit: "Criar Template",
      uploadingPdf: "Enviando PDF...",
      uploadingMp4: "Enviando vídeo MP4...",
      cancel: "Cancelar",
      uploadingFiles: "Enviando arquivos...",
      creating: "Criando...",
      createProject: "Criar Projeto",
      toast: {
        invalidFileType: "Tipo de arquivo inválido",
        onlyMp4: "Apenas arquivos .mp4 são aceitos para o vídeo",
        onlyPdf: "Apenas arquivos .pdf são aceitos",
        failedToReadVideo: "Falha ao ler vídeo",
        couldNotDetermineDuration: "Não foi possível determinar a duração do vídeo.",
        requiredFiles: "Arquivos obrigatórios",
        selectBothFiles: "Por favor, selecione tanto o vídeo MP4 quanto o PDF.",
        pdfUploadError: "Erro no upload do PDF",
        pdfUploadErrorDesc: "Ocorreu um erro durante o upload do PDF.",
        mp4UploadError: "Erro no upload do vídeo",
        mp4UploadErrorDesc: "Ocorreu um erro durante o upload do vídeo.",
        projectCreated: "Projeto criado com sucesso! 🎉",
        projectAdded: "\"{{name}}\" foi adicionado à sua lista de projetos.",
        projectError: "Erro ao criar projeto",
        projectErrorDesc: "Ocorreu um erro ao criar o projeto. Tente novamente.",
      },
    },

    // Configure Subtitles Modal
    configureSubtitles: {
      title: "Configurar Legendas com Templates",
      description: "Selecione um template para visualizar e aplicar legendas aos {{count}} clipes selecionados",
      availableBrandKits: "Templates Disponíveis",
      noBrandKitFound: "Nenhum template encontrado",
      createBrandKit: "Criar Template",
      myBrandKits: "Meus Templates",
      publicBrandKits: "Templates Públicos",
      default: "Padrão",
      public: "Público",
      subtitle: "Legenda",
      loadingClipData: "Carregando dados do clipe...",
      selectClipToPreview: "Selecione um clipe para visualizar",
      noTranscription: "Nenhuma transcrição disponível para este clipe",
      loadingPreview: "Carregando preview...",
      clipHasNoSubtitles: "O clipe não possui legendas",
      brandKitWillBeApplied: "O template será aplicado aos clipes selecionados",
      editBrandKit: "Editar Template",
      applying: "Aplicando...",
      applyToClips: "Aplicar aos {{count}} Clipes",
      selectBrandKitToPreview: "Selecione um template para visualizar o preview",
      selectedClips: "Clipes Selecionados ({{count}})",
      noClipSelected: "Nenhum clipe selecionado",
      clip: "Clipe",
      landscapeFormat: "Formato Paisagem (16:9)",
      portraitFormat: "Formato Retrato (9:16)",
      portraitWarning: "O vídeo será cortado automaticamente de acordo com os rostos falantes detectados no vídeo.",
      toast: {
        error: "Erro",
        noBrandKitSelected: "Nenhum template selecionado",
        success: "Sucesso!",
        appliedToClips: "Template aplicado a {{count}} clipe(s). Os vídeos estão sendo renderizados.",
        partiallyCompleted: "Parcialmente concluído",
        appliedWithErrors: "Template aplicado a {{success}} clipe(s). {{errors}} falharam.",
        applyError: "Não foi possível aplicar o template aos clipes.",
        unexpectedError: "Ocorreu um erro ao aplicar o template.",
        clipsTooLong: "{{count}} clipe(s) excedem o limite de 15 minutos para renderização de legendas e foram ignorados.",
        allClipsTooLong: "Todos os clipes selecionados excedem o limite de 15 minutos para renderização de legendas.",
      },
      tooLong: "Muito longo",
      editor: {
        customize: "Personalizar",
        readOnly: "somente leitura",
        save: "Salvar",
        saving: "Salvando...",
        brandKitSaved: "Template salvo com sucesso.",
        saveError: "Não foi possível salvar as alterações do template.",
        fontAndText: "Fonte e Texto",
        font: "Fonte",
        fontSize: "Tamanho da Fonte",
        textColor: "Cor do Texto",
        overridesPaletteDefault: "Substitui a cor padrão da paleta",
        revertToPaletteDefault: "Padrão da paleta",
        textAlign: "Alinhamento do Texto",
        textTransform: "Caixa do texto",
        textTransformNone: "Aa",
        textTransformNoneTooltip: "Como digitado — mantém a caixa original",
        textTransformUppercase: "AA",
        textTransformUppercaseTooltip: "Tudo em maiúsculas",
        textTransformLowercase: "aa",
        textTransformLowercaseTooltip: "Tudo em minúsculas",
        textTransformSmallCaps: "Small Caps",
        textTransformSmallCapsTooltip: "Small caps — primeira letra em altura total, demais reduzidas",
        removePunctuation: "Remover pontuação",
        removePunctuationHint: "Remove pontos, vírgulas e interrogações das palavras das legendas",
        highlight: "Destaque de Palavras",
        highlightCurrentWord: "Destacar Palavra Atual",
        highlightColor: "Cor de Destaque",
        highlightBox: "Caixa de Destaque",
        highlightBoxColor: "Cor de Fundo da Caixa",
        borderRadius: "Arredondamento",
        paddingX: "Margem Horizontal",
        paddingY: "Margem Vertical",
        positionAndLayout: "Posição e Layout",
        verticalPosition: "Posição Vertical",
        verticalMargin: "Margem Vertical",
        horizontalMargin: "Margem Horizontal",
        maxWordsPerLine: "Máx. Palavras por Linha",
        animation: "Animação",
        animationPrevious: "Animações anteriores",
        animationNext: "Próximas animações",
        tabHighlight: "Destaque",
        tabPosition: "Posição",
        tabEffects: "Efeitos",
        background: "Fundo",
        enableBackground: "Ativar Fundo",
        backgroundColor: "Cor do Fundo",
        opacity: "Opacidade",
        width: "Largura",
        height: "Altura",
        shadow: "Sombra",
        enableShadow: "Ativar Sombra",
        shadowColor: "Cor da Sombra",
        shadowSize: "Tamanho da Sombra",
        enableOutline: "Ativar Contorno",
        outlineColor: "Cor do Contorno",
        outlineWidth: "Espessura do Contorno",
        shadowStyleGlow: "Brilho",
        shadowStyleDrop: "Projetada",
        shadowOffsetX: "Deslocamento horizontal",
        shadowOffsetY: "Deslocamento vertical",
        logo: "Logo",
        uploadLogo: "Enviar Logo",
        logoUploaded: "Logo enviado",
        logoPosition: "Posição do Logo",
        logoOpacity: "Opacidade",
        logoSize: "Tamanho",
        hMargin: "Margem H.",
        vMargin: "Margem V.",
        unsavedChanges: "alterações não salvas",
        applying: "Aplicando...",
        applyToSelected: "Aplicar em {{count}} selecionados",
        selectedClipsCount: "{{count}} clip(s) selecionado(s)",
        selectClipsHint: "Selecione os clips abaixo para aplicar o template",
        livePreview: "Pré-visualização",
      },
    },

    // Project page
    project: {
      title: "Projeto",
      back: "Voltar",
    },

    // Vertical Clip Card
    verticalClipCard: {
      clipNumber: "Clipe #{{number}}",
      noPreview: "Sem Prévia",
      clickToSelect: "Clique para selecionar",
      preview: "Preview",
      ready: "Pronto",
      download: "Baixar",
      downloadingVideo: "Baixando vídeo...",
      browserNotSupported: "Seu navegador não suporta a reprodução de vídeos.",
      showRendered: "Mostrar vídeo renderizado",
      showPreview: "Mostrar preview ao vivo",
      versions: "Versões",
    },

    // Compartilhar Clipe
    shareClip: {
      share: "Compartilhar",
      scanToShare: "Compartilhar este clipe",
      scanQrCode: "Escaneie este QR code com seu celular para compartilhar o vídeo.",
      shareFailed: "Falha ao compartilhar o vídeo.",
    },

    // Página de Compartilhamento
    sharePage: {
      share: "Compartilhar",
      download: "Baixar",
      noVideo: "Nenhum vídeo para compartilhar.",
    },

    // Página de link curto
    shortLink: {
      notFound: "Link não encontrado ou expirado.",
      goHome: "Ir para o início",
    },

    // Project Editor Page
    editor: {
      coverImage: {
        title: 'Capa do vídeo',
        hint: 'A imagem vira o primeiro frame do vídeo exportado. TikTok, Reels e Shorts usam esse frame como capa.',
        captureFrame: 'Usar frame atual',
        chooseImage: 'Escolher imagem',
        replace: 'Trocar',
        remove: 'Remover',
        frameAt: 'Frame em {{time}}',
        capturing: 'Capturando frame...',
        uploading: 'Enviando imagem...',
        captureError: 'Não foi possível capturar o frame. Tente novamente.',
        uploadError: 'Não foi possível enviar a imagem. Tente novamente.',
        invalidImage: 'Esta imagem não pode ser usada como capa (precisa de um link https seguro). Escolha outra imagem.',
        previewAlt: 'Capa do vídeo',
        badge: 'Capa',
        frameSource: {
          label: 'Origem do frame',
          title: 'Escolha o frame da capa',
          description: 'Compare o frame como aparece na prévia (com layout, legendas e camadas) com o frame original do vídeo.',
          preview: 'Prévia',
          previewHint: 'Exatamente como na prévia: layout, legendas e camadas.',
          video: 'Vídeo original',
          videoHint: 'Só o frame do vídeo, sem layout nem legendas.',
          unavailable: 'Indisponível',
          retry: 'Tentar novamente',
          cancel: 'Cancelar',
          confirm: 'Usar este frame',
        },
        ai: {
          button: 'Gerar com IA',
          title: 'Gerar capa com IA',
          useReference: 'Usar o frame atual como referência',
          promptLabel: 'Descreva a capa',
          promptPlaceholder: 'Descreva o que você quer na capa, ou escolha sugestões abaixo',
          presetsLabel: 'Sugestões (clique para adicionar ou remover)',
          presets: {
            clickworthy: { label: 'Capa chamativa', prompt: 'Estilo capa viral que chama o clique' },
            dramaticCloseUp: { label: 'Close dramático', prompt: 'Close no rosto com expressão intensa e dramática' },
            bigTitle: { label: 'Título grande', prompt: 'Título curto, grande e legível em destaque' },
            shocked: { label: 'Reação de choque', prompt: 'Expressão de choque ou surpresa exagerada' },
            vibrant: { label: 'Cores vibrantes', prompt: 'Cores vibrantes e alto contraste' },
            cinematic: { label: 'Cinematográfico', prompt: 'Visual cinematográfico com luz dramática' },
            highlightArrow: { label: 'Seta de destaque', prompt: 'Seta ou círculo destacando o ponto principal' },
            minimal: { label: 'Minimalista', prompt: 'Composição minimalista com fundo limpo' },
          },
          quota: '{{used}} de {{limit}} geradas hoje · renova à meia-noite',
          generate: 'Gerar',
          generating: 'Gerando… pode levar até 1 minuto',
          useAsCover: 'Usar como capa',
          generateAnother: 'Gerar outra',
          proDialog: {
            title: 'Capa com IA é PRO',
            body: 'Gere capas com IA a partir do frame atual ou de uma descrição. Disponível nos planos PRO.',
            dismiss: 'Agora não',
            upgrade: 'Ver planos',
          },
          errors: {
            pro_required: 'A geração de capa com IA é exclusiva dos planos PRO.',
            daily_limit_reached: 'Você atingiu o limite de capas com IA de hoje. O limite renova à meia-noite.',
            invalid_prompt: 'Descreva a capa ou use o frame atual como referência.',
            invalid_reference: 'Não foi possível usar o frame atual como referência. Tente novamente.',
            not_found: 'Este corte não foi encontrado. Recarregue a página e tente novamente.',
            generation_failed: 'Não foi possível gerar a capa. Tente novamente.',
            timeout: 'A geração demorou demais. A imagem ainda pode aparecer em Minha mídia.',
            unknown: 'Algo deu errado ao gerar a capa. Tente novamente.',
          },
        },
      },
    },
    editOnly: {
      title: "Editar mesmo assim",
      description: "Escolha o trecho do vídeo, de até 1 minuto, arrastando o início e o fim, e continue no editor com ele. Ele não terá legendas, porque não há fala para transcrever.",
      startLabel: "Início do trecho",
      endLabel: "Fim do trecho",
      window: "Trecho: {{start}} → {{end}} ({{seconds}} s)",
      projectCharge: "Será cobrado o vídeo inteiro ({{duration}}) do seu tempo de processamento.",
      useSegment: "Usar este trecho",
      errorTitle: "Não foi possível abrir o editor",
      error: "Tente de novo em alguns instantes. Se continuar, fale com o suporte.",
    },
    clipperRun: {
      saved: "Pontuação salva na sua conta.",
      saving: "Salvando sua pontuação.",
      local: "Pontuação mantida neste navegador; não foi possível salvar no servidor.",
      label: "Corrida do Clipper, um joguinho enquanto você espera",
      hint: "Espaço ou toque para pular. Seta para baixo agacha.",
      retry: "Fim de jogo. Espaço ou toque para jogar de novo.",
      gameOver: "FIM DE JOGO",
      score: "PONTOS",
      best: "RECORDE",
    },
    projectEditor: {
      originalVideoDownload: {
        triggerLabel: 'Baixar vídeo original completo',
        title: 'Baixar vídeo original?',
        description:
          'Este arquivo contém o vídeo original completo ({{sourceDuration}}), não o corte atual ({{clipDuration}}).',
        descriptionWithoutDurations:
          'Este arquivo contém o vídeo original completo, não o corte atual.',
        exportHint: 'Para baixar o corte, use Exportar Vídeo.',
        cancel: 'Cancelar',
        confirm: 'Baixar vídeo original',
      },
      loadingProject: "Carregando projeto…",
      errorLoadingProject: "Erro ao carregar o projeto.",
      projectNotFound: "Projeto não encontrado.",
      errorProcessingProject: "Erro ao processar o projeto.",
      newsPdfMismatch: "O PDF do espelho não corresponde a este vídeo. Confira se o vídeo e o PDF são do mesmo bloco e crie o projeto de novo.",
      sourceNoAudio: "Este vídeo não tem áudio, então não foi possível transcrevê-lo. Exporte o vídeo de novo com o áudio ativado e crie o projeto outra vez.",
      transcriptEmpty: "Não encontramos fala neste vídeo. O Autoclipper escolhe os cortes a partir do que as pessoas dizem, então vídeos só com música ou sem fala não podem ser cortados. Tente um vídeo com pessoas falando, como um podcast, live ou entrevista.",
      transcriptTooSparse: "Este vídeo tem pouca fala para escolhermos cortes. O Autoclipper escolhe os cortes a partir do que as pessoas dizem, então tente um vídeo em que as pessoas falem na maior parte do tempo.",
      audioTrackUnavailable: "A faixa de áudio escolhida não está mais disponível neste vídeo. Importe novamente escolhendo outra faixa.",
      projectExpired: "Este projeto expirou e não pode ser editado.",
      estimatedTime: "Tempo estimado: ~{{minutes}} min",
      processingDescription: "Esta página atualiza automaticamente.",
      backToProjects: "Voltar aos projetos",
      backToLibrary: "Voltar ao acervo",
      // Toast messages
      quotaReached: "Limite de clipes atingido",
      upgradeToExport: "Você precisará atualizar seu plano para continuar exportando ou editando clipes.",
      quotaReachedTitle: "Você atingiu o limite mensal de clipes. Atualize seu plano para continuar.",
      minDuration: "A duração total dos segmentos deve ser de pelo menos 1 segundo",
      maxDuration: "A duração do clipe não pode exceder 20 minutos",
      thanksFeedback: "Obrigado pelo feedback!",
      feedbackRemoved: "Feedback removido",
      ratingRemoved: "Sua avaliação foi removida.",
      ratingRegistered: "Sua avaliação foi registrada.",
      feedbackError: "Erro ao registrar feedback",
      feedbackErrorDesc: "Ocorreu um erro ao registrar seu feedback. Tente novamente.",
      brandKitRequired: "Template obrigatório",
      disableSubtitlesFirst: "Você precisa desativar as legendas antes de remover o template.",
      brandKitUpdated: "Template atualizado!",
      brandKitApplied: "O template foi aplicado ao projeto.",
      brandKitRemoved: "O template foi removido do projeto.",
      brandKitUpdateError: "Erro ao atualizar template",
      brandKitUpdateErrorDesc: "Ocorreu um erro ao atualizar o template. Tente novamente.",
      autoClip: "Clipe Automático",
      defaultClipDescription: "Clipe padrão para edição livre",
      exportStarted: "Exportação iniciada com sucesso!",
      clipProcessing: "O clipe \"{{clipName}}\" está sendo processado. Você será notificado quando estiver pronto.",
      exportError: "Erro ao exportar vídeo",
      unexpectedError: "Ocorreu um erro inesperado durante a exportação.",
      editStarted: "Edição iniciada com sucesso!",
      clipEditProcessing: "O clipe \"{{clipName}}\" está sendo processado para edição. Você será notificado quando estiver pronto.",
      editError: "Erro ao editar vídeo",
      unexpectedEditError: "Ocorreu um erro inesperado durante a edição.",
      // UI labels
      editing: "Editando...",
      autoCropPending:
        "O corte automático ainda está sendo processado — por enquanto o enquadramento 9:16 está centralizado e pode mudar.",
      landscapeSwitch: {
        title: "Usar 16:9?",
        description:
          "Este layout só funciona em 9:16. Se continuar, o layout {{layout}} será usado.",
        confirm: "Usar {{layout}} em 16:9",
        cancel: "Cancelar",
      },
      exporting: "Exportando...",
      exportVideo: "Exportar Vídeo",
      clipsByViralization: "Cortes por Sequência de Viralização",
      feedbackQuestion: "Os cortes gerados atenderam ao que você esperava?",
      yesLiked: "Sim, gostei",
      noDisliked: "Não gostei",
      noClipsFound: "Nenhum clipe foi encontrado para este projeto",
      noClipsExplanation: "Isto pode ter ocorrido por não ter sido detectada nenhuma fala no vídeo. No entanto, você pode fazer clipes livremente no editor.",
      clipNumber: "Clipe #{{number}}",
      proOnlyFeature: "Recurso disponível apenas para usuários PRO",
      downloadVideo: "Baixar vídeo",
      skipBackward: "Voltar {{seconds}} segundos",
      skipForward: "Avançar {{seconds}} segundos",
      lockVideoNavigation: "Bloquear navegação aos trechos selecionados",
      unlockVideoNavigation: "Desbloquear navegação pelo vídeo completo",
      subtitlesAndBrandKit: "Legendas e Template",
      templatesSection: "Template",
      subtitlesSection: "Legendas",
      subtitlesToggleLabel: 'Exibir legendas',
      subtitlesOffHint: 'Ative para queimar legendas no vídeo exportado.',
      subtitleControlledByBrandKit: "As configurações de legenda são controladas pelo template selecionado.",
      selectBrandKitForStyles: "Selecione um template acima para aplicar estilos de legenda personalizados.",
      enableSubtitlesToApply: "Template selecionado. Para incluir as legendas no seu vídeo, ative as legendas acima.",
      selectBrandKit: "Selecione um template",
      noBrandKit: "Nenhum template",
      myBrandKits: "Meus Templates",
      default: "Padrão",
      publicBrandKits: "Templates Públicos",
      createCustomBrandKits: "Aplique seus templates pessoais com o Pro",
      upgradeToPro: "Atualizar para PRO",
      updatingProject: "Atualizando projeto...",
      clipTranscription: "Transcrição do Clipe",
      selectClipForTranscription: "Selecione um clipe para ver a transcrição",
      noTranscription: "Nenhuma transcrição disponível para este clipe",
      editTranscription: "Editar transcrição",
      cancelEditTranscription: "Cancelar",
      saveEditTranscription: "Salvar",
      clipSaved: "Clipe salvo com sucesso",
      transcriptionSaveError: "Erro ao salvar transcrição",
      discardTranscriptionChanges: "Descartar",
      revertToOriginalTranscription: "Reverter ao original",
      undoTranscriptionEdit: "Desfazer",
      redoTranscriptionEdit: "Refazer",
      undoEdit: "Desfazer",
      redoEdit: "Refazer",
      clickToEdit: "Clique para editar",
      headlinePosition: { move: "Mover manchete — arraste ou use as setas" },
      insertWordBefore: "Inserir palavra antes",
      insertWordAfter: "Inserir palavra depois",
      deleteSelectedWords: "Apagar {{count}} palavra(s)",
      deleteSubtitleOnly: "Apagar apenas legenda ({{count}})",
      deleteFromVideo: "Apagar trecho do vídeo ({{count}})",
      detectFillerWords: "Detectar vícios",
      fillerWordsFound: "{{count}} vício(s) de linguagem detectado(s)",
      noFillerWordsFound: "Nenhum vício de linguagem detectado neste clipe.",
      decoupClip: "Decupar",
      decoupClipHint:
        "Recortar trechos de silêncio e deixar apenas as partes faladas",
      decoupSilenceGapLabel: "Silêncio máximo entre palavras (s)",
      decoupPaddingLabel: "Margem ao redor de cada trecho (s)",
      decoupClipApply: "Aplicar decupagem",
      revertSegmentToOriginal: "Reverter este trecho ao original",
      selectAll: "Selecionar Todos",
      deselectAll: "Desmarcar Todos",
      exportNClips: "Exportar {{count}} Clipes",
      massExportStarted: "Exportação em massa iniciada!",
      massExportPreview: {
        title: 'Pré-visualizar {{count}} clipes',
        clipOf: 'Clipe {{current}} de {{count}}',
        exportN: 'Exportar {{count}}',
      },
      previewQuality: {
        compressed: 'Leve',
        full: 'HD',
        compressedTitle: 'Prévia comprimida: mais leve e rápida para editar. As exportações são sempre em qualidade máxima.',
        fullTitle: 'Qualidade máxima: a melhor fidelidade visual, porém mais pesada para carregar.',
        fullToastTitle: 'Prévia em qualidade máxima',
        exportsAlwaysFull: 'As exportações são sempre renderizadas em qualidade máxima, independente da prévia.',
      },
      saveBrandKit: { title: 'Salvar como template', body: 'Guarda as opções atuais de legenda, logo e layout como um template reutilizável.', namePlaceholder: 'Nome do template', confirm: 'Salvar template', cta: 'Salvar como template', created: 'Template criado!', driftHint: 'Suas alterações diferem do template aplicado — salve como um novo template para reutilizá-las.' },
      brandKitApplyProTitle: 'Aplicar templates pessoais é PRO',
      brandKitApplyProBody: 'Templates públicos estão disponíveis no plano gratuito. Aplicar um template pessoal criado por você requer o PRO.',
      bulkExportProTitle: 'Exportação em massa é PRO',
      bulkExportProBody: 'No plano gratuito você exporta um clipe por vez. Faça upgrade para selecionar todos os clipes e exportá-los de uma só vez.',
      massExportProcessing: "{{success}} clipes estão sendo processados. Você será notificado quando estiverem prontos.",
      massExportPartial: "{{success}} clipes exportados, {{errors}} falharam.",
      massExportError: "Erro ao exportar clipes",
      massExporting: "Exportando...",
      clipRated: "Clipe avaliado!",
      clipRatingRemoved: "Avaliação do clipe removida",
      clipRatingError: "Erro ao avaliar clipe",
      modified: "Modificado",
      saving: "Salvando...",
      tour: {
        clipsSelection: "Aqui estão os cortes gerados automaticamente pela IA, ordenados por sequência de viralização. Clique em um corte para visualizá-lo.",
        videoPlayer: "Nesta área você pode visualizar o corte selecionado. Use os controles de reprodução para assistir e navegar pelo vídeo.",
        subtitleControls: "Ative as legendas e selecione um template para personalizar o visual do seu vídeo. Templates permitem adicionar legendas estilizadas e logos.",
        transcription: "Aqui você pode ver a transcrição do clipe selecionado. Clique em uma palavra ou segmento para navegar diretamente para esse momento no vídeo.",
        exportButton: "Quando estiver satisfeito com o corte, clique aqui para exportar o vídeo nos formatos horizontal ou vertical.",
        helpButton: "Clique aqui para ver novamente o tour de como usar o editor de projetos.",
      },
      layers: {
        title: 'Camadas',
        add: 'Adicionar camada',
        addImage: 'Imagem',
        addVideo: 'Vídeo',
        addAudio: 'Áudio',
        addText: 'Texto',
        motion: 'Animação',
        motionUnavailable: 'Animação indisponível',
        addClip: 'Este clipe',
        clipMirrorName: 'Visão do clipe',
        empty: 'Nenhuma camada ainda. Solte uma imagem ou use “Adicionar camada”.',
        dropHint: 'Solte a imagem para adicionar como camada',
        opacity: 'Opacidade',
        start: 'Início (s)',
        end: 'Fim (s)',
        volume: 'Volume',
        textDefaultName: 'Texto',
        textContent: 'Texto',
        font: 'Fonte',
        fontSize: 'Tamanho',
        textColor: 'Cor',
        background: 'Fundo',
        backgroundEnabled: 'Cor de fundo',
        backgroundColor: 'Cor',
        backgroundOpacity: 'Opacidade',
        borderRadius: 'Arredondamento',
        paddingX: 'Espaçamento X',
        paddingY: 'Espaçamento Y',
        stroke: 'Contorno',
        strokeColor: 'Cor',
        strokeWidth: 'Espessura do contorno',
        shadow: 'Sombra',
        shadowColor: 'Cor da sombra',
        shadowBlur: 'Desfoque da sombra',
        shadowOffsetX: 'Deslocamento X',
        shadowOffsetY: 'Deslocamento Y',
        align: 'Alinhamento',
        alignLeft: 'Esquerda',
        alignCenter: 'Centro',
        alignRight: 'Direita',
        bold: 'Negrito',
        italic: 'Itálico',
        speed: 'Velocidade',
        style: 'Estilo',
        zoom: 'Zoom',
        reframe: 'Reenquadrar',
        framing: 'Enquadramento',
        fit: 'Encaixar',
        fill: 'Preencher',
        resetCell: 'Redefinir posição',
        deleteLayer: 'Excluir camada',
        proRequiredTitle: 'PRO necessário para exportar com camadas',
        proRequiredDescription: 'Você pode adicionar e visualizar camadas gratuitamente. Faça upgrade para PRO para exportar um clipe que contém camadas.',
        proExportDialogTitle: 'Você usou um recurso PRO',
        proExportDialogBody: 'Camadas de mídia são gratuitas para adicionar e visualizar, mas exportar o vídeo final com elas é um recurso PRO. Faça upgrade para exportar com as camadas — ou remova as camadas do clipe para exportar gratuitamente.',
        proExportDialogDismiss: 'Continuar editando',
        proExportDialogUpgrade: 'Fazer upgrade',
      },
      stockMedia: {
        titleVideo: 'Adicionar vídeo de banco',
        titleImage: 'Adicionar imagem de banco',
        searchPlaceholder: 'Buscar no {{provider}}…',
        uploadInstead: 'Enviar do computador',
        loadMore: 'Carregar mais',
        loading: 'Buscando…',
        noResults: 'Nenhum resultado. Tente outra busca.',
        error: 'A busca falhou. Tente novamente.',
        retry: 'Tentar novamente',
        providedBy: 'Mídia fornecida por {{provider}}',
        libraryTab: 'Minha mídia',
      },
      transitionsProTitle: 'Transições são um recurso PRO',
      transitionsProBody: 'Você pode adicionar e visualizar transições gratuitamente, mas exportar um clipe com transições requer o plano PRO. Remova as transições ou faça upgrade para exportar.',
    },

    // Project Clips Page
    projectClips: {
      source: {
        preparing: {
          title: 'As sugestões de cortes estão prontas',
          description: 'O vídeo ainda está sendo preparado. A prévia, a edição e a exportação serão liberadas aqui automaticamente.',
        },
        failed: {
          title: 'Não foi possível preparar o vídeo',
          description: 'Suas sugestões estão salvas. Tente importar novamente ou entre em contato com o suporte para preparar o vídeo para exportação.',
        },
        expired: {
          title: 'O vídeo original expirou',
          description: 'Importe o vídeo novamente para visualizar, editar e exportar esses cortes.',
        },
      },
      loading: "Carregando...",
      loadingSteps: {
        title: "Carregando seus clipes...",
        library: "Carregando dados do acervo",
        clips: "Carregando clipes",
        sceneDetection: "Carregando detecção de cenas",
        transcription: "Carregando transcrição",
      },
      clipsReady: "Seus clipes estão prontos!",
      clipsOptimized: "{{count}} clipes otimizados para redes sociais",
      deselectAll: "Desselecionar Todos",
      selectAll: "Selecionar Todos",
      selectedOf: "{{selected}} de {{total}} selecionados",
      configureSubtitles: "Configurar Legendas",
      selectBrandKit: "Selecionar Template",
      applyBrandKit: "Aplicar Template",
      applyingBrandKit: "Aplicando...",
      noBrandKits: "Sem templates",
      downloadSRT: "Baixar SRT",
      downloadPDF: "Baixar PDF",
      titlesGenerated: "Títulos gerados",
      titlesGeneratedCopyAgain: "Os títulos foram gerados. Clique no botão novamente para copiá-los.",
      copyAllTitles: "Copiar Títulos",
      downloadTitles: "Baixar Títulos",
      downloadAll: "Baixar Todos ({{count}})",
      downloading: "Baixando...",
      downloadingVideos: "Baixando vídeos...",
      export: "Exportar",
      exportSelected: "Exportar Selecionados ({{count}})",
      exporting: "Exportando...",
      exportingVideos: "Enfileirando clipes para exportação...",
      ofTotal: "{{current}} de {{total}}",
      failedToLoadClips: "Falha ao carregar clipes.",
      noClipsFound: "Nenhum clipe encontrado para este projeto.",
      loadingMore: "Carregando mais...",
      editVideo: "Editar Vídeo",
      rendering: "Renderizando...",
      previewClips: "Pré-visualização de Clipes",
      styleConfig: {
        subtitlesToggle: "Legendas",
        stylize: "Estilizar",
        emptyKits: "Você ainda não tem templates.",
        emptyKitsCta: "Criar template",
      },
      speakerLayout: {
        title: "Layout",
        detected: "{{count}} speakers detectados",
        single: "Único",
        speakers: "{{count}} Speakers",
        twitterLayout: "Modelo X",
        twitterAvatarUrl: "URL do Avatar",
        twitterDisplayName: "Nome de Exibição",
        twitterHandle: "Handle (@usuário)",
        twitterTweetText: "Texto do Post",
      },
      enforcedLayout: {
        notice: 'Layout definido pela campanha',
        subtitleMarginLocked: 'Margem definida pela campanha',
      },
      postLayouts: {
        title: 'Layout de Post',
        none: 'Nenhum',
        upload: 'Enviar',
        uploading: 'Enviando…',
        common: { image: 'Imagem', headline: 'Manchete', accent: 'Cor de destaque', headlineColor: 'Cor do texto', headlineFont: 'Fonte', headlineSize: 'Tamanho do texto' },
        choquei: {
          label: 'Choquei',
          image: 'Imagem',
          brandName: 'Nome da marca',
          headline: 'Manchete',
          logo: 'URL do logo',
          accent: 'Cor de destaque',
        },
        breakingNews: { label: 'Notícia Urgente', channel: 'Nome do canal', tag: 'Selo', logo: 'URL do logo' },
        newspaper: { label: 'Jornal', source: 'Nome do veículo', kicker: 'Linha fina / data' },
        instagram: { label: 'Instagram', handle: 'Perfil', caption: 'Legenda', likes: 'Curtidas', avatar: 'URL do avatar' },
        factQuote: { label: 'Fato / Citação', textColor: 'Cor do texto', scrim: 'Cor do overlay' },
        newsPost: {
          label: 'Post de Notícia',
          style: 'Estilo',
          styleChoquei: 'Fofoca',
          styleBreaking: 'Urgente',
          styleNewspaper: 'Jornal',
          styleInstagram: 'Instagram',
          brandName: 'Nome da marca / veículo',
          tag: 'Selo',
          kicker: 'Linha fina / data',
          likes: 'Curtidas',
        },
        fofoca: {
          label: 'Fofoca',
          image: 'Imagem',
          filler: 'Vídeos de preenchimento',
          storyMedia: 'Mídia da história',
          mediaImage: 'Imagem',
          mediaVideo: 'Vídeo',
          avatar: 'Foto do perfil',
          profileName: 'Nome do perfil',
          caption: 'Texto do post',
          badgeImage: 'Imagem do selo',
          badgeBorderRadius: 'Arredondamento do selo',
          assetReuseHint: 'Os uploads de perfil e selo ficam salvos em Minhas Mídias. Salve este estilo como Template para reutilizar as duas imagens.',
          videoTitle: 'Título sobre o vídeo',
          videoTitleFont: 'Fonte do título',
          videoTitleFontSize: 'Tamanho do título',
          handle: 'Arroba sobre o vídeo',
          portraitOnly: 'O layout Fofoca usa apenas o formato 9:16',
          accent: 'Cor de destaque',
          useCurrentFrame: 'Usar quadro atual do vídeo',
          capturingFrame: 'Capturando quadro…',
          captureFrameError: 'Não foi possível capturar este quadro. Tente outro momento ou envie uma imagem.',
          sectionMedia: 'Mídia da história',
          sectionProfile: 'Perfil',
          sectionBadge: 'Selo',
          sectionTitle: 'Título',
          clipPosition: 'Posição do clipe',
          clipOnRight: 'Clipe à direita',
          clipOnLeft: 'Clipe à esquerda',
        },
        cortes: {
          label: 'Cortes',
          background: 'Imagem de fundo',
          photo1: 'Mídia superior esquerda',
          photo2: 'Mídia superior direita',
          photo3: 'Mídia inferior esquerda',
          photo4: 'Mídia inferior direita',
          handle: 'Arroba / perfil',
          boxColor: 'Cor da caixa da manchete',
          boxWidth: 'Largura da caixa',
          headlineColor: 'Cor da manchete',
          headlineFont: 'Fonte da manchete',
          headlineSize: 'Tamanho da manchete',
          presets: {
            caixaVermelha: 'Caixa de Texto',
            barraBranca: 'Barra de Texto',
          },
          importCapcut: 'Importar do CapCut (.zip)',
          importing: 'Importando…',
          importNotice: 'Estilos e posições importados. Algumas imagens não estavam no arquivo — envie-as manualmente.',
          importErrorTitle: 'Não foi possível importar',
          importErrors: {
            invalid_zip: 'O arquivo não é um .zip válido.',
            no_draft_content: 'O .zip não contém um draft_content.json do CapCut. Compacte a pasta inteira do preset.',
            invalid_json: 'O draft_content.json está corrompido ou em um formato não suportado.',
            no_content: 'O preset não contém fotos nem textos importáveis.',
            upload_failed: 'Falha ao enviar as imagens do preset. Tente novamente.',
          },
        },
        circulo: {
          label: 'Círculo',
          cima: 'Círculo cima',
          baixo: 'Círculo',
          arc: 'Arco da legenda',
          arcUpper: 'Cima',
          arcLower: 'Baixo',
          sectionBackground: 'Fundo',
          backgroundColor: 'Cor de fundo',
          backgroundMedia: 'Mídia de fundo',
          mediaImage: 'Imagem',
          mediaVideo: 'Vídeo',
          still: 'Imagem de fundo',
          filler: 'Vídeos de fundo',
        },
        satisfatorio: {
          label: 'Tela Dividida',
          filler: 'Vídeo de preenchimento',
          myUploads: 'Meus vídeos',
          title: 'Título',
          titleFrame: 'Moldura do título',
          frameNone: 'Nenhum',
          framePill: 'Pílula',
          frameDark: 'Escuro',
          frameAccent: 'Destaque',
          frameOutline: 'Contorno',
          frameBar: 'Faixa inteira',
          speed: 'Velocidade do preenchimento',
          titleColor: 'Cor do título',
          clipPosition: 'Posição do clipe',
          clipOnTop: 'Clipe em cima',
          clipOnBottom: 'Clipe embaixo',
          ratio: 'Tamanho do clipe',
          noPresets: 'Nenhum vídeo disponível ainda — envie o seu abaixo.',
          dialogTitle: 'Acervo de vídeos de preenchimento',
          searchPlaceholder: 'Buscar vídeos…',
          allTags: 'Todos',
          noResults: 'Nenhum vídeo encontrado.',
          browseAll: 'Ver todos ({{count}})',
          carouselPrevious: 'Vídeos de preenchimento anteriores',
          carouselNext: 'Próximos vídeos de preenchimento',
          useFrameAtSeconds: 'Usar um quadro do vídeo em {{seconds}} segundos',
          customVideo: 'Vídeo personalizado',
          sectionVideo: 'Vídeo de preenchimento',
          sectionTitle: 'Título',
          sectionLayout: 'Layout',
          selectedCount: '{{count}} selecionado(s)',
          clearSelection: 'Limpar',
          confirmSelection: 'Confirmar ({{count}})',
          playlistLabel: 'Sequência de vídeos ({{count}})',
          allVideosLabel: 'Todos os vídeos',
          removeFromPlaylist: 'Remover da sequência',
          removeSelectedVideo: 'Remover vídeo',
          autoFillRandom: 'Preencher aleatório',
          fitVideo: 'Encaixar',
          fillVideo: 'Preencher',
          positionTopFirst: 'Mostrar topo',
          positionCenter: 'Mostrar centro',
          positionBottomFirst: 'Mostrar base',
        },
        tripleSplit: {
          label: 'Tela Tripla',
          fillerTop: 'Vídeo de preenchimento de cima',
          fillerBottom: 'Vídeo de preenchimento de baixo',
          title: 'Manchete de cima',
          title2: 'Manchete de baixo',
        },
        binds: {
          clipTitle: 'título do clipe',
          channel: 'canal',
          clipTitleHint: 'Usar o título de cada clipe',
          useClipTitle: 'Usar Título do Clipe',
          channelNameHint: 'Usar o nome do canal do YouTube',
          channelAvatarHint: 'Usar a foto do canal do YouTube',
          useChannelAvatar: 'Usar avatar do canal do vídeo',
          useChannelName: 'Usar nome do canal do vídeo',
          useChannelWhenAvailable: 'Será usado quando o canal estiver disponível',
          useMyAvatar: 'Usar meu avatar',
          useMyName: 'Usar meu nome',
        },
      },
      detectionInProgress: {
        title: "Detecção de cenas e rostos está sendo processada em segundo plano",
        description: "Você pode editar seus vídeos enquanto o processamento acontece. Quando finalizado, a visualização 9:16 estará totalmente disponível para seus clipes. Vídeos exportados são sempre em formato 9:16.",
      },
      sceneDetectionUnavailable: {
        title: "A prévia de detecção de cenas está temporariamente indisponível",
        description: "Seus clipes continuam utilizáveis, mas o enquadramento inteligente da prévia pode ficar limitado até a detecção de cenas carregar novamente.",
        timeoutDescription: "A detecção de cenas demorou demais para carregar. Seus clipes continuam utilizáveis, mas o enquadramento inteligente da prévia pode ficar limitado por enquanto.",
      },
      translationFailed: "Não foi possível traduzir a transcrição. As legendas e os títulos estão no idioma do áudio.",
      transcriptionUnavailable: {
        title: "A prévia da transcrição está temporariamente indisponível",
        description: "Seus clipes continuam utilizáveis, mas os recursos de prévia de legendas podem ficar limitados até a transcrição carregar novamente.",
        timeoutDescription: "A transcrição demorou demais para carregar. Seus clipes continuam utilizáveis, mas os recursos de prévia de legendas podem ficar limitados por enquanto.",
      },
      deleteSelected: "Excluir ({{count}})",
      deleting: "Excluindo...",
      toast: {
        downloadCompleted: "Download concluído",
        videosDownloaded: "{{success}} vídeo(s) baixado(s) com sucesso{{failed}}.",
        failed: ", {{count}} falhou(ram)",
        downloadError: "Erro no download",
        couldNotDownload: "Não foi possível baixar os vídeos selecionados.",
        srtDownloaded: "Legendas SRT baixadas com sucesso.",
        noTranscription: "Nenhuma transcrição disponível para este projeto.",
        exportStarted: "Exportação iniciada",
        exportingClips: "{{count}} clipe(s) enfileirado(s) para exportação.",
        exportPartial: "Exportação parcial",
        exportingWithErrors: "{{success}} clipe(s) enfileirado(s), {{errors}} falhou(ram).",
        exportError: "Erro na exportação",
        couldNotExport: "Não foi possível exportar os clipes selecionados.",
        deleteCompleted: "{{count}} clipe(s) excluído(s) com sucesso.",
        deleteError: "Falha ao excluir {{count}} clipe(s).",
      },
      tour: {
        pageTitle: "Esta página exibe todos os clipes exportados deste projeto específico.",
        clipsGrid: "Aqui você vê todos os clipes que foram criados a partir deste projeto. Clique em um clipe para fazer download, editar ou gerenciar o vídeo.",
        helpButton: "Clique aqui para ver novamente o tour da página de clipes do projeto.",
      },
    },

    // Brand Kits New/Edit Page
    brandKitsNew: {
      newBrandKit: "Novo Template",
      editBrandKit: "Editar Template",
      brandKitName: "Nome do Template",
      brandKitNamePlaceholder: "Digite um nome para o seu template",
      previewSubtitleText: "Este é um exemplo de legenda",
      sampleClipTitle: "Como os melhores criadores crescem tão rápido",
      tabs: {
        colors: "Cores",
        typography: "Tipografia",
        logo: "Logotipo",
        subtitles: "Legendas",
      },
      colors: {
        title: "Paleta de Cores",
        description: "Defina as cores que representam sua marca",
        noColors: "Nenhuma cor adicionada ainda.",
        addColorTip: "Clique em \"Adicionar Cor\" para começar a construir sua paleta.",
        addColor: "Adicionar Cor",
      },
      typography: {
        title: "Tipografia",
        description: "Defina as fontes usadas em sua marca",
        titlesFont: "Fonte dos Títulos",
        titlesFontSize: "Tamanho da Fonte dos Títulos",
        bodyFont: "Fonte do Corpo",
        bodyFontSize: "Tamanho da Fonte do Corpo",
      },
      logo: {
        title: "Logotipo",
        description: "Faça upload do logo da sua marca",
        noLogo: "Nenhum logo enviado",
        selectFile: "Selecionar arquivo",
        uploadingLogo: "Fazendo upload...",
        logoUploaded: "Logo carregada",
        clickToRemove: "Clique no botão ao lado para remover",
        pleaseWait: "Aguarde...",
        position: "Posição",
        opacity: "Opacidade",
        size: "Tamanho",
        horizontalMargin: "Margem Horizontal",
        verticalMargin: "Margem Vertical",
      },
      subtitles: {
        title: "Legendas",
        description: "Personalize como suas legendas aparecem",
        font: "Fonte da Legenda",
        fontSize: "Tamanho da Fonte",
        textColor: "Cor do Texto",
        textAlign: "Alinhamento do Texto",
        alignLeft: "Alinhar à Esquerda",
        alignCenter: "Centralizar",
        alignRight: "Alinhar à Direita",
        maxWordsPerLine: "Máximo de Palavras por Linha",
        highlight: "Destaque",
        highlightEnabled: "Destaque Ativado",
        highlightColor: "Cor do Destaque",
        highlightBox: "Caixa de Destaque",
        highlightBoxEnabled: "Caixa de Destaque Ativada",
        highlightBoxColor: "Cor da Caixa de Destaque",
        highlightBoxBorderRadius: "Raio da Borda da Caixa",
        highlightBoxPaddingX: "Padding Horizontal da Caixa",
        highlightBoxPaddingY: "Padding Vertical da Caixa",
        background: "Fundo",
        backgroundEnabled: "Fundo Ativado",
        backgroundColor: "Cor de Fundo",
        backgroundOpacity: "Opacidade do Fundo",
        backgroundWidth: "Largura do Fundo",
        backgroundHeight: "Altura do Fundo",
        shadow: "Sombra",
        shadowEnabled: "Sombra Ativada",
        shadowColor: "Cor da Sombra",
        shadowSize: "Tamanho da Sombra",
        animation: "Animação",
        selectAnimation: "Selecionar animação",
        position: "Posição",
        verticalPosition: "Posição Vertical",
        top: "Superior",
        middle: "Centro",
        bottom: "Inferior",
        horizontalPosition: "Posição Horizontal",
        left: "Esquerda",
        center: "Centro",
        right: "Direita",
        marginVertical: "Margem Vertical",
        marginHorizontal: "Margem Horizontal",
      },
      preview: {
        title: "Preview",
        landscape: "Paisagem (16:9)",
        portrait: "Retrato (9:16)",
        showSafeZone: "Mostrar Zona Segura",
        safeZonePortraitOnly: "Zona segura disponível apenas no modo retrato",
        noVideoAvailable: "Nenhum vídeo disponível para preview",
      },
      positions: {
        topLeft: "Superior Esquerda",
        topCenter: "Superior Centro",
        topRight: "Superior Direita",
        centerLeft: "Centro Esquerda",
        center: "Centro",
        centerRight: "Centro Direita",
        bottomLeft: "Inferior Esquerda",
        bottomCenter: "Inferior Centro",
        bottomRight: "Inferior Direita",
      },
      toast: {
        loadError: "Erro ao carregar template. Verifique se o ID é válido.",
        loadDataError: "Erro ao carregar dados do template",
        created: "Template criado com sucesso!",
        createError: "Erro ao criar template. Tente novamente.",
        updated: "Template atualizado com sucesso!",
        updateError: "Erro ao atualizar template. Tente novamente.",
        uploadError: "Erro ao fazer upload do logo",
        uploadFailed: "Erro no upload: {{error}}",
        nameRequired: "Por favor, insira um nome para o template.",
        logoRemoved: "Logo removido",
        colorRemoved: "Cor removida",
      },
      save: "Salvar Template",
      saving: "Salvando...",
      tour: {
        nameInput: "Comece dando um nome ao seu template. Este nome ajuda a identificar o template ao aplicá-lo em seus vídeos.",
        tabs: "Use estas abas para navegar entre as diferentes configurações: Cores, Tipografia, Logotipo e Legendas.",
        sidePanel: "Edite a paleta, o layout, o logo e as legendas aqui. As mudanças aparecem ao vivo na prévia.",
        preview: "Aqui você pode ver uma prévia em tempo real de como seu template ficará aplicado em um vídeo.",
        saveButton: "Quando estiver satisfeito com as configurações, clique aqui para salvar seu template e aplicá-lo aos seus vídeos.",
        helpButton: "Clique aqui para ver novamente o tour de criação de templates.",
      },
    },

    // Admin Pages
    admin: {
      aiUsage: {
        title: 'Uso do assistente de IA',
        subtitle: 'Tokens e custo estimado por usuário. O custo usa o preço público de API de cada modelo.',
        from: 'De',
        to: 'Até',
        presets: { d7: '7 dias', d30: '30 dias', d90: '90 dias' },
        brlRate: 'Cotação USD→BRL',
        search: 'Buscar por nome ou e-mail',
        exportCsv: 'Exportar CSV',
        exportError: 'Não foi possível exportar o CSV.',
        loadError: 'Não foi possível carregar o relatório.',
        retry: 'Tentar novamente',
        empty: 'Nenhum uso no período.',
        unpriced: '{{count}} chamadas sem preço configurado',
        kpis: {
          activeUsers: 'Usuários ativos',
          messages: 'Mensagens',
          tokens: 'Tokens (entrada / saída)',
          cost: 'Custo estimado',
          costPerMessage: 'Custo por mensagem',
          costPerUser: 'Custo por usuário ativo',
          failedCalls: 'Chamadas com erro',
        },
        byDay: 'Por dia',
        byModel: 'Por modelo',
        users: 'Usuários',
        columns: {
          user: 'Usuário',
          plan: 'Plano',
          messages: 'Mensagens',
          calls: 'Chamadas',
          promptTokens: 'Entrada',
          completionTokens: 'Saída',
          cost: 'Custo',
          costPerMessage: 'Custo/msg',
          lastUsed: 'Último uso',
          model: 'Modelo',
          purpose: 'Uso',
          day: 'Dia',
        },
        purpose: { chat: 'Conversa', vision: 'Visão' },
        paid: 'Pago',
        free: 'Grátis',
        page: 'Página {{page}} de {{pages}}',
      },
      contacts: {
        description: "Cada envio do formulário aparece aqui. Novos pedidos de um contato existente são marcados como duplicados.",
        requestCount_one: "{{count}} solicitação",
        requestCount_other: "{{count}} solicitações",
        duplicate: "Duplicado",
        original: "Novo",
        requestType: "Tipo de solicitação",
        duplicateHint: "Novo pedido de um contato já cadastrado. A conversa de acompanhamento continua no contato original.",
        origins: {
          label: "Filtrar por origem",
          all: "Todas",
          app: "App",
          site: "autoclipper.live",
          marcas: "marcas.autoclipper.live",
          other: "Outras",
        },
      },
      resultados: {
        title: "Resultados & Métricas",
        subtitle: "Visão consolidada da jornada e desempenho da plataforma",
        tabs: {
          overview:  "Visão Geral",
          users:     "Usuários",
          campaigns: "Campanhas",
          partners:  "Parcerias",
        },
        vsLastMonth: "vs. mês anterior",
        vsLastWeek: "vs. semana anterior",
        kpi: {
          users: "Usuários registrados",
          clips: "Clipes criados",
          downloads: "Downloads realizados",
          projects: "Projetos criados",
          ownBrand: "Minha Marca",
          otherChannels: "Outros Canais",
          periodLabel: "Variação:",
          period_7d: "Semana",
          period_30d: "Mês",
        },
        conversion: {
          title: "Conversão Free → Pago",
          rate: "Taxa de conversão",
          totalFree: "Usuários gratuitos",
          totalPaid: "Usuários pagos",
          tooltip: "Usuários criados no período selecionado, separados entre plano gratuito e plano pago ativo.",
        },
        chart: {
          newUsers: "Novos usuários por dia",
          clipsCreated: "Clipes criados por dia",
          users: "Usuários",
          clips: "Clipes",
        },
        funnel: {
          steps: {
            signup: "Cadastro",
            onboarding: "Onboarding",
            first_project: "1º Projeto",
            first_clip: "1º Clipe",
            first_download: "1º Download",
            first_curation: "1ª Curadoria",
            first_export: "1ª Exportação",
          },
          creator: {
            title: "Funil — Criador de Conteúdo",
            subtitle: "Jornada do usuário com objetivo 'Minha Marca'",
          },
          clipper: {
            title: "Funil — Clipador",
            subtitle: "Jornada do usuário com objetivo 'Outros Canais'",
          },
        },
        sources: {
          sectionTitle: "Origem dos projetos",
          creator: "Minha Marca — fonte dos projetos",
          clipper: "Outros Canais — fonte dos projetos",
          youtube: "Link YouTube",
          local: "Upload Local",
          acervo: "Acervo",
        },
        retention: {
          sectionTitle: "Retenção após 1º Export",
          subtitle: "Usuários que exportaram ≥ 1 clipe e voltaram à plataforma",
          tooltip: "Mede quantos usuários voltaram a criar ou exportar clipes após a primeira exportação, separado por fluxo.",
          chartLabel: "Retorno",
          creator: "Criador de Conteúdo (Minha Marca)",
          clipper: "Clipador (Outros Canais)",
          source: "Fonte: backend — atividade de clipes exportados",
        },
        campaigns: {
          title: "Ganhe com Cortes — Campanhas",
          subtitle: "Participação dos clipadores nas campanhas CPM",
          enrolled: "Inscritos",
          submitted: "Clipes submetidos",
          approved: "Clipes aprovados",
          earnings: "Total pago aos criadores",
          clipperToPaid: "Clipadores que assinaram após participar",
          clipperToPaidTooltip: "Clipadores com pelo menos 1 participação em campanha e plano pago ativo no período selecionado.",
          subscriberToCampaign: "Assinantes que participam de campanhas",
        },
        nwc: {
          title: "Parceria NWC — Networking Cortes",
          subtitle: "Usuários que vieram por indicação da parceria com a Networking Cortes (?affiliate=nwc)",
          total: "Usuários via NWC",
          paidPct: "Conversão para pago",
          campaignPct: "Participação em campanhas",
          retentionTitle: "Retenção NWC vs Orgânico",
          retentionTooltip: "Percentual de usuários que voltaram a exportar ao menos 1 clipe após o primeiro uso, por janela de tempo. NWC em azul, orgânico em cinza.",
          organic: "Orgânico",
          retentionNote: "Retenção medida: usuários que exportaram pelo menos 1 clipe após o primeiro uso.",
        },
        campaignPerformance: {
          title: "Desempenho por Campanha",
          subtitle: "Visão real de cada campanha CPM — clipes submetidos e uso do orçamento",
          submissions: "clipes",
          spent: "utilizado",
          viewDetail: "Ver detalhes",
          noCampaigns: "Nenhuma campanha encontrada.",
        },
      },
      cpmLeads: {
        title: "Leads CPM",
        subtitle: "Leads de marcas e a conversa delas com a Lara no WhatsApp.",
        searchPlaceholder: "Buscar por nome, email, telefone ou empresa",
        loading: "Carregando…",
        empty: "Nenhum lead ainda.",
        pickLead: "Escolha um lead para ver a conversa.",
        back: "Voltar aos leads",
        noMessages: "Ainda não há mensagens de WhatsApp guardadas para este lead.",
        loadError: "Não foi possível carregar os leads.",
        lara: "Lara",
        lead: "Lead",
        team: "Equipe",
        replyPlaceholder: "Responder no WhatsApp",
        send: "Enviar",
        sending: "Enviando…",
        sendFailed: "Não enviado",
        sendError: "Não foi possível enviar a resposta.",
        restart: "Recomeçar",
        restarting: "Recomeçando…",
        restartConfirm: "A Lara apaga o briefing desta conversa e reenvia o resumo do formulário, como se a pessoa tivesse acabado de se cadastrar. Continuar?",
        restartError: "Não foi possível recomeçar o briefing.",
        briefTitle: "Briefing",
        briefMissing: "Lacunas",
        diagnosisTitle: "Perguntas para o Gerson",
        form: {
          profile: "Perfil",
          objective: "Objetivo",
          content: "Conteúdo",
          platforms: "Plataformas",
          budget: "Orçamento",
          company: "Empresa",
          email: "Email",
          phone: "Telefone",
          website: "Site",
          social: "Redes",
        },
        budgets: {
          range_1k_5k: "R$ 1.000 – 5.000",
          range_5k_10k: "R$ 5.000 – 10.000",
          range_10k_50k: "R$ 10.000 – 50.000",
          range_50k_100k: "R$ 50.000 – 100.000",
          range_100k_plus: "R$ 100.000+",
          undecided: "Ainda definindo",
          range_5k_20k: "R$ 5 mil – 20 mil",
          range_10k_20k: "R$ 10 mil – 20 mil",
          range_20k_50k: "R$ 20 mil – 50 mil",
          range_50k_150k: "R$ 50 mil – 150 mil",
          range_150k_plus: "Acima de R$ 150 mil",
        },
        states: {
          captured: "Capturado",
          contacted: "Lara chamou",
          briefing: "Briefing",
          brief_complete: "Briefing fechado",
          diagnosed: "Diagnóstico",
          meeting_link_sent: "Agenda",
          meeting_booked: "Reunião marcada",
          meeting_held: "Reunião feita",
          opted_out: "Opt-out",
          human_handoff: "Humano",
          lost: "Perdido",
        },
      },
      botConversations: {
        title: "Conversas do Bot",
        subtitle: "Audite todas as conversas de Telegram/WhatsApp que os usuários tiveram com o bot.",
        searchPlaceholder: "Buscar por identidade, nome, email ou telefone",
        allChannels: "Todos os canais",
        allLinks: "Todos",
        linkedOnly: "Vinculados",
        unlinkedOnly: "Não vinculados",
        hasErrors: "Apenas com erros",
        columnChannel: "Canal",
        columnIdentity: "Identidade",
        columnUser: "Conta",
        columnMessages: "Mensagens",
        columnLastSeen: "Última atividade",
        unlinked: "Não vinculado",
        noConversations: "Nenhuma conversa encontrada.",
        backToList: "Voltar às conversas",
        backToUser: "Voltar ao usuário",
        perUserTitle: "Conversas do Bot",
        userNoConversations: "Este usuário ainda não conversou com o bot.",
        memorySummary: "Resumo de memória da IA",
        memoryUpdatedAt: "Atualizado",
        noMemory: "Ainda sem resumo de memória.",
        firstSeen: "Primeiro contato",
        lastSeen: "Último contato",
        totalMessages: "Mensagens",
        inbound: "Usuário",
        outbound: "Bot",
        intent: "intenção",
        source: "origem",
        flow: "fluxo",
        model: "modelo",
        mediaOnly: "[mídia]",
        startOfConversation: "Início da conversa",
        entryButton: "Conversas do Bot",
      },
      common: {
        total: "Total",
        page: "Página",
        of: "de",
        noResults: "Nenhum resultado encontrado",
        error: "Erro ao carregar dados",
        chartTotal: "Total",
        chartSuccess: "Sucesso",
        chartFailure: "Falha",
      },
      stats: {
        platformOverview: "Visão Geral da Plataforma",
        totalUsers: "Total de Usuários",
        confirmedUsers: "Confirmados",
        adminUsers: "Admins",
        blockedUsers: "Bloqueados",
        usersByPlan: "Usuários por Plano",
        entityStats: "Atividade da Plataforma",
        projects: "Projetos",
        clips: "Clipes",
        downloads: "Downloads",
        total: "Total",
        success: "Sucesso",
        processing: "Processando",
        queued: "Na fila",
        failure: "Falha",
      },
      users: {
        title: "Usuários",
        subtitle: "Gerenciar todos os usuários da plataforma",
        list: "Lista de Usuários",
        searchPlaceholder: "Buscar por nome, email ou telefone...",
        filterByPlan: "Filtrar por plano",
        allPlans: "Todos os planos",
        name: "Nome",
        email: "Email",
        phone: "Telefone",
        whatsapp: "WhatsApp",
        country: "País",
        plan: "Plano",
        provider: "Provider",
        createdAt: "Criado em",
        usersOnPlan: "usuários",
        usage: "Uso",
        currentUsage: "Uso Atual",
        usagePreview: "Prévia de Uso",
        current: "Atual",
        afterChanges: "Após alterações",
        used: "utilizado",
        library: "Acervo",
        payments: "Pagamentos",
        ltv: "LTV",
        actions: "Ações",
        editUser: "Editar Usuário",
        editUserDesc: "Editar assinatura de {{name}}",
        reliability: {
          title: "Confiabilidade da conta",
          column: "Confiabilidade",
          scorePart: "{{platform}} {{score}}",
          platforms: {
            instagram: "Instagram",
            tiktok: "TikTok",
            youtube: "YouTube",
          },
        },
        userType: "Tipo",
        selectUserType: "Selecione o tipo de usuário",
        ownBrand: "Minha Marca",
        otherChannels: "Outros Canais",
        utmSource: "UTM Source",
        utmSources: "Filtrar por UTM source",
        selectPlan: "Selecione um plano",
        currentMonthSeconds: "Processamento do Mês (segundos)",
        currentMonthClips: "Clips do Mês",
        currentMonthLibrarySeconds: "Tempo de Acervo do Mês (segundos)",
        currentMonthLibraryExports: "Exports de Acervo do Mês",
        currentMonthLibraryCurations: "Curações de Acervo do Mês",
        saving: "Salvando...",
        partnerToggle: "Parceiro",
        partnerToggleHint: "O sistema de cobrança nunca moverá este parceiro de volta para o plano Grátis. Concessões são gratuitas.",
        leaderboardHide: "Ocultar do ranking Clip & Pix",
        leaderboardHideHint: "O clipador continua no app, mas não aparece no ranking público de /community-library e /earn.",
        leaderboardHideReason: "Motivo (opcional)",
        leaderboardHideReasonPlaceholder: "ex.: Banido das campanhas",
        leaderboardHiddenBadge: "Oculto do ranking",
        planPartnerOnly: "Ative Parceiro para alterar o plano.",
        partnerExpiresAt: "Acesso de parceiro até",
        partnerExpiresAtHint: "Protegido até esta data; depois disso as regras normais de cobrança voltam a valer.",
        partnerExpiresInvalid: "Informe uma data válida no formato DD/MM/YYYY.",
        partnerIndefinite: "Sem data = indefinido (nunca expira).",
        partnerNote: "Observação (opcional)",
        partnerNotePlaceholder: "ex: Parceria com influenciador — concedida por Nihey",
        partnersOnly: "Apenas parceiros",
        partnerUntil: "Parceiro até {{date}}",
        partnerIndefiniteBadge: "Parceiro",
        partnerExpired: "Parceiro (expirado)",
        dailyRegistrations: "Registros Diários",
        impersonate: "Personificar usuário",
        impersonating: "Você está personificando um usuário",
        stopImpersonating: "Voltar ao admin",
        toast: {
          updated: "Usuário atualizado",
          updatedDesc: "A assinatura do usuário foi atualizada com sucesso.",
          updateError: "Falha ao atualizar",
          updateErrorDesc: "Falha ao atualizar assinatura do usuário. Tente novamente.",
          impersonateError: "Falha ao personificar",
          impersonateErrorDesc: "Falha ao personificar o usuário. Tente novamente.",
        },
        funnel: {
          title: "Funis de Usuários",
          ownBrand: "Minha Marca",
          otherChannels: "Outros Canais",
          signed_up: "Cadastro",
          created_project: "Criou Projeto",
          created_library: "Criou Projeto",
          created_clip: "Gerou Clip",
          users: "usuários",
        },
        affiliateRates: {
          title: 'Taxas de afiliado',
          payment: 'Assinaturas (%)',
          course: 'Intensivo (%)',
          cpm: 'Clip & Pix (%)',
          placeholderDefault: '{{value}} (padrão)',
          note: 'Motivo / acordo',
          notePlaceholder: 'Ex.: acordo NWC, fechado em 07/2026',
          hint: 'Deixe em branco para usar a taxa padrão. 0 significa sem comissão nesse produto.',
          cpmWarning: 'Atenção: alterar a taxa do Clip & Pix recalcula a comissão histórica desse afiliado — para cima ou para baixo — no próximo processamento de ganhos dele.',
          save: 'Salvar taxas',
          saved: 'Taxas atualizadas',
          error: 'Não foi possível salvar as taxas.',
          invalid: 'Use um número inteiro de 0 a 100.',
        },
        customRatesBadge: 'Taxas custom',
        aiAssistantToggle: "Assistente de IA",
        aiAssistantToggleHint: "Mostra a barra lateral do assistente de IA para este usuário (lançamento beta). Vale a partir do próximo carregamento de página.",
        aiAssistantBadge: "IA",
        facebookConnectionsToggle: "Conexões do Facebook",
        facebookConnectionsToggleHint: "Permite que este usuário conecte Páginas do Facebook antes da aprovação da Meta.",
        facebookConnectionsBadge: "Facebook",
      },
      projects: {
        title: "Projetos",
        subtitle: "Visualizar todos os projetos da plataforma",
        list: "Lista de Projetos",
        searchPlaceholder: "Buscar por nome do projeto...",
        filterByStatus: "Filtrar por status",
        allStatuses: "Todos os status",
        name: "Nome",
        user: "Usuário",
        status: "Status",
        duration: "Duração",
        language: "Idioma",
        createdAt: "Criado em",
        dailyChart: "Criação Diária de Projetos",
      },
      clips: {
        title: "Clipes",
        subtitle: "Visualizar todos os clipes da plataforma",
        list: "Lista de Clipes",
        searchPlaceholder: "Buscar por nome do clipe...",
        filterByClippingStatus: "Filtrar por status de clipping",
        filterByRenderingStatus: "Filtrar por status de rendering",
        allStatuses: "Todos os status",
        name: "Nome",
        project: "Projeto",
        user: "Usuário",
        clippingStatus: "Status Clipping",
        renderingStatus: "Status Rendering",
        duration: "Duração",
        createdAt: "Criado em",
        updatedAt: "Atualizado em",
        videos: "Vídeos",
        clippedVideo: "Vídeo Clipado",
        renderedVideo: "Vídeo Renderizado",
        videoPreview: "Pré-visualização do Vídeo",
        noVideoAvailable: "Nenhum vídeo disponível",
        dailyChart: "Criação Diária de Clipes",
      },
      downloads: {
        title: "Downloads",
        subtitle: "Visualizar todos os downloads do YouTube",
        list: "Lista de Downloads",
        searchPlaceholder: "Buscar por ID do vídeo...",
        videoId: "Video ID",
        status: "Status",
        provider: "Provider",
        language: "Idioma",
        priority: "Prioridade",
        createdAt: "Criado em",
        linkedProjects: "Projetos Vinculados",
        dailyChart: "Criação Diária de Downloads",
      },
      userDetail: {
        title: "Detalhes do Usuário",
        subtitle: "Visualizar projetos e clipes do usuário",
        backToUsers: "Voltar para usuários",
        userInfo: "Informações do Usuário",
        projects: "Projetos",
        clips: "Clipes",
        restoreExpired: "Restaurar Todos Expirados",
        restoring: "Restaurando...",
        restore: "Restaurar",
        restoreSuccess: "Itens expirados restaurados",
        restoreSuccessDesc: "Restaurados {{projects}} projeto(s) e {{clips}} clipe(s).",
        restoreError: "Falha ao restaurar",
        restoreErrorDesc: "Falha ao restaurar itens expirados. Tente novamente.",
        projectRestored: "Projeto restaurado com sucesso",
        clipRestored: "Clipe restaurado com sucesso",
        retry: "Reprocessar",
        retryError: "Falha ao reprocessar",
        projectRetried: "Projeto enfileirado para reprocessamento",
        clipRetried: "Clipe enfileirado para reprocessamento",
      },
      library: {
        title: "Acervo",
        subtitle: "Gerenciar acervo de vídeos de canais do YouTube",
        addChannel: "Adicionar Canal",
        channelUrlPlaceholder: "Digite a URL ou handle do canal do YouTube...",
        fetchVideos: "Buscar Vídeos",
        addedChannels: "Itens do Acervo",
        channelName: "Nome",
        videoCount: "Vídeos",
        dateAdded: "Data de Adição",
        noChannels: "Nenhum item no acervo ainda.",
        videos: "vídeos",
        addSelected: "Adicionar Selecionados ({{count}})",
        fetchError: "Falha ao buscar vídeos do canal. Verifique a URL e tente novamente.",
        addSuccess: "{{count}} vídeo(s) adicionado(s) ao acervo com sucesso!",
        addError: "Falha ao adicionar vídeos ao acervo.",
        submitting: "Adicionando...",
        selectAll: "Selecionar Todos",
        deselectAll: "Desmarcar Todos",
        settings: "Configurações",
        format: "Formato",
        language: "Idioma",
        prompt: "Prompt",
        promptPlaceholder: "Descreva como os clipes devem ser curados...",
        status: "Status",
        duration: "Duração",
        createdAt: "Criado Em",
        noItems: "Nenhum item no acervo encontrado.",
        modal: {
          title: "Selecionar Vídeos",
          subtitle: "Escolha os vídeos que deseja adicionar ao acervo",
        },
        promptOptions: {
          viralClips: "Clipes Virais",
          memorableQuotes: "Frases Memoráveis",
          topicClips: "Clipes por Tópicos",
          productAds: "Anúncios de Produtos",
          testimonials: "Depoimentos",
          other: "Outro",
        },
        deleteSuccess: "Item do acervo excluído com sucesso",
        deleteError: "Falha ao excluir item do acervo",
        retrySuccess: "Item do acervo adicionado à fila para reprocessamento",
        retryError: "Falha ao reprocessar item do acervo",
        restoreSuccess: "Item do acervo restaurado com sucesso",
        restoreError: "Falha ao restaurar item do acervo",
        dailyChart: "Criação Diária de Itens do Acervo",
      },
      coupons: {
        assignedUser: "Restrito a um usuário (opcional)",
        assignedUserPlaceholder: "Buscar por nome ou e-mail",
        assignedUserClear: "Remover restrição",
        assignedUserBadge: "Exclusivo: {{user}}",
        errors: {
          assigned_user_not_found: "Usuário não encontrado.",
        },
        title: "Cupons",
        subtitle: "Gerenciar cupons de desconto",
        list: "Lista de Cupons",
        searchPlaceholder: "Buscar por código...",
        createCoupon: "Criar Cupom",
        createCouponDesc: "Preencha os dados do novo cupom de desconto",
        editCoupon: "Editar Cupom",
        editCouponDesc: "Altere os dados do cupom de desconto",
        deleteCoupon: "Excluir Cupom",
        deleteConfirm: "Tem certeza que deseja excluir o cupom \"{{code}}\"? Esta ação não pode ser desfeita.",
        code: "Código",
        type: "Tipo",
        typePercentage: "Porcentagem",
        typeFlat: "Valor Fixo",
        quantity: "Quantidade",
        expiryDate: "Data de Expiração",
        expired: "Expirado",
        monthlySettings: "Configurações Mensais",
        monthCycles: "Ciclos Mensais (-1 = para sempre)",
        monthDiscount: "Desconto Mensal",
        yearlySettings: "Configurações Anuais",
        yearCycles: "Ciclos Anuais (-1 = para sempre)",
        yearDiscount: "Desconto Anual",
        createdAt: "Criado em",
        updatedAt: "Atualizado em",
        actions: "Ações",
        creating: "Criando...",
        saving: "Salvando...",
        deleting: "Excluindo...",
        selectType: "Selecione o tipo",
        toast: {
          created: "Cupom criado com sucesso",
          updated: "Cupom atualizado com sucesso",
          deleted: "Cupom excluído com sucesso",
          createError: "Falha ao criar cupom",
          updateError: "Falha ao atualizar cupom",
          deleteError: "Falha ao excluir cupom",
        },
      },
      liveWatches: {
        title: "Lives monitoradas",
        subtitle: "Monitore transmissões ao vivo e associe-as aos canais do acervo",
        list: "Monitoramentos configurados",
        create: "Criar monitoramento",
        edit: "Editar monitoramento",
        formDescription: "Cole a URL da live. A plataforma e o canal do acervo são inferidos a partir dela.",
        liveUrlPlaceholder: "https://www.twitch.tv/canal",
        searchPlaceholder: "Buscar monitoramentos...",
        channelSearchPlaceholder: "Buscar canais do acervo...",
        channelsLoading: "Carregando canais...",
        channelsEmpty: "Nenhum canal encontrado.",
        identityPlaceholder: "Login do canal",
        channelMatching: "Procurando o canal do acervo...",
        channelWillCreate: "Um canal do acervo será criado para {{name}}.",
        empty: "Nenhuma live configurada para monitoramento.",
        saving: "Salvando...",
        detailTitle: "Live monitorada",
        detailSubtitle: "Configuração e histórico de sessões",
        configuration: "Configuração",
        sessions: "Sessões",
        sessionsEmpty: "Nenhuma sessão registrada.",
        loadError: "Não foi possível carregar esta live monitorada.",
        sessionsLoadError: "Não foi possível carregar as sessões.",
        stopSession: "Encerrar",
        back: "Voltar para lives monitoradas",
        previous: "Anterior",
        next: "Próxima",
        windows: "Janelas",
        windowsEmpty: "Ainda não há janelas.",
        ingestStatuses: {
          idle: "Ocioso",
          running: "Gravando",
          stopped: "Parado",
          failed: "Falha na ingestão",
        },
        windowStatuses: {
          pending: "Pendente",
          curating: "Em curadoria",
          published: "Publicada",
          empty: "Sem clipes",
          failed: "Falhou",
        },
        errors: {
          ingest_dropped: "A gravação foi interrompida",
          hls_unresolved: "Não foi possível abrir a transmissão ao vivo",
          max_concurrent: "Aguardando uma vaga de gravação",
          cut_failed: "Não foi possível cortar esta janela",
          curate_failed: "Não foi possível fazer a curadoria desta janela",
        },
        fields: {
          platform: "Plataforma",
          kind: "Tipo de monitoramento",
          channel: "Canal associado no acervo",
          enabled: "Ativo",
          currentStatus: "Sessão atual",
          actions: "Ações",
          sourceUrl: "URL da live",
          platformChannelId: "ID do canal no YouTube",
          platformLogin: "Login do canal na plataforma",
          windowMinutes: "Janela (minutos)",
          retentionDays: "Retenção (dias)",
          overlapSeconds: "Sobreposição (segundos)",
          identity: "Identidade da origem",
          status: "Status",
          platformLiveId: "ID da live na plataforma",
          startedAt: "Iniciada em",
          endedAt: "Encerrada em",
          lastError: "Último erro",
          ingestStatus: "Ingestão",
          heartbeatAt: "Sinal de atividade",
          retentionExpiresAt: "Bruto expira",
          windowRange: "Trecho da gravação",
          library: "Acervo",
        },
        kinds: {
          channel: "Canal",
          url: "URL",
        },
        statuses: {
          none: "Sem sessão",
          pending: "Pendente",
          live: "Ao vivo",
          ended: "Encerrada",
          failed: "Falhou",
        },
        validation: {
          channelRequired: "Selecione um canal associado no acervo.",
          identityRequired: "Informe a identidade da plataforma ou a URL da live.",
        },
        toast: {
          created: "Monitoramento de live criado.",
          updated: "Monitoramento de live atualizado.",
          saveError: "Não foi possível salvar o monitoramento.",
          enabledUpdated: "Estado do monitoramento atualizado.",
          enabledError: "Não foi possível atualizar o estado do monitoramento.",
          stopped: "Sessão ao vivo encerrada.",
          stopError: "Não foi possível encerrar a sessão ao vivo.",
        },
      },
      emailFlows: {
        title: 'Fluxos de Email',
        new: 'Novo fluxo',
        search: 'Buscar fluxos...',
        fields: {
          name: 'Nome', slug: 'Slug', description: 'Descrição', trigger: 'Gatilho',
          isActive: 'Ativo', isTransactional: 'Transacional', isEditable: 'Editável',
          audience: 'Audiência',
        },
        audience: {
          all: 'Todos os usuários',
          ownBrand: 'Criadores do próprio canal',
          otherChannels: 'Curadores da comunidade',
        },
        managedBySeedWarning: 'Este fluxo é gerenciado pelo código. Seu conteúdo é atualizado a cada inicialização do backend. Ative "Editável" e salve para assumir o controle e impedir sobrescrita.',
        table: { steps: 'Etapas' },
        inFlightWarning: 'Editar ou excluir etapas não cancela e-mails já agendados em execuções em andamento.',
        steps: {
          title: 'Etapas', add: 'Adicionar etapa', edit: 'Editar', delete: 'Excluir',
          delayMinutes: 'Atraso (minutos)',
          delayHelper: '0 = enviar imediatamente após a etapa anterior (ou imediatamente no gatilho para a etapa 1).',
          tabPt: 'Português', tabEn: 'Inglês (opcional, retorna para PT)',
          subject: 'Assunto', body: 'Corpo (HTML)',
          preview: 'Pré-visualização',
          previewSubject: 'Pré-visualização do assunto',
          variablesAvailable: 'Variáveis disponíveis (clique para copiar)',
          copied: 'Copiado para a área de transferência',
        },
        testSend: {
          title: 'Enviar e-mail de teste', email: 'E-mail destinatário', locale: 'Idioma', send: 'Enviar teste',
          success: 'E-mail de teste enviado', failure: 'Falha no envio de teste',
        },
        runs: {
          title: 'Execuções recentes', user: 'Usuário', started: 'Iniciado', status: 'Status', sends: 'Envios',
          empty: 'Nenhuma execução ainda.',
          statuses: { scheduled: 'Agendado', running: 'Executando', completed: 'Concluído', failed: 'Falhou', cancelled: 'Cancelado' },
        },
        delete: { confirm: 'Excluir este fluxo? Isso não pode ser desfeito.', success: 'Fluxo excluído' },
      },
      payouts: {
        title: "Pagamentos",
        renewalLabel: "Renovação",
        searchPlaceholder: "Buscar por email ou nome...",
        registerButton: "Registrar pagamento",
        empty: "Nenhum pagamento registrado.",
        confirmDeleteTitle: "Remover pagamento?",
        confirmDeleteBody: "O saldo do clipper voltará a refletir esse valor.",
        deleteAction: "Remover",
        cancelAction: "Cancelar",
        toastCreated: "Pagamento registrado.",
        toastDeleted: "Pagamento removido.",
        toastError: "Não foi possível salvar.",
        columns: {
          user: "Clipper",
          amount: "Valor",
          currency: "Moeda",
          paidAt: "Pago em",
          note: "Observação",
          createdBy: "Registrado por",
          actions: "Ações",
        },
        dialog: {
          title: "Registrar pagamento",
          userLabel: "Clipper",
          userPlaceholder: "Buscar clipper...",
          amountLabel: "Valor (R$)",
          paidAtLabel: "Pago em",
          noteLabel: "Observação (opcional)",
          availableHint: "Saldo disponível: {{amount}}",
          submit: "Registrar",
          cancel: "Cancelar",
          overBalance: "O valor excede o saldo disponível.",
        },
        userWallet: {
          sectionTitle: "Pagamentos CPM",
          totalEarned: "Total ganho",
          totalPaidOut: "Total pago",
          available: "Disponível",
        },
      },
      affiliateEarnings: {
        title: 'Comissões e royalties',
        searchPlaceholder: 'Buscar por email ou nome...',
        recipient: 'Recebedor',
        counterparty: 'Indicado ou intensivo',
        kindLabel: 'Tipo de ganho',
        kindAll: 'Todos os tipos',
        kindAffiliate: 'Afiliado',
        kindProducer: 'Coprodutor',
        payment: 'Pagamento',
        commission: 'Valor',
        provider: 'Origem',
        sourcePayment: 'Assinatura',
        sourceCourse: 'Intensivo',
        sourceCpm: 'CPM',
        date: 'Data',
        status: 'Status',
        actions: 'Ações',
        reverse: 'Reverter',
        reverseTitle: 'Reverter comissão ou royalty?',
        reverseDescription:
          'Use quando o pagamento de origem foi estornado ou o ganho foi desqualificado. O valor sai da carteira do recebedor. Esta ação não pode ser desfeita.',
        reverseNotePlaceholder: 'Motivo (opcional)',
        confirmReverse: 'Confirmar reversão',
        cancel: 'Cancelar',
        reversed: 'Comissão ou royalty revertido.',
        empty: 'Nenhuma comissão ou royalty encontrada.',
        statusPending: 'Em espera',
        statusAvailable: 'Liberado',
        statusReversed: 'Revertido',
        previousPage: 'Página anterior',
        nextPage: 'Próxima página',
        loading: 'Carregando comissões e royalties...',
        loadError: 'Não foi possível carregar comissões e royalties.',
        retry: 'Tentar novamente',
        total: '{{total}} no total',
      },
      courseRevenueShares: {
        title: 'Coprodutores de intensivos',
        description:
          'Controle quem participa de cada venda de intensivo e acompanhe os saldos de royalties gerados.',
        add: 'Adicionar coprodutor',
        course: 'Intensivo',
        producer: 'Coprodutor',
        rate: 'Percentual',
        active: 'Ativo',
        inactive: 'Inativo',
        note: 'Observação',
        accrued: 'Acumulado',
        pending: 'Em espera',
        available: 'Disponível',
        reversed: 'Revertido',
        actions: 'Ações',
        edit: 'Editar',
        deactivate: 'Desativar',
        activate: 'Ativar',
        createTitle: 'Adicionar coprodutor',
        createDescription:
          'Escolha o intensivo e o coprodutor. Essa identidade não poderá ser alterada depois.',
        editTitle: 'Editar coprodutor',
        editDescription:
          'Ajuste o percentual, estado ou observação interna. Intensivo e coprodutor permanecem bloqueados.',
        selectCourse: 'Selecione um intensivo',
        selectProducer: 'Selecione um coprodutor',
        coursesLoading: 'Carregando intensivos...',
        coursesLoadError: 'Não foi possível carregar os intensivos.',
        retryCourses: 'Tentar carregar intensivos novamente',
        noCourses: 'Nenhum intensivo está disponível.',
        searchProducer: 'Buscar coprodutores',
        searchProducerPlaceholder: 'Buscar por nome ou email',
        producersLoading: 'Carregando coprodutores...',
        producersLoadError: 'Não foi possível carregar os coprodutores.',
        retryProducers: 'Tentar novamente',
        noProducers: 'Nenhum coprodutor encontrado nesta busca.',
        identityLocked: 'A identidade do intensivo e do coprodutor não pode ser alterada.',
        rateValidation: 'Informe um percentual inteiro de 0 a 100.',
        rateHint: 'Número inteiro de 0 a 100.',
        notePlaceholder: 'Contexto interno deste acordo',
        save: 'Salvar participação',
        create: 'Criar participação',
        cancel: 'Cancelar',
        close: 'Fechar',
        loading: 'Carregando coprodutores...',
        loadError: 'Não foi possível carregar os coprodutores dos intensivos.',
        empty: 'Nenhum coprodutor cadastrado',
        emptyDescription: 'Adicione um acordo para começar a compartilhar vendas pagas.',
        deactivateTitle: 'Desativar coprodutor?',
        deactivateDescription:
          'Novas vendas pagas deixarão de gerar royalties. Os ganhos existentes permanecem no histórico.',
        confirmDeactivate: 'Confirmar desativação',
        created: 'Coprodutor adicionado.',
        updated: 'Coprodutor atualizado.',
        activated: 'Coprodutor ativado.',
        deactivated: 'Coprodutor desativado.',
        errors: {
          producer_share_total_exceeds_100:
            'A soma das participações dos coprodutores não pode ultrapassar 100% no intensivo.',
          generic: 'Algo deu errado. Revise o acordo e tente novamente.',
          activate: 'Não foi possível ativar este coprodutor.',
          deactivate: 'Não foi possível desativar este coprodutor.',
          refresh:
            'A alteração foi salva, mas a lista não pôde ser atualizada.',
        },
        errorTitles: {
          save: 'Não foi possível salvar o coprodutor',
          activate: 'Não foi possível ativar o coprodutor',
          deactivate: 'Não foi possível desativar o coprodutor',
          refresh: 'A lista precisa ser atualizada',
        },
      },
      channels: {
        title: "Canais do YouTube",
        subtitle: "Gerencie quais canais são Parceiros Autoclipper",
        list: "Lista de Canais",
        searchPlaceholder: "Buscar por nome, handle ou ID do canal...",
        partnerOnly: "Apenas parceiros",
        thumbnail: "Foto",
        name: "Nome",
        handle: "Handle",
        subscribers: "Inscritos",
        category: "Categoria",
        partner: "Parceiro",
        actions: "Ações",
        partnerYes: "Parceiro",
        partnerNo: "Não-Parceiro",
        toast: {
          updated: "Canal atualizado",
          updateError: "Falha ao atualizar canal",
        },
        importDrive: "Importar do Google Drive",
        importModal: {
          title: "Importar do Google Drive — {{channel}}",
          subtitle: "Cole uma URL do Drive por linha. Pastas são percorridas recursivamente. Até 50 URLs por envio.",
          placeholder: "https://drive.google.com/drive/folders/...\nhttps://drive.google.com/file/d/.../view",
          submit: "Importar",
          cancel: "Cancelar",
          importMore: "Importar mais",
          close: "Fechar",
          status: {
            queued: "Na fila",
            linked_existing: "Vinculado existente",
            already_linked: "Já vinculado",
            error: "Erro",
          },
          summary: "{{queued}} na fila · {{linked}} vinculados · {{alreadyLinked}} já vinculados · {{errors}} erro(s)",
          column: {
            input: "URL de entrada",
            fileName: "Nome do arquivo",
            status: "Status",
            error: "Erro",
          },
          toast: {
            failed: "Falha na importação",
          },
        },
      },
      challenges: {
        title: "Desafios",
        subtitle: "Gerenciar desafios do campeonato",
        list: "Lista de Desafios",
        searchPlaceholder: "Buscar por nome do desafio...",
        createChallenge: "Criar Desafio",
        createChallengeDesc: "Preencha os dados do novo desafio",
        editChallenge: "Editar Desafio",
        editChallengeDesc: "Altere os dados do desafio",
        deleteChallenge: "Excluir Desafio",
        deleteConfirm: "Tem certeza que deseja excluir o desafio \"{{name}}\"? Esta ação não pode ser desfeita.",
        name: "Nome",
        description: "Descrição",
        startDate: "Data de Início",
        endDate: "Data de Término",
        prizePool: "Premiação",
        warningMessage: "Mensagem de Aviso",
        rulesAllowed: "Regras Permitidas",
        rulesForbidden: "Regras Proibidas",
        rulesAttention: "Regras Atenção / Aviso",
        isAcceptingParticipants: "Aceitando inscrições",
        isAcceptingParticipantsHint: "Quando desativado, usuários não poderão mais entrar neste campeonato",
        rankings: "Rankings",
        rankingsFor: "Rankings de {{name}}",
        addRanking: "Adicionar ranking",
        editRanking: "Editar ranking",
        rankingName: "Nome do ranking",
        rankingTimezone: "Fuso horário",
        rankingConsolidationTime: "Data/hora de consolidação",
        rankingConsolidationTimeHint: "Insira no horário local do fuso selecionado acima",
        consolidated: "Consolidado",
        pending: "Pendente",
        pendingValidation: "Aguardando validação",
        validated: "Validado",
        validate: "Validar",
        unvalidate: "Revogar validação",
        rankingValidation: "Validação de ranking",
        rankingValidated: "Ranking validado e publicado!",
        rankingUnvalidated: "Validação do ranking revogada.",
        rankingNotConsolidated: "Este ranking ainda não foi consolidado.",
        partialRankingHint: "Ranking parcial ao vivo — os dados podem mudar até a consolidação.",
        consolidatedNotValidated: "Ranking consolidado — aguardando validação do admin antes da publicação.",
        validateConfirmTitle: "Validar ranking?",
        validateConfirmDescription: "Isso publicará o ranking \"{{name}}\" e o tornará visível para todos os usuários.",
        unvalidateConfirmTitle: "Revogar validação?",
        unvalidateConfirmDescription: "Isso ocultará o ranking \"{{name}}\" dos usuários até que seja validado novamente.",
        rankingCreated: "Ranking criado com sucesso!",
        rankingUpdated: "Ranking atualizado com sucesso!",
        rankingDeleted: "Ranking excluído com sucesso!",
        audit: "Auditar",
        auditParticipant: "Auditar participante",
        auditClips: "Clipes do participante",
        approvalReason: "Motivo da reprovação",
        approvalReasonPlaceholder: "Descreva o motivo da reprovação (opcional)...",
        disapproveConfirm: "Definir motivo da reprovação",
        requiredHashtags: "Hashtags Obrigatórias",
        captionExamples: "Exemplos de Legenda",
        prizeData: "Dados de Premiação",
        onePerLine: "Um item por linha",
        jsonFormat: "Formato JSON",
        prizeBuilder: {
          addTab: "Adicionar ranking / período",
          tabName: "Nome da aba (ex: Semana 1)",
          prizes: "Prêmios",
          position: "Posição (ex: 1º LUGAR)",
          prize: "Prêmio (ex: R$ 3.000)",
          addPrize: "Adicionar prêmio",
          bonus: "Bônus (linha de presente)",
          bonusPlaceholder: "ex: Plano PRO + Mentoria",
          footer: "Nota de rodapé",
          footerPlaceholder: "ex: Cada competidor pode ser premiado em apenas um ranking.",
          preview: "Pré-visualização",
          viewJson: "Ver / Importar JSON",
          copy: "Copiar",
          applyJson: "Aplicar JSON",
          jsonInvalid: "JSON inválido — verifique o formato e tente novamente.",
          startDate: "Data/hora de início",
          endDate: "Data/hora de fim",
          timezone: "Fuso horário",
          timezonePlaceholder: "Selecionar fuso horário",
          timezoneSearch: "Buscar fuso horário...",
          timezoneNotFound: "Fuso horário não encontrado.",
        },
        viewChallenge: "Ver página do desafio",
        viewClips: "Ver todos os clipes",
        approval: "Aprovação",
        approvalNeutral: "Neutro",
        approvalApprove: "Aprovado",
        approvalDisapprove: "Reprovado",
        approvalFilter: "Filtrar por aprovação",
        approvalAll: "Todos",
        approvalSet: "Aprovação atualizada!",
        approvalError: "Falha ao atualizar aprovação",
        hashtagValidation: "Hashtags",
        hashtagValidated: "Validado",
        hashtagInvalidated: "Invalidado",
        hashtagNeutral: "Pendente",
        hashtagValidationSet: "Validação de hashtags atualizada!",
        hashtagValidationError: "Falha ao atualizar validação de hashtags",
        manualViews: "Definir visualizações manualmente",
        manualViewsConfirm: "Registrar visualizações manualmente para este clipe (cria ou sobrescreve o registro de hoje)",
        manualViewsLabel: "Visualizações",
        manualViewsSave: "Salvar visualizações",
        manualViewsSaved: "Visualizações salvas!",
        manualViewsError: "Falha ao salvar visualizações",
        manualViewsInvalid: "Por favor, insira um número válido",
        forceUpdateAllViews: "Forçar Atualização de Views",
        forceUpdateAllViewsConfirm: "Isso irá re-buscar as views de todas as plataformas para todos os clipes deste desafio. Continuar?",
        forceUpdateAllViewsSuccess: "Atualização de views enviada para {{count}} clipes",
        forceUpdateAllViewsError: "Falha ao enviar atualização de views",
        syncMissingViews: "Sincronizar Apenas Pendentes",
        syncMissingViewsConfirm: "Isso irá buscar views apenas para clipes que ainda não têm dados de hoje. Continuar?",
        syncMissingViewsSuccess: "Sincronização de views pendentes enviada para {{count}} clipes",
        syncMissingViewsError: "Falha ao enviar sincronização de views pendentes",
        syncMissingViewsNone: "Nenhum clipe está sem dados de hoje",
        forceUpdateClipView: "Forçar atualização de views",
        forceUpdateClipViewSuccess: "Atualização de views enviada para este clipe",
        forceUpdateClipViewError: "Falha ao enviar atualização de views do clipe",
        hashtagValidationFilter: "Filtrar por validação de hashtags",
        participant: "Participante",
        participants: "Participantes",
        participantCount: "Participantes",
        addParticipant: "Adicionar Participante",
        addParticipantDesc: "Digite o e-mail do usuário para adicioná-lo como participante",
        participantEmail: "E-mail do Usuário",
        importParticipants: "Importar Participantes",
        importParticipantsDesc: "Envie um arquivo CSV ou XLSX com uma coluna \"email\" para adicionar participantes em massa.",
        selectFile: "Selecionar Arquivo",
        importSummary: "Resumo da Importação",
        importAdded: "Adicionados",
        importSkipped: "Já participando",
        importCreated: "Conta criada (e-mail de redefinição de senha enviado)",
        importing: "Importando...",
        importDone: "Importação concluída",
        importNoEmails: "Nenhum e-mail válido encontrado no arquivo",
        removeParticipant: "Remover Participante",
        removeParticipantConfirm: "Tem certeza que deseja remover {{name}} deste desafio?",
        totalViews: "Total de Views",
        clipCount: "Clipes",
        active: "Ativo",
        ended: "Encerrado",
        upcoming: "Em breve",
        createdAt: "Criado em",
        actions: "Ações",
        creating: "Criando...",
        saving: "Salvando...",
        deleting: "Excluindo...",
        adding: "Adicionando...",
        removing: "Removendo...",
        status: "Status",
        disqualified: "Desclassificado",
        qualified: "Ativo",
        disqualify: "Desclassificar",
        requalify: "Requalificar",
        disqualifyConfirm: "Tem certeza que deseja desclassificar {{name}} deste desafio?",
        requalifyConfirm: "Tem certeza que deseja requalificar {{name}} neste desafio?",
        disqualificationReason: "Motivo da desclassificação",
        disqualificationReasonPlaceholder: "Explique por que este participante está sendo desclassificado...",
        disqualifying: "Atualizando...",
        noParticipants: "Nenhum participante ainda",
        usage: "Uso",
        resetUsage: "Resetar Uso",
        resetAllUsage: "Resetar Uso de Todos",
        resetUsageConfirm: "Tem certeza que deseja resetar o uso de {{name}}? Isso vai zerar todos os contadores do mês atual.",
        resetAllUsageConfirm: "Tem certeza que deseja resetar o uso de todos os participantes deste desafio? Isso vai zerar todos os contadores do mês atual.",
        resettingUsage: "Resetando...",
        usageReset: "Uso resetado com sucesso",
        allUsageReset: "Uso de todos os participantes resetado com sucesso",
        usageResetError: "Falha ao resetar uso",
        forceStartSnapshot: "Forçar Snapshot Inicial",
        forceConsolidation: "Forçar Consolidação",
        forceStartSnapshotConfirmTitle: "Forçar snapshot inicial?",
        forceStartSnapshotConfirmDescription: "Isso vai capturar as views atuais de todos os clipes do ranking \"{{name}}\". Essa ação não pode ser desfeita.",
        forceConsolidationConfirmTitle: "Forçar consolidação?",
        forceConsolidationConfirmDescription: "Isso vai consolidar o ranking \"{{name}}\" usando as views atuais como snapshot final. Essa ação não pode ser desfeita.",
        forceStartSnapshotSuccess: "Snapshot inicial criado com sucesso!",
        forceConsolidationSuccess: "Ranking consolidado com sucesso!",
        forceStartSnapshotError: "Falha ao criar snapshot inicial",
        forceConsolidationError: "Falha ao consolidar ranking",
        snapshotAlreadyExists: "Snapshot inicial já existe",
        alreadyConsolidated: "Ranking já foi consolidado",
        snapshotAudit: "Auditoria de Snapshots",
        snapshotAuditFor: "Auditoria de snapshots de \"{{name}}\"",
        startSnapshot: "Snapshot Inicial",
        endSnapshot: "Snapshot Final",
        snapshotViews: "Views do Snapshot",
        clipUrl: "URL do Clipe",
        platform: "Plataforma",
        views: "Views",
        editViews: "Editar views",
        saveViews: "Salvar",
        viewsUpdated: "Views atualizadas com sucesso!",
        viewsUpdateError: "Falha ao atualizar views",
        noSnapshots: "Sem registros de snapshot",
        delta: "Delta",
        partialRankingExtract: "Extrair Ranking Parcial",
        partialRankingExtractDesc: "Selecione um período para calcular um ranking parcial com base nos snapshots de views mais próximos disponíveis.",
        partialRankingResults: "Resultado do Ranking Parcial",
        partialRankingPeriod: "Período: {{start}} até {{end}}",
        partialRankingNoResults: "Nenhum participante com views neste período.",
        partialRankingClipsWithoutViews: "{{count}} clipe(s) sem dados de views neste período",
        partialRankingClipsWithoutViewsDetail: "Os seguintes clipes não tinham snapshots de views disponíveis:",
        partialRankingMissingStart: "sem snapshot inicial",
        partialRankingMissingEnd: "sem snapshot final",
        partialRankingMissingBoth: "sem ambos snapshots",
        partialRankingError: "Falha ao buscar ranking parcial",
        syncAllViews: "Sincronizar Views",
        syncingViews: "Sincronizando views...",
        copyToClipboard: "Copiar",
        copiedToClipboard: "Copiado!",
        viewsGrowthChart: "Crescimento de Views & Novos Clipes (Últimos 30 Dias)",
        newClips: "Novos Clipes",
        summaryTotalViews: "Total de Views",
        summaryTotalClips: "Total de Clipes",
        summaryAvgViewsPerClip: "Média Views/Clipe",
        summaryNewClipsToday: "Novos Clipes Hoje",
        toast: {
          created: "Desafio criado com sucesso",
          updated: "Desafio atualizado com sucesso",
          deleted: "Desafio excluído com sucesso",
          createError: "Falha ao criar desafio",
          updateError: "Falha ao atualizar desafio",
          deleteError: "Falha ao excluir desafio",
          participantAdded: "Participante adicionado com sucesso",
          participantAddError: "Falha ao adicionar participante",
          participantRemoved: "Participante removido com sucesso",
          participantRemoveError: "Falha ao remover participante",
          participantDisqualified: "Participante desclassificado com sucesso",
          participantRequalified: "Participante requalificado com sucesso",
          disqualifyError: "Falha ao atualizar status de desclassificação",
        },
      },
      clipperSeasons: {
        title: "Temporadas dos clipadores",
        subtitle: "Gerencie as janelas de temporada usadas nos rankings de clipadores.",
        list: "Todas as temporadas",
        create: "Criar temporada",
        createDescription: "Defina o nome e a janela de datas para uma nova temporada.",
        edit: "Editar temporada",
        editDescription: "Atualize o nome ou as datas antes do snapshot inicial.",
        loading: "Carregando…",
        empty: "Nenhuma temporada ainda.",
        forceSnapshot: "Forçar snapshot inicial",
        forceConsolidate: "Forçar consolidação",
        datesLockedHelp: "As datas da temporada ficam bloqueadas após o snapshot inicial.",
        columns: {
          name: "Nome",
          window: "Janela",
          status: "Status",
          actions: "Ações",
        },
        fields: {
          name: "Nome",
          startsAt: "Início",
          endsAt: "Término",
        },
        status: {
          scheduled: "Agendada",
          active: "Ativa",
          consolidated: "Consolidada",
        },
        errors: {
          overlap: "Esta temporada se sobrepõe a outra temporada.",
          datesLocked: "As datas da temporada ficam bloqueadas após o snapshot inicial.",
          generic: "Não foi possível atualizar as temporadas dos clipadores",
        },
        toast: {
          created: "Temporada criada",
          updated: "Temporada atualizada",
          snapshotted: "Snapshot inicial concluído",
          consolidated: "Temporada consolidada",
        },
      },
      campaigns: {
        title: "Campanhas CPM",
        subtitle: "Gerenciar campanhas CPM e envios de clipes.",
        allCampaigns: "Todas as campanhas",
        allStatuses: "Todos os status",
        newCampaign: "Nova campanha",
        empty: "Nenhuma campanha ainda.",
        loading: "Carregando…",
        submissionsCount_one: "{{count}} envio",
        submissionsCount_other: "{{count}} envios",
        perThousandViews: "por 1.000 visualizações",
        backToList: "Voltar à lista",
        viewSubmissions: "Ver envios",
        rankMinFinishedRenders: "Mínimo de cortes finalizados para patentes",
        rankMinFinishedRendersHint: "O clipador precisa finalizar pelo menos este número de cortes na campanha para ela contar no rank Mercenário de Conteúdo. Deixe em branco para usar o padrão.",
        status: {
          draft: "Rascunho",
          active: "Ativa",
          paused: "Pausada",
          ended: "Encerrada",
          scheduled: "Agendada",
        },
        statusDescriptions: {
          draft: "Só a equipe vê — nada aparece pros clipadores ainda.",
          active: "No ar: aparece na lista de campanhas ativas e pode ser participada.",
          paused: "Sai temporariamente da lista de ativas, sem apagar nada — volta ao trocar pra Ativa de novo.",
          ended: "Encerrada — some das ativas e passa a aparecer como prova social na lista de campanhas encerradas.",
          scheduled: "Aparece pros clipadores na seção Em Breve. Se tiver data de início, ela é mostrada; se não tiver, o card fica só como em breve. Ainda não dá pra participar. Passe pra Ativa manualmente quando a campanha realmente abrir — sem data, ela nunca ativa sozinha.",
        },
        edit: {
          cpmPerPlatformErrors: {
            cpm_platform_rate_invalid: "Use um valor maior que zero. Para a rede não pagar, desmarque-a em Plataformas permitidas.",
            cpm_platform_rate_duplicate: "A mesma rede apareceu duas vezes nas taxas por rede.",
            cpm_platform_rate_platform_not_allowed: "Há uma taxa para uma rede que a campanha não aceita. Marque a rede em Plataformas permitidas ou apague a taxa.",
          },
          newTitle: "Nova campanha",
          editTitle: "Editar campanha",
          newSubtitle: "Crie uma nova campanha CPM.",
          editSubtitle: "Atualize detalhes, regras e alvos da campanha.",
          detailsCard: "Detalhes da campanha",
          economicsCard: "Economia",
          rulesCard: "Regras",
          targetsCard: "Alvos e auditores",
          liveImport: {
            title: "Novas lives automáticas",
            description: "Quando o canal terminar uma live com estas palavras, ela entra no acervo e nesta campanha, e quem participa recebe um e-mail.",
            enabled: "Ativar lives automáticas",
            channel: "Canal do YouTube",
            channelPlaceholder: "Link do canal, @handle ou link de um vídeo",
            channelHint: "Cole o link do canal ou de qualquer vídeo dele. Só lives já encerradas entram; Shorts e vídeos normais não.",
            words: "Palavras que a live precisa ter",
            wordsPlaceholder: "digite e aperte Enter…",
            wordsHint: "Procuradas no título e na descrição. Maiúsculas, acentos e espaços não importam.",
            removeWord: "Remover",
            processing: "Como processar cada live",
            format: "Duração dos cortes",
            language: "Idioma",
            formats: {
              max_30_sec: "Cortes de até 30 s",
              max_1_min: "Cortes de até 1 min",
              auto: "Duração automática",
            },
            languages: {
              "pt-BR": "Português (BR)",
              "en-US": "Inglês (EUA)",
              "es-ES": "Espanhol",
            },
            promptPlaceholder: "Instruções para a IA escolher os cortes (opcional)",
            notify: "Avisar os participantes por e-mail",
            notifyHint: "Um e-mail por live, quando ela termina de processar. Só quem entrou e não saiu da campanha.",
            save: "Salvar lives automáticas",
            latestChecks: "Últimas verificações",
            lastCheck: "Última:",
            nextCheck: "próxima:",
            neverChecked: "Ainda não verificado. Verifica a cada 30 min.",
            lastError: "Erro na última verificação:",
            checkNow: "Verificar agora",
            emptyLog: "Nenhuma live encontrada ainda.",
            status: {
              added_sent: "Adicionada · e-mail enviado",
              added: "Adicionada · processando",
              live: "Ao vivo agora · entra quando acabar",
              ignored_no_keyword: "Ignorada: nenhuma palavra",
              ignored_out_of_dates: "Ignorada: fora das datas da campanha",
              ignored_before_enabled: "Ignorada: anterior à ativação",
              already_linked: "Já estava na campanha",
              failed: "Falhou ao processar",
            },
            errors: {
              title: "Não foi possível concluir",
              already_running: "Uma verificação já está em andamento. Tente de novo em instantes.",
              campaign_not_found: "Campanha não encontrada.",
              channel_not_found: "Não encontramos esse canal do YouTube. Confira o link.",
              channel_required: "Informe o canal do YouTube para ativar.",
              keywords_required: "Adicione pelo menos uma palavra para ativar.",
              invalid_keywords: "Use no máximo 20 palavras, com até 60 caracteres cada.",
              invalid_format: "Duração dos cortes inválida.",
              invalid_language: "Idioma inválido.",
              generic: "Algo deu errado. Tente de novo.",
            },
          },
          fields: {
            name: "Nome",
            logo: "Logo da campanha",
            banner: "Banner da campanha (16:9)",
            categories: "Categorias",
            description: "Descrição",
            status: "Status",
            currency: "Moeda",
            startDate: "Data de início",
            startDateScheduledHint: "Opcional. Deixe vazio para anunciar a campanha como Em Breve sem data. Ela não ativa sozinha até você passar pra Ativa.",
            endDate: "Data de término",
            cpmRate: "Taxa CPM por 1.000 visualizações",
            cpmPerPlatform: "CPM diferente por rede social",
            cpmPerPlatformHint: "Em branco, a rede usa a taxa CPM acima. Ao aumentar uma taxa, os clipes dessa rede ainda dentro da janela de views pagas recebem a diferença na próxima atualização. Para clipes fora da janela (no Instagram eles não são mais atualizados) ou ao reduzir uma taxa, use Recalcular pagamentos.",
            budgetTotal: "Orçamento total",
            minViews: "Visualizações mínimas",
            minViewsHint: "Aplica-se automaticamente a novas visualizações. Para reprecificar clipes que já ganharam (por ex. após aumentar este valor), use \"Recalcular pagamentos\" abaixo.",
            minPayout: "Pagamento mín. por clipador",
            maxPayout: "Pagamento máx. por clipador",
            maxPayoutPerClip: "Pagamento máx. por clipe",
            rankMinFinishedRenders: "Mínimo de cortes finalizados para patentes",
            rankMinFinishedRendersHint: "O clipador precisa finalizar pelo menos este número de cortes na campanha para ela contar no rank Mercenário de Conteúdo.",
            viewAccrualWindow: "Janela de views pagas (horas)",
            viewAccrualWindowHint: "As views geram pagamento apenas dentro desse número de horas após o envio do clipe. 0 = ilimitado. As views continuam sendo contadas depois, mas deixam de ser pagas.",
            requiredHashtags: "Hashtags obrigatórias",
            requiredMention: "Menção obrigatória",
            requiredMentionHint: "Perfil que o clipe precisa marcar/mencionar (ex.: @perfil). Usado pelo gate de pré-aprovação automática. Deixe vazio se a campanha não exige menção.",
            minClipDuration: "Duração mínima do clipe (segundos)",
            minClipDurationPlaceholder: "Sem mínimo",
            minClipDurationHint: "Clipes mais curtos são recusados no envio, inclusive no envio em massa e na importação automática, e o clipador vê o motivo. Vale para clipes enviados depois de salvar. Deixe vazio para não exigir.",
            rulesAllowed: "Regras — permitido",
            rulesForbidden: "Regras — proibido",
            rulesAttention: "Regras — atenção",
            rulesWarning: "Regras — aviso",
            captionExamples: "Exemplos de legenda",
            captionExamplesHelpIntro: "Use cabeçalhos em MAIÚSCULAS seguidos de dois-pontos para separar plataformas. Exemplo:",
            captionExamplesHelpExample: "TIKTOK:\nO texto de exemplo para TikTok...\n\nREELS:\nO texto de exemplo para Reels...\n\nSHORTS:\nO texto de exemplo para YouTube Shorts...\n\nDICA:\nEi clipador! Inclua aqui uma dica ou instrução extra que aparece em destaque no rodapé do card — ex: marcar o canal como colaborador.",
            captionExamplesHelpDica: "A seção DICA: aparece como um bloco de destaque no rodapé do card de exemplos, separado dos exemplos de legenda.",
            channels: "Canais do YouTube",
            channelsPlaceholder: "Selecione os canais…",
            channelsSearchPlaceholder: "Buscar canais por nome…",
            videos: "Vídeos da campanha",
            videosPlaceholder: "Selecione os vídeos…",
            videosSearchPlaceholder: "Buscar vídeos por nome…",
            addAllFromChannel: "Adicionar todos de um canal",
            addAllFromChannelHint: "Escolha um canal para adicionar todos os seus vídeos.",
            admins: "Auditores",
            adminsPlaceholder: "Selecione os auditores…",
            adminsSearchPlaceholder: "Buscar usuários por nome ou email…",
            emptyResults: "Nenhum resultado",
            loading: "Carregando…",
          },
          cpmOverride: {
            title: "CPM personalizado por vídeo",
            allow: "Permitir CPM personalizado por vídeo",
            allowHelp: "Auditores da campanha poderão alterar o CPM de vídeos individuais durante a auditoria. O ganho do vídeo é recalculado retroativamente.",
            mode: "Valores permitidos",
            modePresets: "Valores predefinidos",
            modeFree: "Valor livre",
            presets: "Valores de CPM disponíveis",
            addPreset: "Adicionar",
            removePreset: "Remover valor",
            min: "CPM mínimo (opcional)",
            max: "CPM máximo (opcional)",
          },
          preApproval: {
            cardTitle: "Pré-aprovação automática (piloto)",
            cardHint: "Controla o piloto de pré-aprovação automática desta campanha: conexão do clipador com Analytics, engajamento acima do limiar e regras da campanha (hashtag, menção e plataforma). A pré-aprovação nunca substitui a decisão do auditor.",
            enabled: "Ativar pré-aprovação automática nesta campanha",
            enabledHelp: "Liga o piloto para esta campanha. Clipes que passarem nos gates aparecem como Pré-Aprovado até a auditoria confirmar.",
            minScore: "Nota mínima de engajamento (0-100)",
            minScoreHint: "Clipes com nota de engajamento abaixo deste valor não são pré-aprovados. Padrão: 50.",
            allowedPlatforms: "Plataformas permitidas",
            allowedPlatformsHint: "Nenhuma marcada = todas as plataformas são permitidas. Marcar uma ou mais restringe a pré-aprovação a essas plataformas.",
          },
          actions: {
            create: "Criar",
            save: "Salvar",
            delete: "Excluir",
          },
          recompute: {
            button: "Recalcular pagamentos",
            running: "Recalculando…",
            dialogTitle: "Recalcular os pagamentos de todos os clipes?",
            dialogDescription: "Reprecifica todos os clipes aprovados desta campanha de acordo com as configurações atuais (visualizações mínimas, CPM, limites). Clipes que não se qualificam mais terão o pagamento REDUZIDO e o valor devolvido ao orçamento. Valores já pagos nunca são estornados — a diferença é compensada nos ganhos futuros do clipador. Salve suas alterações antes.",
            confirm: "Recalcular",
            successTitle: "Pagamentos recalculados",
            successDescription: "{{changed}} clipe(s) alterado(s). Mudança líquida no orçamento: {{delta}}.",
            errorTitle: "Não foi possível recalcular os pagamentos",
          },
          deleteConfirm: "Excluir esta campanha?",
          forceDeleteConfirm: "A campanha tem pagamentos. Forçar exclusão?",
          toast: {
            createSuccessTitle: "Campanha criada",
            createSuccessDescription: "Sua campanha está pronta para ser editada.",
            saveSuccessTitle: "Campanha salva",
            saveSuccessDescription: "Suas alterações estão no ar.",
            saveErrorTitle: "Não foi possível salvar a campanha",
            deleteSuccessTitle: "Campanha excluída",
            deleteErrorTitle: "Não foi possível excluir a campanha",
          },
          tabs: {
            edit: "Editar",
            submissions: "Envios",
            participants: "Participantes",
          },
          requiresChannelApproval: "Exigir aprovação de canal antes que usuários possam enviar vídeos",
          requiresChannelApprovalHelp: "Os usuários precisam registrar seus canais e serem aprovados por um admin antes de publicar vídeos nesta campanha.",
          restrictToListedVideos: "Somente os vídeos listados participam",
          restrictToListedVideosHelp: "Os canais anexados servem apenas para exibir a campanha na vitrine — os demais vídeos deles não ficam elegíveis.",
          excludedVideos: {
            title: "Vídeos removidos da campanha",
            help: "Para remover um vídeo (inclusive os que vêm de um canal anexado), use o botão de lixeira no card do vídeo na página da campanha.",
            empty: "Nenhum vídeo removido.",
            restore: "Restaurar",
            errorTitle: "Não foi possível restaurar",
            error: "Não conseguimos restaurar o vídeo. Tente novamente.",
          },
          inviteOnly: "Campanha exclusiva (invite only)",
          inviteOnlyHelp: "Só quem foi pré-aprovado pelo admin ou assina qualquer plano pago pode submeter clipes. O card aparece na página 'Ganhe com Cortes' mas sem navegação para quem não tem acesso.",
          selectedOnly: {
            label: "Restringir a clipadores selecionados",
            help: "Só os clipadores escolhidos aqui podem participar — nem plano pago nem canal aprovado dão acesso. Use quando o contratante quiser uma campanha fechada só pros clipadores que ele (ou a Autoclipper) já escolheu, por exemplo os melhores de uma campanha aberta anterior.",
            emptyListWarning: "Nenhum clipador escolhido ainda. Dá pra salvar assim e montar a lista depois, mas enquanto ela estiver vazia a campanha fica invisível — ninguém vê nem participa.",
            pickerLabel: "Clipadores selecionados",
            pickerPlaceholder: "Nenhum clipador selecionado",
          },
          banner: {
            uploadLabel: "Enviar banner da campanha",
            uploadHint: "Imagem 16:9 exibida no topo dos cards da campanha. Recomendado: 1600×900, PNG, JPG ou WebP, sem texto.",
            uploading: "Enviando...",
            uploadErrorTitle: "Falha no envio",
            uploadErrorFormat: "Apenas imagens PNG, JPG e WebP são aceitas.",
            uploadErrorGeneric: "Não foi possível enviar o banner da campanha.",
            removeButton: "Remover banner",
          },
          categories: {
            hint: "Escolha até 3. Aparecem nos cards da campanha.",
            errors: {
              invalid_category: "Categoria inválida. Recarregue a página e tente de novo.",
              too_many_categories: "Escolha no máximo 3 categorias.",
            },
          },
          logo: {
            uploadLabel: "Enviar logo da campanha",
            uploadHint: "Exibido no lugar do avatar do canal nos cards da campanha. Recomendado: PNG ou JPG quadrado.",
            uploading: "Enviando...",
            uploadErrorTitle: "Falha no envio",
            uploadErrorFormat: "Apenas imagens PNG e JPG são aceitas.",
            uploadErrorGeneric: "Não foi possível enviar o logo da campanha.",
            removeButton: "Remover logo",
          },
          watermark: {
            cardTitle: "Marca d'água",
            uploadLabel: "Enviar imagem da marca d'água",
            uploadHint: "Recomendado: PNG transparente. PNG ou JPG.",
            uploading: "Enviando...",
            uploadErrorTitle: "Falha no envio",
            uploadErrorFormat: "Apenas imagens PNG e JPG são aceitas.",
            uploadErrorGeneric: "Não foi possível enviar a imagem da marca d'água.",
            removeButton: "Remover marca d'água",
            anchorLabel: "Posição",
            anchors: {
              "top-left": "Superior esquerda",
              "top-center": "Superior centro",
              "top-right": "Superior direita",
              "center-left": "Centro esquerda",
              center: "Centro",
              "center-right": "Centro direita",
              "bottom-left": "Inferior esquerda",
              "bottom-center": "Inferior centro",
              "bottom-right": "Inferior direita",
            },
            sizeLabel: "Tamanho: {{value}}% da altura do vídeo",
            opacityLabel: "Opacidade: {{value}}%",
            marginXLabel: "Margem horizontal: {{value}}%",
            marginYLabel: "Margem vertical: {{value}}%",
            marginHelp: "Afasta a marca d'água da borda âncora. Ignorado para âncoras centralizadas.",
            previewLabel: "Pré-visualização",
            verticalFrame: "Vertical (9:16)",
            horizontalFrame: "Horizontal (16:9)",
          },
          enforcedLayout: {
            cardTitle: "Layout Obrigatório",
            description: "Força um layout de post em todos os vídeos exportados desta campanha.",
            enable: "Forçar um layout",
            locked: "Bloqueado",
            default: "Padrão",
          },
          editingAssets: {
            cardTitle: "Arquivos para Edição",
            description: "Arquivos disponibilizados para download aos clippers que editam os vídeos da campanha fora da plataforma (logos, fontes, overlays, arquivos de projeto).",
            upload: "Enviar arquivos",
            uploading: "Enviando…",
          },
          enforcedSubtitle: {
            cardTitle: "Posição da Legenda",
            description: "Âncora e margem vertical das legendas, igual ao template. Sobrepõe os valores do template. \"Padrão\" permite que o usuário altere; \"Bloqueado\" torna obrigatório.",
            enable: "Definir a posição da legenda",
            positionLabel: "Posição vertical",
            marginLabel: "Margem vertical",
            previewLabel: "Pré-visualização",
          },
        },
        channelRequests: {
          tab: "Solicitações de canal",
          tabWithCount: "Solicitações de canal ({{count}})",
          invite: {
            title: "Adicionar um usuário a esta campanha",
            help: "Cria uma solicitação de canal já aprovada para o usuário participar — útil para campanhas exclusivas (invite only). Informe a URL do canal/perfil do usuário (obrigatória para casar o canal no YouTube).",
            emailPlaceholder: "E-mail do usuário",
            channelUrlPlaceholder: "URL do canal / perfil",
            button: "Adicionar usuário",
            success: "Usuário adicionado à campanha.",
            missingFields: "E-mail e URL do canal são obrigatórios.",
          },
          empty: "Nenhuma solicitação de canal para este filtro.",
          approve: "Aprovar",
          reject: "Rejeitar",
          revoke: "Revogar",
          reasonPlaceholder: "Motivo (obrigatório ao rejeitar)",
          approveReasonPlaceholder: "Motivo / observação para o usuário (opcional)",
          confirmApprove: "Confirmar aprovação",
          reasonLabel: "Motivo",
          reasonRequired: "É preciso informar um motivo ao rejeitar.",
          statusFilter: { pending: "Aguardando", approved: "Aprovados", rejected: "Rejeitados", all: "Todos" },
          totalLabel: "solicitações",
          previousPage: "Página anterior",
          nextPage: "Próxima página",
          columns: {
            user: "Usuário",
            platform: "Plataforma",
            channel: "Canal",
            submittedAt: "Enviado em",
            status: "Status",
            reviewer: "Revisor",
            actions: "Ações",
          },
        },
        accountDisqualification: {
          action: "Desclassificar conta",
          activeStatus: "Ativa",
          liftedStatus: "Revogada",
          restoredStatus: "Clipes restaurados",
          reasonLabel: "Motivo",
          reasonHint: "O motivo é mostrado ao clipador.",
          reasonPlaceholder: "Explique por que esta conta foi desclassificada",
          disqualifiedBy: "Por {{name}}",
          liftedBy: "Revogada por {{name}}",
          disqualifyTitle: "Desclassificar {{account}}",
          disqualifyDescription: "Apenas a conta {{account}} ({{platform}}) é desclassificada. Os demais clipes do usuário continuam valendo.",
          previewAffected: "Clipes afetados: {{count}}",
          previewReversed: "Valor revertido: {{amount}}",
          previewRefunded: "Devolvido ao orçamento: {{amount}}",
          previewRetained: "Retido (não devolvido): {{amount}}",
          confirmDisqualify: "Desclassificar conta",
          updateTitle: "Atualizar desclassificação de {{account}}",
          updateDescription: "A conta {{account}} ({{platform}}) já está desclassificada nesta campanha. Confirmar troca o motivo e desclassifica os clipes desta conta que ainda valem.",
          confirmUpdate: "Atualizar desclassificação",
          successUpdated: "Desclassificação atualizada.",
          liftAction: "Revogar desclassificação",
          liftTitle: "Revogar desclassificação de {{account}}",
          restoreAction: "Restaurar clipes",
          restoreTitle: "Restaurar clipes de {{account}}",
          restoreClips: "Restaurar também os clipes e o dinheiro",
          restorableCount: "Clipes restauráveis: {{count}}",
          skippedCount: "Clipes ignorados: {{count}}",
          restoreAmount: "Valor a restaurar: {{amount}}",
          budgetCharge: "Cobrado do orçamento: {{amount}}",
          budgetRemaining: "Orçamento restante: {{amount}}",
          forceCappedHint: "A restauração completa passaria do limite em {{amount}}. Restaure só até o limite.",
          restoreWithCap: "Restaurar com limite",
          nothingToRestore: "Não há clipes para restaurar nesta conta.",
          previewLoadError: "Não foi possível carregar a prévia. Feche e tente de novo.",
          filterWithAccount: "Com conta desclassificada",
          filterWithAccountEmpty: "Nenhum clipador com conta desclassificada.",
          blockers: {
            budget: "O orçamento restante não cobre a restauração. Faltam {{amount}}.",
            userDisqualified: "O usuário está desclassificado da campanha. Reverta isso antes de restaurar os clipes.",
            rankingFinalized: "O ranking já foi finalizado. Não é possível alterar contas.",
          },
          confirmLift: "Revogar",
          confirmRestore: "Restaurar",
          cancel: "Cancelar",
          successDisqualified: "Conta desclassificada.",
          allAccountsLabel: "Desclassificar todas as contas de {{user}} nesta campanha",
          allAccountsTitle: "Desclassificar {{user}}",
          allAccountsDescription: "Todas as contas de {{user}} são desclassificadas nesta campanha, e o usuário não pode enviar novos clipes.",
          allAccountsNote: "Todos os clipes aprovados e pendentes do usuário deixam de valer. O dinheiro deles volta ao orçamento, exceto o que o clipador já sacou.",
          allAccountsNoteRanking: "Todos os clipes do usuário saem do ranking.",
          reasonPlaceholderUser: "Explique por que o usuário foi desclassificado",
          confirmDisqualifyUser: "Desclassificar usuário",
          successUserDisqualified: "Usuário desclassificado da campanha.",
          successLifted: "Desclassificação revogada.",
          successRestored: "Clipes restaurados.",
          errors: {
            cpm_account_unidentified: "Não foi possível identificar a conta deste clipe.",
            cpm_account_restore_cap_exceeded: "A restauração passaria do limite por clipador em {{overCents}}.",
            cpm_account_restore_budget_insufficient: "O orçamento não cobre a restauração. Faltam {{missingCents}}.",
            cpm_account_restore_user_disqualified: "O usuário está desclassificado da campanha.",
            cpm_account_not_found: "Registro não encontrado.",
            cpm_account_forbidden: "Você não tem permissão para esta ação.",
            cpm_account_reason_required: "Informe o motivo.",
            cpm_account_already_lifted: "Esta desclassificação já foi revogada.",
            cpm_account_already_restored: "Os clipes desta conta já foram restaurados.",
            cpm_account_conflict: "Outra alteração aconteceu ao mesmo tempo. Atualize e tente de novo.",
            cpm_account_failed: "Não foi possível concluir a ação. Tente novamente.",
            ranking_finalized: "O ranking já foi finalizado.",
          },
        },
        submissions: {
          reviewImages: {
            appealHint: "As imagens só são enviadas com \"Manter reprovação\" ou \"Pedir mais dados\". Remova-as para aceitar a contestação.",
            label: "Imagens (opcional)",
            hint: "Imagens públicas são exibidas ao clipador. Imagens privadas ficam visíveis apenas para admins.",
            add: "Adicionar",
            public: "Pública",
            private: "Privada",
            remove: "Remover imagem",
            invalidType: "Apenas arquivos de imagem são aceitos.",
            uploadFailed: "Falha ao enviar a imagem. Tente novamente.",
            maxReached: "Limite de {{max}} imagens atingido.",
            errors: {
              invalid_rejection_images: "Uma ou mais imagens da reprovação são inválidas.",
              too_many_rejection_images: "Imagens demais na reprovação.",
              invalid_reviewer_images: "Uma ou mais imagens da resposta são inválidas.",
              too_many_reviewer_images: "Imagens demais na resposta.",
            },
          },
          title: "Envios",
          subtitle: "Revise, aprove e desclassifique envios de clipes desta campanha.",
          empty: "Nenhum envio corresponde a este filtro.",
          filters: {
            all: "Todos",
            pending: "Pendentes",
            approved: "Aprovados",
            disapproved: "Reprovados",
            suspectedDuplicates: "Duplicatas",
            platform: "Plataforma",
            aging: "Pendentes há 72h+",
            hashtags: "Hashtags",
          },
          appeals: {
            tab: "Contestações",
            pending: "Pendentes",
            accepted: "Aceitas",
            kept: "Mantidas",
            needs_more_info: "Aguardando clipador",
            all: "Todas",
            accept: "Reverter e aprovar",
            keep: "Manter reprovação",
            requestMore: "Pedir dados adicionais",
            keepReply: "Resposta ao clipador",
            observation: "Observação para o clipador",
            observationHint: "Opcional ao aprovar. Obrigatória para manter a reprovação ou pedir dados adicionais.",
            contestingBadge: "Contestando",
            pendingToast: "Há uma contestação pendente. Resolva na aba Contestações.",
            empty: "Nenhuma contestação corresponde a este filtro.",
            originalReason: "Motivo original",
            argument: "Argumento",
            extraUrl: "Link extra",
            photos: "Fotos",
          },
          bulkApprove: "Aprovar {{count}}",
          bulkApproveConfirm: "Aprovar {{count}} envios pendentes selecionados? Envios com contestação, agrupados ou desclassificados serão ignorados.",
          bulkApproveResult: "{{approved}} aprovados, {{skipped}} ignorados",
          bulkDisapprove: {
            button: "Reprovar {{count}}",
            title_one: "Reprovar {{count}} envio",
            title_other: "Reprovar {{count}} envios",
            description_one: "O motivo abaixo vale para o envio pendente selecionado.",
            description_other: "O mesmo motivo vale para os {{count}} envios pendentes selecionados. Envios com contestação, agrupados ou desclassificados serão ignorados.",
            reasonHint: "O clipador vê este motivo em cada clipe reprovado.",
            confirm: "Reprovar {{count}}",
            result: "{{disapproved}} reprovados, {{skipped}} ignorados",
            errors: {
              reason_required: "Informe um motivo antes de reprovar.",
              reason_too_long: "O motivo pode ter até 500 caracteres.",
              too_many_submissions: "Selecione no máximo 100 envios por vez.",
              generic: "Não foi possível reprovar os envios. Tente novamente.",
            },
          },
          reasonRequired: "Informe um motivo antes de reprovar.",
          reasonChips: {
            video_from_unapproved_channel: "Canal não aprovado",
            missing_hashtag: "Sem hashtag",
            off_brief: "Conteúdo fora",
            missing_watermark: "Sem watermark",
            other: "Outro…",
          },
          disqualifiedBadge: "DESCLASSIFICADO",
          suspectedDuplicateBadge: "Suspeita de duplicata",
          preApproval: {
            badge: "Pré-aprovado",
            ineligibleBadge: "Atenção",
            score: " · nota {{score}}",
            tooltip: "Resultado automático dos gates de pré-aprovação (conexão com Analytics, engajamento e regras da campanha). Não substitui a decisão do auditor.",
          },
          reliability: {
            lowBadge: 'Baixa confiabilidade · {{score}}',
            tooltip: '{{username}} · {{rate}}% de engajamento · {{views}} views · {{videos}} vídeos',
          },
          notDuplicate: "Não é duplicata",
          disqualifyDuplicate: "Desclassificar",
          disqualifyDuplicateConfirm: "Desclassificar este envio como duplicata? O pagamento será zerado.",
          resolveClearedSuccess: "Marcado como não duplicata",
          resolveDisqualifiedSuccess: "Envio desclassificado como duplicata",
          resolveFailed: "Não foi possível resolver a marcação. Tente novamente.",
          views: "Visualizações",
          earned: "Ganho",
          cents: "centavos",
          actions: {
            approve: "Aprovar",
            disapprove: "Reprovar",
            disqualify: "Desclassificar",
            forceUpdate: "Forçar atualização de views",
            disqualifyUser: "Desclassificar usuário",
            undisqualifyUser: "Reabilitar usuário",
            editObservation: "Adicionar / editar observação",
          },
          forceUpdateQueued: "Atualização de views disparada para este clipe",
          forceUpdateError: "Falha ao disparar a atualização de views",
          forceUpdateAll: "Forçar atualização de todas as views",
          forceUpdateAllConfirm: "Isso irá re-buscar as views de todas as plataformas para todos os envios desta campanha. Continuar?",
          forceUpdateAllQueued: "Atualização de views disparada para {{count}} envios",
          forceUpdateAllError: "Falha ao disparar a atualização de views",
          syncMissing: "Sincronizar views faltantes",
          syncMissingConfirm: "Isso irá buscar as views de hoje apenas para envios que ainda não as possuem. Continuar?",
          syncMissingQueued: "Sincronização disparada para {{count}} envios",
          syncMissingNone: "Todos os envios já possuem views de hoje",
          syncMissingError: "Falha ao disparar a sincronização de views faltantes",
          countLabel: "envios",
          filtersLabel: "Aprovação",
          searchPlaceholder: "Buscar URL ou usuário…",
          reasonLabel: "Motivo",
          reasonPlaceholder: "Explique o motivo…",
          adminObservationLabel: "Observação do admin",
          disapproveConfirm: "Informe um motivo antes de reprovar este envio.",
          disqualifyConfirm: "Informe um motivo antes de desclassificar este envio.",
          approvalSet: "Aprovação atualizada",
          approvalError: "Falha ao atualizar aprovação",
          reviewGroup: {
            link: "Vincular publicações",
            selected: "{{count}} selecionados",
            selectColumn: "Selecionar para vínculo",
            selectLabel: "Selecionar {{url}} para vínculo",
            dialogTitle: "Vincular publicações em plataformas diferentes",
            approvalPrecedence: "Confirme apenas publicações do mesmo conteúdo e usuário. Se uma delas já estiver aprovada, a aprovação prevalecerá para todo o grupo.",
            confirm: "Confirmar vínculo",
            success: "{{count}} publicações vinculadas",
            error: "Não foi possível vincular as publicações",
            badge: "Conteúdo vinculado",
            singleReviewError: "Este envio pertence a um conteúdo vinculado. Revise o grupo inteiro para alterar a decisão.",
            validation: {
              minimum: "Selecione pelo menos duas publicações.",
              sameUser: "As publicações precisam pertencer ao mesmo usuário.",
              crossPlatform: "Selecione publicações de pelo menos duas plataformas.",
              alreadyGrouped: "Uma das publicações já pertence a um grupo.",
            },
          },
          disqualifySet: "Envio desclassificado",
          disqualifyError: "Falha ao desclassificar envio",
          budgetPace: {
            title: "Ritmo do orçamento",
            subtitle: "Saldo dia a dia e a projeção no ritmo dos últimos dias completos. O relatório PDF traz o mesmo gráfico.",
            remaining: "Saldo disponível",
            remainingHint: "de {{total}} · {{percent}}% usado",
            pace: "Gasto médio por semana",
            paceHint_one: "Média do último dia completo",
            paceHint_other: "Média dos últimos {{count}} dias completos",
            paceEmpty: "Ainda sem um dia completo",
            outlook: "Previsão de fim do saldo",
            runsOut: "~{{date}}",
            beyond: "Mais de 6 meses",
            noForecast: "Sem previsão",
            exhausted: "Esgotado",
            beforeEnd: "Antes do término ({{date}})",
            leftAtEnd: "No término ({{date}}) sobram ~{{amount}}",
            afterEnd: "Depois do término ({{date}})",
            atCurrentPace: "No ritmo atual",
            noRecentSpend_one: "Sem gasto no último dia",
            noRecentSpend_other: "Sem gasto nos últimos {{count}} dias",
            tooYoung: "Poucos dados para projetar",
            exhaustedHint: "Orçamento totalmente usado",
            inactive: "Campanha fora do ar, sem projeção",
            chartTitle: "Orçamento restante",
            chartLabel: "Orçamento restante por dia, com a projeção no ritmo atual",
            start: "Início",
            today: "Hoje",
            end: "Término",
            remainingSeries: "Restante",
            projectionSeries: "Projeção",
            tooltipStart: "Início · {{amount}}",
            tooltipSpend: "Gasto no dia",
            tooltipProjection: "Projeção · acaba em ~{{date}}",
            tooltipProjectionEnd: "Projeção · {{date}}",
            adjustment: "inclui {{amount}} sem dia definido (sacado de vídeos revertidos ou ajuste)",
            weeklyViews: "Views por semana",
            weeklyViewsTooltip: "Semana de {{date}} · {{views}} views",
            weeklyViewsTooltipPartial: "Semana de {{date}} (parcial) · {{views}} views",
          },
          summary: {
            totalViews: "Total de Views",
            totalSubmissions: "Total de Envios",
            avgViews: "Média de Views por Envio",
            totalEarnings: "Ganhos Totais",
            paidViews: "Views pagas",
            paidViewsHint: "{{share}} das {{approved}} views aprovadas",
            afterWindowViews: "Views após a janela de {{hours}}h",
            afterWindowViewsUnlimited: "Views após a janela (sem limite)",
            afterWindowViewsHint: "Aprovadas, mas fora da janela paga",
            effectiveCpm: "CPM efetivo",
            effectiveCpmHint: "Nominal {{nominal}} · {{efficiency}} do nominal",
            effectiveCpmNominalPerPlatform: "Nominal por rede:",
            paidCpm: "CPM sobre views pagas",
            paidCpmHint: "Abaixo do nominal = teto por clipe ou orçamento",
          },
          topEarning: {
            title: "Clipes que mais ganharam",
            rank: "Posição",
            count: "{{count}} clipes",
            downloadClip: "Baixar",
            downloading: "Baixando…",
            downloadFailed: "Falha ao baixar",
            downloadUnsupported: "Não é possível baixar este link",
            expand: "Mostrar clipes que mais ganharam",
            pageOf: "Página {{page}} de {{pageCount}}",
            previousPage: "Página anterior",
            nextPage: "Próxima página",
            loadFailed: "Não foi possível carregar esta página do ranking. Tente novamente.",
            exportSpreadsheet: "Baixar ranking completo",
            exporting: "Preparando planilha…",
            exportProgress: "Preparando {{loaded}} de {{total}} clipes…",
            exportErrorTitle: "Não foi possível baixar a planilha",
            exportFailed: "Não foi possível reunir o ranking completo. Os dados podem ter mudado durante a consulta. Tente novamente.",
            currency: "Moeda",
          },
          chart: {
            title: "Views e envios ao longo do tempo",
            totalViews: "Total de Views",
            newSubmissions: "Novos Envios",
            approvedPaidViews: "Aprovados (pagas)",
            approvedUnpaidViews: "Aprovados (fora da janela)",
          },
          table: {
            platform: "Plataforma",
            url: "URL",
            submitter: "Enviado por",
            views: "Total de Views",
            cpm: "CPM",
            earned: "Ganho",
            hashtags: "Hashtags",
            submittedAt: "Enviado em",
            actions: "Ações",
          },
          hashtagValidated: "Hashtags validadas",
          hashtagNeutral: "Hashtags pendentes",
          hashtagInvalidated: "Hashtags inválidas",
          hashtagValidationSet: "Validação de hashtags atualizada",
          hashtagValidationError: "Falha ao atualizar a validação de hashtags",
          prompts: {
            reviewReason: "Motivo (opcional)",
            disqualifyReason: "Motivo da desclassificação (obrigatório)",
          },
          userDisqualifiedBadge: "Usuário banido",
          banUserConfirm: "Desclassificar este usuário da campanha? Os envios pendentes dele serão marcados como desclassificados.",
          unbanUserConfirm: "Reverter o banimento deste usuário? Os envios já marcados continuam desclassificados.",
          banUserSuccess: "Usuário desclassificado da campanha",
          banUserReclaimed: "{{amount}} devolvidos ao orçamento da campanha",
          unbanUserSuccess: "Usuário reabilitado",
          banUserError: "Falha ao desclassificar usuário",
          unbanUserError: "Falha ao reabilitar usuário",
          observation: {
            title: "Observação do admin",
            label: "Observação",
            placeholder: "Nota interna sobre este clipe aprovado…",
            save: "Salvar",
            remove: "Remover",
            saved: "Observação salva",
            cleared: "Observação removida",
            error: "Falha ao salvar observação",
          },
          cpmOverride: {
            title: "Alterar o CPM deste vídeo",
            boundsHint: "Entre {{min}} e {{max}}",
            save: "Salvar",
            resetToBase: "Usar padrão da campanha ({{value}})",
            saved: "CPM atualizado — ganhos recalculados",
            error: "Falha ao atualizar CPM",
          },
        },
        participants: {
          title: "Participantes",
          countLabel: "participantes",
          searchPlaceholder: "Buscar por nome ou e-mail...",
          filtersLabel: "Filtros",
          filters: {
            all: "Todos",
            disqualified: "Apenas desclassificados",
          },
          table: {
            user: "Usuário",
            submissions: "Envios",
            approved: "Aprovados",
            totalViews: "Visualizações",
            earnings: "Ganhos",
            firstSubmitted: "Primeiro envio",
            status: "Status",
            actions: "Ações",
          },
          statusActive: "Ativo",
          statusDisqualified: "Desclassificado",
          actions: {
            disqualify: "Desclassificar usuário",
            undisqualify: "Reabilitar",
          },
          banReasonLabel: "Motivo",
          banReasonPlaceholder: "Por que o usuário está sendo desclassificado?",
          banSuccess: "Usuário desclassificado da campanha",
          banReclaimed: "{{amount}} devolvidos ao orçamento da campanha",
          unbanSuccess: "Usuário reabilitado",
          banError: "Falha ao desclassificar usuário",
          unbanError: "Falha ao reabilitar usuário",
          emptyTitle: "Nenhum participante ainda",
          emptyDescription: "Os envios para esta campanha aparecerão aqui.",
        },
      },
      templateSuggestions: {
        title: 'Sugestões de template',
        searchPlaceholder: 'Buscar por nome, link ou usuário...',
        filterAll: 'Todos os status',
        columns: {
          suggestion: 'Sugestão',
          author: 'Autor',
          votes: 'Votos',
          status: 'Status',
          createdAt: 'Enviada em',
          actions: 'Ações',
        },
        approve: 'Aprovar',
        reject: 'Recusar',
        promote: 'Marcar como produzido',
        reopen: 'Reabrir',
        rejectTitle: 'Recusar sugestão',
        rejectDescription: 'O registro é mantido; informe o motivo da recusa.',
        reasonLabel: 'Motivo',
        promoteTitle: 'Marcar como produzido',
        promoteDescription: 'Opcional: informe o id do template (brand kit) criado a partir dessa sugestão.',
        brandKitLabel: 'ID do template',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        empty: 'Nenhuma sugestão encontrada.',
        loadError: 'Não foi possível carregar as sugestões. Isso não quer dizer que a fila está vazia.',
        retry: 'Tentar de novo',
        saved: 'Sugestão atualizada.',
        error: 'Não foi possível atualizar a sugestão.',
      },
      communityCuration: {
        title: 'Curadoria da comunidade',
        subtitle: 'Todo dia às 09:00 (horário de Brasília), o Clippinho adiciona à biblioteca da comunidade os vídeos em alta de cada nicho.',
        loadError: 'Não foi possível carregar a curadoria. Isso não quer dizer que não há nichos.',
        retry: 'Tentar de novo',
        enabled: 'Curadoria diária ativa',
        enabledHint: 'Desligada, a execução diária e o "Rodar agora" não criam nada. Simular e adicionar um vídeo continuam funcionando.',
        curator: 'Curador',
        curatorMissing: 'Conta do curador não configurada. Rode cli/create-community-curator.js no backend.',
        addedToday: '{{count}}/{{cap}} adicionados hoje',
        globalDailyCap: 'Limite diário total',
        youtubeQuotaBudget: 'Orçamento da API do YouTube por execução (unidades)',
        estimatePerRun: 'Estimativa por execução: ~{{estimated}} unidades',
        budgetDraftBelow: 'Abaixo do estimado ({{estimated}}): as execuções ficariam retidas.',
        budgetWarningTitle: 'Execuções retidas',
        budgetWarning: 'O orçamento da API do YouTube ({{budget}} unidades) é menor que o estimado para os nichos ativos ({{estimated}}). Nenhuma execução roda, nem a diária, até você aumentar o orçamento ou remover palavras-chave.',
        save: 'Salvar',
        saved: 'Configurações salvas.',
        runNow: 'Rodar agora',
        simulate: 'Simular',
        addVideo: 'Adicionar vídeo',
        running: 'Executando…',
        runStarted: 'Execução iniciada.',
        simulationStarted: 'Simulação iniciada.',
        runFinished: 'Execução concluída: {{added}} adicionados, {{skipped}} ignorados, {{failed}} com erro.',
        simulationFinished: 'Simulação concluída: {{added}} seriam adicionados.',
        runFailed: 'A execução falhou. Veja os detalhes em Execuções.',
        tabs: {
          niches: 'Nichos',
          runs: 'Execuções',
        },
        niches: {
          new: 'Novo nicho',
          empty: 'Nenhum nicho ainda. Crie um para começar.',
          columns: {
            name: 'Nicho',
            region: 'Região',
            sources: 'Palavras-chave e canais',
            dailyLimit: 'Por dia',
            enabled: 'Ativo',
            actions: 'Ações',
          },
          channelsCount_one: '+ {{count}} canal-semente',
          channelsCount_other: '+ {{count}} canais-semente',
          edit: 'Editar nicho',
          delete: 'Excluir',
          deleteTitle: 'Excluir nicho',
          deleteDescription: 'O nicho "{{name}}" deixa de ser usado. Os vídeos já escolhidos continuam no histórico e na comunidade.',
          saved: 'Nicho salvo.',
          deleted: 'Nicho excluído.',
        },
        regions: {
          BR: 'Brasil (português)',
          US: 'EUA (inglês)',
        },
        form: {
          createTitle: 'Novo nicho',
          editTitle: 'Editar nicho',
          description: 'Cada palavra-chave vira uma busca no YouTube; os canais-semente sempre contribuem com os uploads recentes.',
          name: 'Nome',
          region: 'Região e idioma da curadoria',
          keywords: 'Palavras-chave',
          keywordsHint: 'Uma por linha (até 10). Cada uma custa 100 unidades da API do YouTube por execução.',
          seedChannels: 'Canais-semente',
          seedChannelsHint: 'Um por linha (até 10): @handle, link do canal ou ID UC…',
          needsSource: 'Informe ao menos uma palavra-chave ou um canal-semente.',
          minDuration: 'Duração mínima (min)',
          maxDuration: 'Duração máxima (min)',
          lookbackHours: 'Publicados nas últimas (horas)',
          dailyLimit: 'Vídeos por dia',
          enabled: 'Nicho ativo',
          submit: 'Salvar',
          cancel: 'Cancelar',
        },
        runs: {
          columns: {
            startedAt: 'Início',
            trigger: 'Origem',
            status: 'Status',
            result: 'Resultado',
            units: 'Unidades',
          },
          empty: 'Nenhuma execução ainda.',
          loadError: 'Não foi possível carregar as execuções.',
          view: 'Ver',
          dryRun: 'Simulação',
          result: '{{added}} adicionados · {{skipped}} ignorados · {{failed}} com erro',
          resultDryRun: '{{added}} seriam adicionados · {{skipped}} ignorados',
          heldBudget: 'Retida: orçamento {{budget}} < estimado {{estimated}} unidades',
        },
        triggers: {
          cron: 'Diária',
          admin: 'Painel',
          mcp: 'Claude (MCP)',
          manual: 'Manual',
        },
        statuses: {
          running: 'Executando',
          success: 'Concluída',
          failed: 'Falhou',
          held: 'Retida',
        },
        pickStatuses: {
          added: 'Adicionado',
          skipped: 'Ignorado',
          failed: 'Erro',
          dry_run: 'Seria adicionado',
        },
        reasons: {
          already_in_community: 'Já tem biblioteca na plataforma',
          already_picked: 'Já escolhido antes',
          duplicate_in_run: 'Escolhido por outro nicho',
          niche_limit: 'Limite diário do nicho',
          global_cap: 'Limite diário total',
          out_of_duration: 'Fora da duração',
          live_or_upcoming: 'Ao vivo ou agendado',
          music_category: 'Categoria Música',
          wrong_language: 'Idioma diferente do nicho',
          create_error: 'Erro ao criar a biblioteca',
          quota_error: 'Limite de cota do curador',
          unknown: 'Outro motivo',
        },
        runDialog: {
          title: 'Execução de {{date}}',
          units: '{{count}} unidades da API',
          loadError: 'Não foi possível carregar esta execução.',
          niches: 'Nichos',
          nicheSummary: '{{searches}} buscas · {{candidates}} candidatos · {{added}} adicionados',
          noteQuotaBudget: 'Orçamento da API esgotado: os nichos seguintes não foram buscados.',
          noteYoutubeQuota: 'Cota diária do YouTube esgotada.',
          showing: '{{shown}} de {{total}} vídeos',
          filterAll: 'Todos',
          columns: {
            video: 'Vídeo',
            niche: 'Nicho',
            views: 'Views',
            velocity: 'Views/hora',
            status: 'Status',
          },
          velocity: '{{value}}/h',
          empty: 'Nenhum vídeo nesta execução.',
          libraryStatus: 'Biblioteca: {{status}}',
        },
        addVideoDialog: {
          title: 'Adicionar vídeo',
          description: 'Adiciona um vídeo do YouTube à comunidade como Clippinho, fora dos limites diários. Vídeos que já têm biblioteca são ignorados.',
          url: 'Link do YouTube',
          niche: 'Nicho (opcional)',
          noNiche: 'Sem nicho',
          region: 'Idioma da curadoria',
          submit: 'Adicionar',
          added: 'Vídeo adicionado. Ele aparece na comunidade quando o processamento terminar.',
          skipped: 'Vídeo ignorado: {{reason}}.',
          failed: 'Não foi possível adicionar o vídeo. Veja os detalhes em Execuções.',
        },
        errors: {
          title: 'Não foi possível concluir',
          ok: 'Ok',
          alreadyRunning: 'Já há uma execução em andamento. Aguarde ela terminar.',
          disabled: 'A curadoria diária está desligada. Ative-a ou use Simular.',
          curatorMissing: 'A conta do curador não está configurada.',
          notFound: 'Não encontrado. Recarregue a página.',
          invalid: 'Dados inválidos.',
          invalidField: 'Valor inválido em: {{field}}.',
          generic: 'Algo deu errado. Tente novamente.',
          budgetBelowEstimate: 'Execução retida: o orçamento da API do YouTube ({{budget}} unidades) é menor que o estimado para os nichos ativos ({{estimated}}). Aumente o orçamento ou remova palavras-chave.',
        },
        fields: {
          name: 'Nome',
          enabled: 'Ativo',
          region: 'Região',
          keywords: 'Palavras-chave',
          seed_channels: 'Canais-semente',
          min_duration_minutes: 'Duração mínima',
          max_duration_minutes: 'Duração máxima',
          lookback_hours: 'Publicados nas últimas (horas)',
          daily_limit: 'Vídeos por dia',
          global_daily_cap: 'Limite diário total',
          youtube_quota_budget: 'Orçamento da API do YouTube',
        },
      },
    },

    // Contact Support
    contact: {
      support: "Falar com Suporte",
      title: "Falar com Suporte",
      chooseMethod: "Escolha como gostaria de entrar em contato",
      describeIssue: "Descreva seu problema e nós te ajudaremos",
      whatsapp: "WhatsApp",
      whatsappDescription: "Converse conosco instantaneamente",
      email: "E-mail",
      emailDescription: "Envie-nos uma mensagem",
      placeholder: "O que está acontecendo? Descreva seu problema aqui...",
      sendWhatsApp: "Enviar para WhatsApp",
      sendEmail: "Enviar E-mail",
    },

    // Invoice page
    invoice: {
      title: "Fatura PIX",
      subtitle: "Complete seu pagamento via PIX para ativar sua assinatura",
      loadingUserData: "Carregando dados do usuário...",
      generatePixCode: "Gerar código PIX",
      noPendingPayment: "Nenhum Pagamento Pendente",
      noPendingPaymentDescription: "Não foi encontrado nenhum pagamento PIX pendente em sua conta.",
      loadingPaymentData: "Carregando dados do pagamento...",
      paymentLoadError: "Erro ao Carregar Pagamento",
      tryAgain: "Tentar Novamente",
      paymentStatus: "Status do Pagamento",
      amount: "Valor",
      createdAt: "Criado em",
      expiresAt: "Expira em",
      qrCodeTitle: "QR Code PIX",
      qrCodeAlt: "QR Code PIX",
      qrCodeInstructions: "Escaneie o QR Code com o app do seu banco ou copie o código PIX abaixo",
      pixCodeTitle: "Código PIX",
      copyPixCode: "Copiar Código PIX",
      pixCodeCopyHint: "Cole este código no app do seu banco na opção \"PIX Copia e Cola\"",
      howToPay: "Como Pagar",
      howToPayStep1: "Abra o app do seu banco",
      howToPayStep2: "Vá na opção PIX",
      howToPayStep3: "Escolha \"Ler QR Code\" ou \"PIX Copia e Cola\"",
      howToPayStep4: "Escaneie o QR Code ou cole o código PIX",
      howToPayStep5: "Confirme o pagamento",
      howToPayNote: "O pagamento será processado automaticamente após a confirmação. Sua assinatura será ativada em alguns minutos.",
      paymentConfirmed: "Pagamento Confirmado!",
      paymentConfirmedDescription: "Seu pagamento PIX foi processado com sucesso. Sua assinatura foi ativada e você já pode aproveitar todos os recursos.",
      goToProjects: "Ir para Projetos",
      autoCheckingStatus: "Verificando automaticamente o status do pagamento...",
      autoCheckPaused: "Verificação automática pausada. Clique para verificar manualmente.",
      checkStatus: "Verificar Status",
      copied: "Copiado!",
      pixCodeCopied: "Código PIX copiado para a área de transferência",
      pixCodeCopyError: "Não foi possível copiar o código PIX",
      pixPaymentError: "Erro ao carregar dados do pagamento PIX",
      timeLimitReached: "Tempo Limite Atingido",
      timeLimitDescription: "Paramos de verificar automaticamente. Você pode atualizar manualmente.",
      paymentConfirmedToastTitle: "Pagamento Confirmado!",
      paymentConfirmedToastDescription: "Seu pagamento PIX foi processado com sucesso. Sua assinatura foi ativada.",
      statusWaitingPayment: "Aguardando Pagamento",
      statusPaid: "Pago",
      statusExpired: "Expirado",
      statusCanceled: "Cancelado",
    },

    // Pro-only route
    proOnlyRoute: {
      title: "Recurso PRO Necessário",
      locked: "Esta funcionalidade está disponível apenas para usuários PRO",
      description: "As funcionalidades da API (chaves, requisições e documentação) fazem parte do nosso plano PRO. Faça o upgrade para acessar recursos avançados de integração.",
      upgradeButton: "Fazer Upgrade para PRO",
      backToProjects: "Voltar aos Projetos",
    },

    couponLanding: {
      title: "Seu cupom AutoClipper",
      description: "Escolha onde deseja continuar com seu cupom.",
      openApp: "Abrir no app",
      continueWebsite: "Continuar no site",
    },

    // Auth messages (toasts)
    auth: {
      loginSuccess: "Login realizado com sucesso",
      welcomeBack: "Bem-vindo de volta!",
      loginFailed: "Falha no login",
      loggedOut: "Logout realizado",
      loggedOutDescription: "Você foi desconectado com sucesso.",
      backendUnavailable: {
        title: "Não foi possível conectar ao Autoclipper",
        description: "Sua conta continua conectada. Verifique sua internet ou tente novamente em instantes.",
      },
      connectionLost: {
        title: "Sem conexão com o Autoclipper",
        description: "Suas alterações continuam na tela. Tentando reconectar…",
      },
      profileUpdated: "Perfil atualizado",
      profileUpdatedDescription: "Seu perfil foi atualizado com sucesso.",
      profileUpdateFailed: "Falha na atualização",
      profileUpdateError: "Falha ao atualizar perfil",
      passwordChanged: "Senha alterada",
      passwordChangedDescription: "Sua senha foi alterada com sucesso.",
      passwordChangeError: "Erro ao alterar senha",
      authError: "Erro na autenticação",
      processingLogin: "Processando login",
      processingAuthWait: "Aguarde enquanto processamos sua autenticação...",
      authProviderFailed: "Falha na autenticação com {{provider}}",
      authTokenNotFound: "Token de autenticação não encontrado",
      authProcessingError: "Erro ao processar autenticação",
      backToLogin: "Voltar para login",
      loginWithGoogle: "Entrar com Google",
    },

    // Login/Register modal
    loginRegisterModal: {
      title: "Faça login ou crie sua conta",
      loginTab: "Entrar",
      registerTab: "Criar Conta",
      emailLabel: "Email",
      emailPlaceholder: "Digite o seu email",
      passwordLabel: "Senha",
      passwordPlaceholder: "Digite a sua senha",
      forgotPassword: "Esqueceu a senha?",
      loggingIn: "Entrando...",
      loginButton: "Entrar",
      nameLabel: "Nome",
      namePlaceholder: "Digite o seu nome",
      roleLabel: "Função",
      rolePlaceholder: "Escolha sua função",
      phoneLabel: "Telefone",
      confirmPasswordLabel: "Confirmar Senha",
      confirmPasswordPlaceholder: "Digite a sua senha novamente",
      creatingAccount: "Criando conta...",
      createAccountButton: "Criar Conta",
      invalidCredentials: "Email ou senha inválidos",
      passwordMismatch: "As senhas não coincidem.",
      registrationError: "Erro no registro. Tente novamente.",
      emailTaken: "Email já cadastrado.",
      invalidEmail: "Email inválido.",
    },

    // Clip status texts
    clipStatus: {
      queuedProcessing: "Aguardando processamento...",
      exportingVideo: "Exportando vídeo...",
      videoReady: "Vídeo pronto",
      processingError: "Erro no Processamento",
      expired: "Expirado",
      waitingSceneDetection: "Aguardando detecção de cenas...",
      detectingScenes: "Detectando cenas...",
      readyForEditing: "Vídeo pronto para edição",
      waitingGeneration: "Aguardando geração...",
      generatingFinalVideo: "Gerando vídeo final...",
      loading: "Carregando...",
      preparingVideo: "Preparando vídeo...",
      cuttingVideo: "Cortando vídeo...",
      generatingVideo: "Gerando vídeo...",
    },

    // Coupon errors
    couponErrors: {
      notFound: "Cupom não encontrado",
      expired: "Cupom expirado",
      noUsesRemaining: "Cupom sem utilizações restantes",
      invalidForPlan: "Cupom não é válido para este plano",
      invalidForRecurrency: "Cupom não é válido para esta recorrência",
    },

    renewalCoupon: {
      toggle: "Tenho um cupom",
      placeholder: "Código do cupom",
      apply: "Aplicar",
      applying: "Aplicando…",
      appliedTitle: "Cupom {{code}} aplicado",
      appliedPercent_one: "{{discount}}% de desconto na próxima renovação",
      appliedPercent_other: "{{discount}}% de desconto por {{count}} renovações",
      appliedFlat_one: "{{amount}} de desconto na próxima renovação",
      appliedFlat_other: "{{amount}} de desconto por {{count}} renovações",
      appliedPercentUnlimited: "{{discount}}% de desconto em todas as renovações",
      appliedFlatUnlimited: "{{amount}} de desconto em todas as renovações",
      planPrice: "Preço do plano",
      couponDiscount: "Cupom {{code}}",
      couponDiscountNoCode: "Desconto do cupom",
      cyclesLeft_one: "{{count}} renovação com desconto",
      cyclesLeft_other: "{{count}} renovações com desconto",
      cyclesUnlimited: "em todas as renovações",
      unsupportedTitle: "Cupom indisponível para o seu plano",
      unsupportedDescription: "Cupons de renovação valem para planos renovados manualmente via PIX ou saldo da carteira.",
      errors: {
        not_eligible: "Seu plano não aceita cupons de renovação.",
        renewal_payment_pending: "Você tem um pagamento de renovação em andamento. Cancele-o para usar um cupom.",
        coupon_not_found: "Cupom não encontrado.",
        coupon_expired: "Este cupom expirou.",
        coupon_exhausted: "Este cupom esgotou.",
        coupon_invalid_for_plan: "Este cupom não vale para o seu plano.",
        coupon_invalid_for_recurrency: "Este cupom não vale para o seu ciclo de cobrança.",
        coupon_not_assigned: "Este cupom pertence a outra conta.",
        coupon_already_used: "Você já usou este cupom.",
        coupon_not_better: "Seu desconto atual já é melhor que este cupom.",
        coupon_invalid: "Este cupom não pode ser aplicado.",
        generic: "Não foi possível aplicar o cupom. Tente novamente.",
      },
    },

    // Phone input
    phoneInput: {
      label: "Telefone",
      other: "Outro",
      selectCountry: "Selecione um país...",
      searchCountry: "Buscar país...",
      noCountryFound: "Nenhum país encontrado.",
    },

    // Clip editor
    clipEditor: {
      backgroundMusic: "Música de Fundo",
      copy: " (cópia)",
      undoAction: "Desfazer última ação",
      redoAction: "Refazer última ação",
    },

    // Tutorial card
    tutorialCard: {
      beginner: "Iniciante",
      intermediate: "Intermediário",
      advanced: "Avançado",
      clickToWatch: "Clique para assistir no YouTube",
    },

    // Timeline
    timeline: {
      sourceDuration: "Duração do vídeo: {{time}}",
      clipSequence: "Clipe",
      fullVideo: "Vídeo completo",
      clipSequenceHint: "Reordenar cenas",
      fullVideoHint: "Selecionar e estender trechos do vídeo completo",

      focusPreview: "Enquadramento atual da cena",
      playhead: "Cursor de reprodução",
      trimStart: "Ajustar início da cena {{number}}",
      trimEnd: "Ajustar fim da cena {{number}}",
      frameTrimHint: "Esquerda/Direita: ajustar um quadro (30 fps)",
      moveSceneToStart: "Mover cena para o início",
      moveSceneToEnd: "Mover cena para o final",
      reorderScene: "Cena {{number}}. Alt + Esquerda ou Direita para reordenar.",
      duration: "Duração do clipe: {{time}}",
      sceneNumber: "Cena #{{number}}",
      seekDetectedScene: "Ir para a cena detectada em {{time}}",
      addIntervalAfterCurrent: "Adicionar intervalo após o atual",
      addIntervalAtCurrentTime: "Adicionar intervalo no tempo atual",
      undo: "Desfazer",
      redo: "Refazer",
      split: "Dividir em {{time}}",
      splitScene: "Dividir cena no cursor",
      splitSceneHere: "Dividir a cena em {{time}}",
      addCopyHere: "Adicionar cópia deste trecho (5s)",
      playheadInsideScene: "O cursor está dentro de uma cena.",
      zoomLabel: "Zoom da timeline",
    },

    // Clip titles
    clipTitlesHook: {
      generationFailed: "Falha ao gerar títulos",
      generationRequestError: "Erro ao solicitar geração de títulos",
    },

    // Upload modal extras
    uploadModalExtra: {
      whatYouLookFor: "O que você procura no vídeo",
      describeWhatYouLookFor: "Descreva o que você procura no vídeo",
      customPromptPlaceholder: "Por exemplo: 'Extraia momentos engraçados', 'Encontre partes sobre marketing digital', 'Crie clipes com dicas práticas'...",
      customPromptHint: "Seja específico sobre o que você quer extrair do vídeo para obter melhores resultados.",
      videoExtentLabel: "Extensão do vídeo para processamento",
      selectExtension: "Selecione a extensão",
      fullVideo: "Vídeo inteiro",
      videoSegment: "Trecho do Vídeo",
    },

    // News PDF upload modal
    newsPdfUpload: {
      defaultPrompt: "Criar clipes virais a partir do vídeo e PDF fornecidos.",
    },

    // Header
    headerExtra: {
      defaultUser: "Usuário",
    },

    // Plans
    plansExtra: {
      whatsappMessage: "Olá! Gostaria de saber mais sobre os planos da AutoClipper e ter um plano personalizado.",
    },

    // Project status labels
    projectStatus: {
      preQueued: "Baixando vídeo",
      queued: "Aguardando Processamento...",
      processing: "Processando...",
      transcribing: "Transcrevendo...",
      segmenting: "Segmentando...",
      trimming: "Cortando...",
      curating: "Curando...",
      success: "Pronto!",
      failure: "Erro",
      expired: "Expirado",
    },

    // Delete project hook
    deleteProject: {
      success: "Projeto removido",
      successDescription: "O projeto foi removido com sucesso.",
      error: "Erro ao remover projeto",
      errorDescription: "Ocorreu um erro ao tentar remover o projeto. Tente novamente.",
    },

    // Auto editor
    autoEditor: {
      editClip: "Editar Clipe: {{name}}",
      startingGeneration: "Iniciando geração...",
      generateClip: "Gerar Clipe",
      loadingClip: "Carregando clipe…",
      renderSuccess: "Seu clipe está sendo renderizado",
      renderError: "Ocorreu um erro ao renderizar o clipe",
    },

    // Target objectives
    targetObjectives: {
      ownContent: "Criar cortes de vídeos dos meus próprios conteúdos",
      ownContentExample: "(Ex: podcasts, lives, vídeos do YouTube, etc.)",
      serviceProvider: "Prestar serviços de edição de cortes para outras pessoas ou empresas",
      serviceProviderExample: "(Ex: atuar como freelancer ou agência)",
      revenueGeneration: "Gerar novas fontes de renda por meio da criação de conteúdo digital",
      revenueGenerationExample: "(Ex: monetização de redes sociais, venda de produtos, parcerias, etc.)",
      other: "Outro",
    },

    // Font selector
    fontSelector: {
      loadingFonts: "Carregando fontes...",
      loadingFont: "Carregando fonte...",
      selectFont: "Selecionar Fonte",
      chooseFontPlaceholder: "Escolha uma fonte...",
      noFamily: "Sem Família",
      errorLoadingFonts: "Erro ao carregar fontes",
      noFontsAvailable: "Nenhuma fonte disponível",
      noFontsFound: "Nenhuma fonte encontrada",
      tryDifferentSearch: "Tente um termo de busca diferente",
      noResultsFound: "Nenhum resultado encontrado",
      fontsFound_one: "{{count}} fonte encontrada",
      fontsFound_other: "{{count}} fontes encontradas",
      fontPreview: "Visualização da Fonte",
      blackText: "Texto preto",
      whiteText: "Texto branco",
      fontFile: "Arquivo da fonte",
      downloadFont: "Baixar fonte",
    },

    // Contact support
    contactSupport: {
      emailSubject: "Suporte Autoclipper",
    },

    // Account settings
    accountSettings: {
      cancelWhatsappMessage: "Olá, eu gostaria de cancelar o meu plano da Autoclipper.",
      emailMarketingOptIn: "Receber atualizações de produto e dicas por e-mail",
    },

    // Upload modal extras (batch 3)
    uploadModalExtra2: {
      createBrandKit: "Criar Template",
      createBrandKitTitle: "Crie seu primeiro Template",
      createBrandKitDescription: "Personalize seus vídeos com cores, logos e fontes da sua marca. Templates garantem consistência visual em todos os seus clipes.",
      loadingUsageData: "Carregando dados de uso...",
      processingTime: "Tempo de Processamento",
      clipsCreated: "Clipes Criados",
      upgradeToPro: "Atualize para PRO",
      videoWillConsume: "Este vídeo irá consumir: {{duration}}",
      processingSelectedSegment: "(Processando apenas o trecho selecionado: {{duration}})",
      insufficientTime: "Tempo insuficiente: este projeto requer {{required}} e você tem {{available}} disponíveis neste mês.",
      considerUpgrading: "Considere atualizar seu plano para ter mais tempo de processamento.",
      upgradePlan: "Atualizar Plano",
      createProjectError: "Erro ao criar projeto: {{error}}",
      creating: "Criando...",
      waitingUpload: "Aguardando upload...",
      createProject: "Criar Projeto",
      timeInputHint: "Digite somente números (ex: 123456 = 12:34:56)",
      captureTimeHint: "Use os botões para capturar o tempo atual do vídeo, ou digite apenas números no formato HH:mm:ss",
    },

    // News PDF upload modal extras
    newsPdfUploadExtra: {
      defaultProjectName: "Novo Projeto",
    },

    // Timeline extras
    timelineExtra: {
      removeInterval: "Remover intervalo",
    },

    // Crop center editor
    cropCenter: {
      sceneTime: "Tempo da cena",
      previousFrame: "Quadro anterior",
      nextFrame: "Próximo quadro",
      frameNumber: "Quadro {{number}} / {{total}}",

      editPosition: "Ajustar enquadramento em {{time}}",
      thisSceneOnly: "Só esta cena",
      segment: "Segmento",
      delete: "Remover este trecho (usa o enquadramento do trecho vizinho na cena)",
      applyToAllScenes: "Copiar para todas as cenas",
      applyToAllScenesConfirm: "Isso troca o enquadramento e o zoom de todas as cenas do clipe por este.",
      applyToAllScenesAction: "Aplicar em todas",
      addAtPlayhead: "Dividir aqui",
      dragHint: "Arraste o quadro para reposicionar o recorte",
    },

    // Reframe modal
    reframeModal: {
      trigger: "Reenquadrar",
      title: "Reenquadrar vídeo",
      keyframes: "Keyframes",
      addAtPlayhead: "Dividir no playhead",
      empty: "Ainda não há dados de recorte para este clipe.",
      outsideScene: "Posicione o playhead em uma cena do clipe para ajustar o enquadramento dela.",
      selectHint: "Selecione um keyframe para editar.",
      zoomTrigger: "Zoom no foco atual",
      zoomLabel: "Zoom",
      zoomSceneOnly: "Zoom desta cena",
      zoomEmpty: "Posicione o playhead em uma cena do clipe.",
    },

    // Earn page
    campaignCategories: {
      label: "Categorias",
      business: "Negócios e empreendedorismo",
      marketing: "Marketing e vendas",
      finance: "Finanças",
      personal_development: "Desenvolvimento pessoal",
      health: "Saúde e bem-estar",
      news: "Notícias e política",
      sports: "Esportes",
      entertainment: "Entretenimento",
      technology: "Tecnologia",
      education: "Educação",
      products: "Produtos e marcas",
      podcast: "Podcasts e entrevistas",
    },
    // Compact cards: the full name abbreviated to fit three chips in a row.
    campaignCategoriesShort: {
      business: "Negócios",
      marketing: "Marketing",
      finance: "Finanças",
      personal_development: "Desenv. pessoal",
      health: "Saúde",
      news: "Notícias",
      sports: "Esportes",
      entertainment: "Entretenimento",
      technology: "Tecnologia",
      education: "Educação",
      products: "Produtos",
      podcast: "Podcasts",
    },
    earnPage: {
      activeBadge: "{{count}} campanhas pagando agora",
      heroTitle: "Ganhe dinheiro com",
      heroTitleHighlight: "cortes",
      heroSubtitle: "Escolha uma campanha, gere cortes com IA e publique no TikTok, Instagram ou Shorts com as marcações obrigatórias. Envie o link do vídeo e receba por visualizações.",
      howItWorksTitle: "Como Funciona",
      howItWorksSubtitle: "Em 5 passos simples você já está ganhando",
      step1Title: "Escolha um vídeo",
      step1Desc: "Navegue pelos vídeos elegíveis da campanha",
      step2Title: "Crie um corte",
      step2Desc: "Gere um clipe viral com a IA da AutoClipper",
      step3Title: "Poste nas redes",
      step3Desc: "Publique no TikTok, Instagram ou YouTube com as marcações obrigatórias",
      step4Title: "Envie o link",
      step4Desc: "Na página da campanha, cole o link do post publicado no campo \"Enviar clipe\"",
      step5Title: "Ganhe por views",
      step5Desc: "Receba por cada 1.000 visualizações verificadas",
      campaignsTitle: "Campanhas pagando agora",
      otherCampaignsTitle: "Outras campanhas pagando agora",
      showLeaderboard: "Mostrar ranking das campanhas ativas",
      hideLeaderboard: "Ocultar ranking das campanhas ativas",
      myCampaignsTitle: "Minhas campanhas",
      myCampaignsSubtitle_one: "Você participa de {{count}} campanha. Envie seus clipes e acompanhe os ganhos.",
      myCampaignsSubtitle_other: "Você participa de {{count}} campanhas. Envie seus clipes e acompanhe os ganhos.",
      minViewsPerClip: "Mínimo de {{views}} views por clipe para ganhar",
      noMinViewsPerClip: "Sem mínimo de views: todas as views contam",
      campaignsSubtitle: "Escolha um canal, gere cortes e ganhe por views.",
      payUpTo: "Ganhe até",
      perThousandViews: "/ 1.000 views",
      remainingBudget: "Orçamento restante",
      budgetExhausted: "Orçamento esgotado",
      earnWithCampaign: "Ganhar com essa campanha",
      noCampaigns: "Nenhuma campanha ativa no momento. Volte em breve!",
      inviteOnly: {
        ctaLabel: "Exclusivo Assinantes",
        popoverTitle: "Campanha Exclusiva",
        popoverText: "Esta campanha é exclusiva para assinantes de planos pagos. Assine um plano pago para participar.",
        tickerLabel: "Campanha exclusiva para assinantes",
      },
      proExclusive: {
        badge: "ASSINANTE",
        tooltip: "Você tem acesso a esta campanha exclusiva porque é assinante de um plano pago.",
      },
      selectedOnly: {
        badge: "SELEÇÃO",
        exclusiveBadge: "SELECIONADO",
        exclusiveTooltip: "Você tem acesso a esta campanha porque foi selecionado para participar.",
        ctaLabel: "Somente convidados",
        popoverTitle: "Campanha por Seleção",
        popoverText: "Esta campanha é restrita a clipadores selecionados. Não é possível participar por assinatura ou convite.",
        tickerLabel: "Campanha somente para selecionados",
      },
      proLocked: {
        partnerName: "Parceiro Exclusivo",
        ctaLabel: "Desbloquear acesso PRO",
        popoverTitle: "Disponível no Plano PRO",
        popoverText: "Desbloqueie campanhas exclusivas e ganhe mais por view com nossos parceiros.",
        upgradeButton: "Fazer upgrade",
      },
      joinedBadge: "Participando",
      freeLimit: {
        cta: "Faça upgrade para entrar em mais campanhas",
        note: "Plano gratuito: você pode participar de 1 campanha por vez.",
      },
      partnersTitle: "Ganhe com Parceiros",
      partnersSubtitle: "Campanhas de marcas parceiras — acesso exclusivo para assinantes PRO.",
      endedCampaignsTitle: "Campanhas Encerradas",
      endedCampaignsSubtitle: "Veja quanto já foi pago aos clipadores em campanhas anteriores.",
      endedSummary: {
        description: "Veja quanto já foi pago aos clipadores em campanhas anteriores. Ganhos liberados na carteira após a auditoria das visualizações, com saque via PIX.",
        totalPaid: "Total pago aos clipadores",
        walletNote: "Ganhos de campanhas liberados na carteira",
        totalDistributed: "Total distribuído",
        closedCycles_one: "{{count}} ciclo encerrado",
        closedCycles_other: "{{count}} ciclos encerrados",
        average: "Média / campanha",
        perCycle: "Por ciclo de conteúdo",
        largest: "Maior distribuição",
        myEarnings: "Meus Ganhos",
        myEarningsNote: "Ganhos acumulados na plataforma",
        earningsUnavailable: "Não foi possível carregar seus ganhos",
      },
      endedBadge: "Encerrada",
      paidLabel: "pagos",
      scheduledCampaignsTitle: "Em Breve",
      scheduledCampaignsSubtitle: "Campanhas já confirmadas, ainda não abertas para participação.",
      scheduledBadge: "Em breve",
      scheduledBudgetLabel: "Orçamento total",
      scheduledStartsAt: "Começa em {{date}}",
      scheduledStartsSoon: "Data a definir",
      vitrine: {
        title: "Vitrine de Parcerias",
        subtitle: "Parceiros selecionados pela AutoClipper para potencializar sua jornada como clipador.",
        officialPartner: "parceria oficial",
        badgeExternal: "PRO",
        badgeAcervo: "PRO",
        ctaExternal: "Conferir oportunidades",
        ctaAcervo: "Conferir oportunidades",
      },
      earnPerView: "Ganhe por visualização",
      cpmTooltip: "CPM = valor pago a cada 1.000 visualizações válidas",
      paymentBar: {
        approval72h: "Aprovação do clipe em até",
        approval72hBold: "72h",
        views72h: "Views contabilizadas por até",
        views72hBold: "72h após o envio do link para a campanha",
        payment48h: "Pagamento em até",
        payment48hBold: "48h após auditoria",
        minWithdrawal: "Saque mínimo:",
        minWithdrawalValue: "R$ 20",
        viewDetails: "Ver detalhes",
      },
      faq: {
        title: "Dúvidas sobre pagamento",
        q1: "Como funciona a aprovação e a contagem de views?",
        a1: "Após enviar o link do clipe, ele passa por uma auditoria de aprovação em até 72h. As visualizações elegíveis são contabilizadas durante as primeiras 72h após o envio do link para a campanha. Apenas views reais e únicas de contas válidas são consideradas.",
        q2: "Quando recebo o pagamento?",
        a2: "Após a auditoria das views, o valor cai na sua carteira na plataforma. Para receber, você precisa solicitar o saque manualmente pelo botão \"Solicitar saque\" — disponível quando seu saldo atingir o mínimo de R$ 20. O pagamento é então processado em até 48h.",
        q3: "Qual o valor mínimo para saque?",
        a3: "O valor mínimo para solicitar um saque é de R$ 20. Valores abaixo desse limite ficam acumulados para o próximo pagamento.",
        q4: "Posso participar de várias campanhas ao mesmo tempo?",
        a4: "Sim! Você pode participar de quantas campanhas estiverem ativas. Cada clipe enviado é avaliado individualmente pela campanha correspondente.",
        q5: "O que acontece se o clipe for reprovado?",
        a5: "Se o clipe não seguir as regras da campanha (marcações obrigatórias, qualidade mínima), ele pode ser reprovado e não gerar pagamento. Sempre confira as instruções antes de publicar.",
      },
    },

    cpmLeaderboard: {
      title: "Ranking dos clipadores",
      tickerSubtitle: "Mais views nas campanhas ativas",
      views: "{{views}} views",
      videos: "{{count}} vídeos",
      remainAnonymous: "Permanecer anônimo",
      remainAnonymousHint: "Oculte seu nome e foto do ranking. Suas views continuam contando.",
      anonymousName: "Clipador",
      anonymousAria: "Clipador anônimo, {{views}} views",
      upgradeTitle: "Permanecer anônimo no ranking",
      upgradeBody: "Ocultar seu nome e foto do ranking Clip & Pix é um recurso dos planos pagos.",
      upgradeCta: "Fazer upgrade",
      upgradeDismiss: "Agora não",
      privacySaved: "Privacidade do ranking atualizada",
      privacyError: "Não foi possível atualizar a privacidade do ranking",
      rank: "{{rank}}º",
      you: "Você",
      yourPosition: "Você está em {{rank}}º de {{total}}",
      unranked: "Você não está no ranking.",
      unrankedRank: "??",
      gap: "…",
      ranksLink: "Ver patentes",
      rankingLink: "Ver ranking",
    },

    ranks: {
      title: "Rankings",
      yours: "Suas patentes",
      hall: "Hall da fama",
      fullRankingLink: "Ver ranking completo",
      link: "Ver patentes",
      emptyTrack: "Ainda sem progresso nesta patente",
      tracks: {
        views: "Viralizador",
        campaign_money: "Caçador de Recompensas",
        affiliate: "Vendedor Implacável",
        campaigns: "Mercenário de Conteúdo",
        renders: "Máquina de Cortes",
        season: "Lenda da Temporada",
      },
      metrics: {
        views: "Visualizações",
        campaign_money: "Dinheiro",
        affiliate: "Dinheiro",
        campaigns: "Número de campanhas",
        renders: "Número de cortes",
        season: "Visualizações da temporada",
      },
      units: {
        views: "visualizações",
        campaigns: "campanhas",
        clips: "cortes",
      },
      requirements: {
        views: "Alcançou {{metric}}",
        money: "Faturou {{metric}}",
        campaigns: "Participou de {{metric}}",
        clips: "Exportou {{metric}}",
        affiliateBronze: "Fez a primeira venda indicada",
        seasonExact: "Terminou em {{placement}}º no ranking da temporada",
        seasonExactNamed: "Terminou em {{placement}}º em {{season}}",
        seasonRange: "Terminou entre {{from}}º e {{to}}º no ranking da temporada",
        seasonRangeNamed: "Terminou entre {{from}}º e {{to}}º em {{season}}",
      },
      tierTooltip: "{{name}}: {{requirement}}",
      lifetime: "Ranking vitalício",
      tabs: {
        season: "Temporada",
        lifetime: "Vitalício",
      },
      tiers: {
        views: {
          bronze: "Alcance Bronze",
          silver: "Alcance Prata",
          gold: "Alcance Ouro",
          platinum: "Platina Viral",
          master: "Mestre Viral",
          legend: "Lenda Viral",
        },
        campaign_money: {
          bronze: "Bronze",
          silver: "Prata",
          gold: "Ouro",
          black: "Cartão Black",
        },
        affiliate: {
          bronze: "Afiliado Bronze",
          silver: "Afiliado Prata",
          gold: "Afiliado Ouro",
          six_digits: "Clube dos 6 Dígitos",
        },
        campaigns: {
          bronze: "Iniciante",
          silver: "Especialista",
          gold: "Dominador de Nichos",
        },
        renders: {
          bronze: "Operador",
          silver: "Editor Hardcore",
          gold: "Usina de Conteúdo",
          diamond: "Processador Humano",
        },
        season: {
          emperor: "Imperador da Temporada",
          elite: "Elite da Temporada",
          master: "Mestre da Temporada",
          veteran: "Veterano da Temporada",
        },
      },
      ladder: {
        show: "Ver níveis",
        hide: "Ocultar níveis",
        title: "Níveis de {{track}}",
        stripLabel: "Níveis desta patente",
        current: "Atual",
        earned: "Conquistado",
        locked: "Bloqueado",
        affiliateBronze: "Primeira venda indicada",
      },
      progress: "{{metric}} / {{next}}",
      rankStartsAt: "Esta patente começa em {{next}}",
      rankEndsAt: "Esta patente termina em {{next}}",
      placement: "#{{placement}}",
      seasonActive: "Temporada em andamento. Os títulos são definidos quando ela termina.",
      seasonActiveUntil: "Em andamento até {{date}}",
      seasonEndedOn: "Encerrada em {{date}}",
      seasonActiveRange: "Inicia em {{start}} · Termina em {{end}}",
      seasonEndedRange: "Iniciou em {{start}} · Encerrou em {{end}}",
      loadError: "Não foi possível carregar as patentes. Tente novamente.",
      loadMore: "Carregar mais",
    },

    // Monthly earnings chart — /earn/wallet
    walletMonthlyEarnings: {
      title: "Evolução de ganhos mensais",
      range: { label: "Período do gráfico", last6: "Últimos 6 meses", last12: "Últimos 12 meses" },
      periodTotal: "Total no período: {{amount}}",
      bestMonth: "Melhor mês: {{month}} ({{amount}})",
      total: "Total",
      current: "em andamento",
      sources: {
        clips: "Clip & Pix",
        affiliate: "Comissões de indicação",
        producer: "Royalties de intensivos",
      },
      tableCaption: "Ganhos por mês",
      footnote: "Clipes contam no mês em que foram enviados; comissões e royalties, no mês da venda. O mês atual (barra listrada) ainda está em andamento.",
      empty: "Nenhum ganho neste período ainda. Envie clipes nas campanhas do Clip & Pix para ver sua evolução aqui.",
    },

    // Wallet statement (extrato) — /earn/wallet, /affiliates, /course-royalties
    walletStatement: {
      title: "Extrato",
      walletTitle: "Extrato da carteira",
      withdrawHistoryLink: "Ver extrato",
      period: { label: "Período do extrato", last30: "Últimos 30 dias" },
      upcoming: {
        title: "Lançamentos futuros",
        hint: "Valores em espera que entram no seu saldo na data e hora indicadas.",
      },
      today: "Hoje",
      dayClosing: "Saldo do dia",
      currentBalance: "Saldo atual",
      openingBalance: "Saldo antes do período",
      noSnapshot: "Saldo não registrado",
      snapshotsStarted: "O saldo do dia é registrado desde {{date}}. Dias anteriores mostram só os lançamentos.",
      snapshotsPending: "O saldo do dia começa a ser registrado à meia-noite. Até lá, o extrato mostra só os lançamentos.",
      empty: "Nenhuma movimentação neste período.",
      error: "Não foi possível carregar o extrato.",
      retry: "Tentar novamente",
      withdrawable: { label: "Disponível para saque", link: "Ver extrato da carteira" },
      lines: {
        cpmDaily: "Ganhos do Clip & Pix no dia",
        cpmToday: "Ganhos do Clip & Pix hoje (até agora)",
        cpmSince: "Ganhos do Clip & Pix desde {{date}}",
        cpmAdjustment: "Ajuste nos ganhos do Clip & Pix",
        commissionRelease: {
          payment: "Comissão liberada · Assinatura",
          course: "Comissão liberada · Intensivo",
          cpm: "Comissão liberada · Clip & Pix",
        },
        royaltyRelease: "Royalty liberado",
        commissionReversal: "Comissão estornada",
        royaltyReversal: "Royalty estornado",
        fromReferred: "Indicado: {{name}}",
        course: "{{course}}",
        payout: {
          pix_withdrawal: "Saque PIX",
          plan_redemption: "Plano pago com o saldo",
          minutes_redemption: "Minutos pagos com o saldo",
        },
        payoutCancellation: "Valor devolvido (pagamento cancelado)",
        adjustment: "Ajustes",
        adjustmentHint: "Correções no saldo que não têm um lançamento próprio.",
        unknown: "Movimentação",
      },
      reversalReason: {
        recalculated: "Recalculada após mudança nos ganhos do indicado",
        forfeited: "Perdida com a suspensão do programa",
        refunded: "Pagamento reembolsado",
        chargeback: "Pagamento contestado",
        other: "Estorno manual",
      },
      payoutStatus: {
        pending: "Em análise",
        paid: "Pago",
        paidOn: "Pago em {{date}}",
        cancelled: "Cancelado",
      },
    },

    // Affiliates page
    affiliates: {
      title: 'Indique e Ganhe',
      subtitle: 'Ganhe {{payment}}% de tudo que seus indicados pagarem, {{course}}% do intensivo Viralize em 4 Semanas e {{cpm}}% dos ganhos do Clip & Pix',
      join: {
        heading: 'Participe do programa de afiliados',
        bullet1: 'Você ganha {{payment}}% de cada pagamento feito por quem se cadastrar pelo seu link',
        bulletCourse: 'Comissão especial: {{course}}% em cada venda do intensivo Viralize em 4 Semanas feita pelo seu link',
        bulletCpm: 'E ainda {{cpm}}% de tudo que seus indicados ganharem com campanhas do Clip & Pix',
        bullet2: 'Para sempre — vale para todos os pagamentos do seu indicado, sem prazo',
        bullet3: 'Os ganhos caem na sua carteira e podem ser sacados via PIX',
        termsTitle: 'Termos do programa',
        termsBody:
          'Ao participar, você concorda que: (1) a comissão é de {{payment}}% sobre todos os pagamentos confirmados de usuários cadastrados pelo seu link, sem limite de prazo; (2) você também ganha {{cpm}}% sobre os ganhos do Clip & Pix dos seus indicados; (3) vendas do intensivo Viralize em 4 Semanas pagam comissão de {{course}}% e são atribuídas ao link usado na compra; (4) cada comissão fica disponível para saque 30 dias após ser registrada, como proteção contra estornos; (5) comissões de pagamentos estornados ou de ganhos do Clip & Pix desqualificados são revertidas; (6) auto-indicação, spam e uso de marca Autoclipper em anúncios pagos são proibidos e podem levar à remoção do programa; (7) o programa pode ser alterado ou encerrado com aviso prévio.',
        accept: 'Li e aceito os termos',
        button: 'Participar do programa',
        joining: 'Entrando...',
      },
      link: {
        title: 'Seus links de indicação',
        copy: 'Copiar',
        copied: 'Link copiado!',
        appLabel: 'Link do Autoclipper',
        appPerPayment: '{{payment}}% das assinaturas',
        appPerCpm: '{{cpm}}% do Clip & Pix',
        hint: 'Compartilhe este link. Quem se cadastrar por ele vira seu indicado.',
        viralizeLabel: 'Link do intensivo Viralize em 4 Semanas',
        viralizePerSale: '{{course}}% por venda',
        viralizeHint:
          'Leva direto para a página de vendas do intensivo, com checkout sem precisar criar conta. Toda compra feita por este link paga {{course}}% de comissão para você.',
        customize: 'Personalizar link',
        customHint: 'De 3 a 30 caracteres: letras minúsculas, números e hífens (sem hífen no começo ou fim).',
        customWarning: 'Ao trocar o código personalizado, o anterior deixa de funcionar. Seu link original continua valendo.',
        customSave: 'Salvar',
        customCancel: 'Cancelar',
        customSaving: 'Salvando...',
        customSaved: 'Link personalizado salvo!',
        customTaken: 'Este código já está em uso. Escolha outro.',
        customInvalid: 'Código inválido. Use de 3 a 30 caracteres: letras minúsculas, números e hífens (sem hífen no começo ou fim).',
        alsoWorks: 'Seu link original também continua funcionando:',
      },
      materials: {
        title: 'Materiais de divulgação',
        description:
          'Vídeos prontos do intensivo Viralize em 4 Semanas para você postar nas suas redes. Baixe, publique e coloque o seu link do intensivo na legenda ou na bio.',
        download: 'Baixar vídeos',
      },
      stats: {
        referred: 'Indicados',
        earned: 'Total ganho',
        pending: 'Em espera (30 dias)',
        available: 'Liberado (total histórico)',
        breakdown: 'Assinaturas {{payment}} · Intensivo {{course}} · Clip & Pix {{cpm}}',
      },
      earnings: {
        title: 'Suas comissões',
        empty: 'Nenhuma comissão ainda. Compartilhe seu link para começar a ganhar.',
        date: 'Data',
        referredUser: 'Indicado',
        source: 'Origem',
        sourcePayment: 'Assinatura',
        sourceCourse: 'Intensivo',
        sourceCpm: 'Clip & Pix',
        paymentAmount: 'Pagamento',
        commission: 'Comissão',
        releasesAt: 'Liberação',
        status: 'Status',
        statusPending: 'Em espera',
        statusAvailable: 'Liberado',
        statusReversed: 'Revertido',
        showMore: 'Mostrar mais',
      },
      referred: {
        title: 'Seus indicados',
        empty: 'Ninguém se cadastrou pelo seu link ainda.',
        name: 'Indicado',
        signedUp: 'Cadastro',
        status: 'Status',
        earned: 'Você ganhou',
        paid: 'Pagante',
        pendingPayment: 'Aguardando pagamento',
        showingRecent: 'Mostrando os 100 indicados mais recentes',
        detailsTitle: 'Pagamentos de {{name}}',
        detailsEmpty: 'Nenhum pagamento com comissão ainda.',
      },
      wallet: {
        hint: 'Seus ganhos somam na sua carteira, junto com os ganhos de campanhas.',
        goToWallet: 'Ir para a carteira',
        affiliateBreakdown: 'Afiliados: {{amount}}',
      },
      blocked: {
        title: 'Sua participação no programa de afiliados está suspensa',
        body:
          'Você não pode mais indicar novos usuários nem ganhar novas comissões. Comissões já liberadas continuam disponíveis para saque.',
        reason: 'Motivo: {{reason}}',
      },
      error: 'Algo deu errado. Tente novamente.',
      loadError: 'Não foi possível carregar seus dados de afiliado. Recarregue a página.',
    },

    // Tutorials page
    tutorialsPage: {
      tutorial1: "Conheça a AutoClipper em 3 Minutos (Guia Completo para Iniciantes)",
      tutorial2: "Transforme 1 Vídeo em VÁRIOS Cortes Virais com IA (Muito Rápido)",
      tutorial3: "Como Criar Cortes com Vídeos do Seu Computador (Passo a Passo)",
      tutorial4: "Como Exportar Seus Cortes Prontos para TikTok, Reels e Shorts",
      tutorial5: "Conheça o Modo Copiloto da AutoClipper (Crie Cortes com IA Profissional)",
      tutorial6: "Cole um Link do YouTube e Gere Cortes Automáticos com IA",
      tutorial7: "O Acervo da AutoClipper: Use Vídeos Prontos para Criar Cortes",
      tutorial8: "Minha Marca vs Outros Canais: Qual Usar na AutoClipper?",
    },
    course: {
      badge: "Intensivo",
      freeLessonBadge: "1 aula grátis",
      freeLabel: "Grátis",
      lockedMessage: "Conteúdo disponível para assinantes",
      subscribePrompt: "Conteúdo exclusivo para assinantes",
      subscribeBody: "Assine algum plano para desbloquear 100% do intensivo.",
      subscribeButton: "Ver planos de assinatura",
      ctaButton: "Começar agora — grátis",
      pilotUnlocked: "Aula piloto liberada",
      weeksLabel: "4 semanas",
      modulesCount: "{{count}} módulos",
      duration: "~3h de conteúdo",
      completed: "Concluído",
      progressLabel: "{{percent}}% concluído",
      notFound: "Intensivo não encontrado",
      back: "Voltar",
      courseCompleted: "Intensivo concluído",
      previousLesson: "Aula anterior",
      nextLesson: "Próxima aula",
      continueLesson: "Continuar aula",
      startNow: "Começar agora",
      completedCount: "{{done}} / {{total}} concluídos",
      videoPlayer: {
        label: "Player da aula: {{title}}",
        play: "Reproduzir vídeo",
        pause: "Pausar vídeo",
        seek: "Posição do vídeo",
        mute: "Silenciar",
        unmute: "Ativar som",
        volume: "Volume",
        playbackRate: "Velocidade de reprodução",
        fullscreen: "Tela cheia",
        subtitlesOn: "Ativar legendas",
        subtitlesOff: "Desativar legendas",
        errorTitle: "Não foi possível carregar esta aula",
        errorBody: "Verifique sua conexão e tente carregar o vídeo novamente.",
        retry: "Tentar novamente",
      },
      lessonResources: {
        title: "Materiais da aula",
        subtitle: "Resumo, capítulos e transcrição",
        overviewTab: "Sobre a aula",
        transcriptTab: "Transcrição",
        chapters: "Capítulos",
        loading: "Carregando transcrição…",
        error: "Não foi possível carregar a transcrição. Tente novamente.",
      },
    },
    coursePurchase: {
      buyCta: "Comprar intensivo por {{price}}",
      lockedBanner: "Compre o intensivo para desbloquear todas as aulas — inclui 1 mês do plano STARTER.",
      confirmedTitle: "Compra confirmada!",
      confirmedBody: "O intensivo foi liberado e seu bônus do plano STARTER está ativo.",
      title: "Finalizar compra",
      subtitle: "Viralize em 4 Semanas — acesso vitalício + 1 mês do plano STARTER",
      includedTitle: "O que está incluído",
      includedCourse: "Acesso vitalício a todas as aulas do intensivo",
      includedPlan: "1 mês do plano STARTER incluso",
      payWithPix: "Pagar com PIX",
      payWithCard: "Pagar com cartão",
      alreadyOwned: "Você já possui este intensivo.",
      purchaseError: "Não foi possível iniciar a compra. Tente novamente.",
      couponInvalid: "Cupom inválido",
      couponExpired: "Este cupom expirou.",
      couponExhausted: "Este cupom não tem mais usos.",
      couponNotValid: "Este cupom não vale para este intensivo.",
      backToCourse: "Voltar ao intensivo",
    },
    challengeBanner: {
      text: "Desafio Autoclipper: concorra a mais de R$10.000 criando cortes com IA",
      cta: "Participar agora",
    },
    challenge: {
      title: "Desafio",
      titleSuffix: ": Ganhe Dinheiro com Redes Sociais",
      subtitle: "Envie seus vídeos e acompanhe sua participação no campeonato",
      warningPrefix: "🚨 Ei clipador,",
      noActiveChallenge: "Nenhum campeonato ativo",
      checkBackLater: "Volte em breve para participar do próximo desafio!",
      rules: {
        allowed: "PODE",
        forbidden: "NÃO PODE",
        attention: "ATENÇÃO",
        warning: "AVISO",
      },
      requiredHashtags: "Marcações obrigatórias",
      hashtagsDescription: "Copie e utilize essas marcações na legenda dos seus vídeos",
      copyHashtags: "Copiar marcações",
      hashtagsCopied: "Marcações copiadas!",
      validateHashtags: "Validar marcações",
      hashtagsValid: "Marcações encontradas",
      hashtagsMissing: "Faltando: {{tags}}",
      hashtagsInvalid: "Marcações não encontradas na descrição",
      hashtagsValidationError: "Não foi possível validar — tente novamente ou envie assim mesmo",
      hashtagsValidating: "Validando marcações...",
      checkingViews: "Verificando visualizações...",
      instagramMustBeReel: "O link do Instagram deve ser um Reel (instagram.com/reel/...)",
      urlAlreadySubmitted: "Este vídeo já foi enviado",
      urlDuplicate: "Esta URL aparece mais de uma vez na lista",
      captionExamples: "Exemplos de legenda",
      watermarkRequired: "Marca d'água obrigatória",
      downloadWatermark: "Baixar marca d'água",
      freeDescription: "Descrição livre permitida",
      hashtagsRequired: "Marcações obrigatórias",
      quickWarning: "AVISO RÁPIDO",
      prizePool: "Premiação do Campeonato",
      prizePoolSubtitle: "Veja quanto você pode ganhar participando",
      joinTitle: "Participe do Campeonato!",
      joinDescription: "Entre no desafio e concorra a prêmios criando cortes incríveis",
      joinButton: "Participar agora",
      joined: "Você entrou no campeonato!",
      notAcceptingParticipants: "Inscrições encerradas",
      submissionsClosed: "Envios encerrados",
      joinConsentTitle: "Regras do Campeonato",
      joinConsentCheckbox: "Li e aceito todas as regras e estou de acordo com elas",
      joinConsentButton: "Confirmar e participar",
      submitConsentTitle: "Confirme as Regras antes de enviar",
      submitConsentCheckbox: "Confirmo que li e aceito todas as regras do campeonato",
      submitConsentButton: "Concordo, enviar vídeo",
      myVideos: "Meus Vídeos",
      submitVideo: "Enviar vídeo",
      submitVideoTitle: "Enviar vídeo para contabilização",
      submitVideoSubtitle: "Certifique-se de que o vídeo segue todas as regras antes de enviar",
      video: "Vídeo",
      invalidUrl: "URL não reconhecida. Plataformas suportadas: TikTok, Instagram, YouTube",
      addAnotherVideo: "Adicionar outro vídeo",
      duplicateWarning: "O mesmo vídeo pode ser enviado apenas uma vez por plataforma",
      watermarkWarning: "Vídeos devem conter marca d'água e hashtags obrigatórias",
      confirmTitle: "Confirmo que:",
      confirmItem1: "Li e aceito as regras",
      confirmItem2: "O vídeo segue as diretrizes",
      confirmItem3: "Contém marca d'água e marcações",
      submitting: "Enviando...",
      submitButton: "Enviar vídeo",
      videosSubmitted: "Vídeos enviados com sucesso!",
      submissionFailed: "Envio falhou. Verifique os erros destacados acima.",
      noVideosYet: "Nenhum vídeo enviado ainda. Envie seu primeiro vídeo!",
      ranking: "Ranking",
      views: "views",
      clip: "vídeo",
      clips: "vídeos",
      anonymous: "Anônimo",
      participationDisqualified: "Sua participação foi desclassificada",
      participationDisqualifiedReason: "Motivo: {{reason}}",
      clipSubmittedAt: "Enviado em {{date}}",
      clipDisqualified: "Reprovado",
      clipDisqualifiedReason: "Motivo: {{reason}}",
      clipPendingValidation: "Validação Pendente",
      clipApproved: "Aprovado",
      clipHashtagsValidated: "Hashtags Validadas",
      clipHashtagsInvalidated: "Hashtags Inválidas",
      clipHashtagsPending: "Hashtags Pendentes",
      viewsUpdatedDaily: "As visualizações são atualizadas diariamente.",
      prizePoolRanking: "Ranking Parcial",
      prizePoolRankingLive: "Ao vivo",
      prizePoolRankingNotStarted: "Este período do ranking ainda não começou.",
      rankings: {
        consolidated: "Consolidado",
        countdown: "Consolida em {{time}}",
        startsIn: "Começa em {{time}}",
        consolidating: "Consolidando...",
        timeRemaining: "Tempo restante",
        pendingDescription: "O ranking ainda não foi consolidado. Aguarde o prazo para ver os resultados.",
      },
    },

    // API Getting Started
    apiGettingStarted: {
      title: "Primeiros Passos com a API do Autoclipper",
      subtitle: "Aprenda a integrar a edição de vídeo nos seus aplicativos",
      prerequisites: "Pré-requisitos",
      prerequisitesDescription: "Antes de começar, certifique-se de ter o seguinte:",
      apiKey: "Chave de API",
      apiKeyDescription: "Você precisará de uma chave de API ativa do seu painel do Autoclipper",
      getApiKey: "Obter Chave de API",
      videoContent: "Conteúdo em Vídeo",
      videoContentDescription: "Uma URL de vídeo pública (YouTube, Vimeo ou link direto)",
      httpClient: "Cliente HTTP",
      httpClientDescription: "Qualquer ferramenta que possa fazer requisições HTTP (curl, Postman, etc.)",
      formatAuto: "Automático",
      formatAutoDescription: "A IA determina o comprimento ideal do clipe com base no conteúdo",
      formatMax1Min: "Máximo 1 Minuto",
      formatMax1MinDescription: "Os clipes terão até 60 segundos de duração",
      formatMax30Sec: "Máximo 30 Segundos",
      formatMax30SecDescription: "Os clipes terão de 15 a 30 segundos de duração",
      authentication: "Autenticação",
      authDescription: "Todas as requisições de API requerem autenticação usando sua chave de API",
      authInstructions: "Inclua sua chave de API no cabeçalho Authorization em cada requisição:",
      authorization: "Autorização",
      authHeader: "Cabeçalho de Autorização",
      securityWarning: "Mantenha sua chave de API segura e nunca a exponha em código do lado do cliente. Armazene-a como uma variável de ambiente.",
      createFirstProject: "Crie Seu Primeiro Projeto",
      createFirstProjectDescription: "Envie um vídeo para processamento criando um novo projeto",
      createProjectInstructions: "Envie uma requisição POST para criar um novo projeto. Aqui estão os parâmetros obrigatórios e opcionais:",
      requestParameters: "Parâmetros da Requisição:",
      required: "Obrigatório",
      optional: "Opcional",
      paramBaseVideoUrl: "URL do vídeo a ser processado",
      paramName: "Nome legível para o seu projeto",
      paramFormat: "Formato de saída dos clipes (veja as opções abaixo)",
      paramLanguage: 'Código do idioma: "pt-BR", "en-US" ou "es-ES"',
      paramWebhookUrl: "URL para receber notificações de conclusão",
      paramPrompt: "Orientação adicional para geração de clipes",
      paramBrandKitId: "ID do template para estilos de legenda, logo e cores. Usa o padrão da conta e depois o template público 'Basic'.",
      formatOptions: "Opções de Formato:",
      exampleRequest: "Exemplo de Requisição",
      exampleResponse: "Exemplo de Resposta",
      monitorProgress: "Monitorar o Progresso do Processamento",
      monitorProgressDescription: "Verifique o status do seu projeto e recupere os clipes quando estiverem prontos",
      monitorInstructions: "O processamento do vídeo normalmente leva alguns minutos. Você pode verificar o status consultando o projeto:",
      checkStatus: "Verificar Status do Projeto",
      statusValues: "Valores de Status do Processamento:",
      statusProcessing: "O vídeo está sendo analisado e os clipes estão sendo gerados",
      statusCompleted: "Processamento concluído com sucesso, os clipes estão prontos",
      statusFailed: "O processamento falhou devido a um erro",
      responseWhenCompleted: "Resposta Quando Concluído",
      proTip: "Dica: Use webhooks para ser notificado automaticamente quando o processamento for concluído, em vez de consultar atualizações de status.",
      understandingWebhooks: "Entendendo Webhooks",
      webhookDescription: "Receba notificações automáticas quando seus projetos forem concluídos",
      webhookInstructions: "Quando você fornece uma webhook_url na sua requisição de criação de projeto, o Autoclipper enviará uma requisição POST para essa URL quando o processamento terminar — tanto em caso de sucesso quanto de falha.",
      webhookDetailsTitle: "Detalhes do Webhook:",
      method: "Método",
      methodDescription: "Requisição POST para a URL do seu webhook",
      contentType: "Content-Type",
      success: "Sucesso",
      successDescription: 'Enviado quando todos os clipes terminam de renderizar — process_status: "completed" com array de clipes',
      failure: "Falha",
      failureDescription: 'Enviado quando o processamento falha — process_status: "failed" com array de clipes vazio',
      retries: "Tentativas",
      retriesDescription: "Até 3 tentativas se o seu servidor não retornar uma resposta 2xx",
      successPayloadExample: "Exemplo de Payload de Sucesso",
      webhookImportant: "Importante: Seu endpoint de webhook deve responder com um código de status 2xx para confirmar o recebimento. Caso contrário, o Autoclipper tentará novamente até 3 vezes. Após 3 tentativas falhadas, nenhuma nova tentativa será feita. Você sempre pode consultar GET /api/v1/project/{id} para verificar o status.",
      whatsNext: "O Que Vem a Seguir?",
      whatsNextDescription: "Explore recursos mais avançados e integrações",
      tryPlayground: "Experimente o Playground",
      tryPlaygroundDescription: "Teste endpoints de forma interativa",
      exploreReference: "Explorar Referência da API",
      exploreReferenceDescription: "Documentação detalhada para todos os endpoints",
      monitorUsage: "Monitorar Uso da API",
      monitorUsageDescription: "Acompanhe suas requisições e uso da API",
    },

    // API Reference
    apiReference: {
      title: "Referência da API",
      subtitle: "Documentação completa de todos os endpoints da API do Autoclipper",
      baseUrlAuth: "URL Base e Autenticação",
      baseUrl: "URL Base",
      authentication: "Autenticação",
      authDescription: "Todas as requisições requerem uma chave de API no cabeçalho Authorization:",
      getApiKey: "Obter Chave de API",
      openApiSpec: "Especificação OpenAPI",
      tabs: {
        overview: "Visão Geral",
        parameters: "Parâmetros",
        examples: "Exemplos",
      },
      summary: "Resumo",
      responseCodes: "Códigos de Resposta",
      requestBodyTitle: "Corpo da Requisição",
      queryParameters: "Parâmetros de Consulta",
      curlRequest: "Requisição cURL",
      responseBody: "Corpo da Resposta",
      parameter: "Parâmetro",
      type: "Tipo",
      required: "Obrigatório",
      description: "Descrição",
      yes: "Sim",
      no: "Não",
      webhooks: "Webhooks",
      webhooksDescription: "Notificações automáticas enviadas quando o processamento do projeto é concluído ou falha",
      howWebhooksWork: "Como os Webhooks Funcionam",
      webhookExplanation: "Quando você fornece uma webhook_url durante a criação do projeto, o Autoclipper enviará uma requisição POST para essa URL quando o processamento terminar. O webhook é acionado em dois cenários:",
      success: "Sucesso",
      failure: "Falha",
      webhookSuccessItem: "todos os clipes foram renderizados. O payload inclui process_status: \"completed\" e o array completo de clipes com URLs de download.",
      webhookFailureItem: "o processamento do vídeo ou a curadoria de clipes falhou. O payload inclui process_status: \"failed\" e um array de clipes vazio.",
      webhookDetails: "Detalhes do Webhook",
      method: "Método",
      contentType: "Tipo de Conteúdo",
      trigger: "Gatilho",
      triggerDescription: "Quando todos os clipes terminam a renderização (sucesso) ou quando o processamento falha",
      expectedResponse: "Resposta Esperada",
      expectedResponseDescription: "Código de status 2xx para confirmar o recebimento",
      retries: "Tentativas",
      retriesDescription: "Até 3 tentativas se seu servidor não retornar uma resposta 2xx",
      successPayload: "Payload de Sucesso",
      successPayloadDescription: "Enviado quando todos os clipes foram renderizados com sucesso. O array clips contém cada clipe com sua rendered_video_url (vídeo final com legendas e efeitos):",
      failurePayload: "Payload de Falha",
      failurePayloadDescription: "Enviado quando o processamento do vídeo ou a curadoria de clipes falha. O process_status será \"failed\" e o array clips estará vazio:",
      retryBehavior: "Comportamento de Tentativas",
      retryBehaviorDescription: "Se o seu endpoint de webhook não retornar um código de status 2xx, o Autoclipper tentará reenviar a notificação até 3 vezes. Após 3 tentativas falhas, a notificação é marcada como entregue e nenhuma nova tentativa será feita. Você sempre pode verificar o status do projeto consultando o endpoint GET /api/v1/project/{id}.",
      dataModels: "Modelos de Dados",
      dataModelsDescription: "Definições de esquema para objetos de requisição e resposta",
      property: "Propriedade",
      endpoints: {
        createProject: {
          summary: "Criar um novo projeto",
          description: "Cria um novo projeto de vídeo para processamento. O projeto começará a processar a URL do vídeo fornecida e gerará clipes com base nos parâmetros especificados.",
          response200: "Projeto criado com sucesso",
          response400: "Parâmetros de requisição inválidos ou template não encontrado",
          response401: "Falha na autenticação",
        },
        listProjects: {
          summary: "Listar projetos",
          description: "Recupera uma lista paginada de todos os projetos do usuário autenticado.",
          response200: "Lista de projetos recuperada com sucesso",
          response401: "Falha na autenticação",
        },
        getProject: {
          summary: "Obter projeto por ID",
          description: "Recupera informações detalhadas sobre um projeto específico, incluindo todos os clipes gerados se o projeto estiver concluído.",
          response200: "Detalhes do projeto recuperados com sucesso",
          response401: "Falha na autenticação",
          response404: "Projeto não encontrado",
        },
        listCommunityLibraries: {
          summary: "Listar vídeos do acervo da comunidade",
          description: "Navegue pelo acervo da comunidade — vídeos já baixados e curados dentro do Autoclipper que você pode remixar. Suporta busca textual, filtros por canal/tag e diferentes ordenações.",
          response200: "Lista de vídeos do acervo da comunidade",
          response401: "Falha na autenticação",
        },
        getCommunityLibrary: {
          summary: "Obter um vídeo do acervo da comunidade",
          description: "Recupera um vídeo do acervo da comunidade pelo id. O video_url retornado é a URL canônica — passe-a como base_video_url para POST /v1/project, ou use o atalho /remix.",
          response200: "Detalhes do vídeo no acervo",
          response401: "Falha na autenticação",
          response404: "Vídeo do acervo da comunidade não encontrado",
        },
        listCommunityChannels: {
          summary: "Listar canais da comunidade",
          description: "Descubra canais cujos vídeos estão no acervo da comunidade. Retorna os valores de id usados pelo parâmetro channel_id.",
          response200: "Lista de canais",
          response401: "Falha na autenticação",
        },
        listCommunityTags: {
          summary: "Listar tags da comunidade",
          description: "Descubra tags aplicadas aos vídeos do acervo. Retorna os valores de id usados pelo parâmetro tag_id. Tags com menos de 5 downloads ficam ocultas.",
          response200: "Lista de tags",
          response401: "Falha na autenticação",
        },
        remixCommunityLibrary: {
          summary: "Remixar um vídeo do acervo da comunidade",
          description: "Cria um novo projeto a partir de um vídeo do acervo da comunidade. Resolve a URL fonte e executa o mesmo fluxo de POST /v1/project. Todos os campos são opcionais — os omitidos herdam do item de origem no acervo. auto_export padrão: false.",
          response200: "Projeto criado a partir do acervo",
          response401: "Falha na autenticação",
          response404: "Vídeo do acervo da comunidade não encontrado",
          response422: "Item do acervo sem URL fonte resolvível",
        },
        createProjectClip: {
          summary: "Criar um clipe em um projeto",
          description: "Crie manualmente um clipe em um projeto existente especificando start_time e end_time (em segundos, relativos ao vídeo fonte). O projeto precisa ter curation_status: success. Com auto_render true (padrão), o clipe é enfileirado para renderização imediatamente.",
          response201: "Clipe criado",
          response400: "Tempos inválidos ou brand_kit_id não encontrado",
          response401: "Falha na autenticação",
          response402: "Cota mensal de clipes excedida",
          response404: "Projeto não encontrado",
          response409: "Curação do projeto ainda não finalizou",
        },
        renderClip: {
          summary: "Renderizar um clipe existente",
          description: "Enfileira a renderização de um clipe que foi curado mas não renderizado (ex: projeto criado com auto_export: false). Idempotente — retorna a URL existente se o clipe já está renderizado.",
          response200: "Clipe renderizado, em renderização ou enfileirado",
          response400: "brand_kit_id não encontrado",
          response401: "Falha na autenticação",
          response402: "Cota mensal de clipes excedida",
          response404: "Clipe não encontrado",
        },
        getCommunityChannel: {
          summary: "Obter um canal da comunidade",
          description: "Busca um canal da comunidade pelo id. Retorna 404 se o canal não tem vídeos comunitários elegíveis.",
          response200: "Detalhes do canal",
          response401: "Falha na autenticação",
          response404: "Canal da comunidade não encontrado",
        },
        listCommunityChannelLibraries: {
          summary: "Listar vídeos comunitários de um canal",
          description: "Navega pelos vídeos de um único canal. Mesmos filtros e ordenações de listar vídeos do acervo da comunidade, com channel_id fixado pelo id da rota.",
          response200: "Lista de vídeos do canal",
          response401: "Falha na autenticação",
          response404: "Canal da comunidade não encontrado",
        },
        checkCommunityLibrary: {
          summary: "Verificar se uma URL está no acervo da comunidade",
          description: "Dada uma URL de vídeo, retorna o registro correspondente no acervo da comunidade, se o Autoclipper já tiver curado. Útil para decidir entre remixar um vídeo existente no acervo ou enviar um projeto novo.",
          response200: "Vídeo correspondente no acervo da comunidade",
          response400: "Parâmetro url ausente",
          response401: "Falha na autenticação",
          response404: "Nenhum vídeo do acervo da comunidade corresponde a essa URL",
        },
      },
    },

    // Scene transitions (per-cut badge + picker popover in the timeline)
    transitions: {
      title: 'Transição',
      duration: 'Duração (s)',
      direction: 'Direção',
      remove: 'Remover',
      applyAll: 'Aplicar a todos',
      addToAllScenes: 'Adicionar em todas as cenas',
      randomize: 'Aleatorizar',
      randomizeHint: 'Escolha as transições e sorteie uma para cada corte.',
      auto: 'Automático',
      autoHint: 'Lê os sinais de áudio e movimento do vídeo e coloca transições nos cortes de cena reais e nos picos de energia.',
      autoUnavailable: 'Indisponível para este projeto — ele foi processado antes da análise automática de vídeo.',
      autoLoading: 'Lendo os sinais do vídeo…',
      autoError: 'Os sinais do vídeo não estão disponíveis para este projeto.',
      autoNoSuggestions: 'Nenhuma transição sugerida para este conteúdo.',
      autoContentType: 'Detectado: {{type}}',
      contentTypes: {
        soccer: 'Futebol',
        gameplay: 'Gameplay',
        vlog: 'Vlog',
        podcast: 'Podcast',
        unknown: 'Indefinido',
      },
      kinds: {
        'camera-move': 'Movimento de câmera',
        'zoom-in': 'Zoom in',
        'zoom-out': 'Zoom out',
        'whip-pan': 'Whip pan',
        'dip-to-black': 'Fade preto',
        'dip-to-white': 'Flash branco',
        blur: 'Desfoque',
        crossfade: 'Crossfade',
        slide: 'Deslizar',
        wipe: 'Cortina',
      },
    },

    // Publicação de cortes (rascunhos do TikTok e publicação direta no YouTube)
    publishQueues: {
      eyebrow: 'Automação de publicações',
      title: 'Filas de publicação',
      subtitle: 'Defina uma agenda recorrente e envie clipes para um fluxo de publicação organizado.',
      create: 'Nova fila',
      edit: 'Editar',
      delete: 'Excluir fila',
      active: 'Ativa',
      inactive: 'Inativa',
      schedule: 'Agenda semanal',
      card: {
        calendarHint: 'Clique ou toque em um dia para ver os horários exatos.',
        dayDetails: 'Ver horários de {{day}}',
        publishingOrder: 'Ordem de publicação: {{position}}',
        noAccounts: 'Nenhuma conta disponível nesta fila.',
        noSchedule: 'Nenhum horário configurado.',
      },
      accounts: '{{count}} conta',
      accounts_other: '{{count}} contas',
      gap: 'Intervalo mínimo: {{minutes}} min',
      spacingBadge: 'Espaça contra tudo nas contas',
      upcoming: {
        title: 'Próximos posts',
        empty: 'Nenhum post agendado nesta fila.',
        showAll: 'Ver todos ({{count}})',
        showLess: 'Mostrar menos',
        untitled: 'Clipe sem título',
        otherQueue: 'Fila {{name}}',
        manual: 'Agendado manualmente',
        loadError: 'Não foi possível carregar os posts agendados.',
      },
      loadError: 'Não foi possível carregar suas filas de publicação.',
      retry: 'Tentar novamente',
      mode: {
        crossPost: 'Publicação simultânea',
        roundRobin: 'Rodízio',
      },
      send: {
        action: 'Enviar para a fila',
        titleDialog: 'Enviar clipe para uma fila de publicação',
        descriptionDialog: 'Revise os textos e adicione este clipe à sua agenda recorrente.',
        queue: 'Fila de publicação',
        queuePlaceholder: 'Selecione uma fila',
        noQueues: 'Crie uma fila de publicação ativa antes de enviar um clipe.',
        title: 'Título do YouTube',
        description: 'Descrição do YouTube',
        caption: 'Legenda (não usada no YouTube)',
        generate: 'Gerar com IA',
        generating: 'Gerando…',
        cancel: 'Cancelar',
        submit: 'Enviar para a fila',
        submitting: 'Enviando…',
        success: 'Agendado para {{times}}.',
      },
      errors: {
        queueNotFound: 'Esta fila de publicação não está mais disponível.',
        queueNoAccounts: 'Esta fila não tem contas sociais disponíveis.',
        invalidCopy: 'Adicione o título e a legenda obrigatórios para esta fila.',
        clipNotRendered: 'Renderize este clipe antes de enviá-lo para uma fila.',
        clipNotFound: 'Este clipe não está mais disponível.',
        connectionReconnectRequired: 'Reconecte uma das contas da fila para continuar.',
        publishingDisabled: 'A publicação está temporariamente indisponível.',
        unknown: 'Não foi possível enviar este clipe para a fila. Tente novamente.',
      },
      empty: {
        title: 'Crie seu primeiro ritmo de publicação',
        description: 'Escolha contas e horários semanais. Os clipes adicionados à fila seguirão essa agenda.',
        cta: 'Criar fila',
      },
      form: {
        createTitle: 'Criar fila de publicação',
        editTitle: 'Editar fila de publicação',
        description: 'Defina as contas, a ordem e os horários recorrentes usados por esta fila.',
        name: 'Nome da fila',
        namePlaceholder: 'Ex.: Melhores momentos diários',
        accounts: 'Contas conectadas',
        accountsHint: 'A ordem de seleção é usada nas filas em rodízio.',
        hiddenAccounts: {
          note: 'Estas contas continuam na fila, mas não podem ser alteradas aqui agora. Salvar as mantém como estão.',
        },
        noAccounts: 'Nenhuma conta social ativa está conectada.',
        moveAccountUp: 'Mover conta para cima',
        moveAccountDown: 'Mover conta para baixo',
        mode: {
          label: 'Modo de publicação',
          crossPost: 'Publicação simultânea',
          crossPostHint: 'Publica cada clipe em todas as contas selecionadas.',
          roundRobin: 'Rodízio',
          roundRobinHint: 'Alterna os clipes entre as contas na ordem selecionada.',
        },
        gapMinutes: 'Intervalo mínimo (minutos)',
        gapHint: 'Os vídeos serão publicados respeitando sempre este intervalo mínimo.',
        spacing: {
          label: 'Espaçamento entre posts',
          queue: 'Só os posts desta fila',
          queueHint: 'O intervalo mínimo vale entre os posts desta fila. Outras filas e agendamentos manuais nas mesmas contas são ignorados.',
          account: 'Tudo agendado nas contas',
          accountHint: 'O intervalo mínimo também respeita posts de outras filas e agendamentos manuais nas mesmas contas.',
        },
        timezone: 'Fuso horário',
        slots: 'Horários semanais',
        addSlot: 'Adicionar horário',
        weekday: 'Dia da semana',
        startTime: 'Início',
        endTime: 'Fim',
        weekPreview: 'Intervalos da semana',
        dragHint: 'Arraste um bloco para mover ou suas bordas para ajustar início e fim, de 5 em 5 minutos. Arraste em um espaço vazio para adicionar. As setas do teclado também ajustam o bloco em foco, e Delete o remove (ou use o × no bloco). Esc cancela.',
        resizeStart: 'Ajustar início: {{range}}',
        resizeEnd: 'Ajustar fim: {{range}}',
        deleteSlot: 'Excluir {{range}}',
        searchTimezone: 'Buscar cidade ou fuso horário…',
        searchWeekday: 'Buscar dia da semana…',
        searchTime: 'Buscar ou digitar HH:mm…',
        noResults: 'Nenhum resultado encontrado.',
        rangeHint: 'Cada vídeo é agendado em uma faixa disponível, respeitando o intervalo mínimo. Clique em um bloco para editar os horários.',
        scheduleHelp: {
          title: 'Como os horários da fila funcionam',
          description: 'As faixas indicam quando os vídeos podem ser agendados, no fuso horário escolhido.',
          selection: 'Para cada vídeo adicionado, a fila escolhe um minuto aleatório disponível na primeira faixa que ainda pode recebê-lo. Faixas sobrepostas são permitidas: no mesmo dia, a prioridade é da faixa que começa mais cedo.',
          spacing: 'O próximo vídeo precisa respeitar o intervalo mínimo após o último vídeo já agendado nesta fila. A sobreposição mantém essa regra, mesmo entre faixas diferentes.',
          overflow: 'Se o intervalo mínimo impedir o uso de uma faixa, a fila tenta a próxima. Se nenhuma faixa do dia puder receber o vídeo, ele vai para o próximo dia com um horário disponível.',
          capacity: 'Uma faixa pode receber vários vídeos, desde que haja espaço para o intervalo mínimo. A sobreposição não cria publicações extras.',
          exampleTitle: 'Exemplo com faixas sobrepostas',
          exampleDescription: 'Faixas de 09:00–11:20 e 10:55–11:55 no mesmo dia, com intervalo mínimo de 60 minutos.',
          previous: 'Último vídeo agendado',
          next: 'Horário possível do próximo',
          nextWindow: 'Próxima faixa ou dia disponível',
          close: 'Entendi',
        },
        exactTimeHint: 'Para um horário exato, use o mesmo início e fim. Para atravessar a meia-noite, adicione uma faixa em cada dia.',
        removeSlot: 'Remover horário',
        cancel: 'Cancelar',
        save: 'Salvar',
        saving: 'Salvando…',
      },
      validation: {
        name_required: 'Digite um nome para a fila.',
        slots_required: 'Adicione pelo menos um horário semanal.',
        accounts_required: 'Selecione pelo menos uma conta conectada.',
        invalid_slot: 'Digite horários válidos, com o fim igual ou posterior ao início no mesmo dia.',
        gap_invalid: 'Digite um número inteiro de minutos, igual ou maior que 5.',
      },
      deleteDialog: {
        title: 'Excluir fila de publicação?',
        description: '“{{name}}” será removida. Publicações já agendadas por ela não serão excluídas.',
        cancel: 'Manter fila',
        confirm: 'Excluir fila',
        deleting: 'Excluindo…',
      },
      toasts: {
        created: 'Fila de publicação criada',
        updated: 'Fila de publicação atualizada',
        deleted: 'Fila de publicação excluída',
        saveError: 'Não foi possível salvar esta fila de publicação.',
        deleteError: 'Não foi possível excluir esta fila de publicação.',
      },
      calendar: {
        badge: 'Fila: {{name}}',
      },
    },
    templateIdeas: {
      eyebrow: 'Comunidade',
      title: 'Ideias de template',
      subtitle: 'Mande o link de um post com um formato que a gente deveria transformar em template. Os mais votados a gente produz.',
      suggest: 'Sugerir template',
      empty: 'Nenhuma ideia aprovada ainda. Seja o primeiro a mandar uma.',
      votes_one: '{{count}} voto',
      votes_other: '{{count}} votos',
      vote: 'Votar',
      voted: 'Votado',
      promotedTitle: 'Já viraram template',
      promotedBadge: 'Já é template',
      mineTitle: 'Minhas sugestões',
      mineEmpty: 'Você ainda não sugeriu nenhum template.',
      loadError: 'Não foi possível carregar o ranking de ideias.',
      mineLoadError: 'Não foi possível carregar as suas sugestões.',
      retry: 'Tentar de novo',
      openPost: 'Ver post original',
      noPreview: 'Sem pré-visualização',
      status: {
        pending: 'Em moderação',
        public: 'Publicada',
        promoted: 'Virou template',
        rejected: 'Recusada',
      },
      form: {
        url: 'Link do post',
        urlPlaceholder: 'https://www.tiktok.com/@perfil/video/...',
        title: 'Nome do formato',
        titlePlaceholder: 'Ex.: tarja vermelha com zoom',
        useCase: 'Para que serve',
        useCasePlaceholder: 'Ex.: cortes de podcast, campanha de futebol...',
        note: 'Recado (opcional)',
        notePlaceholder: 'Algo que a gente precise saber sobre esse formato',
        submit: 'Enviar sugestão',
        cancel: 'Cancelar',
      },
      toast: {
        submitted: 'Sugestão enviada! Ela entra na moderação antes de aparecer no ranking.',
        voted: 'Voto registrado.',
        unvoted: 'Voto removido.',
      },
      duplicate: {
        notice: 'Esse post já foi sugerido. Vote na sugestão que já existe.',
        noticePromoted: 'Esse post já foi sugerido e virou template.',
        noticePending: 'Esse post já foi sugerido e está em moderação.',
        noticeRejected: 'Esse post já foi sugerido e foi recusado.',
        action: 'Ver e votar',
        hidden: 'Esse post já foi sugerido e ainda está em moderação.',
      },
      errors: {
        invalid_url: 'Esse link não parece válido. Cole o endereço completo do post.',
        missing_field: 'Preencha o link, o nome e para que serve.',
        not_votable: 'Essa sugestão não está aberta para votos.',
        generic: 'Não foi possível concluir. Tente de novo.',
      },
    },
    publishing: {
      post: 'Postar',
      platforms: {
        tiktok: 'TikTok',
        instagram: 'Instagram',
        youtube: 'YouTube',
        facebook: 'Facebook',
      },
      sendToTikTok: 'Enviar para o TikTok',
      dialogTitle: 'Enviar para o TikTok',
      dialogDescription:
        'O corte vai para os rascunhos do seu TikTok. Abra o app para escrever a legenda e publicar.',
      accountLabel: 'Conta do TikTok',
      captionLabel: 'Legenda para copiar',
      captionHelp:
        'O TikTok não permite definir a legenda em rascunhos. Copie aqui e cole no app.',
      captionCopied: 'Legenda copiada',
      copyCaption: 'Copiar',
      send: 'Enviar para rascunhos',
      sending: 'Enviando…',
      sent: 'Enviado para os seus rascunhos do TikTok',
      quotaRemaining: '{{remaining}} de {{limit}} rascunhos restantes hoje',
      quotaExceededTitle: 'Limite de rascunhos do TikTok atingido',
      quotaExceededBody:
        'O TikTok permite 5 rascunhos pendentes por conta a cada 24 horas. Publique alguns no app do TikTok e volte aqui.',
      reconnectTitle: 'Reconecte sua conta do TikTok',
      reconnectBody:
        'Enviar cortes exige uma permissão que sua conta não tinha ao ser conectada. Reconecte em Configurações da Conta para liberar o envio.',
      reconnectAction: 'Ir para Configurações da Conta',
      noConnectionTitle: 'Nenhuma conta do TikTok conectada',
      noConnectionBody: 'Conecte uma conta do TikTok em Configurações da Conta para enviar cortes aos rascunhos.',
      badge: {
        sending: 'Enviando para o TikTok',
        inDrafts: 'Nos rascunhos do TikTok',
        published: 'Publicado no TikTok',
        failed: 'Falha no envio',
        youtube: {
          publishing: 'Publicando no YouTube',
          published: 'Publicado no YouTube',
          failed: 'Falha ao publicar no YouTube',
        },
        instagram: {
          publishing: 'Publicando no Instagram',
          published: 'Publicado no Instagram',
          failed: 'Falha ao publicar no Instagram',
        },
        facebook: {
          publishing: 'Publicando no Facebook',
          published: 'Publicado no Facebook',
          failed: 'Falha ao publicar no Facebook',
        },
      },
      pro: {
        title: 'Publicar nas redes sociais é um recurso PRO',
        body: 'Faça upgrade para publicar cortes direto nas suas contas sociais conectadas.',
        dismiss: 'Agora não',
        upgrade: 'Ver planos',
      },
      youtube: {
        dialogTitle: 'Publicar no YouTube',
        dialogDescription: 'Revise os dados do vídeo e escolha como ele aparecerá no YouTube.',
        loadingAccounts: 'Carregando canais do YouTube…',
        accountLoadError: 'Não foi possível carregar suas contas conectadas. Tente novamente.',
        retryAccounts: 'Tentar novamente',
        retryingAccounts: 'Tentando novamente…',
        accountLabel: 'Conta do YouTube',
        accountSettingsAction: 'Ir para Configurações da Conta',
        noConnectionBody: 'Conecte uma conta do YouTube nas Configurações da Conta antes de publicar este corte.',
        reconnectBody:
          'Reconecte sua conta do YouTube nas Configurações da Conta para liberar o envio de vídeos.',
        titleLabel: 'Título',
        titleHelp: 'Obrigatório. Títulos do YouTube podem ter até 100 caracteres.',
        titleRequired: 'Digite um título para publicar este vídeo.',
        descriptionLabel: 'Descrição',
        descriptionHelp: 'Opcional. Adicione contexto, links ou créditos para quem assistir.',
        characterCount: '{{current}} / {{max}}',
        visibilityLabel: 'Visibilidade',
        visibility: {
          public: 'Público',
          unlisted: 'Não listado',
          private: 'Privado',
        },
        audienceLabel: 'Público',
        audience: {
          notMadeForKids: 'Não é conteúdo para crianças',
          madeForKids: 'É conteúdo para crianças',
        },
        visibilityCaveat:
          'O Google pode forçar os envios como Privado enquanto o projeto de API conectado não for auditado. A visibilidade final exibida aqui refletirá o resultado do YouTube.',
        cancel: 'Cancelar',
        publish: 'Publicar no YouTube',
        publishing: 'Publicando…',
        success: 'A publicação no YouTube foi iniciada',
        errorTitle: 'Não foi possível publicar no YouTube',
        errorDismiss: 'Fechar',
      },
      tiktok: {
        dialogTitle: 'Publicar no TikTok',
        dialogDescription: 'Revise o corte e escolha como ele aparecerá no TikTok.',
        loadingCreator: 'Carregando opções de publicação do TikTok…',
        creatorError: 'Não foi possível carregar as opções de publicação do TikTok. Reconecte a conta e tente novamente.',
        postingAs: 'Publicando como {{name}}',
        noConnectionBody: 'Conecte uma conta do TikTok em Configurações da Conta para publicar este corte.',
        reconnectBody:
          'Reconecte sua conta do TikTok em Configurações da Conta para liberar a publicação direta.',
        titleLabel: 'Legenda',
        characterCount: '{{current}} / {{max}}',
        privacyLabel: 'Quem pode ver',
        privacyPlaceholder: 'Selecione a visibilidade',
        privacy: {
          everyone: 'Todos',
          friends: 'Amigos',
          followers: 'Seguidores',
          onlyMe: 'Somente eu',
        },
        interactionsLabel: 'Permitir que as pessoas',
        allowComment: 'Comentem',
        allowDuet: 'Façam Duet',
        allowStitch: 'Façam Stitch',
        commercialLabel: 'Declarar conteúdo comercial',
        yourBrand: 'Sua marca',
        brandedContent: 'Conteúdo de marca',
        yourBrandHint: 'Seu vídeo será marcado como conteúdo promocional.',
        brandedHint: 'Seu vídeo será marcado como parceria paga.',
        commercialRequired: 'Indique se o conteúdo promove você, um terceiro, ou ambos.',
        brandedNotPrivate: 'Conteúdo de marca não pode ser privado.',
        aiGenerated: 'Este vídeo foi gerado por IA',
        previewLabel: 'Prévia',
        watermarked:
          'Este corte tem a marca d\'água do AutoClipper, e o TikTok não permite que apps coloquem a própria marca d\'água nos vídeos publicados. Assine um plano e exporte o corte de novo para postar no TikTok.',
        watermarkUpgrade: 'Ver planos',
        tooLong:
          'Este vídeo tem {{duration}}, e esta conta do TikTok só pode postar vídeos de até {{max}}. Encurte o corte e exporte de novo.',
        processingNote: 'Depois de publicar, o vídeo pode levar alguns minutos para aparecer no seu perfil do TikTok.',
        declarationMusic: 'Ao publicar, você concorda com a',
        declarationBranded: 'Ao publicar, você concorda com a Política de Conteúdo de Marca e a',
        musicPolicy: 'Confirmação de uso de música do TikTok',
        brandedPolicy: 'Política de Conteúdo de Marca',
        publish: 'Publicar no TikTok',
        publishing: 'Publicando…',
        cancel: 'Cancelar',
        success: 'A publicação no TikTok foi iniciada',
      },
      instagram: {
        dialogTitle: 'Publicar no Instagram',
        dialogDescription: 'Este corte será publicado como Reel na conta do Instagram selecionada.',
        accountLabel: 'Conta do Instagram',
        accountSettingsAction: 'Ir para Configurações da Conta',
        noConnectionBody: 'Conecte uma conta Profissional ou de Criador do Instagram nas Configurações da Conta antes de publicar este corte.',
        reconnectBody:
          'Reconecte sua conta do Instagram nas Configurações da Conta para liberar a publicação.',
        captionLabel: 'Legenda',
        cancel: 'Cancelar',
        publish: 'Publicar no Instagram',
        publishing: 'Publicando…',
        success: 'A publicação no Instagram foi iniciada',
      },
      facebook: {
        dialogTitle: 'Publicar no Facebook',
        dialogDescription:
          'Este corte será publicado na Página do Facebook selecionada: como Reel se for vertical e tiver de 3 a 90 segundos; caso contrário, como vídeo.',
        accountLabel: 'Página do Facebook',
        accountSettingsAction: 'Conectar uma Página do Facebook',
        noConnectionBody: 'Conecte uma Página do Facebook nas Configurações da Conta antes de publicar este corte.',
        reconnectBody:
          'Nenhuma das suas Páginas conectadas permite publicar ainda. Conecte o Facebook de novo nas Configurações da Conta e permita publicar em uma Página que você administra.',
        captionLabel: 'Legenda',
        cancel: 'Cancelar',
        publish: 'Publicar no Facebook',
        publishing: 'Publicando…',
        success: 'A publicação no Facebook foi iniciada',
      },
      when: {
        label: 'Quando',
        now: 'Agora',
        later: 'Mais tarde',
      },
      errors: {
        quotaExceeded: 'O TikTok permite apenas 5 rascunhos pendentes por conta a cada 24 horas.',
        reconnectRequired: 'Reconecte esta conta para liberar as permissões necessárias para publicar.',
        connectionNotFound: 'Não encontramos esta conta conectada. Atualize a página e tente novamente.',
        clipNotFound: 'Não encontramos este corte. Atualize a página e tente novamente.',
        clipNotRendered: 'Este corte ainda não terminou de ser renderizado. Aguarde terminar e tente novamente.',
        publishingDisabled: 'A publicação está temporariamente desativada. Tente novamente mais tarde.',
        temporarilyUnavailable: 'A publicação está temporariamente indisponível. Já estamos resolvendo.',
        videoPullFailed: 'O TikTok não conseguiu baixar este corte. Tente novamente.',
        fileFormatCheckFailed: 'O TikTok rejeitou o formato deste vídeo.',
        rateLimitExceeded: 'Tentativas demais. Espere um minuto e tente de novo.',
        invalidTitle: 'Digite um título entre 1 e 100 caracteres.',
        descriptionTooLong: 'A descrição deve ter no máximo 5.000 caracteres.',
        invalidPrivacyStatus: 'Escolha a visibilidade Público, Não listado ou Privado.',
        invalidAudience: 'Informe se este vídeo é conteúdo para crianças.',
        mediaOriginNotAllowed: 'Esta mídia não pode ser publicada do local onde está armazenada.',
        youtubeQuotaExceeded: 'A cota de envios do YouTube foi atingida. Tente novamente mais tarde.',
        youtubePermissionDenied: 'O YouTube negou este envio. Reconecte a conta e tente novamente.',
        youtubeVideoRejected: 'O YouTube rejeitou este vídeo. Revise o vídeo e tente novamente.',
        instagramQuotaExceeded: 'O limite diário de publicações do Instagram foi atingido. Tente novamente mais tarde.',
        instagramMediaRejected: 'O Instagram rejeitou este Reel. Use um corte vertical e tente novamente.',
        facebookQuotaExceeded: 'O limite de publicações do Facebook foi atingido. Tente novamente mais tarde.',
        facebookMediaFetchFailed: 'O Facebook não conseguiu baixar este corte. Tente novamente.',
        facebookMediaRejected: 'O Facebook rejeitou esta mídia. Revise o corte e tente novamente.',
        facebookPublishFailed: 'Não foi possível publicar na sua Página do Facebook. Tente novamente.',
        facebookStatusUnknown: 'Não conseguimos confirmar se esta publicação chegou à sua Página do Facebook. Ela pode já estar lá, então confira a Página antes de publicar de novo.',
        captionTooLong: 'A legenda deve ter no máximo 2.200 caracteres.',
        timedOut: 'A plataforma não terminou de processar este corte. Tente novamente.',
        providerUnavailable: 'O serviço de publicação está temporariamente indisponível. Tente novamente mais tarde.',
        proRequired: 'Publicar é um recurso PRO. Faça upgrade para publicar.',
        tooFewImages: 'Um carrossel precisa de pelo menos 2 imagens.',
        tooManyImages: 'Um carrossel pode ter no máximo 10 imagens.',
        carouselUnsupported: 'Esta plataforma não aceita este tipo de post em carrossel.',
        clipWatermarked:
          'O TikTok não aceita vídeos com a marca d\'água do AutoClipper. Assine um plano e exporte o corte de novo.',
        unknown: 'Algo deu errado ao publicar este corte. Tente novamente.',
        scheduledInPast: 'Escolha um horário pelo menos dois minutos no futuro.',
        notScheduled: 'Esta publicação já não está agendada e não pode ser alterada.',
      },
      calendar: {
        carousel: 'Carrossel',
        title: 'Calendário',
        subtitle: 'Agende publicações e veja o que já foi enviado.',
        prevMonth: 'Mês anterior',
        nextMonth: 'Próximo mês',
        schedule: 'Agendar',
        pickClipTitle: 'Escolha um corte',
        pickClipDescription: 'Veja o preview e publique para {{date}}.',
        clipPreview: 'Prévia de {{name}}',
        loadMore: 'Carregar mais',
        untitled: 'Corte sem título',
        loading: 'Carregando…',
        error: 'Não foi possível carregar as publicações agendadas. Tente novamente.',
        status: {
          scheduled: 'Agendado',
          pending: 'Enviando',
          processing: 'Enviando',
          published: 'Publicado',
          sent_to_drafts: 'Nos rascunhos',
          failed: 'Falhou',
        },
      },
      schedule: {
        createTitle: 'Agendar publicação',
        editTitle: 'Editar publicação agendada',
        viewTitle: 'Publicação agendada',
        description: 'Escolha o corte, a conta e o horário. Você pode editar até o envio.',
        viewDescription: 'Detalhes desta publicação.',
        save: 'Salvar',
        saving: 'Salvando…',
        saved: 'Publicação agendada salva',
        cancelSend: 'Cancelar envio',
        cancelling: 'Cancelando…',
        cancelled: 'Publicação agendada cancelada',
        clipLabel: 'Corte',
        clipSearch: 'Buscar cortes',
        clipEmpty: 'Nenhum corte publicável encontrado',
        platformLabel: 'Plataforma',
        accountLabel: 'Conta',
        postLink: 'Vídeo',
        openPost: 'Abrir no {{platform}}',
        datetimeLabel: 'Data e hora',
        openCalendar: 'Escolher data e hora',
        timeLabel: 'Horário',
        timePlaceholder: '15:30',
        hourLabel: 'Hora',
        minuteLabel: 'Min',
        timeEarlier: '15 minutos antes',
        timeLater: '15 minutos depois',
        alreadyScheduled: 'Já agendados',
        moreScheduled: '+{{count}}',
        tooSoon: 'Escolha um horário pelo menos dois minutos no futuro.',
        failReason: 'Motivo da falha',
        noConnectionBody: 'Conecte uma conta nas Configurações da Conta para agendar esta publicação.',
        reconnectBody: 'Reconecte esta conta nas Configurações da Conta para liberar a publicação.',
        platforms: {
          tiktok: 'TikTok',
          instagram: 'Instagram',
          youtube: 'YouTube',
          facebook: 'Facebook',
        },
      },
    },
    quoteCarousel: {
      title: 'Carrossel de frases',
      back: 'Voltar',
      backToClips: 'Voltar para os cortes',
      loadError: 'Não foi possível carregar este corte.',
      notFound: 'Corte não encontrado.',
      retry: 'Tentar novamente',
      saving: 'Salvando…',
      saved: 'Salvo',
      generate: 'Sugerir frases com IA',
      regenerate: 'Gerar novamente',
      generating: 'Escolhendo as melhores falas do transcript…',
      quota: '{{used}}/{{limit}} hoje',
      empty: 'Nenhum slide ainda. Sugira frases com IA ou escolha trechos do transcript.',
      noTranscript: 'Este corte ainda não tem transcript, então não dá para sugerir frases.',
      notEnoughQuotes: 'A IA encontrou menos de {{min}} boas frases. Escolha trechos do transcript para completar o seu carrossel.',
      regenerateConfirm: {
        title: 'Substituir os slides atuais?',
        body: 'As novas sugestões vão substituir todos os slides deste carrossel, incluindo as suas edições.',
        cancel: 'Cancelar',
        confirm: 'Substituir slides',
      },
      proDialog: {
        title: 'Limite diário de frases atingido',
        body: 'O plano gratuito inclui 1 sugestão de frases com IA por dia. Assine o PRO para ter até 10 por dia e downloads sem marca d\'água.',
        dismiss: 'Agora não',
        upgrade: 'Ver planos',
      },
      errors: {
        daily_limit_reached: 'Você atingiu o limite de sugestões de frases de hoje. Tente novamente amanhã.',
        transcript_unavailable: 'Este corte não tem transcript para extrair frases.',
        not_found: 'Corte não encontrado.',
        timeout: 'A sugestão de frases demorou demais. Tente novamente.',
        generation_failed: 'Não foi possível sugerir frases. Tente novamente.',
      },
      slides: {
        title: 'Slides',
        slideLabel: 'Slide {{number}}',
        dragHandle: 'Arraste para reordenar',
        moveUp: 'Mover para cima',
        moveDown: 'Mover para baixo',
        delete: 'Excluir slide',
        minSlides: 'Um carrossel precisa de pelo menos {{min}} slides.',
        maxSlides: 'Um carrossel comporta até {{max}} slides.',
        addFromTranscript: 'Adicionar do transcript',
        charCount: '{{used}}/{{max}}',
      },
      picker: {
        title: 'Escolha um trecho do transcript',
        description: 'Clique em uma palavra para iniciar a frase e depois clique (ou use shift + clique) em outra para terminá-la.',
        searchPlaceholder: 'Buscar no transcript',
        noTranscript: 'Nenhum transcript disponível para este corte.',
        noMatches: 'Nenhuma palavra encontrada para a sua busca.',
        previewLabel: 'Frase',
        previewEmpty: 'Selecione palavras para montar a frase.',
        tooLong: 'As frases podem ter até {{max}} caracteres. Selecione um trecho menor.',
        cancel: 'Cancelar',
        add: 'Adicionar',
      },
      preview: {
        title: 'Prévia',
        empty: 'Adicione slides para ver a prévia.',
        capturing: 'Capturando frame do vídeo…',
      },
      placement: {
        dragHint: 'Arraste o texto para movê-lo; arraste o fundo para enquadrar (dê zoom primeiro).',
        zoom: 'Zoom do fundo',
        reset: 'Restaurar posição',
      },
      textStyle: {
        title: 'Texto',
        reset: 'Voltar ao template',
        font: 'Fonte',
        text: 'Texto',
        accent: 'Destaque',
        background: 'Fundo',
        size: 'Tamanho',
        align: 'Alinhamento',
        align_left: 'Alinhar à esquerda',
        align_center: 'Centralizar',
        align_right: 'Alinhar à direita',
        bold: 'Negrito',
        italic: 'Itálico',
        outline: 'Contorno',
        outlineWidth: 'Espessura do contorno',
      },
      singleImage: {
        download: 'Baixar imagem',
        downloadSlide: 'Baixar imagem do slide {{number}}',
        error: 'Não foi possível gerar a imagem deste slide. Tente novamente.',
      },
      settings: {
        title: 'Configurações',
        style: 'Estilo',
        styleCard: 'Cartão',
        styleFrame: 'Frame do vídeo',
        format: 'Formato',
        format4x5: '4:5 (feed)',
        format9x16: '9:16 (stories)',
        templates: 'Templates',
        noTemplate: 'Sem template',
        frameSource: 'Origem dos frames',
        frameAuto: 'Automático: frame da frase',
        framePicked: 'Escolhido: {{time}} ({{source}})',
        pickFrame: 'Escolher frame',
        handle: 'Arroba',
        handlePlaceholder: '@seuperfil',
        slideBackground: 'Fundo do slide {{number}}',
        slideBackgroundNone: 'Selecione um slide para mudar o fundo',
        backgroundFrame: 'Frame do vídeo',
        backgroundColor: 'Cor',
      },
      frameSource: {
        original: 'Vídeo original',
        edited: 'Vídeo editado',
      },
      framePicker: {
        title: 'Escolher frame',
        description: 'Percorra o vídeo e escolha o frame exato para o fundo deste slide.',
        editedUnavailable: 'O vídeo editado fica disponível depois que o corte é exportado.',
        originalLoadError: 'Não foi possível carregar o vídeo original.',
        originalLoading: 'Carregando o vídeo original…',
        originalUnavailable: 'O vídeo original não está disponível para este corte.',
        previewAlt: 'Frame selecionado',
        scrubber: 'Posição no vídeo',
        prevFrame: 'Frame anterior',
        nextFrame: 'Próximo frame',
        use: 'Usar este frame',
        resetAuto: 'Voltar ao automático',
        cancel: 'Cancelar',
      },
      frameCaptureFailed: 'Não foi possível capturar um frame do vídeo para alguns slides, então eles ficaram com fundo de cor sólida. Você pode voltar o fundo para frame do vídeo para tentar de novo.',
      export: {
        download: 'Baixar ZIP',
        title: 'Gerando os slides',
        generating: 'Gerando {{done}}/{{total}}…',
        keepTabOpen: 'Mantenha esta aba aberta até todos os slides ficarem prontos.',
        status: {
          pending: 'Aguardando',
          rendering: 'Gerando…',
          done: 'Pronto',
          failed: 'Falhou',
        },
        retry: 'Tentar novamente',
        failedHint: 'Alguns slides falharam. Tente novamente para baixar o ZIP.',
        downloadZip: 'Baixar ZIP',
        close: 'Fechar',
        zipError: 'Não foi possível criar o arquivo ZIP. Tente novamente.',
        blocked: {
          too_few_slides: 'Um carrossel precisa de pelo menos {{min}} slides para ser baixado.',
          empty_text: 'Todos os slides precisam ter texto antes de baixar.',
          frames_pending: 'Aguarde os frames do vídeo terminarem de carregar e tente de novo.',
        },
      },
      publish: {
        menu: 'Postar',
        title: 'Postar carrossel no {{platform}}',
        description_one: '{{count}} slide será postado como carrossel de imagens.',
        description_other: '{{count}} slides serão postados como carrossel de imagens.',
        captionLabel: 'Legenda',
        submit: 'Postar agora',
        schedule: 'Agendar',
        started: 'Carrossel enviado. Ele aparece no {{platform}} em alguns minutos.',
        noConnection: 'Conecte uma conta do {{platform}} nas Configurações da conta para postar carrosséis.',
        noConnectionFacebook: 'Conecte uma Página do Facebook nas Configurações da conta para postar carrosséis.',
        tiktokReconnect: 'Postar carrosséis no TikTok exige permissão de postagem direta. Reconecte sua conta do TikTok para concedê-la.',
        tiktokNowOnly: 'Carrosséis no TikTok são postados na hora; o agendamento não está disponível.',
        instagramFormatBlocked: 'O Instagram não aceita imagens 9:16 em carrosséis. Mude este carrossel para 4:5 para postar.',
        switchTo4x5: 'Mudar para 4:5',
        stage: {
          rendering: 'Gerando slides {{done}}/{{total}}…',
          uploading: 'Enviando imagens {{done}}/{{total}}…',
          publishing: 'Enviando para a plataforma…',
        },
        errors: {
          renderFailed: 'Não foi possível gerar alguns slides. Tente novamente.',
          uploadFailed: 'Não foi possível enviar as imagens dos slides. Tente novamente.',
        },
        blocked: {
          too_few_slides: 'Um carrossel precisa de pelo menos {{min}} slides para ser postado.',
          empty_text: 'Todos os slides precisam ter texto antes de postar.',
          frames_pending: 'Aguarde os frames do vídeo terminarem de carregar e tente de novo.',
        },
        proDialog: {
          title: 'Postar é um recurso PRO',
          body: 'Faça upgrade para o PRO e poste seus carrosséis direto nas suas contas sociais conectadas, sem marca d’água.',
        },
      },
    },

    editorWatermark: {
      handleLabel: "Marca d'água — arraste para mover",
      appearsAt: "Aparece aos {{seconds}}s",
      reset: "Restaurar posição",
    },
    aiAssistant: {
      studio: {
        play: 'Reproduzir',
        pause: 'Pausar',
        mute: 'Silenciar',
        unmute: 'Ativar som',
        seek: 'Posição no corte',
        fullscreen: 'Tela cheia',
        clip: 'Corte',
        undo: 'Desfazer',
        redo: 'Refazer',
        fullEditor: 'Abrir editor completo',
        timeline: 'Linha do tempo',
        open: 'AI Studio',
        editWithAi: 'Editar com IA',
      },
      title: 'Assistente de IA',
      short: 'IA',
      beta: 'Beta',
      open: 'Abrir assistente de IA',
      close: 'Fechar',
      more: 'Mais opções',
      newChat: 'Nova conversa',
      history: 'Conversas recentes',
      noHistory: 'Nenhuma conversa ainda.',
      untitled: 'Conversa sem título',
      deleteConversation: 'Apagar conversa',
      deleteTitle: 'Apagar esta conversa?',
      deleteBody: 'As mensagens são removidas de vez. Nada do que ela fez na sua conta é desfeito.',
      emptyTitle: 'O que vamos fazer?',
      openingConversation: 'Abrindo a conversa…',
      suggestionsLoading: 'Pensando em ideias para esta página…',
      suggestionsLoadingClip: 'Pensando em ideias para este corte…',
      emptyBody: 'Peça cortes, renderizações, postagens, campanhas ou tire dúvidas sobre o Autoclipper. Mande imagens, vídeos ou o link de um vídeo que você quer copiar. Eu confirmo com você antes de mudar sua conta.',
      placeholder: 'Pergunte ao assistente…',
      send: 'Enviar',
      thinking: 'Trabalhando nisso…',
      stopped: 'Você interrompeu a resposta.',
      stop: 'Parar',
      loadError: 'Não foi possível carregar a conversa.',
      retry: 'Tentar novamente',
      steps_one: '{{count}} passo',
      steps_other: '{{count}} passos',
      stepsFailed: '{{count}} falhou',
      activity: {
        sending: 'Enviando…',
        thinking: 'Pensando…',
        editing: 'Editando o vídeo…',
        capturing: 'Capturando a tela…',
        awaitingConfirmation: 'Confirme no card acima',
        tool: '{{tool}}…',
        elapsed: '{{seconds}} s',
        longWait: 'pode levar até 2 min',
        tools: {
          analyze_video: 'Assistindo ao vídeo…',
          wait_for_import: 'Preparando o vídeo…',
        },
      },
      interrupted: 'A última resposta foi interrompida. Envie o pedido de novo.',
      reloadNotice: 'O assistente alterou dados desta página. Recarregue para ver.',
      reload: 'Recarregar',
      disclaimer: 'A IA pode errar. Ações na conta pedem confirmação; edições no editor podem ser desfeitas.',
      editApplied: 'A IA editou este corte.',
      undoEdit: 'Desfazer',
      editUndone: 'Edições da IA desfeitas',
      toolFailed: '{{tool}} falhou',
      action: {
        title: 'Confirmar: {{action}}',
        confirm: 'Confirmar',
        cancel: 'Cancelar',
        status: {
          pending: 'Aguardando confirmação',
          approved: 'Confirmado',
          cancelled: 'Cancelado',
          expired: 'Não confirmado',
        },
      },
      suggestions: {
        studioFunny: 'Deixe esse corte engraçado',
        studioHormozi: 'Adicione legenda estilo Hormozi',
        studioCutPauses: 'Corte as pausas',
        studioLayout: 'Use o layout Cortes',
        studioBroll: 'Coloque um b-roll no começo',
        makeClips: 'Gerar cortes de um vídeo do YouTube',
        latestProjects: 'Como estão meus últimos vídeos?',
        myUsage: 'Quanto de cota ainda tenho este mês?',
        bestClips: 'Quais cortes daqui parecem mais virais?',
        renderBest: 'Renderize o melhor corte deste vídeo na vertical',
        captionIdeas: 'Escreva título e legenda para o primeiro corte',
        renderThisProject: 'Renderize os cortes deste projeto',
        subtitleStyleHelp: 'Como mudo o estilo da legenda aqui?',
        editorTour: 'O que dá pra fazer neste editor?',
        trendingNow: 'O que está em alta no acervo esta semana?',
        remixIdea: 'Ache um vídeo de podcast para remixar',
        bestCampaign: 'Qual campanha está pagando mais agora?',
        howEarn: 'Como funciona o Clip & Pix?',
        myEarnings: 'Quanto eu já ganhei até agora?',
        analyticsSummary: 'Resuma meus resultados nas redes',
        bestPosts: 'Quais posts meus foram melhor?',
      },
      errors: {
        featureDisabled: 'O assistente de IA não está liberado para sua conta.',
        busy: 'O assistente ainda está respondendo. Espere terminar.',
        dailyLimit: 'Você atingiu o limite de mensagens de hoje. Tente amanhã.',
        unavailable: 'O assistente está indisponível agora. Tente mais tarde.',
        actionExpired: 'Esta confirmação não vale mais.',
        clientCallsExpired: 'O assistente perdeu o editor de vista. Envie o pedido de novo.',
        notFound: 'Esta conversa não existe mais.',
        invalidInput: 'Escreva uma mensagem de até 4.000 caracteres.',
        generic: 'Algo deu errado com o assistente. Tente de novo.',
      },
      attach: {
        button: 'Anexar imagem ou vídeo',
        captureFrame: 'Anexar frame atual',
        remove: 'Remover anexo',
        errors: {
          capture_failed: 'Não foi possível capturar o frame.',
          unsupported_type: 'Só imagens (PNG, JPG, WebP, GIF) e vídeos (MP4, MOV, WebM).',
          too_large: 'Arquivo grande demais: imagens até 10 MB, vídeos até 300 MB.',
          too_many: 'Até 4 anexos por mensagem, sendo 2 vídeos.',
          upload_failed: 'O envio falhou. Remova e tente de novo.',
        },
      },
      previewKinds: {
        clip: 'Corte',
        project: 'Projeto',
        library: 'Curadoria',
        community_video: 'Vídeo do acervo',
        video_url: 'Vídeo',
        campaign: 'Campanha',
        plan: 'Plano',
      },
      args: {
        aspect_ratio_format: 'Formato',
        subtitles_enabled: 'Legendas',
        subtitle_position: 'Posição da legenda',
        name: 'Novo nome',
        rating: 'Avaliação',
        platform: 'Rede',
        title: 'Título',
        caption: 'Legenda do post',
        description: 'Descrição',
        privacy_status: 'Visibilidade',
        made_for_kids: 'Feito para crianças',
        scheduled_at: 'Agendado para',
        tiktok_direct_post: 'Postar direto no TikTok',
        youtube_url: 'Link',
        video_url: 'Link',
        url: 'Link',
        language: 'Idioma',
        format: 'Duração dos cortes',
        start_time: 'Início',
        end_time: 'Fim',
        yearly: 'Cobrança anual',
        provider: 'Pagamento',
        version: 'Versão dos termos',
      },
      values: {
        true: 'Sim',
        false: 'Não',
        vertical: 'Vertical',
        horizontal: 'Horizontal',
        like: 'Manter',
        dislike: 'Descartar',
        neutral: 'Sem avaliação',
        instagram: 'Instagram',
        tiktok: 'TikTok',
        youtube: 'YouTube',
        public: 'Público',
        private: 'Privado',
        unlisted: 'Não listado',
        stripe: 'Cartão (Stripe)',
        pagarme: 'PIX',
      },
      tools: {
        analyze_video: 'Vídeo assistido',
        wait_for_import: 'Preparação do vídeo',
        ui_open_page: 'Página aberta',
        editor_set_subtitle_style: 'Estilo da legenda',
        editor_apply_template: 'Template aplicado',
        editor_add_text: 'Texto adicionado',
        editor_update_text: 'Texto ajustado',
        editor_remove_layer: 'Camada removida',
        editor_add_effect: 'Efeito adicionado',
        editor_remove_effect: 'Efeito removido',
        editor_set_transition: 'Transição',
        editor_set_look: 'Cor do vídeo',
        editor_seek: 'Prévia posicionada',
        editor_capture_frames: 'Olhou o vídeo',
        editor_select_clip: 'Corte selecionado',
        editor_cut_ranges: 'Cortes no vídeo',
        editor_trim: 'Início e fim do corte',
        editor_extend: 'Mais trecho do vídeo',
        editor_split: 'Cena dividida',
        editor_remove_scene: 'Cena removida',
        editor_reorder_scenes: 'Ordem das cenas',
        editor_set_framing: 'Enquadramento',
        editor_camera_move: 'Movimento de câmera',
        editor_set_layout: 'Layout',
        editor_search_media: 'Busca de mídia',
        editor_add_media: 'Mídia adicionada',
        editor_update_layer: 'Camada ajustada',
        editor_set_cover: 'Capa',
        editor_motion_reference: 'Referência de animação',
        editor_add_motion: 'Animação adicionada',
        editor_get_motion: 'Animação inspecionada',
        editor_update_motion: 'Animação ajustada',
        editor_add_captions: 'Legendas em camadas adicionadas',
        navigate_to: 'Abrir página',
        get_my_account: 'Dados da conta',
        list_plans: 'Lista de planos',
        create_checkout: 'Link de pagamento',
        get_checkout_status: 'Status do pagamento',
        search_community_libraries: 'Busca no acervo',
        get_community_library: 'Detalhes do vídeo do acervo',
        search_community_channels: 'Busca de canais do acervo',
        get_community_channel: 'Detalhes do canal do acervo',
        list_community_channel_libraries: 'Vídeos do canal',
        search_community_tags: 'Temas do acervo',
        check_community_url: 'Verificação do link no acervo',
        list_import_videos: 'Vídeos do link compartilhado',
        create_project: 'Novo projeto',
        create_library: 'Nova curadoria',
        remix_community_library: 'Remix de vídeo do acervo',
        update_project: 'Atualização do projeto',
        delete_project: 'Exclusão do projeto',
        retry_project: 'Nova tentativa do projeto',
        update_library: 'Atualização da curadoria',
        delete_library: 'Exclusão da curadoria',
        retry_library: 'Nova tentativa da curadoria',
        list_my_projects: 'Lista de projetos',
        get_project: 'Detalhes do projeto',
        list_my_libraries: 'Lista de curadorias',
        get_library: 'Detalhes da curadoria',
        list_clips: 'Lista de cortes',
        get_clip: 'Detalhes do corte',
        generate_clip_copy: 'Título e legenda do corte',
        rate_clip: 'Avaliação do corte',
        render_clip: 'Renderização do corte',
        get_render_status: 'Status da renderização',
        list_social_connections: 'Redes sociais conectadas',
        publish_clip: 'Publicação do corte',
        list_cpm_campaigns: 'Campanhas do Clip & Pix',
        accept_cpm_terms: 'Aceite dos termos do Clip & Pix',
        join_cpm_campaign: 'Inscrição na campanha',
        submit_cpm_clip: 'Envio do corte para a campanha',
        list_brand_kits: 'Brand kits',
        schedule_clip_publish: 'Agendamento da publicação',
        list_scheduled_publishes: 'Publicações agendadas',
        cancel_scheduled_publish: 'Cancelamento do agendamento',
        list_publish_queues: 'Filas de publicação',
        create_publish_queue: 'Nova fila de publicação',
        update_publish_queue: 'Atualização da fila de publicação',
        delete_publish_queue: 'Exclusão da fila de publicação',
        enqueue_clip_to_queue: 'Corte adicionado à fila',
        list_analytics_accounts: 'Contas do analytics',
        get_analytics_summary: 'Resumo do analytics',
        list_analytics_media: 'Posts do analytics',
        list_analytics_cpm_submissions: 'Analytics dos envios de campanha',
        open_billing_portal: 'Link do portal de cobrança',
        preview_clip_frame: 'Prévia do corte',
      },
    },
  },
};
